import React, { createContext, useContext, useState, useEffect } from 'react';

// Translation data
const translations = {
  en: {
    // --- Common / General ---
    // --- Missing Keys Update ---
    // Englisch (en)
    assignToGeneral: 'Add to general group',
    assignToGeneralOn: 'Content will be visible to all members of the default group after creation.',
    assignToGeneralOff: '⚠ Warning: This content will not be visible to the general audience. It will only be accessible to admins and the creator.',
    videoRenderingBackground: 'Video is rendering in the background – you can continue in a moment.',
    manyPagesHint: 'Document has {count} pages – analysis will take a little longer.',
    analyzingPages: 'Analysing pages…',
    // --- New extracted strings ---
    notif_goto_adminpanel:    'Open Admin Panel',
    notif_type_new_question:  'New Question',
    notif_title:         'Notifications',
    notif_back:          'Back',
    notif_loading:       'Loading…',
    notif_empty:         'No messages yet',
    notif_just_now:          'Just now',
    notif_type_message:      'Admin Message',
    notif_type_new_content:  'New Content',
    notif_goto_collection:   'Go to Collection',
    notif_goto_document:     'View Document',
    notif_open_document:     'Open Document',
    notif_goto_fraghejvi:    'Open FragHejVi',
    notif_close:             'Close',
    notif_dismiss_all:       'Close all',
    // ── en ──────────────────────────────────────────────────
    adminArea: 'Admin area',
    adm_pin_format_hint:    'Exactly 8 characters: letters and digits (e.g. "Ab3x9kQ2")',
    adm_pin_format_error:   'PIN must be exactly 8 alphanumeric characters (a-z, A-Z, 0-9).',
    // ─── Admin Panel ───────────────────────────────────────────────────────
    adm_subtitle:          'HejVi Management',
    adm_access_denied:     'Access denied',
    adm_access_denied_desc:'You do not have permission to access the admin area.',
    adm_back:              'Back',
    adm_users:             'Users',
    adm_groups:            'Groups',
    adm_videos:            'Videos',
    adm_topics:            'Topics',
    adm_video_sg:          'Video',
    adm_topic_sg:          'Topic',
    adm_docs:              'Documents & Knowledge Base',
    adm_open_video:        'Open video in new tab',
    adm_open_doc:          'Open document in new tab',
    adm_open_element:      'Open element in new tab',
    adm_stat_users:        'Total users',
    adm_stat_active:       'Active users',
    adm_members:           'Members',
    adm_content:           'Content',
    adm_name:              'Name',
    adm_status:            'Status',
    adm_role:              'Role',
    adm_role_standard:     'Standard',
    adm_created:           'Created',
    adm_actions:           'Actions',
    adm_preview:           'Preview',
    adm_active:            'Active',
    adm_inactive:          'Inactive',
    adm_edit:              'Edit',
    adm_delete:            'Delete',
    adm_new_user:          'New user',
    adm_new_group:         'New group',
    adm_edit_user:         'Edit user',
    adm_edit_group:        'Edit group',
    adm_create:            'Create',
    adm_save:              'Save',
    adm_save_translate:    'Save & translate',
    adm_translating:       'Translating…',
    adm_cancel:            'Cancel',
    adm_done:              'Done',
    adm_confirm:           'Sure?',
    adm_yes:               'Yes',
    adm_no:                'No',
    adm_mandatory:         'Mandatory',
    adm_description:       'Description',
    adm_rights_level:      'Rights level',
    adm_lang_id:           'Language ID',
    adm_client_id:         'Client ID',
    adm_pin_change:        'New PIN (leave empty = no change)',
    adm_pin_hint:          'At least 4 characters',
    adm_pin_change_hint:   'Leave empty for no change',
    adm_groups_for:        'Groups for',
    adm_groups_assign_hint:'Toggle groups to assign the user:',
    adm_content_for_group: 'Content for group',
    adm_content_visible_hint: 'This content is visible in the following groups:',
    adm_assigned:          'Assigned',
    adm_add:               'Add',
    adm_remove:            'Remove',
    adm_assign:            'Assign',
    adm_search_hint:       'search',
    adm_no_users:          'No users found',
    adm_no_groups:         'No groups available',
    adm_no_entries:        'No entries found',
    adm_no_content:        'No content found',
    adm_toast_deleted:     'Deleted',
    adm_toast_created:     'Created',
    adm_toast_saved:       'Saved',
    adm_toast_deactivated: 'Deactivated',
    adm_toast_removed:     'Removed from group',
    adm_toast_added:       'Added to group',
    adm_toast_error:       'Error',
    adm_toast_load_error:  'Error loading data',
    chatGreeting: 'Hej! I\'m happy to help. What would you like to know?',
    chatSubtitle: 'Ask about document',
    chatButton: 'Ask',
    chatPlaceholder: 'Ask a question about the document …',
    chatClear: 'Clear chat',
    chatSuggestion1: 'Summarize the document',
    chatSuggestion2: 'What are the key points?',
    chatSuggestion3: 'What requirements are mentioned?',
    chatErrorNotAuthenticated: 'Not authenticated. Please log in again.',
    chatErrorNoAnswer: 'No answer received.',
    chatErrorGeneric: 'Error',
    // --- Global Chat Widget ---
    globalChatTitle: 'Knowledge Assistant',
    globalChatSubtitle: 'All documents & videos',
    globalChatFab: 'Ask HejVi',
    globalChatGreeting: 'Hej! I can help you with questions across all your documents and videos. What would you like to know?',
    globalChatPlaceholder: 'Ask a question about all your content …',
    globalSuggestion1: 'What do my documents say about safety requirements?',
    globalSuggestion2: 'Summarize all available content',
    globalSuggestion3: 'Which videos cover this topic?',
    sourcesUsed: 'Sources',
    sourceDocument: 'Document',
    sourceVideo: 'Video',
    goToElement: 'Open element →',
    goToVideo: 'Watch video →',
    createdOn: 'Created on',
    pleaseSelectDocument: 'Please select a document (PDF, TXT, or DOC).',
    selectDocument: 'Select Document',
    photoVideo: 'Photo / Video',
    document: 'Document',
    replaceFile: 'Replace',
    removeFile: 'Remove',
    documentTypeDefault: 'Document',
    invalidDocumentType: 'Please upload a valid file: PDF, TXT, DOC/DOCX or PPT/PPTX.',
    documentTooLarge: 'File is too large. Max {mb} MB allowed.',
    documentAiInfo: 'The AI automatically extracts the content, creates a summary (1-2 sentences) as voiceover, and uses the first page as a thumbnail.',
    documentModeActive: 'Document Mode Active',
    documentModeDesc: 'The AI will automatically use your document content as video text. You can optionally add context or leave it empty.',
    docAdditionalContextPlaceholder: 'Optional additional context (e.g. target audience, focus area)...',
    optionLabel: 'Option',
    aiOptionLabel: 'AI Option',
    autoGeneratedFromDoc: 'Automatically generated from document',
    documentAutoProcess: 'AI extracts content and creates summary as video text.',
    aiDocProcessingInfo: 'We are analyzing the document, generating a summary as voiceover, and creating a video with the first page as thumbnail.',
    viewDocument: 'View',
    downloadDocument: 'Download',
    responseVideoNotFound: 'Response video not found',
    responseVideoNotReady: 'The response video for this challenge doesn\'t exist yet.',
    unknownQRCodeTitle: 'Unknown QR Code',
    unknownQRCodeQuestion: 'How would you like to proceed?',
    unknownQRCodeCreateCollection: 'Create new collection',
    addVideo: 'Add Video',
    pleaseSelectMedia: 'Please select a video or photo.',
    originalText: 'Original',
    printQRLabel: '🖨️ Print QR Label',
    printerConnecting: '🔵 Connecting printer...',
    printerPrinting: '⏳ Printing...',
    printerDone: '✅ Printed!',
    printerError: '❌ Error – Try again',
    bluetoothHint: 'Connects via Bluetooth – select Niimbot B1 from the list',
    printerErrorHint: 'Printer turned on? Only Chrome/Edge support Web Bluetooth.',
    number_of_views: 'Views',
    number_of_likes: 'Likes',
    qrCode: 'QR Code',
    printQrCode: 'Print QR Code',
    playFrom: 'Play from',
    voiceSearchSummary: '{collections} collections, {elements} elements',
    pleaseLoginFirst: 'Please login first to scan QR codes',
    openingUrl: 'Opening URL...',
    eanNotFound: 'No item matched this EAN in the feed',
    sessionExpired: 'Your session has expired. Please login again.',
    // --- Script / Moderation Selection ---
    recordingTooShort: "Recording too short",
    errorNoSpeechDetected: "No speech detected. Please speak louder or get closer to the microphone.",
    errorTranscriptionFailed: "Could not understand audio. Please try again clearly.",
    reactionVideo: 'Reaction Video?',
    setThisToReaction: 'Marks this element as a response video (Content Type 4).',
    selectModeration: 'Select moderation script',
    selectModerationDesc: 'The AI generated the following text suggestions based on your description:',
    generatingScripts: 'Generating scripts...',
    nothingFits: 'Nothing fits',
    backToDesc: 'Back to description',
    selectedModeration: 'Selected moderation',
    maxRetriesReached: 'Please refine your description. No further attempts possible.',
    errorLoadingScripts: 'Error loading suggestions. Please check your internet connection or login again.',

    challenge: 'Challenge',
    thinking: 'Thinking...',
    aiSuggest: 'Hejvi AI Suggestions',
    aiNoSuggestions: 'The AI could not find specific elements. Showing all.',
    showAll: 'Show All',
    totalXp: 'Total Experience Points',
    levelUp: "Level Up!",
    achievementUnlocked: "Achievement Unlocked!",
    congrats: "Congratulations!",
    awesome: "Awesome!",
    newXp: "XP earned",
    sec: "sec",
    min: "min",
    invalidInput: "Input contains invalid characters or HTML code.",
    errorContentRejected: "This content was rejected because it violates our safety guidelines (e.g. hate speech, violence, sexual content). Please revise your input.",
    errorImageTooLarge: "The image is too large (Max 4MB).",
    errorInvalidImageType: "Invalid format. Allowed: JPG, PNG, WEBP, GIF.",
    warningImageTooLarge: "The thumbnail image is too large for temporary storage. Your course structure was saved, but the image was dropped. Please re-select it upon return.",
    draftSaveError: "Draft could not be saved (Storage full).",
    authErrorTokenMissing: "Authentication token missing. Please login again.",
    uploadFailed: "Upload failed.",
    qrErrorEmpty: "Please enter the QR Code value.",
    errorOptionMissing: "Please enter text for Option",
    viewQuiz: 'View Quiz',
    details: 'Details',
    pleaseUploadThumbnail: "Please upload a thumbnail image for the course.",
    createVideoElement: 'Create Video',
    createQuizElement: 'Create Quiz',
    orSelectExisting: 'Or select existing elements:',
    organize: 'Move videos to change the order',
    viewCourse: 'View Course',
    filterMyContent: 'My Content Only',
    makeVisible: 'Make Visible',
    makeInvisible: 'Hide',
    selectCorrectAnswer: 'Select Correct Answer',
    selectCorrectAnswerDesc: 'Which option is the correct solution?',
    QuizExampleQrHash: 'e.g. el-32hhuz3',
    pleaseEnterQuestion: 'Please enter a question or title.',
    typeYesNo: 'Yes / No',
    typeQR: 'QR Scan',
    typeMulti: 'Multi Option',
    QuizQuestionPlaceholder: 'e.g. Is this safety gear correct?',
    QuizDescriptionPlaceholder: 'Optional description...',
    quizCreatedSuccess: 'Quiz successfully created!',
    tapToUpload: 'Upload thumbnail image',
    uploadOrAutoThumb: 'Upload image',
    autoThumbHint: 'Otherwise generated automatically from video thumbnails',
    imageSelected: 'Image selected',
    yes: 'Yes',
    no: 'No',
    correct: 'Correct',
    incorrect: 'Incorrect',
    submit: 'Submit',
    next: 'Next',
    back: 'Back',
    cancel: 'Cancel',
    create: 'Create',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    previous: 'Previous',
    loading: 'Loading...',
    
    // --- Quiz Builder Specific ---
    createQuiz: 'Create Quiz',
    configureQuiz: 'Configure Quiz',
    selectType: 'Select Type',
    selectResponses: 'Select Responses',
    selectResponsesDesc: 'Select the videos that play after the user answers.',
    question: 'Question',
    enableHint: 'Enable Hint?',
    hintNotAvailableQR: 'Hints are disabled for QR Code challenges.',
    
    // QR Specific
    qrTargetTitle: 'QR Code Target',
    qrTargetDesc: 'What text/code is hidden in the QR code the user must scan?',
    qrValueLabel: 'QR Content (Exact)',
    
    // Review Step
    reviewQuiz: 'Summary',
    reviewDesc: 'Please review your settings before creating the quiz.',
    
    // Validation / Errors
    pleaseEnterName: 'Please enter a question/name.',
    errorSelectCorrect: 'Please select the correct answer.',
    selectBothResponses: 'Please select both response videos.',
    
    // Success Step
    backToDashboard: 'Back to Dashboard',
    createAnother: 'Create Another',
    scanToStart: 'Scan to start',
    
    // Element Creator / Course Builder
    createChallenge: 'Create Challenge',
    configureChallenge: 'Configure Challenge',
    useExactTextTitle: 'Use exact text',
    useExactTextDesc: 'Skip AI optimization and read description 1:1.',
    transcribeVideoTitle: 'Use video audio as voiceover',
    transcribeVideoDesc: 'The spoken text is transcribed. Use as 1:1 voiceover (synced to video) or let the AI create an optimized script from it.',
    transcribeVideo: 'Transcribe',
    transcribing: 'Transcribing...',
    transcriptAdopted: 'Video audio adopted as voiceover',
    resetTranscript: 'Discard transcript',
    transcriptionFailed: 'Transcription failed.',
    transcribeExactInfo: 'The spoken text is transcribed 1:1 and used as voiceover. Subtitles remain in sync with the original video.',
    transcribeLLMInfo: 'The spoken text is transcribed. The AI creates an optimized voiceover script in the detected video language.',
    transcribeExactToggleDesc: 'Use 1:1 transcript as voiceover (synced to video). Off: AI generates an optimized script from the transcript.',
    confirmDelete: 'Are you sure you want to delete this item? This cannot be undone.',
    deleteSuccess: 'Item deleted successfully.',
    deleteError: 'Failed to delete item.',
    loginWithQRCode: 'Login with QR Code',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    needHint: 'Need a hint?',
    
    // Navigation
    home: 'Home',
    challenges: 'Challenges',
    favorites: 'Favorites',
    profile: 'Profile',
    myCourses: 'My Courses',
    
    // Dashboard
    welcome: 'Welcome back! 👋',
    searchPlaceholder: 'Search content…',
    mustSee: 'Must-See',
    safety: 'Safety',
    tools: 'Tools',
    law: 'Law',
    mandatory: 'Mandatory',
    mandatoryFilter: 'Mandatory courses',
    mandatoryCourses: 'Mandatory Courses',
    favourites: 'Favourites',
    favouritesFilter: 'Favourites',
    loadMore: 'Load more',
    play: 'Play',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    
    // Login
    login: 'Log In',
    enterPin: 'Please Enter Pin',
    invalidPin: 'Please enter a valid 8-character PIN',
    loginError: 'Invalid PIN. Please try again.',
    wrongPin: 'Wrong PIN. Please try again.',
    loginSuccess: 'Login successful! Welcome back! 🎉',
    
    // Profile
    myProfile: 'My Profile',
    myProgress: 'My Progress',
    contactSupport: 'Contact Support',
    language: 'Language',
    settings: 'Settings',
    privacy: 'Privacy',
    help: 'Help',
    logout: 'Log Out',
    active: 'Active',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    joined: 'Joined',
    courses: 'Courses',
    completed: 'Completed',
    inProgress: 'In Progress',
    achievements: 'Achievements',
    topLearner: 'Top Learner',
    safetyStar: 'Safety Star',
    firstSteps: 'First Steps',
    learner: 'Learner',
    group: 'Group',
    client: 'Client',
    
    // Contact Form
    yourName: 'Your Name',
    emailAddress: 'Email Address',
    describeIssue: 'Describe your issue...',
    sendMessage: 'Send Message',
    messageSent: 'Message sent successfully!',
    messageSendError: 'Failed to send message. Please try again.',
    
    // Course/Video
    startCourse: 'Start Course',
    continueCourse: 'Continue Course',
    courseProgress: 'Course Progress',
    videoProgress: 'Video Progress',
    stepsInThisVideo: 'Steps in this video',
    relatedVideos: 'Related Videos',
    duration: 'Duration',
    experiencePoints: 'Experience Points',
    levelComplexity: 'Level Complexity',
    lessons: 'Lessons',
    nextLessonStartsIn: 'Next lesson starts in',
    nextVideoIn: 'Next video in',
    seconds: 's',
    replay: 'Replay',
    cancelAutoplay: 'Cancel Auto-play',
    loadingCourses: 'Loading courses...',
    noCourses: 'No courses available',
    searchCourses: 'Search courses...',
    noResults: 'No courses found',
    workplaceSafety: 'Workplace Safety Basics',
    workplaceSafetyDesc: 'Essential safety protocols for the workplace',
    
    // Challenges
    allChallenges: 'All Challenges',
    currentChallenges: 'Current Challenges',
    challengeProgress: 'Challenge Progress',
    challengeEnds: 'Challenge Ends',
    daysLeft: 'days left',
    hoursLeft: 'hours left',
    minutesLeft: 'minutes left',
    loadingChallenges: 'Loading challenges...',
    activeChallenges: 'Active Challenges',
    weeklyProgress: 'Progress',
    noChallenges: 'No challenges available at the moment.',
    startNow: 'Start Now',
    discoverMore: 'Discover More Challenges',
    stayMotivated: 'Stay motivated & earn rewards!',
    doneChallenges: 'done',
    challengesProgressLabel: 'Challenges Progress',
    mandatoryProgressLabel: 'Mandatory Courses Progress',
    doneMandatory: 'mandatory courses completed',
    completeChallengesEarnXP: 'Complete challenges to earn XP!',
    noDeadline: 'No deadline',
    failedToLoadChallenges: 'Failed to load challenges',
    expired: 'Expired',
    lessThan1hLeft: 'Less than 1h left',
    expert: 'Expert',
    
    // QR Scanner
    scanQR: 'Scan QR Code',
    scanPlaceholder: 'Point camera at QR code',
    scanSuccess: 'QR code scanned successfully!',
    scanError: 'Failed to scan QR code',
    cameraError: 'Camera access denied',
    cameraPermission: 'Please allow camera access',
    cameraPermissionDenied: 'Camera permission denied. Please allow camera access.',
    noCameraFound: 'No camera found. Please check your device.',
    cameraNotSupported: 'Camera not supported in this browser.',
    cameraInUse: 'Camera is in use by another application.',
    cameraConstraintsNotMet: 'Camera constraints not met. Please try a different camera.',
    failedToStartCamera: 'Failed to start camera',
    failedToAccessCamera: 'Failed to access camera. Please check your browser permissions.',
    onlyOneCameraAvailable: 'Only one camera available on this device',
    noSuitableCameraFound: 'No suitable camera found for switching',
    failedToSwitchCamera: 'Failed to switch camera',
    cameraSwitchFailed: 'Camera switch failed',
    unableToReadCodeFromImage: 'Unable to read code from image',
    errorAccessingCamera: 'Error accessing camera',
    tryAgain: 'Try Again',
    switchingCamera: 'Switching camera...',
    gallery: 'Gallery',
    flash: 'Flash',
    switchCamera: 'Switch Camera',
    capture: 'Capture',
    
    // Voice Recording
    voiceSearch: 'Voice Search',
    tapToStartRecording: 'Tap to start recording',
    speakYourSearchQuery: 'Speak your search query clearly',
    startRecording: 'Start Recording',
    stopRecording: 'Stop Recording',
    recording: 'Recording...',
    processingAudio: 'Processing audio...',
    transcript: 'Transcript',
    closingOverlay: 'Closing overlay and showing search results...',
    searchAgain: 'Search Again',
    
    // Toast Messages
    urlOpened: 'URL opened in new tab',
    navigatingCourse: 'Navigating to course...',
    productCode: 'Product code: {code}',
    lookingUpEAN: 'Looking up EAN {ean}...',
    fetchingContent: 'Fetching content...',
    elementFound: 'Element found: {name}',
    collectionFound: 'Collection found: {name}',
    contentNotFound: 'Content not found',
    
    // Errors
    networkError: 'Network error. Please check your connection.',
    serverError: 'Server error. Please try again later.',
    unauthorized: 'Unauthorized. Please log in again.',
    notFound: 'Content not found.',
    generalError: 'An unexpected error occurred.',
    
    // Time
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    ago: 'ago',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',
    
    // Additional UI Elements
    seeAll: 'See All',
    seeMore: 'See More',
    seeLess: 'See Less',
    expand: 'Expand',
    collapse: 'Collapse',
    refresh: 'Refresh',
    retry: 'Retry',
    confirm: 'Confirm',
    ok: 'OK',
    done: 'Done',
    skip: 'Skip',
    continue: 'Continue',
    finish: 'Finish',
    start: 'Start',
    stop: 'Stop',
    pause: 'Pause',
    resume: 'Resume',
    restart: 'Restart',
    reset: 'Reset',
    clear: 'Clear',
    remove: 'Remove',
    add: 'Add',
    update: 'Update',
    change: 'Change',
    select: 'Select',
    choose: 'Choose',
    browse: 'Browse',
    upload: 'Upload',
    download: 'Download',
    share: 'Share',
    copy: 'Copy',
    paste: 'Paste',
    cut: 'Cut',
    undo: 'Undo',
    redo: 'Redo',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
    volume: 'Volume',
    mute: 'Mute',
    unmute: 'Unmute',
    preferences: 'Preferences',
    account: 'Account',
    notifications: 'Notifications',
    messages: 'Messages',
    inbox: 'Inbox',
    sent: 'Sent',
    drafts: 'Drafts',
    trash: 'Trash',
    archive: 'Archive',
    starred: 'Starred',
    important: 'Important',
    unread: 'Unread',
    read: 'Read',
    markAsRead: 'Mark as Read',
    markAsUnread: 'Mark as Unread',
    reply: 'Reply',
    forward: 'Forward',
    compose: 'Compose',
    send: 'Send',
    receive: 'Receive',
    sync: 'Sync',
    backup: 'Backup',
    restore: 'Restore',
    import: 'Import',
    export: 'Export',
    print: 'Print',
    saveAs: 'Save As',
    open: 'Open',
    new: 'New',
    openInNewTab: 'Open in New Tab',
    openInNewWindow: 'Open in New Window',
    bookmark: 'Bookmark',
    unbookmark: 'Remove Bookmark',
    history: 'History',
    bookmarks: 'Bookmarks',
    downloads: 'Downloads',
    recent: 'Recent',
    popular: 'Popular',
    trending: 'Trending',
    featured: 'Featured',
    recommended: 'Recommended',
    suggested: 'Suggested',
    related: 'Related',
    similar: 'Similar',
    other: 'Other',
    more: 'More',
    less: 'Less',
    none: 'None',
    some: 'Some',
    few: 'Few',
    many: 'Many',
    most: 'Most',
    least: 'Least',
    best: 'Best',
    worst: 'Worst',
    highest: 'Highest',
    lowest: 'Lowest',
    fastest: 'Fastest',
    slowest: 'Slowest',
    newest: 'Newest',
    oldest: 'Oldest',
    latest: 'Latest',
    earliest: 'Earliest',
    first: 'First',
    last: 'Last',
    current: 'Current',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    on: 'On',
    off: 'Off',
    true: 'True',
    false: 'False',
    maybe: 'Maybe',
    unknown: 'Unknown',
    pending: 'Pending',
    processing: 'Processing',
    failed: 'Failed',
    cancelled: 'Cancelled',
    scheduled: 'Scheduled',
    overdue: 'Overdue',
    due: 'Due',
    valid: 'Valid',
    invalid: 'Invalid',
    required: 'Required',
    optional: 'Optional',
    available: 'Available',
    unavailable: 'Unavailable',
    online: 'Online',
    offline: 'Offline',
    connected: 'Connected',
    disconnected: 'Disconnected',
    public: 'Public',
    private: 'Private',
    hidden: 'Hidden',
    visible: 'Visible',
    locked: 'Locked',
    unlocked: 'Unlocked',
    secure: 'Secure',
    insecure: 'Insecure',
    verified: 'Verified',
    unverified: 'Unverified',
    authenticated: 'Authenticated',
    unauthenticated: 'Unauthenticated',
    authorized: 'Authorized',
    permitted: 'Permitted',
    forbidden: 'Forbidden',
    allowed: 'Allowed',
    denied: 'Denied',
    granted: 'Granted',
    revoked: 'Revoked',
    accepted: 'Accepted',
    rejected: 'Rejected',
    approved: 'Approved',
    disapproved: 'Disapproved',
    confirmed: 'Confirmed',
    unconfirmed: 'Unconfirmed',
    signed: 'Signed',
    unsigned: 'Unsigned',
    encrypted: 'Encrypted',
    decrypted: 'Decrypted',
    compressed: 'Compressed',
    uncompressed: 'Uncompressed',
    archived: 'Archived',
    unarchived: 'Unarchived',
    backedUp: 'Backed Up',
    restored: 'Restored',
    imported: 'Imported',
    exported: 'Exported',
    printed: 'Printed',
    saved: 'Saved',
    opened: 'Opened',
    created: 'Created',
    updated: 'Updated',
    changed: 'Changed',
    selected: 'Selected',
    chosen: 'Chosen',
    browsed: 'Browsed',
    uploaded: 'Uploaded',
    downloaded: 'Downloaded',
    shared: 'Shared',
    copied: 'Copied',
    pasted: 'Pasted',
    zoomedIn: 'Zoomed In',
    zoomedOut: 'Zoomed Out',
    fullscreened: 'Fullscreened',
    muted: 'Muted',
    unmuted: 'Unmuted',
    notified: 'Notified',
    messaged: 'Messaged',
    replied: 'Replied',
    forwarded: 'Forwarded',
    composed: 'Composed',
    synced: 'Synced',
    bookmarked: 'Bookmarked',
    unbookmarked: 'Unbookmarked',
    openedInNewTab: 'Opened in New Tab',
    openedInNewWindow: 'Opened in New Window',
    
    // Element Creator Specific
    elementCreator: 'Video Creator',
    createElement: 'Create Video',
    createStep1Title: "Let's start! Give it a name.",
    elementNamePlaceholder: "e.g., How to fix the milling machine",
    createStep2Title: "Upload your content",
    createStep2Sub: "Take a photo/video or upload from library.",
    selectMedia: 'Select Media',
    tapToChange: 'Tap to change',
    createStep3Title: "Explain it",
    createStep3Sub: "What is happening in this video? Our AI will turn this into a professional narration.",
    descPlaceholder: "Describe the process step by step...",
    createStep4Title: "Review",
    aiProcessingInfo: "We will now compress the video, generate a professional voiceover from your description, and translate everything into 10 languages.",
    creatingElement: "Creating Element...",
    videoGenerating: "Video is being generated, please wait a moment…",
    videoProcessing: "Video is being finalized… The button will be enabled automatically.",
    videoProcessingHint: "The video is still being processed. Wait a moment to view it directly, or simply continue working.",
    pleaseWait: "This may take a minute. Uploading and processing AI tasks.",
    elementCreatedSuccess: 'Element successfully created!',
    elementReadyDesc: 'Your element has been created and processed successfully.',
    viewElement: 'View Element Now',
    goToMyCourses: 'Go to My Courses',
    elementPendingTitle: 'Your video is being reviewed',
    elementPendingDesc: 'Your video was uploaded successfully and is now being reviewed by an administrator. It will be published for everyone shortly.',
    elementPendingHint: 'You will be notified once your video has been approved.',
    elementApprovedTitle: 'Your video has been approved!',
    elementApprovedBody: 'Great news — your video "{name}" has been approved and is now visible to all users.',
    descTooShort: 'Please provide a detailed description (min. 10 chars).',
    invalidFileType: 'Please upload a valid video or image.',
    fileTooLarge: 'File is too large. Maximum size is 500MB.',
    media: 'Media',
    description: 'Description',
    name: 'Name',
    
    // Course Builder
    courseDetails: 'Course Details',
    courseName: 'Course Name',
    courseNamePlaceholder: 'e.g. machine maintenance',
    courseDescPlaceholder: 'Briefly describe what this course is about...',
    thumbnail: 'Thumbnail Image',
    uploadImage: '+ Upload Image',
    addElements: 'Add Elements',
    searchElements: 'Search elements...',
    loadingElements: 'Loading elements...',
    preview: 'Preview',
    added: 'Added',
    noElementsFound: 'No matching elements found.',
    organizeCourse: 'Organize Course',
    dragDropReorder: 'Drag and drop to reorder',
    addMoreElements: '+ Add more elements',
    courseCreated: 'Course Created!',
    courseCreatedDesc: 'Your collection has been successfully saved.',
    createAnotherCourse: 'Create Another Course',
    createCourse: 'Create Course',
    addToCourse: 'Add to Course',
    saving: 'Saving...',
    noElementsSelected: 'Please select at least one element',
    errorCreatingCourse: 'Error creating course',
    authError401: 'Not authorized (401). Your session may have expired. Please login again.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: 'Automatically translate missing fields.',
    adm_en_readonly_hint: 'English is the base language and cannot be edited automatically.',
    adm_filter_active: 'Active',
    adm_filter_all: 'All',
    adm_filter_inactive: 'Inactive',
    adm_last_superadmin_hint: 'The last superadmin cannot be deactivated.',
    adm_no_group_access: 'User has no group access.',
    adm_no_group_assign_warn: 'User must have at least one group.',
    adm_no_group_warn_body: 'Removing this group will leave the user without access.',
    adm_no_group_warn_title: 'No group assigned',
    adm_toast_added_to_group: 'User added to group',
    adm_toast_removed_from_group: 'User removed from group',
    adm_toast_group_assigned: 'Group assigned',
    adm_toast_group_removed: 'Group removed',
    adm_toast_content_assigned: 'Content assigned',
    adm_toast_content_removed: 'Content removed',
    // ── Notification system ───────────────────────────────────────────────
    adm_notifications:          'Messages',
    notif_type_new_content:     'New Content',
    notif_type_message:         'Message',
    notif_goto_collection:      'Go to Collection',
    notif_dismiss_all:          'Close all',
    notif_just_now:             'Just now',

    // ── MyCourses: filter pills, section headers & empty states ─────────
    mc_filter_all:            'All',
    mc_filter_courses:        '📚 My Courses',
    mc_filter_videos:         '▶ My Videos',
    mc_filter_favorites:      '★ Favorites',
    mc_status_all:            'All Status',
    mc_only_mine:             'Only mine',
    mc_section_courses_sub:   'Started and completed courses',
    mc_section_videos:        'My Videos',
    mc_section_videos_sub:    'Content created by you',
    mc_section_favorites:     'My Favorites',
    mc_section_favorites_sub: 'Liked courses and videos',
    mc_empty_courses:         "You haven't started any course yet.",
    mc_empty_videos:          "You haven't created any videos yet.",
    mc_empty_favorites:       "You haven't added any content to your favorites yet.",
    videoRendering:     'Video is being rendered…',
    videoRenderingHint: 'The video is still being processed. It will be available shortly.',
    // ── AdminPanel: new i18n strings ─────────────────────────────────────
    adm_qr_unavailable:         'QR not available — npm install qrcode',
    adm_qr_login_title:         'QR Code for Login',
    adm_qr_scan_login_hint:     'Scan → login directly without PIN',
    adm_qr_permanent_hint:      'The QR code is permanently available in the user record.',
    adm_qr_print_hint:          'Print the PIN now or transmit it securely.',
    adm_msg_subject_placeholder:'e.g. New safety instruction available',
    adm_msg_text_placeholder:   'Message text…',
    adm_col_license_type:       'Licence Type',
    adm_btn_show_qr:            'Show QR Code',
    adm_btn_send_msg:           'Send Message',
    adm_login_qr_label:         'Login QR Code',
    adm_btn_gen_pin:            'Generate New PIN',
    adm_qr_scan_hint:           'User can scan this code to log in without entering a PIN.',
    adm_pin_reset_hint:         'To reset the PIN: close this dialog and use 🔄 Reset PIN in the user card.',
    adm_role_supervisor:        'Supervisor',
    adm_role_admin_opt:         'Admin',
    adm_role_superadmin:        'Super Admin',
    adm_seat_essentials_desc:   'Essentials – all features except content creation',
    adm_pin_force_change:       'Force PIN change on first login',
    adm_btn_msg_group:          'Message to Group',
    adm_btn_show:               'Show',
    adm_btn_unlock:             'Unlock Element',
    adm_btn_show_assigned:      'Show Assigned Content',
    adm_no_videos_assigned:     'No videos assigned. Click "+ Add Video".',
    adm_drag_sort:              'Drag to sort',
    adm_search_video:           'Search video…',
    adm_no_videos:              'No videos found.',
    adm_video_unassigned:       'This video is not assigned to any content.',
    adm_search_messages:        'Search messages…',
    adm_btn_reload:             'Reload',
    adm_enriching:              'Enrichment running…',
    adm_no_video_chunks:        'No videos with transcript chunks found',
    adm_ki_enrichment:          'AI Enrichment',
    adm_col_updated:            'Updated',
    adm_search_docs:            'Search document or element…',
    adm_no_docs:                'No documents available',
    adm_col_size:               'Size',
    adm_search_questions:       'Search questions…',
    adm_label_question:         "Employee's Question",
    adm_label_answer:           'Answer',
    adm_btn_upload_doc:         'Upload Document',
    adm_just_moment:            'Just a moment',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Only admins can edit the domain profile.',
    adm_primary_lang:           'Primary Working Language',
    adm_drop_doc:               'Drop document here or click',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Existing Company Documents',
    adm_company_docs_empty:     'No company documents uploaded yet.',
    adm_no_licence:             'No licence data available.',
    adm_full_seats_label:       '⭐ Full Seats (incl. Content Creation)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'Valid until',
    adm_base_lang:              'Base Language',
    adm_active_ui_langs:        'Active UI Languages',
    adm_tts_langs:              'TTS Languages',
    adm_full_seats_total_label: '⭐ Full Seats total',
    adm_essentials_total_label: 'Essentials Seats total',
    adm_ui_langs_field:         'UI Languages (active app languages)',
    adm_tts_langs_field:        'TTS Languages (Text-to-Speech)',
    adm_config_title:           'Configuration',
    adm_config_desc:            'Platform settings for this tenant. Changes take effect immediately.',
    adm_supervisor_mode:        'Supervisor Mode',
    adm_warning_no_admin:       '⚠️ Warning: There is currently no active user with Supervisor or Admin role (Group 2 or 3). Elements cannot be approved with Supervisor Mode active. Please assign at least one user to a Supervisor or Admin role first.',
    adm_std_delete_toggle:      'Standard Users: Delete & Deactivate Videos',
    adm_std_course_toggle:      'Standard Users: Create Courses & Quizzes',
    adm_supervisor_confirm_title: 'Activate Supervisor Mode?',
    adm_btn_activate:           'Activate',
    adm_admin_only_setting:     'Only tenant administrators (Group 3) or Super Admins can change this setting.',
    adm_only_admins_edit:       'Only administrators can change this setting.',
  },
  
  de: {
    // --- Allgemein ---
    // --- Skript / Moderation Auswahl ---
    // --- Missing Keys Update ---
    // --- Neue extrahierte Strings ---
    // Deutsch (de)
    assignToGeneral: 'Zur Allgemein-Gruppe hinzufügen',
    assignToGeneralOn: 'Inhalt wird nach Erstellung für alle Nutzer der Standard-Gruppe sichtbar.',
    assignToGeneralOff: '⚠ Achtung: Dieser Inhalt wird nicht für die Allgemeinheit sichtbar sein. Er ist nur für Admins und den Ersteller zugänglich.',
    videoRenderingBackground: 'Video wird im Hintergrund gerendert – Sie können gleich fortfahren.',
    manyPagesHint: 'Dokument enthält {count} Seiten – Analyse dauert etwas länger.',
    analyzingPages: 'Seiten werden analysiert…',
    // Profile.js – Benachrichtigungen-Button und Modal
    notif_goto_adminpanel:    'Zum Admin-Panel',
    notif_type_new_question:  'Neue Frage',

    notif_title:         'Benachrichtigungen',
    notif_back:          'Zurück',
    notif_loading:       'Lade…',
    notif_empty:         'Keine Nachrichten vorhanden',
    // NotificationToast.jsx
    notif_just_now:          'Gerade eben',
    notif_type_message:      'Admin-Nachricht',
    notif_type_new_content:  'Neuer Inhalt',
    notif_goto_collection:   'Zur Sammlung',
    notif_goto_document:     'Zum Dokument',
    notif_open_document:     'Dokument öffnen',
    notif_goto_fraghejvi:    'FragHejVi öffnen',
    notif_close:             'Schließen',
    notif_dismiss_all:       'Alle schließen',
    // ─── Admin Panel ───────────────────────────────────────────────────────
    adminArea: 'Adminbereich',
    adm_pin_format_hint:    'Genau 8 Zeichen: Buchstaben und Ziffern',
    adm_pin_format_error:   'PIN muss genau 8 alphanumerische Zeichen haben (a-z, A-Z, 0-9).',
    adm_subtitle:          'HejVi Verwaltung',
    adm_access_denied:     'Kein Zugriff',
    adm_access_denied_desc:'Du hast keine Berechtigung für diesen Bereich.',
    adm_back:              'Zurück',
    adm_users:             'Nutzer',
    adm_groups:            'Gruppen',
    adm_videos:            'Videos',
    adm_topics:            'Themen',
    adm_video_sg:          'Video',
    adm_topic_sg:          'Thema',
    adm_docs:              'Dokumente & Wissensbasis',
    adm_open_video:        'Video in neuem Tab öffnen',
    adm_open_doc:          'Dokument in neuem Tab öffnen',
    adm_open_element:      'Element in neuem Tab öffnen',
    adm_stat_users:        'Nutzer gesamt',
    adm_stat_active:       'Aktive Nutzer',
    adm_members:           'Mitglieder',
    adm_content:           'Inhalte',
    adm_name:              'Name',
    adm_status:            'Status',
    adm_role:              'Rolle',
    adm_role_standard:     'Standard',
    adm_created:           'Erstellt',
    adm_actions:           'Aktionen',
    adm_preview:           'Vorschau',
    adm_active:            'Aktiv',
    adm_inactive:          'Inaktiv',
    adm_filter_all:        'Alle',
    adm_filter_active:     'Aktiv',
    adm_filter_inactive:   'Inaktiv',
    adm_edit:              'Bearbeiten',
    adm_delete:            'Löschen',
    adm_new_user:          'Neuer Nutzer',
    adm_new_group:         'Neue Gruppe',
    adm_edit_user:         'Nutzer bearbeiten',
    adm_edit_group:        'Gruppe bearbeiten',
    adm_create:            'Erstellen',
    adm_save:              'Speichern',
    adm_save_translate:    'Speichern & übersetzen',
    adm_translating:       'Übersetze…',
    adm_cancel:            'Abbrechen',
    adm_done:              'Fertig',
    adm_confirm:           'Sicher?',
    adm_yes:               'Ja',
    adm_no:                'Nein',
    adm_mandatory:         'Pflichtinhalt',
    adm_description:       'Beschreibung',
    adm_rights_level:      'Rechtestufe',
    adm_lang_id:           'Sprache',
    adm_client_id:         'Mandant',
    adm_pin_change:        'PIN ändern (leer lassen = unverändert)',
    adm_pin_hint:          'Mindestens 4 Zeichen',
    adm_pin_change_hint:   'Leer lassen für keine Änderung',
    adm_groups_for:        'Gruppen für',
    adm_groups_assign_hint:'Gruppen zuweisen oder entfernen',
    adm_content_for_group: 'Inhalte für Gruppe',
    adm_content_visible_hint: 'Dieser Inhalt ist für folgende Gruppen sichtbar:',
    adm_assigned:          'Zugewiesen',
    adm_add:               'Hinzufügen',
    adm_remove:            'Entfernen',
    adm_assign:            'Zuweisen',
    adm_search_hint:       'suchen',
    adm_no_users:          'Keine Nutzer gefunden',
    adm_no_groups:         'Keine Gruppen vorhanden',
    adm_no_entries:        'Keine Einträge gefunden',
    adm_no_content:        'Keine Inhalte gefunden',
    adm_toast_deleted:     'Gelöscht',
    adm_toast_created:     'Erstellt',
    adm_toast_saved:       'Gespeichert',
    adm_toast_deactivated: 'Deaktiviert',
    adm_toast_removed:     'Aus Gruppe entfernt',
    adm_toast_added:       'Zur Gruppe hinzugefügt',
    adm_toast_error:       'Ein Fehler ist aufgetreten',
    adm_toast_load_error:  'Fehler beim Laden',
    adm_activate:          'Aktivieren',
    adm_deactivate:        'Deaktivieren',
    adm_auto_translate_hint: '💡 Name und Beschreibung werden automatisch in alle Sprachen übersetzt.',
    adm_en_readonly_hint:  'Wird automatisch übersetzt – nicht editierbar',
    adm_last_superadmin_hint: 'Letzter Super Admin – kann nicht gelöscht werden',
    adm_no_group:          'keine Gruppe',
    adm_no_group_access:   'Kein Zugriff auf Inhalte',
    adm_no_group_assign_warn: 'Dieser Nutzer ist keiner Gruppe zugeordnet und hat daher keinen Zugriff auf Inhalte.',
    adm_no_group_warn_body: 'Neue Nutzer ohne Gruppenzuordnung haben keinen Zugriff auf Inhalte. Bitte nach der Erstellung über 🏷️ Gruppen eine Gruppe zuweisen.',
    adm_no_group_warn_title: 'Hinweis: Kein Gruppenzugang',
    adm_toast_added_to_group: 'Zur Gruppe hinzugefügt',
    adm_toast_removed_from_group: 'Aus Gruppe entfernt',
    adm_toast_group_assigned: 'Gruppe zugewiesen',
    adm_toast_group_removed: 'Gruppe entfernt',
    adm_toast_content_assigned: 'Inhalt zugewiesen',
    adm_toast_content_removed: 'Inhalt entfernt',
    // ── Benachrichtigungssystem ───────────────────────────────────────────
    adm_notifications:          'Nachrichten',
    notif_type_new_content:     'Neue Inhalte',
    notif_type_message:         'Nachricht',
    notif_goto_collection:      'Zur Collection',
    notif_dismiss_all:          'Alle schließen',
    notif_just_now:             'Gerade eben',
    // --- Document Chat ---
    chatGreeting: 'Hej! Ich helfe dir gerne weiter. Was möchtest du wissen?',
    chatSubtitle: 'Dokument befragen',
    chatButton: 'Fragen',
    chatPlaceholder: 'Stelle eine Frage zum Dokument …',
    chatClear: 'Chat leeren',
    chatSuggestion1: 'Fasse das Dokument zusammen',
    chatSuggestion2: 'Was sind die wichtigsten Punkte?',
    chatSuggestion3: 'Welche Anforderungen werden genannt?',
    chatErrorNotAuthenticated: 'Nicht authentifiziert. Bitte neu einloggen.',
    chatErrorNoAnswer: 'Keine Antwort erhalten.',
    chatErrorGeneric: 'Fehler',
    // --- Global Chat Widget ---
    globalChatTitle: 'Hej! Schön dich zu sehen!',
    globalChatSubtitle: 'Ich helfe dir gerne.',
    globalChatFab: 'Frag HejVi',
    globalChatGreeting: 'Was möchtest du wissen?',
    globalChatPlaceholder: 'Stelle eine Frage über alle deine Inhalte …',
    globalSuggestion1: 'Was enthalten meine Dokumente zu Sicherheitsanforderungen?',
    globalSuggestion2: 'Fasse alle verfügbaren Inhalte zusammen',
    globalSuggestion3: 'Welche Videos behandeln dieses Thema?',
    sourcesUsed: 'Quellen',
    sourceDocument: 'Dokument',
    sourceVideo: 'Video',
    goToElement: 'Element öffnen →',
    goToVideo: 'Video ansehen →',
    createdOn: 'Erstellt',
    pleaseSelectDocument: 'Bitte wähle ein Dokument aus (PDF, TXT oder DOC).',
    selectDocument: 'Dokument auswählen',
    photoVideo: 'Foto / Video',
    document: 'Dokument',
    replaceFile: 'Ersetzen',
    removeFile: 'Entfernen',
    documentTypeDefault: 'Dokument',
    invalidDocumentType: 'Bitte lade eine gültige Datei hoch: PDF, TXT, DOC/DOCX oder PPT/PPTX.',
    documentTooLarge: 'Die Datei ist zu groß. Maximal {mb} MB erlaubt.',
    documentAiInfo: 'Die KI extrahiert automatisch den Inhalt, erstellt eine kurze Zusammenfassung (1–2 Sätze) als Videotext und nutzt die erste Seite als Vorschaubild.',
    documentModeActive: 'Dokument-Modus aktiv',
    documentModeDesc: 'Die KI wird den Inhalt deines Dokuments automatisch als Videotext verwenden. Du kannst optional zusätzlichen Kontext hinzufügen oder das Feld leer lassen.',
    docAdditionalContextPlaceholder: 'Optionaler zusätzlicher Kontext (z.B. Zielgruppe, Fokusbereich)...',
    optionLabel: 'Option',
    aiOptionLabel: 'KI Option',
    autoGeneratedFromDoc: 'Wird automatisch aus dem Dokument generiert',
    documentAutoProcess: 'KI extrahiert Inhalt und erstellt Zusammenfassung als Videotext.',
    aiDocProcessingInfo: 'Wir analysieren das Dokument, erzeugen eine Zusammenfassung als Voiceover und erstellen ein Video mit der ersten Seite als Vorschaubild.',
    viewDocument: 'Ansehen',
    downloadDocument: 'Herunterladen',
    responseVideoNotFound: 'Antwort-Video nicht gefunden',
    responseVideoNotReady: 'Das Antwort-Video für diese Aufgabe existiert noch nicht.',
    unknownQRCodeTitle: 'Unbekannter QR-Code',
    unknownQRCodeQuestion: 'Wie möchtest du fortfahren?',
    unknownQRCodeCreateCollection: 'Neue Sammlung erstellen',
    addVideo: 'Video hinzufügen',
    pleaseSelectMedia: 'Bitte wähle ein Video oder Foto aus.',
    originalText: 'Original',
    printQRLabel: '🖨️ QR-Label drucken',
    printerConnecting: '🔵 Verbinde Drucker...',
    printerPrinting: '⏳ Druckt...',
    printerDone: '✅ Gedruckt!',
    printerError: '❌ Fehler – Erneut versuchen',
    bluetoothHint: 'Verbindet per Bluetooth – Niimbot B1 in der Liste auswählen',
    printerErrorHint: 'Drucker eingeschaltet? Nur Chrome/Edge unterstützen Web Bluetooth.',
    number_of_views: 'Aufrufe',
    number_of_likes: 'Gefällt mir',
    qrCode: 'QR-Code',
    printQrCode: 'QR-Code drucken',
    playFrom: 'Abspielen ab',
    voiceSearchSummary: '{collections} Themen, {elements} Elemente',
    pleaseLoginFirst: 'Bitte logge dich ein, um QR-Codes zu scannen',
    openingUrl: 'Öffne Link...',
    eanNotFound: 'Kein Element mit dieser EAN gefunden',
    sessionExpired: 'Deine Sitzung ist abgelaufen. Bitte logge dich erneut ein.',
    recordingTooShort: "Die Aufnahme ist zu kurz. Lass dir etwas Zeit.",
    errorNoSpeechDetected: "Keine Sprache erkannt. Bitte spreche lauter oder gehe näher ans Mikrofon.",
    errorTranscriptionFailed: "Konnte leider nicht verstehen. Bitte versuche es erneut und sprich deutlich.",
    reactionVideo: 'Reaktionsvideo?',
    setThisToReaction: 'Markiert dieses Element als Antwort-Video (Content Type 4).',
    selectModeration: 'Wähle den passenden Text aus',
    selectModerationDesc: 'Die KI hat folgende Textvorschläge basierend auf deiner Beschreibung erstellt:',
    generatingScripts: 'Texte werden generiert...',
    nothingFits: 'Nichts passt',
    backToDesc: 'Zurück zur Beschreibung',
    selectedModeration: 'Gewählte Moderation',
    maxRetriesReached: 'Bitte präzisiere deine Beschreibung. Keine weiteren Versuche möglich.',
    errorLoadingScripts: 'Fehler beim Laden der Vorschläge. Bitte prüfe deine Internetverbindung oder logge dich neu ein.',

    challenge: 'Aufgabe',
    thinking: 'Denke nach...',
    aiSuggest: 'Hejvi KI Vorschläge',
    aiNoSuggestions: 'Die KI konnte keine spezifischen Elemente finden. Es werden alle angezeigt.',
    showAll: 'Alle anzeigen',
    totalXp: 'Gesamtpunkte (XP)',
    levelUp: "Level Aufstieg!",
    achievementUnlocked: "Auszeichnung freigeschaltet!",
    congrats: "Herzlichen Glückwunsch!",
    awesome: "Großartig!",
    newXp: "XP erhalten",
    sec: "Sek.",
    min: "Min.",
    invalidInput: "Die Eingabe enthält ungültige Zeichen oder HTML-Code.",
    errorContentRejected: "Dieser Inhalt wurde abgelehnt, da er gegen unsere Sicherheitsrichtlinien verstößt (z.B. Hassrede, Gewalt, sexuelle Inhalte). Bitte überprüfe deine Eingaben.",
    errorImageTooLarge: "Das Bild ist zu groß (Maximal 4MB).",
    errorInvalidImageType: "Ungültiges Format. Erlaubt sind: JPG, PNG, WEBP, GIF.",
    warningImageTooLarge: "Das Vorschaubild ist zu groß für den Zwischenspeicher. Deine Themen-Struktur wurde gespeichert, aber das Bild wurde entfernt. Bitte wähle es nach der Rückkehr erneut aus.",
    draftSaveError: "Entwurf konnte nicht gespeichert werden (Speicher voll).",
    authErrorTokenMissing: "Authentifizierungs-Token fehlt. Bitte neu einloggen.",
    uploadFailed: "Upload fehlgeschlagen.",
    qrErrorEmpty: "Bitte gib den Wert für den QR Code ein.",
    errorOptionMissing: "Bitte fülle Option",
    viewQuiz: 'Quiz ansehen',
    details: 'Details',
    pleaseUploadThumbnail: "Bitte lade ein Vorschaubild für das Thema hoch.",
    createVideoElement: 'Video erstellen',
    createQuizElement: 'Quiz erstellen',
    orSelectExisting: 'Oder wähle bestehende Elemente:',
    organize: 'Bewege die Videos, um die Reihenfolge zu ändern',
    viewCourse: 'Thema ansehen',
    filterMyContent: 'Nur meine Inhalte',
    makeVisible: 'Sichtbar machen',
    makeInvisible: 'Verstecken',
    selectCorrectAnswer: 'Richtige Antwort wählen',
    selectCorrectAnswerDesc: 'Welche Option ist die korrekte Lösung?',
    QuizExampleQrHash: 'z. B. el-32hhuz3',
    pleaseEnterQuestion: 'Bitte gib eine Frage oder einen Titel ein.',
    typeYesNo: 'Ja / Nein',
    typeQR: 'QR Scan',
    typeMulti: 'Mehrfachauswahl',
    QuizQuestionPlaceholder: 'z.B. Ist diese Schutzkleidung korrekt?',
    QuizDescriptionPlaceholder: 'Optionale Beschreibung...',
    quizCreatedSuccess: 'Quiz erfolgreich erstellt!',
    tapToUpload: 'Bild hochladen',
    uploadOrAutoThumb: 'Bild hochladen',
    autoThumbHint: 'Sonst automatisch aus den Videothumbnails generiert',
    imageSelected: 'Bild ausgewählt',
    yes: 'Ja',
    no: 'Nein',
    correct: 'Richtig',
    incorrect: 'Falsch',
    submit: 'Absenden',
    next: 'Weiter',
    back: 'Zurück',
    cancel: 'Abbrechen',
    create: 'Erstellen',
    error: 'Fehler',
    success: 'Erfolg',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    previous: 'Zurück',
    loading: 'Lade...',

    // --- Quiz Builder Spezifisch ---
    createQuiz: 'Quiz erstellen',
    configureQuiz: 'Quiz konfigurieren',
    selectType: 'Typ wählen',
    selectResponses: 'Antwort-Videos wählen',
    selectResponsesDesc: 'Wähle die Videos aus, die abgespielt werden, je nachdem ob der Nutzer richtig oder falsch antwortet.',
    question: 'Frage',
    enableHint: 'Hinweis aktivieren?',
    hintNotAvailableQR: 'Hinweise sind bei QR-Code-Challenges deaktiviert.',

    // QR Spezifisch
    qrTargetTitle: 'QR Code Ziel',
    qrTargetDesc: 'Welcher Text/Code ist im QR-Code hinterlegt, den der Nutzer scannen muss?',
    qrValueLabel: 'QR Inhalt (Exakt)',

    // Review Schritt
    reviewQuiz: 'Zusammenfassung',
    reviewDesc: 'Bitte prüfe deine Angaben, bevor du das Quiz erstellst.',

    // Validierung / Fehler
    pleaseEnterName: 'Bitte gib einen Namen ein.',
    errorSelectCorrect: 'Bitte wähle die korrekte Antwort aus.',
    selectBothResponses: 'Bitte wähle für Richtig und Falsch je ein Video aus.',

    // Success Schritt
    backToDashboard: 'Zum Dashboard',
    createAnother: 'Noch eins erstellen',
    scanToStart: 'Scannen zum Starten',
    useExactTextTitle: 'Text exakt übernehmen',
    useExactTextDesc: 'KI-Optimierung überspringen und Beschreibung 1:1 vorlesen (Berücksichtigt dann auch Tags wie [de][/de] und [ignore][/ignore]).',
    transcribeVideoTitle: 'Videoton als Voiceover verwenden',
    transcribeVideoDesc: 'Der gesprochene Text wird transkribiert. Wahlweise 1:1 als Voiceover (synchron zum Bild) oder als Basis für ein optimiertes KI-Skript.',
    transcribeVideo: 'Transkribieren',
    transcribing: 'Transkribiere...',
    transcriptAdopted: 'Videoton als Voiceover übernommen',
    resetTranscript: 'Transkript verwerfen',
    transcriptionFailed: 'Transkription fehlgeschlagen.',
    transcribeExactInfo: 'Der gesprochene Text wird 1:1 transkribiert und als Voiceover übernommen. Die Untertitel bleiben synchron zum Originalbild.',
    transcribeLLMInfo: 'Der gesprochene Text wird transkribiert. Die KI erstellt daraus ein optimiertes Voiceover-Skript in der erkannten Videosprache.',
    transcribeExactToggleDesc: 'Transkription 1:1 übernehmen (synchron zum Bild). Aus: KI erstellt optimiertes Skript aus dem Transkript.',
    confirmDelete: 'Möchtest du dieses Element wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
    deleteSuccess: 'Element erfolgreich gelöscht.',
    deleteError: 'Fehler beim Löschen.',
    loginWithQRCode: 'Login mit QR Code',
    search: 'Suchen',
    filter: 'Filter',
    all: 'Alle',
    needHint: 'Hinweis zeigen',
    
    // Navigation
    home: 'Startseite',
    challenges: 'Aufgaben',
    favorites: 'Favoriten',
    profile: 'Profil',
    myCourses: 'Meine Inhalte',
    
    // Dashboard
    welcome: 'Willkommen zurück! 👋',
    searchPlaceholder: 'Inhalte durchsuchen…',
    mustSee: 'Must-See',
    safety: 'Sicherheit',
    tools: 'Werkzeuge',
    law: 'Recht',
    mandatory: 'Pflicht',
    mandatoryFilter: 'Pflichtkurse',
    mandatoryCourses: 'Pflichtkurse',
    favourites: 'Favoriten',
    favouritesFilter: 'Favoriten',
    loadMore: 'Mehr laden',
    play: 'Abspielen',
    favorite: 'Favorit',
    unfavorite: 'Nicht mehr favorisieren',
    
    // Login
    login: 'Anmelden',
    enterPin: 'Bitte PIN eingeben',
    invalidPin: 'Bitte geben Sie eine gültige 8-stellige PIN ein',
    loginError: 'Ungültige PIN. Bitte versuchen Sie es erneut.',
    wrongPin: 'Falsche PIN. Bitte versuchen Sie es erneut.',
    loginSuccess: 'Anmeldung erfolgreich! Willkommen zurück! 🎉',
    
    // Profile
    myProfile: 'Mein Profil',
    myProgress: 'Mein Fortschritt',
    contactSupport: 'Support kontaktieren',
    language: 'Sprache',
    settings: 'Einstellungen',
    privacy: 'Datenschutz',
    help: 'Hilfe',
    logout: 'Abmelden',
    active: 'Aktiv',
    beginner: 'Anfänger',
    intermediate: 'Fortgeschritten',
    advanced: 'Experte',
    joined: 'Beigetreten',
    courses: 'Themen',
    completed: 'Abgeschlossen',
    inProgress: 'In Bearbeitung',
    achievements: 'Auszeichnungen',
    topLearner: 'Top Lerner',
    safetyStar: 'Sicherheits-Star',
    firstSteps: 'Erste Schritte',
    learner: 'Lerner',
    group: 'Gruppe',
    client: 'Kunde',
    
    // Contact Form
    yourName: 'Ihr Name',
    emailAddress: 'E-Mail-Adresse',
    describeIssue: 'Beschreiben Sie Ihr Problem...',
    sendMessage: 'Nachricht senden',
    messageSent: 'Nachricht erfolgreich gesendet!',
    messageSendError: 'Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    
    // Course/Video
    startCourse: 'Thema starten',
    continueCourse: 'Thema fortsetzen',
    courseProgress: 'Themenfortschritt',
    videoProgress: 'Videofortschritt',
    stepsInThisVideo: 'Schritte in diesem Video',
    relatedVideos: 'Verwandte Videos',
    duration: 'Dauer',
    experiencePoints: 'Erfahrungspunkte',
    levelComplexity: 'Schwierigkeitsgrad',
    lessons: 'Lektionen',
    nextLessonStartsIn: 'Nächste Lektion startet in',
    nextVideoIn: 'Nächstes Video in',
    seconds: 's',
    replay: 'Wiederholen',
    cancelAutoplay: 'Auto-Play abbrechen',
    loadingCourses: 'Themen werden geladen...',
    noCourses: 'Keine Themen verfügbar',
    searchCourses: 'Themen suchen...',
    noResults: 'Keine Themen gefunden',
    workplaceSafety: 'Grundlagen der Arbeitssicherheit',
    workplaceSafetyDesc: 'Wesentliche Sicherheitsprotokolle für den Arbeitsplatz',
    
    // Challenges
    allChallenges: 'Alle Aufgaben',
    currentChallenges: 'Aktuelle Herausforderungen',
    challengeProgress: 'Aufgabenfortschritt',
    challengeEnds: 'Aufgabe endet',
    daysLeft: 'Tage übrig',
    hoursLeft: 'Stunden übrig',
    minutesLeft: 'Minuten übrig',
    loadingChallenges: 'Aufgaben werden geladen...',
    activeChallenges: 'Aktive Aufgaben',
    weeklyProgress: 'Fortschritt',
    noChallenges: 'Momentan keine Aufgaben verfügbar.',
    startNow: 'Jetzt starten',
    discoverMore: 'Weitere Aufgaben entdecken',
    stayMotivated: 'Bleib motiviert & verdiene Belohnungen!',
    doneChallenges: 'erledigt',
    challengesProgressLabel: 'Fortschritt Herausforderungen',
    mandatoryProgressLabel: 'Fortschritt Pflichtkurse',
    doneMandatory: 'Pflichtkurse erledigt',
    completeChallengesEarnXP: 'Vervollständige Aufgaben um XP zu verdienen!',
    noDeadline: 'Keine Frist',
    failedToLoadChallenges: 'Aufgaben konnten nicht geladen werden',
    expired: 'Abgelaufen',
    lessThan1hLeft: 'Weniger als 1h übrig',
    expert: 'Experte',
    
    // QR Scanner
    scanQR: 'QR-Code scannen',
    scanPlaceholder: 'Kamera auf QR-Code richten',
    scanSuccess: 'QR-Code erfolgreich gescannt!',
    scanError: 'QR-Code konnte nicht gescannt werden',
    cameraError: 'Kamerazugriff verweigert',
    cameraPermission: 'Bitte erlauben Sie den Kamerazugriff',
    cameraPermissionDenied: 'Kamerazugriff verweigert. Bitte erlauben Sie den Kamerazugriff.',
    noCameraFound: 'Keine Kamera gefunden. Bitte überprüfen Sie Ihr Gerät.',
    cameraNotSupported: 'Kamera wird in diesem Browser nicht unterstützt.',
    cameraInUse: 'Kamera wird von einer anderen Anwendung verwendet.',
    cameraConstraintsNotMet: 'Kameraeinschränkungen nicht erfüllt. Bitte versuchen Sie eine andere Kamera.',
    failedToStartCamera: 'Kamera konnte nicht gestartet werden',
    failedToAccessCamera: 'Kamerazugriff fehlgeschlagen. Bitte überprüfen Sie Ihre Browserberechtigungen.',
    onlyOneCameraAvailable: 'Nur eine Kamera auf diesem Gerät verfügbar',
    noSuitableCameraFound: 'Keine geeignete Kamera zum Wechseln gefunden',
    failedToSwitchCamera: 'Kamerawechsel fehlgeschlagen',
    cameraSwitchFailed: 'Kamerawechsel fehlgeschlagen',
    unableToReadCodeFromImage: 'Code konnte nicht aus Bild gelesen werden',
    errorAccessingCamera: 'Fehler beim Zugriff auf Kamera',
    tryAgain: 'Erneut versuchen',
    switchingCamera: 'Kamera wird gewechselt...',
    gallery: 'Galerie',
    flash: 'Blitz',
    switchCamera: 'Kamera wechseln',
    capture: 'Aufnehmen',
    
    // Voice Recording
    voiceSearch: 'Frag HejVi!',
    tapToStartRecording: 'Tippe auf den Knopf, um mit der Aufnahme zu beginnen',
    speakYourSearchQuery: 'Warte dann kurz und spreche deine Suchanfrage deutlich',
    startRecording: 'Aufnahme starten',
    stopRecording: 'Aufnahme stoppen',
    recording: 'Aufnahme läuft...',
    processingAudio: 'Audio wird verarbeitet...',
    transcript: 'Transkript',
    closingOverlay: 'Overlay wird geschlossen und Suchergebnisse werden angezeigt...',
    searchAgain: 'Erneut suchen',
    
    // Toast Messages
    urlOpened: 'URL in neuem Tab geöffnet',
    navigatingCourse: 'Navigiere zum Thema...',
    productCode: 'Produktcode: {code}',
    lookingUpEAN: 'Suche EAN {ean}...',
    fetchingContent: 'Lade Inhalt...',
    elementFound: 'Element gefunden: {name}',
    collectionFound: 'Sammlung gefunden: {name}',
    contentNotFound: 'Inhalt nicht gefunden',
    
    // Errors
    networkError: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.',
    serverError: 'Serverfehler. Bitte versuchen Sie es später erneut.',
    unauthorized: 'Nicht autorisiert. Bitte melden Sie sich erneut an.',
    notFound: 'Inhalt nicht gefunden.',
    generalError: 'Ein unerwarteter Fehler ist aufgetreten.',
    
    // Time
    today: 'Heute',
    yesterday: 'Gestern',
    thisWeek: 'Diese Woche',
    thisMonth: 'Dieser Monat',
    ago: 'vor',
    minutes: 'Minuten',
    hours: 'Stunden',
    days: 'Tage',
    weeks: 'Wochen',
    months: 'Monate',
    years: 'Jahre',
    
    // Additional UI Elements
    seeAll: 'Alle anzeigen',
    seeMore: 'Mehr anzeigen',
    seeLess: 'Weniger anzeigen',
    expand: 'Erweitern',
    collapse: 'Einklappen',
    refresh: 'Aktualisieren',
    retry: 'Wiederholen',
    confirm: 'Bestätigen',
    ok: 'OK',
    done: 'Fertig',
    skip: 'Überspringen',
    continue: 'Weiter',
    finish: 'Beenden',
    start: 'Start',
    stop: 'Stopp',
    pause: 'Pause',
    resume: 'Fortsetzen',
    restart: 'Neustart',
    reset: 'Zurücksetzen',
    clear: 'Löschen',
    remove: 'Entfernen',
    add: 'Hinzufügen',
    update: 'Aktualisieren',
    change: 'Ändern',
    select: 'Auswählen',
    choose: 'Wählen',
    browse: 'Durchsuchen',
    upload: 'Hochladen',
    download: 'Herunterladen',
    share: 'Teilen',
    copy: 'Kopieren',
    paste: 'Einfügen',
    cut: 'Ausschneiden',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinerern',
    fullscreen: 'Vollbild',
    exitFullscreen: 'Vollbild beenden',
    volume: 'Lautstärke',
    mute: 'Stummschalten',
    unmute: 'Stummschaltung aufheben',
    preferences: 'Einstellungen',
    account: 'Konto',
    notifications: 'Benachrichtigungen',
    messages: 'Nachrichten',
    inbox: 'Posteingang',
    sent: 'Gesendet',
    drafts: 'Entwürfe',
    trash: 'Papierkorb',
    archive: 'Archiv',
    starred: 'Markiert',
    important: 'Wichtig',
    unread: 'Ungelesen',
    read: 'Gelesen',
    markAsRead: 'Als gelesen markieren',
    markAsUnread: 'Als ungelesen markieren',
    reply: 'Antworten',
    forward: 'Weiterleiten',
    compose: 'Verfassen',
    send: 'Senden',
    receive: 'Empfangen',
    sync: 'Synchronisieren',
    backup: 'Sicherung',
    restore: 'Wiederherstellen',
    import: 'Importieren',
    export: 'Exportieren',
    print: 'Drucken',
    saveAs: 'Speichern unter',
    open: 'Öffnen',
    new: 'Neu',
    openInNewTab: 'In neuem Tab öffnen',
    openInNewWindow: 'In neuem Fenster öffnen',
    bookmark: 'Lesezeichen',
    unbookmark: 'Lesezeichen entfernen',
    history: 'Verlauf',
    bookmarks: 'Lesezeichen',
    downloads: 'Downloads',
    recent: 'Kürzlich',
    popular: 'Beliebt',
    trending: 'Trending',
    featured: 'Empfohlen',
    recommended: 'Empfohlen',
    suggested: 'Vorgeschlagen',
    related: 'Verwandt',
    similar: 'Ähnlich',
    other: 'Andere',
    more: 'Mehr',
    less: 'Weniger',
    none: 'Keine',
    some: 'Einige',
    few: 'Wenige',
    many: 'Viele',
    most: 'Die meisten',
    least: 'Am wenigsten',
    best: 'Beste',
    worst: 'Schlimmste',
    highest: 'Höchste',
    lowest: 'Niedrigste',
    fastest: 'Schnellste',
    slowest: 'Langsamste',
    newest: 'Neueste',
    oldest: 'Älteste',
    latest: 'Neueste',
    earliest: 'Früheste',
    first: 'Erste',
    last: 'Letzte',
    current: 'Aktuell',
    inactive: 'Inaktiv',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    on: 'An',
    off: 'Aus',
    true: 'Wahr',
    false: 'Falsch',
    maybe: 'Vielleicht',
    unknown: 'Unbekannt',
    pending: 'Ausstehend',
    processing: 'Verarbeitung',
    failed: 'Fehlgeschlagen',
    cancelled: 'Abgebrochen',
    scheduled: 'Geplant',
    overdue: 'Überfällig',
    due: 'Due',
    valid: 'Gültig',
    invalid: 'Ungültig',
    required: 'Erforderlich',
    optional: 'Optional',
    available: 'Verfügbar',
    unavailable: 'Nicht verfügbar',
    online: 'Online',
    offline: 'Offline',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    public: 'Öffentlich',
    private: 'Privat',
    hidden: 'Versteckt',
    visible: 'Sichtbar',
    locked: 'Gesperrt',
    unlocked: 'Entsperrt',
    secure: 'Sicher',
    insecure: 'Insecure',
    verified: 'Verifiziert',
    unverified: 'Nicht verifiziert',
    authenticated: 'Authentifiziert',
    unauthenticated: 'Nicht authentifiziert',
    authorized: 'Autorisiert',
    permitted: 'Erlaubt',
    forbidden: 'Verboten',
    allowed: 'Erlaubt',
    denied: 'Verweigert',
    granted: 'Gewährt',
    revoked: 'Révoqué',
    accepted: 'Akzeptiert',
    rejected: 'Abgelehnt',
    approved: 'Approved',
    disapproved: 'Nicht genehmigt',
    confirmed: 'Bestätigt',
    unconfirmed: 'Nicht bestätigt',
    signed: 'Unterschrieben',
    unsigned: 'Nicht unterschrieben',
    encrypted: 'Verschlüsselt',
    decrypted: 'Entschlüsselt',
    compressed: 'Komprimiert',
    uncompressed: 'Nicht komprimiert',
    archived: 'Archiviert',
    unarchived: 'Nicht archiviert',
    backedUp: 'Gesichert',
    restored: 'Wiederhergestellt',
    imported: 'Importiert',
    exported: 'Exportiert',
    printed: 'Gedruckt',
    saved: 'Gespeichert',
    opened: 'Geöffnet',
    created: 'Erstellt',
    updated: 'Aktualisiert',
    changed: 'Geändert',
    selected: 'Ausgewählt',
    chosen: 'Gewählt',
    browsed: 'Durchsucht',
    uploaded: 'Hochgeladen',
    downloaded: 'Heruntergeladen',
    shared: 'Geteilt',
    copied: 'Kopiert',
    pasted: 'Eingefügt',
    undone: 'Rückgängig gemacht',
    redone: 'Wiederholt',
    zoomedIn: 'Vergrößert',
    zoomedOut: 'Verkleinert',
    fullscreened: 'Vollbild',
    muted: 'Stummgeschaltet',
    unmuted: 'Stummschaltung aufgehoben',
    notified: 'Benachrichtigt',
    messaged: 'Nachricht gesendet',
    replied: 'Geantwortet',
    forwarded: 'Weitergeleitet',
    composed: 'Composé',
    received: 'Reçu',
    synced: 'Synchronisé',
    bookmarked: 'Lesezeichen gesetzt',
    unbookmarked: 'Lesezeichen entfernt',
    openedInNewTab: 'In neuem Tab öffnen',
    openedInNewWindow: 'In neuem Fenster öffnen',

    // Element Creator
    elementCreator: 'Video Ersteller',
    createElement: 'Video erstellen',
    createStep1Title: "Los geht's! Gib ihm einen Namen.",
    elementNamePlaceholder: "z. B. Wie man die Fräsmaschine repariert",
    createStep2Title: "Inhalt hochladen",
    createStep2Sub: "Mach ein Foto/Video oder wähle eines aus der Mediathek.",
    selectMedia: 'Medien auswählen',
    tapToChange: 'Zum Ändern tippen',
    createStep3Title: "Erkläre es",
    createStep3Sub: "Was passiert in diesem Video? HejVi verwandelt dies in eine professionelle Moderation.",
    descPlaceholder: "Beschreibe den Prozess Schritt für Schritt...",
    createStep4Title: "Überprüfen",
    aiProcessingInfo: "Wir komprimieren nun das Video, erstellen aus deiner Beschreibung einen professionellen Sprechertext und übersetzen alles in 10 Sprachen.",
    creatingElement: "Element wird erstellt...",
    videoGenerating: "Video wird generiert, bitte einen Moment warten…",
    videoProcessing: "Video wird fertiggestellt… Der Button wird automatisch freigeschaltet.",
    videoProcessingHint: "Video wird gerade fertiggestellt. Warte noch, um es direkt anzusehen, oder arbeite einfach weiter.",
    pleaseWait: "Das kann eine Minute dauern. Upload und Verarbeitung laufen.",
    elementCreatedSuccess: 'Element erfolgreich erstellt!',
    elementReadyDesc: 'Dein Element wurde erfolgreich erstellt und verarbeitet.',
    viewElement: 'Element jetzt ansehen',
    goToMyCourses: 'Zu meinen Themen',
    elementPendingTitle: 'Dein Video wird geprüft',
    elementPendingDesc: 'Dein Video wurde erfolgreich hochgeladen und wird jetzt kurz von einem Administrator geprüft. In Kürze wird es für alle freigeschaltet.',
    elementPendingHint: 'Du erhältst eine Benachrichtigung, sobald dein Video freigegeben wurde.',
    elementApprovedTitle: 'Dein Video wurde freigegeben!',
    elementApprovedBody: 'Gute Neuigkeit — dein Video „{name}" wurde freigegeben und ist jetzt für alle Nutzer sichtbar.',
    descTooShort: 'Bitte gib eine detaillierte Beschreibung ein (min. 10 Zeichen).',
    invalidFileType: 'Bitte lade ein gültiges Video oder Bild hoch.',
    fileTooLarge: 'Datei ist zu groß. Maximale Größe ist 500MB.',
    media: 'Medien',
    description: 'Beschreibung',
    name: 'Name',
    
    // Course Builder
    courseDetails: 'Themendetails',
    courseName: 'Themenname',
    courseNamePlaceholder: 'z. B. Maschinenwartung',
    courseDescPlaceholder: 'Beschreibe kurz, worum es bei diesem Thema geht...',
    thumbnail: 'Vorschaubild',
    uploadImage: '+ Bild hochladen',
    addElements: 'Elemente hinzufügen',
    searchElements: 'Elemente suchen...',
    loadingElements: 'Lade Elemente...',
    preview: 'Vorschau',
    added: 'Hinzugefügt',
    noElementsFound: 'Keine passenden Elemente gefunden.',
    organizeCourse: 'Thema organisieren',
    dragDropReorder: 'Zum Neuordnen ziehen und ablegen',
    addMoreElements: '+ Mehr Elemente hinzufügen',
    courseCreated: 'Thema erstellt!',
    courseCreatedDesc: 'Dein Thema wurde erfolgreich gespeichert.',
    createAnotherCourse: 'Weiteres Thema erstellen',
    createCourse: 'Thema erstellen',
    addToCourse: 'Zum Thema hinzufügen',
    saving: 'Speichern...',
    noElementsSelected: 'Bitte wähle mindestens ein Element aus',
    errorCreatingCourse: 'Fehler beim Erstellen des Themas',
    authError401: 'Nicht autorisiert (401). Deine Sitzung ist möglicherweise abgelaufen. Bitte erneut anmelden.',
    // ── MyCourses: Filter-Pills, Sektions-Header & Leer-Meldungen ────────
    mc_filter_all:            'Alle',
    mc_filter_courses:        '📚 Meine Kurse',
    mc_filter_videos:         '▶ Meine Videos',
    mc_filter_favorites:      '★ Favoriten',
    mc_status_all:            'Alle Status',
    mc_only_mine:             'Nur meine',
    mc_section_courses_sub:   'Begonnene und abgeschlossene Kurse',
    mc_section_videos:        'Meine Videos',
    mc_section_videos_sub:    'Von dir erstellte Inhalte',
    mc_section_favorites:     'Meine Favoriten',
    mc_section_favorites_sub: 'Gelikte Kurse und Videos',
    mc_empty_courses:         'Du hast noch keinen Kurs gestartet.',
    mc_empty_videos:          'Du hast noch keine eigenen Videos erstellt.',
    mc_empty_favorites:       'Du hast noch keine Inhalte zu deinen Favoriten hinzugefügt.',
    videoRendering:     'Video wird gerendert…',
    videoRenderingHint: 'Das Video wird noch verarbeitet. Es ist gleich verfügbar.',
    // ── AdminPanel: neue i18n-Strings ────────────────────────────────────
    adm_qr_unavailable:         'QR nicht verfügbar — npm install qrcode',
    adm_qr_login_title:         'QR-Code zum Einloggen',
    adm_qr_scan_login_hint:     'Scannen → direkt einloggen ohne PIN-Eingabe',
    adm_qr_permanent_hint:      'Der QR-Code ist dauerhaft im Nutzer-Eintrag abrufbar.',
    adm_qr_print_hint:          'Den PIN jetzt ausdrucken oder sicher übermitteln.',
    adm_msg_subject_placeholder:'z.B. Neue Sicherheitsanweisung verfügbar',
    adm_msg_text_placeholder:   'Nachrichtentext…',
    adm_col_license_type:       'Lizenztyp',
    adm_btn_show_qr:            'QR-Code anzeigen',
    adm_btn_send_msg:           'Nachricht senden',
    adm_login_qr_label:         'Login QR-Code',
    adm_btn_gen_pin:            'Neuen PIN generieren',
    adm_qr_scan_hint:           'Nutzer kann diesen Code scannen, um sich ohne PIN-Eingabe einzuloggen.',
    adm_pin_reset_hint:         'Zum Zurücksetzen des PINs: Speichern schließen und 🔄 PIN zurücksetzen in der Nutzerkarte verwenden.',
    adm_role_supervisor:        'Supervisor',
    adm_role_admin_opt:         'Admin',
    adm_role_superadmin:        'Super Admin',
    adm_seat_essentials_desc:   'Essentials – alle Features außer Content-Erstellung',
    adm_pin_force_change:       'PIN-Änderung bei erstem Login erzwingen',
    adm_btn_msg_group:          'Nachricht an Gruppe',
    adm_btn_show:               'Anzeigen',
    adm_btn_unlock:             'Element freischalten',
    adm_btn_show_assigned:      'Zugeordnete Inhalte anzeigen',
    adm_no_videos_assigned:     'Keine Videos zugeordnet. Klicke auf „+ Video hinzufügen".',
    adm_drag_sort:              'Ziehen zum Sortieren',
    adm_search_video:           'Video suchen…',
    adm_no_videos:              'Keine Videos gefunden.',
    adm_video_unassigned:       'Dieses Video ist keinem Inhalt zugeordnet.',
    adm_search_messages:        'Nachrichten durchsuchen…',
    adm_btn_reload:             'Neu laden',
    adm_enriching:              'Anreicherung läuft…',
    adm_no_video_chunks:        'Keine Videos mit Transkript-Chunks gefunden',
    adm_ki_enrichment:          'KI-Anreicherung',
    adm_col_updated:            'Aktualisiert',
    adm_search_docs:            'Dokument oder Element suchen…',
    adm_no_docs:                'Keine Dokumente vorhanden',
    adm_col_size:               'Größe',
    adm_search_questions:       'Fragen durchsuchen…',
    adm_label_question:         'Frage des Mitarbeiters',
    adm_label_answer:           'Antwort',
    adm_btn_upload_doc:         'Dokument hochladen',
    adm_just_moment:            'Einen Moment bitte',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Nur Admins können das Domänen-Profil bearbeiten.',
    adm_primary_lang:           'Primäre Arbeitssprache',
    adm_drop_doc:               'Dokument hier ablegen oder klicken',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Bestehende Unternehmens-Dokumente',
    adm_company_docs_empty:     'Noch keine Unternehmens-Dokumente hochgeladen.',
    adm_no_licence:             'Keine Lizenzdaten verfügbar.',
    adm_full_seats_label:       '⭐ Full-Seats (inkl. Content-Erstellung)',
    adm_essentials_seats_label: 'Essentials-Seats',
    adm_valid_until:            'Gültig bis',
    adm_base_lang:              'Stammsprache',
    adm_active_ui_langs:        'Aktive UI-Sprachen',
    adm_tts_langs:              'TTS-Sprachen',
    adm_full_seats_total_label: '⭐ Full-Seats gesamt',
    adm_essentials_total_label: 'Essentials-Seats gesamt',
    adm_ui_langs_field:         'UI-Sprachen (aktive App-Sprachen)',
    adm_tts_langs_field:        'TTS-Sprachen (Text-to-Speech)',
    adm_config_title:           'Konfiguration',
    adm_config_desc:            'Plattform-Einstellungen für diesen Mandanten. Änderungen sind sofort wirksam.',
    adm_supervisor_mode:        'Supervisor-Modus',
    adm_warning_no_admin:       '⚠️ Achtung: Es gibt derzeit keinen aktiven User mit Supervisor- oder Admin-Rolle (Group 2 oder 3). Bei aktiviertem Supervisor-Modus können Elemente nicht freigegeben werden. Bitte zuerst mindestens einen User auf Supervisor- oder Admin-Rolle setzen.',
    adm_std_delete_toggle:      'Standard-User: Videos löschen & deaktivieren',
    adm_std_course_toggle:      'Standard-User: Kurse & Quizze erstellen',
    adm_supervisor_confirm_title: 'Supervisor-Modus aktivieren?',
    adm_btn_activate:           'Aktivieren',
    adm_admin_only_setting:     'Nur Tenant-Administratoren (Gruppe 3) oder Super-Admins können diese Einstellung ändern.',
    adm_only_admins_edit:       'Nur Administratoren können diese Einstellung ändern.',
  },
  
  nl: {
    // Common
    // --- Script / Moderatie Selectie ---
    // --- Missing Keys Update ---
    // --- Document Chat ---
    chatGreeting: 'Hej! Ik help je graag verder. Wat wil je weten?',
    chatSubtitle: 'Vraag over document',
    chatButton: 'Vragen',
    chatPlaceholder: 'Stel een vraag over het document …',
    chatClear: 'Chat wissen',
    chatSuggestion1: 'Vat het document samen',
    chatSuggestion2: 'Wat zijn de belangrijkste punten?',
    chatSuggestion3: 'Welke vereisten worden genoemd?',
    chatErrorNotAuthenticated: 'Niet ingelogd. Log a.u.b. opnieuw in.',
    chatErrorNoAnswer: 'Geen antwoord ontvangen.',
    chatErrorGeneric: 'Fout',
    // --- Global Chat Widget ---
    globalChatTitle: 'Kennisassistent',
    globalChatSubtitle: 'Alle documenten & video\'s',
    globalChatFab: 'Vraag alles',
    globalChatGreeting: 'Hej! Ik kan je helpen met vragen over al je documenten en video\'s. Wat wil je weten?',
    globalChatPlaceholder: 'Stel een vraag over al je inhoud …',
    globalSuggestion1: 'Wat zeggen mijn documenten over veiligheidseisen?',
    globalSuggestion2: 'Vat alle beschikbare inhoud samen',
    globalSuggestion3: 'Welke video\'s behandelen dit onderwerp?',
    sourcesUsed: 'Bronnen',
    sourceDocument: 'Document',
    sourceVideo: 'Video',
    goToElement: 'Element openen →',
    goToVideo: 'Video bekijken →',
    createdOn: 'Aangemaakt op',
    pleaseSelectDocument: 'Selecteer een document (PDF, TXT of DOC).',
    selectDocument: 'Document selecteren',
    photoVideo: 'Foto / Video',
    document: 'Document',
    replaceFile: 'Vervangen',
    removeFile: 'Verwijderen',
    documentTypeDefault: 'Document',
    invalidDocumentType: 'Upload een geldig bestand: PDF, TXT, DOC/DOCX of PPT/PPTX.',
    documentTooLarge: 'Bestand is te groot. Maximaal {mb} MB toegestaan.',
    documentAiInfo: 'De AI extraheert automatisch de inhoud, maakt een korte samenvatting (1-2 zinnen) als voice-over en gebruikt de eerste pagina als miniatuur.',
    documentModeActive: 'Documentmodus actief',
    documentModeDesc: 'De AI gebruikt de inhoud van uw document automatisch als videotekst. U kunt context toevoegen of het leeg laten.',
    docAdditionalContextPlaceholder: 'Optionele extra context (bijv. doelgroep, focusgebied)...',
    optionLabel: 'Optie',
    aiOptionLabel: 'AI Optie',
    autoGeneratedFromDoc: 'Automatisch gegenereerd uit document',
    documentAutoProcess: 'AI extraheert inhoud en maakt samenvatting als videotekst.',
    aiDocProcessingInfo: 'We analyseren het document, genereren een samenvatting als voice-over en maken een video met de eerste pagina als miniatuur.',
    viewDocument: 'Bekijken',
    downloadDocument: 'Downloaden',
    responseVideoNotFound: 'Antwoordvideo niet gevonden',
    responseVideoNotReady: 'De antwoordvideo voor deze uitdaging bestaat nog niet.',
    unknownQRCodeTitle: 'Onbekende QR-code',
    unknownQRCodeQuestion: 'Hoe wilt u verdergaan?',
    unknownQRCodeCreateCollection: 'Nieuwe collectie maken',
    addVideo: 'Video toevoegen',
    pleaseSelectMedia: 'Selecteer een video of foto.',
    originalText: 'Origineel',
    printQRLabel: '🖨️ QR-label afdrukken',
    printerConnecting: '🔵 Printer verbinden...',
    printerPrinting: '⏳ Bezig met afdrukken...',
    printerDone: '✅ Afgedrukt!',
    printerError: '❌ Fout – Probeer opnieuw',
    bluetoothHint: 'Verbindt via Bluetooth – selecteer Niimbot B1 uit de lijst',
    printerErrorHint: 'Printer ingeschakeld? Alleen Chrome/Edge ondersteunen Web Bluetooth.',
    number_of_views: 'Weergaven',
    number_of_likes: 'Vind-ik-leuks',
    qrCode: 'QR-code',
    printQrCode: 'QR-code afdrukken',
    playFrom: 'Afspelen vanaf',
    voiceSearchSummary: '{collections} collecties, {elements} elementen',
    pleaseLoginFirst: 'Log eerst in om QR-codes te scannen',
    openingUrl: 'URL openen...',
    eanNotFound: 'Geen item gevonden met deze EAN',
    sessionExpired: 'Je sessie is verlopen. Log opnieuw in.',
    recordingTooShort: "Opname te kort",
    errorNoSpeechDetected: "Geen spraak gedetecteerd. Spreek luider of kom dichter bij de microfoon.",
    errorTranscriptionFailed: "Kon audio niet verstaan. Probeer het opnieuw en spreek duidelijk.",
    reactionVideo: 'Reactievideo?',
    setThisToReaction: 'Markeert dit element als antwoordvideo (Content Type 4).',
    selectModeration: 'Kies de bijpassende tekst',
    selectModerationDesc: 'De AI heeft de volgende tekstsuggesties gedaan op basis van je beschrijving:',
    generatingScripts: 'Teksten worden gegenereerd...',
    nothingFits: 'Niets past',
    backToDesc: 'Terug naar beschrijving',
    selectedModeration: 'Geselecteerde moderatie',
    maxRetriesReached: 'Verfijn je beschrijving. Geen verdere pogingen mogelijk.',
    errorLoadingScripts: 'Fout bij laden suggesties. Controleer je internetverbinding of log opnieuw in.',

    challenge: 'Uitdaging',
    thinking: 'Nadenken...',
    aiSuggest: 'Hejvi AI-suggesties',
    aiNoSuggestions: 'De AI kon geen specifieke elementen vinden. Alles wordt getoond.',
    showAll: 'Alles tonen',
    totalXp: 'Totaal XP',
    createVideoElement: 'Video maken',
    createQuizElement: 'Quiz maken',
    orSelectExisting: 'Of selecteer bestaande elementen:',
    organize: 'Verplaats video\'s om de volgorde te wijzigen',
    viewCourse: 'Cursus bekijken',
    filterMyContent: 'Alleen mijn inhoud',
    makeVisible: 'Zichtbaar maken',
    makeInvisible: 'Verbergen',
    selectCorrectAnswer: 'Selecteer het juiste antwoord',
    selectCorrectAnswerDesc: 'Welke optie is de juiste oplossing?',
    QuizExampleQrHash: 'bijv. el-32hhuz3',
    pleaseEnterQuestion: 'Voer een vraag of titel in.',
    typeYesNo: 'Ja / Nee',
    typeQR: 'QR Scan',
    typeMulti: 'Meerkeuze',
    QuizQuestionPlaceholder: 'bijv. Is deze veiligheidsuitrusting correct?',
    QuizDescriptionPlaceholder: 'Optionele beschrijving...',
    quizCreatedSuccess: 'Quiz succesvol aangemaakt!',
    yes: 'Ja',
    no: 'Nee',
    correct: 'Correct',
    incorrect: 'Incorrect',
    submit: 'Versturen',
    next: 'Volgende',
    back: 'Terug',
    cancel: 'Annuleren',
    create: 'Aanmaken',
    error: 'Fout',
    success: 'Succes',
    save: 'Opslaan',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    close: 'Sluiten',
    previous: 'Vorige',
    loading: 'Laden...',

    // --- Quiz Builder ---
    createQuiz: 'Quiz aanmaken',
    configureQuiz: 'Quiz configureren',
    selectType: 'Type selecteren',
    selectResponses: 'Antwoordvideo\'s selecteren',
    selectResponsesDesc: 'Selecteer de video\'s die worden afgespeeld na het antwoord van de gebruiker.',
    question: 'Vraag',
    enableHint: 'Hint inschakelen?',
    hintNotAvailableQR: 'Hints zijn uitgeschakeld voor QR-code uitdagingen.',

    // QR
    qrTargetTitle: 'QR-code Doel',
    qrTargetDesc: 'Welke tekst/code zit verborgen in de QR-code?',
    qrValueLabel: 'QR Inhoud (Exact)',
    qrErrorEmpty: 'Voer de QR-code waarde in.',

    // Review
    reviewQuiz: 'Samenvatting',
    reviewDesc: 'Controleer je instellingen voordat je de quiz aanmaakt.',

    // Validatie
    pleaseEnterName: 'Voer een naam in.',
    errorSelectCorrect: 'Selecteer het juiste antwoord.',
    errorOptionMissing: 'Vul optie in', 
    selectBothResponses: 'Selecteer beide antwoordvideo\'s.',

    // Success
    backToDashboard: 'Terug naar dashboard',
    createAnother: 'Nog een maken',
    scanToStart: 'Scannen om te starten',
    elementCreator: 'Video Maker',
    createElement: 'Video aanmaken',
    createStep1Title: "Laten we beginnen! Geef het een naam.",
    elementNamePlaceholder: "bijv. Hoe de freesmachine te repareren",
    createStep2Title: "Upload je inhoud",
    createStep2Sub: "Maak een foto/video of upload uit de bibliotheek.",
    selectMedia: 'Media selecteren',
    tapToChange: 'Tik om te wijzigen',
    createStep3Title: "Leg het uit",
    createStep3Sub: "Wat gebeurt er in deze video? Onze AI maakt hier een professionele vertelling van.",
    descPlaceholder: "Beschrijf het proces stap voor stap...",
    createStep4Title: "Beoordeling",
    aiProcessingInfo: "We comprimeren nu de video, genereren een professionele voice-over van je beschrijving en vertalen alles in 10 talen.",
    creatingElement: "Element aanmaken...",
    videoGenerating: "Video wordt gegenereerd, even geduld a.u.b.…",
    videoProcessing: "Video wordt afgerond… De knop wordt automatisch ingeschakeld.",
    videoProcessingHint: "De video wordt nog verwerkt. Wacht even om deze direct te bekijken, of werk gewoon verder.",
    pleaseWait: "Dit kan een minuut duren. Uploaden en verwerken van AI-taken.",
    elementCreatedSuccess: 'Element succesvol aangemaakt!',
    elementReadyDesc: 'Je element is succesvol aangemaakt en verwerkt.',
    viewElement: 'Bekijk element nu',
    goToMyCourses: 'Naar mijn cursussen',
    elementPendingTitle: 'Je video wordt beoordeeld',
    elementPendingDesc: 'Je video is succesvol geüpload en wordt nu door een beheerder beoordeeld. Het zal binnenkort voor iedereen zichtbaar zijn.',
    elementPendingHint: 'Je ontvangt een melding zodra je video is goedgekeurd.',
    elementApprovedTitle: 'Je video is goedgekeurd!',
    elementApprovedBody: 'Goed nieuws — je video "{name}" is goedgekeurd en nu zichtbaar voor alle gebruikers.',
    descTooShort: 'Geef een gedetailleerde beschrijving (min. 10 tekens).',
    invalidFileType: 'Upload een geldige video of afbeelding.',
    fileTooLarge: 'Bestand is te groot. Maximale grootte is 500MB.',
    media: 'Media',
    description: 'Beschrijving',
    name: 'Naam',
    
    // Extra Tags
    useExactTextTitle: 'Exacte tekst gebruiken',
    useExactTextDesc: 'Sla AI-optimalisatie over en lees beschrijving 1:1.',
    transcribeVideoTitle: 'Videogeluid als voiceover gebruiken',
    transcribeVideoDesc: 'De gesproken tekst wordt getranscribeerd. Gebruik als 1:1 voiceover (gesynchroniseerd) of laat de AI een geoptimeerd script maken.',
    transcribeVideo: 'Transcriberen',
    transcribing: 'Transcriberen...',
    transcriptAdopted: 'Videogeluid overgenomen als voiceover',
    resetTranscript: 'Transcript verwijderen',
    transcriptionFailed: 'Transcriptie mislukt.',
    transcribeExactInfo: 'De gesproken tekst wordt 1:1 getranscribeerd en als voiceover gebruikt. Ondertitels blijven synchroon met de originele video.',
    transcribeLLMInfo: 'De gesproken tekst wordt getranscribeerd. De AI maakt een geoptimeerd voiceover-script in de gedetecteerde videotaal.',
    transcribeExactToggleDesc: 'Transcript 1:1 gebruiken als voiceover (gesynchroniseerd met video). Uit: AI maakt geoptimeerd script van het transcript.',
    loginWithQRCode: 'Login with QR Code',
    search: 'Zoeken',
    filter: 'Filter',
    all: 'Alle',
    
    // Navigation
    home: 'Home',
    challenges: 'Uitdagingen',
    favorites: 'Favorieten',
    profile: 'Profiel',
    myCourses: 'Mijn Cursussen',
    
    // Dashboard
    welcome: 'Welkom terug! 👋',
    searchPlaceholder: 'Inhoud doorzoeken…',
    mustSee: 'Must-See',
    safety: 'Veiligheid',
    tools: 'Gereedschap',
    law: 'Wet',
    mandatory: 'Verplicht',
    mandatoryFilter: 'Verplichte cursussen',
    mandatoryCourses: 'Verplichte cursussen',
    favourites: 'Favorieten',
    favouritesFilter: 'Favorieten',
    loadMore: 'Meer laden',
    play: 'Afspelen',
    favorite: 'Favoriet',
    unfavorite: 'Niet meer favoriet',
    
    // Login
    login: 'Inloggen',
    enterPin: 'Voer PIN in',
    invalidPin: 'Voer een geldige 8-cijferige PIN in',
    loginError: 'Ongeldige PIN. Probeer het opnieuw.',
    wrongPin: 'Verkeerde PIN. Probeer het opnieuw.',
    loginSuccess: 'Inloggen succesvol! Welkom terug! 🎉',
    
    // Profile
    myProfile: 'Mijn Profiel',
    myProgress: 'Mijn Voortgang',
    contactSupport: 'Support Contacten',
    language: 'Taal',
    settings: 'Instellingen',
    privacy: 'Privacy',
    help: 'Help',
    logout: 'Uitloggen',
    active: 'Actief',
    beginner: 'Beginner',
    intermediate: 'Gevorderd',
    advanced: 'Expert',
    joined: 'Toegetreden',
    courses: 'Cursussen',
    completed: 'Voltooid',
    inProgress: 'In Uitvoering',
    achievements: 'Prestaties',
    topLearner: 'Top Leerling',
    safetyStar: 'Veiligheids-Star',
    firstSteps: 'Eerste Stappen',
    learner: 'Leerling',
    group: 'Groep',
    client: 'Klant',
    
    // Contact Form
    yourName: 'Uw Naam',
    emailAddress: 'E-mailadres',
    describeIssue: 'Beschrijf uw probleem...',
    sendMessage: 'Bericht Versturen',
    messageSent: 'Bericht succesvol verzonden!',
    
    // Course/Video
    startCourse: 'Cursus Starten',
    continueCourse: 'Cursus Voortzetten',
    courseProgress: 'Cursusvoortgang',
    videoProgress: 'Videovoortgang',
    stepsInThisVideo: 'Stappen in deze video',
    relatedVideos: 'Gerelateerde video\'s',
    duration: 'Duur',
    experiencePoints: 'Ervaringspunten',
    levelComplexity: 'Moeilijkheidsgraad',
    lessons: 'Lessen',
    nextLessonStartsIn: 'Volgende les start in',
    nextVideoIn: 'Volgende video in',
    seconds: 's',
    replay: 'Opnieuw afspelen',
    cancelAutoplay: 'Auto-play annuleren',
    loadingCourses: 'Cursussen laden...',
    noCourses: 'Geen cursussen beschikbaar',
    searchCourses: 'Cursussen zoeken...',
    noResults: 'Geen cursussen gevonden',
    workplaceSafety: 'Basisprincipes Arbeidsveiligheid',
    workplaceSafetyDesc: 'Essentiële veiligheidsprotocollen voor de werkplek',
    
    // Challenges
    allChallenges: 'Alle Uitdagingen',
    currentChallenges: 'Huidige Uitdagingen',
    challengeProgress: 'Uitdagingsvoortgang',
    challengeEnds: 'Uitdaging eindigt',
    daysLeft: 'dagen over',
    hoursLeft: 'uur over',
    minutesLeft: 'minuten over',
    loadingChallenges: 'Uitdagingen laden...',
    activeChallenges: 'Actieve Uitdagingen',
    weeklyProgress: 'Voortgang',
    noChallenges: 'Momenteel geen uitdagingen beschikbaar.',
    startNow: 'Nu Starten',
    discoverMore: 'Meer Uitdagingen Ontdekken',
    stayMotivated: 'Blijf gemotiveerd & verdien beloningen!',
    doneChallenges: 'gedaan',
    challengesProgressLabel: 'Voortgang Uitdagingen',
    mandatoryProgressLabel: 'Voortgang Verplichte cursussen',
    doneMandatory: 'verplichte cursussen voltooid',
    completeChallengesEarnXP: 'Voltooi uitdagingen om XP te verdienen!',
    noDeadline: 'Geen deadline',
    failedToLoadChallenges: 'Uitdagingen konden niet worden geladen',
    expired: 'Verlopen',
    lessThan1hLeft: 'Minder dan 1u over',
    expert: 'Expert',
    
    // QR Scanner
    scanQR: 'QR-Code scannen',
    scanPlaceholder: 'Richt camera op QR-code',
    scanSuccess: 'QR-code succesvol gescand!',
    scanError: 'QR-code kon niet worden gescand',
    cameraError: 'Cameratoegang geweigerd',
    cameraPermission: 'Geef toegang tot camera',
    cameraPermissionDenied: 'Cameratoegang geweigerd. Geef toegang tot camera.',
    noCameraFound: 'Geen camera gevonden. Controleer uw apparaat.',
    cameraNotSupported: 'Camera wordt niet ondersteund in deze browser.',
    cameraInUse: 'Camera wordt gebruikt door een andere applicatie.',
    cameraConstraintsNotMet: 'Camera beperkingen niet voldaan. Probeer een andere camera.',
    failedToStartCamera: 'Camera kon niet worden gestart',
    failedToAccessCamera: 'Camera toegang mislukt. Controleer uw browser machtigingen.',
    onlyOneCameraAvailable: 'Slechts één camera beschikbaar op dit apparaat',
    noSuitableCameraFound: 'Geen geschikte camera gevonden om te wisselen',
    failedToSwitchCamera: 'Camera wisselen mislukt',
    cameraSwitchFailed: 'Camera wisselen mislukt',
    unableToReadCodeFromImage: 'Code kon niet uit afbeelding worden gelezen',
    errorAccessingCamera: 'Fout bij toegang tot camera',
    tryAgain: 'Opnieuw proberen',
    switchingCamera: 'Camera wisselen...',
    gallery: 'Galerij',
    flash: 'Flits',
    switchCamera: 'Camera wisselen',
    capture: 'Vastleggen',
    
    // Voice Recording
    voiceSearch: 'Spraakzoeken',
    tapToStartRecording: 'Tik om opname te starten',
    speakYourSearchQuery: 'Spreek je zoekopdracht duidelijk uit',
    startRecording: 'Opname starten',
    stopRecording: 'Opname stoppen',
    recording: 'Opname...',
    processingAudio: 'Audio verwerken...',
    transcript: 'Transcript',
    closingOverlay: 'Overlay sluiten en zoekresultaten tonen...',
    searchAgain: 'Opnieuw zoeken',
    
    // Errors
    networkError: 'Netwerkfout. Controleer uw verbinding.',
    serverError: 'Serverfout. Probeer het later opnieuw.',
    unauthorized: 'Niet geautoriseerd. Log opnieuw in.',
    notFound: 'Inhoud niet gevonden.',
    generalError: 'Er is een onverwachte fout opgetreden.',
    
    // Time
    today: 'Vandaag',
    yesterday: 'Gisteren',
    thisWeek: 'Deze Week',
    thisMonth: 'Deze Maand',
    ago: 'geleden',
    minutes: 'minuten',
    hours: 'uur',
    days: 'dagen',
    weeks: 'weken',
    months: 'maanden',
    years: 'jaren',

    // Course Builder
    courseDetails: 'Cursusdetails',
    courseName: 'Cursusnaam',
    courseNamePlaceholder: 'bijv. machineonderhoud',
    courseDescPlaceholder: 'Beschrijf kort waar deze cursus over gaat...',
    thumbnail: 'Miniatuurafbeelding',
    uploadImage: '+ Afbeelding uploaden',
    addElements: 'Elementen toevoegen',
    searchElements: 'Elementen zoeken...',
    loadingElements: 'Elementen laden...',
    preview: 'Voorbeeld',
    added: 'Toegevoegd',
    noElementsFound: 'Geen overeenkomende elementen gevonden.',
    organizeCourse: 'Cursus organiseren',
    dragDropReorder: 'Sleep om te herschikken',
    addMoreElements: '+ Meer elementen toevoegen',
    courseCreated: 'Cursus aangemaakt!',
    courseCreatedDesc: 'Je collectie is succesvol opgeslagen.',
    createAnotherCourse: 'Nog een cursus maken',
    createCourse: 'Cursus aanmaken',
    addToCourse: 'Aan cursus toevoegen',
    saving: 'Opslaan...',
    noElementsSelected: 'Selecteer ten minste één element',
    authErrorTokenMissing: 'Authenticatiefout: Geen token gevonden. Herlaad of log opnieuw in.',
    errorCreatingCourse: 'Fout bij aanmaken cursus',
    authError401: 'Niet geautoriseerd (401). Je sessie is mogelijk verlopen. Log opnieuw in.',
    // ── Meldingssysteem ───────────────────────────────────────────────────
    adm_notifications:          'Berichten',
    notif_type_new_content:     'Nieuwe inhoud',
    notif_type_message:         'Bericht',
    notif_goto_collection:      'Naar collectie',
    notif_dismiss_all:          'Alles sluiten',
    notif_just_now:             'Zojuist',

    // ── MyCourses: filterpillen, sectiekopjes & lege meldingen ──────────
    mc_filter_all:            'Alle',
    mc_filter_courses:        "📚 Mijn Cursussen",
    mc_filter_videos:         "▶ Mijn Video's",
    mc_filter_favorites:      '★ Favorieten',
    mc_status_all:            'Alle statussen',
    mc_only_mine:             'Alleen de mijne',
    mc_section_courses_sub:   'Gestarte en voltooide cursussen',
    mc_section_videos:        "Mijn Video's",
    mc_section_videos_sub:    'Door jou gemaakt content',
    mc_section_favorites:     'Mijn Favorieten',
    mc_section_favorites_sub: "Gelikte cursussen en video's",
    mc_empty_courses:         'Je hebt nog geen cursus gestart.',
    mc_empty_videos:          "Je hebt nog geen eigen video's gemaakt.",
    mc_empty_favorites:       'Je hebt nog geen inhoud aan je favorieten toegevoegd.',
    videoRendering:     'Video wordt gerenderd…',
    videoRenderingHint: 'De video wordt nog verwerkt. Het is binnenkort beschikbaar.',
    // ── AdminPanel: nieuwe i18n-strings ──────────────────────────────────
    adm_qr_unavailable:         'QR niet beschikbaar — npm install qrcode',
    adm_qr_login_title:         'QR-code voor inloggen',
    adm_qr_scan_login_hint:     'Scannen → direct inloggen zonder PIN',
    adm_qr_permanent_hint:      'De QR-code is permanent beschikbaar in de gebruikersinvoer.',
    adm_qr_print_hint:          'Druk de PIN nu af of verstuur hem veilig.',
    adm_msg_subject_placeholder:'bijv. Nieuwe veiligheidsinstructie beschikbaar',
    adm_msg_text_placeholder:   'Berichttekst…',
    adm_col_license_type:       'Licentietype',
    adm_btn_show_qr:            'QR-code weergeven',
    adm_btn_send_msg:           'Bericht versturen',
    adm_login_qr_label:         'Login QR-code',
    adm_btn_gen_pin:            'Nieuwe PIN genereren',
    adm_qr_scan_hint:           'Gebruiker kan deze code scannen om in te loggen zonder PIN.',
    adm_pin_reset_hint:         'Om de PIN te resetten: sluit dit venster en gebruik 🔄 PIN resetten in de gebruikerskaart.',
    adm_role_supervisor:        'Supervisor',
    adm_role_admin_opt:         'Admin',
    adm_role_superadmin:        'Super Admin',
    adm_seat_essentials_desc:   'Essentials – alle functies behalve het maken van content',
    adm_pin_force_change:       'PIN-wijziging verplichten bij eerste inlog',
    adm_btn_msg_group:          'Bericht aan groep',
    adm_btn_show:               'Weergeven',
    adm_btn_unlock:             'Element vrijgeven',
    adm_btn_show_assigned:      'Toegewezen inhoud weergeven',
    adm_no_videos_assigned:     'Geen video\'s toegewezen. Klik op "+ Video toevoegen".',
    adm_drag_sort:              'Slepen om te sorteren',
    adm_search_video:           'Video zoeken…',
    adm_no_videos:              'Geen video\'s gevonden.',
    adm_video_unassigned:       'Deze video is niet aan inhoud gekoppeld.',
    adm_search_messages:        'Berichten doorzoeken…',
    adm_btn_reload:             'Opnieuw laden',
    adm_enriching:              'Verrijking loopt…',
    adm_no_video_chunks:        'Geen video\'s met transcriptfragmenten gevonden',
    adm_ki_enrichment:          'AI-verrijking',
    adm_col_updated:            'Bijgewerkt',
    adm_search_docs:            'Document of element zoeken…',
    adm_no_docs:                'Geen documenten beschikbaar',
    adm_col_size:               'Grootte',
    adm_search_questions:       'Vragen doorzoeken…',
    adm_label_question:         'Vraag van de medewerker',
    adm_label_answer:           'Antwoord',
    adm_btn_upload_doc:         'Document uploaden',
    adm_just_moment:            'Een ogenblik geduld',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Alleen admins kunnen het domeinprofiel bewerken.',
    adm_primary_lang:           'Primaire werktaal',
    adm_drop_doc:               'Document hier neerzetten of klikken',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Bestaande bedrijfsdocumenten',
    adm_company_docs_empty:     'Nog geen bedrijfsdocumenten geüpload.',
    adm_no_licence:             'Geen licentiegegevens beschikbaar.',
    adm_full_seats_label:       '⭐ Full Seats (incl. contentcreatie)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'Geldig tot',
    adm_base_lang:              'Basistaal',
    adm_active_ui_langs:        'Actieve UI-talen',
    adm_tts_langs:              'TTS-talen',
    adm_full_seats_total_label: '⭐ Full Seats totaal',
    adm_essentials_total_label: 'Essentials Seats totaal',
    adm_ui_langs_field:         'UI-talen (actieve apptalen)',
    adm_tts_langs_field:        'TTS-talen (tekst-naar-spraak)',
    adm_config_title:           'Configuratie',
    adm_config_desc:            'Platforminstellingen voor deze tenant. Wijzigingen zijn direct van kracht.',
    adm_supervisor_mode:        'Supervisormodus',
    adm_warning_no_admin:       '⚠️ Let op: Er is momenteel geen actieve gebruiker met Supervisor- of Adminrol (Groep 2 of 3).',
    adm_std_delete_toggle:      'Standaardgebruikers: video\'s verwijderen & deactiveren',
    adm_std_course_toggle:      'Standaardgebruikers: cursussen & quizzen maken',
    adm_supervisor_confirm_title: 'Supervisormodus activeren?',
    adm_btn_activate:           'Activeren',
    adm_admin_only_setting:     'Alleen tenant-beheerders (Groep 3) of Super Admins kunnen deze instelling wijzigen.',
    adm_only_admins_edit:       'Alleen beheerders kunnen deze instelling wijzigen.',
  },
  
  fr: {
    // --- Général ---
    // --- Sélection de Script / Modération ---
    // Französisch (fr)
      assignToGeneral: 'Ajouter au groupe général',
  assignToGeneralOn: 'Le contenu sera visible par tous les membres du groupe par défaut après sa création.',
  assignToGeneralOff: '⚠ Attention : Ce contenu ne sera pas visible par le grand public. Il ne sera accessible qu\'aux administrateurs et au créateur.',
    videoRenderingBackground: 'La vidéo est en cours de rendu en arrière-plan – vous pourrez continuer dans un instant.',
    manyPagesHint: 'Le document contient {count} pages – l\'analyse prendra un peu plus de temps.',
    analyzingPages: 'Analyse des pages en cours…',
    notif_goto_adminpanel:    'Ouvrir le panneau admin',
    notif_type_new_question:  'Nouvelle question',
    notif_title:         'Notifications',
    notif_back:          'Retour',
    notif_loading:       'Chargement…',
    notif_empty:         'Aucun message disponible',
    notif_just_now:          'À l\'instant',
    notif_type_message:      'Message admin',
    notif_type_new_content:  'Nouveau contenu',
    notif_goto_collection:   'Voir la collection',
    notif_goto_document:     'Voir le document',
    notif_open_document:     'Ouvrir le document',
    notif_goto_fraghejvi:    'Ouvrir FragHejVi',
    notif_close:             'Fermer',
    notif_dismiss_all:       'Tout fermer',
    adminArea: 'Espace admin',
    adm_pin_format_hint:    'Exactement 8 caractères : lettres et chiffres',
    adm_pin_format_error:   'Le PIN doit contenir exactement 8 caractères alphanumériques.',
    adm_subtitle:          'Gestion HejVi',
    adm_access_denied:     'Accès refusé',
    adm_access_denied_desc:'Vous n\'avez pas l\'autorisation d\'accéder à cette zone.',
    adm_back:              'Retour',
    adm_users:             'Utilisateurs',
    adm_groups:            'Groupes',
    adm_videos:            'Vidéos',
    adm_topics:            'Thèmes',
    adm_video_sg:          'Vidéo',
    adm_topic_sg:          'Thème',
    adm_docs:              'Documents & Base de connaissances',
    adm_open_video:        'Ouvrir la vidéo dans un nouvel onglet',
    adm_open_doc:          'Ouvrir le document dans un nouvel onglet',
    adm_open_element:      "Ouvrir l'élément dans un nouvel onglet",
    adm_stat_users:        'Utilisateurs total',
    adm_stat_active:       'Utilisateurs actifs',
    adm_members:           'Membres',
    adm_content:           'Contenu',
    adm_name:              'Nom',
    adm_status:            'Statut',
    adm_role:              'Rôle',
    adm_role_standard:     'Standard',
    adm_created:           'Créé',
    adm_actions:           'Actions',
    adm_preview:           'Aperçu',
    adm_active:            'Actif',
    adm_inactive:          'Inactif',
    adm_edit:              'Modifier',
    adm_delete:            'Supprimer',
    adm_new_user:          'Nouvel utilisateur',
    adm_new_group:         'Nouveau groupe',
    adm_edit_user:         'Modifier l\'utilisateur',
    adm_edit_group:        'Modifier le groupe',
    adm_create:            'Créer',
    adm_save:              'Enregistrer',
    adm_save_translate:    'Enregistrer & traduire',
    adm_translating:       'Traduction…',
    adm_cancel:            'Annuler',
    adm_done:              'Terminé',
    adm_confirm:           'Sûr ?',
    adm_yes:               'Oui',
    adm_no:                'Non',
    adm_mandatory:         'Obligatoire',
    adm_description:       'Description',
    adm_rights_level:      'Niveau de droits',
    adm_lang_id:           'Langue',
    adm_client_id:         'Client',
    adm_pin_change:        'Modifier le PIN (laisser vide = inchangé)',
    adm_pin_hint:          'Au moins 4 caractères',
    adm_pin_change_hint:   'Laisser vide pour ne pas changer',
    adm_groups_for:        'Groupes pour',
    adm_groups_assign_hint:'Assigner ou retirer des groupes',
    adm_content_for_group: 'Contenu pour le groupe',
    adm_content_visible_hint: 'Ce contenu est visible par les groupes suivants :',
    adm_assigned:          'Attribué',
    adm_add:               'Ajouter',
    adm_remove:            'Retirer',
    adm_assign:            'Attribuer',
    adm_search_hint:       'rechercher',
    adm_no_users:          'Aucun utilisateur trouvé',
    adm_no_groups:         'Aucun groupe disponible',
    adm_no_entries:        'Aucune entrée trouvée',
    adm_no_content:        'Aucun contenu trouvé',
    adm_toast_deleted:     'Supprimé',
    adm_toast_created:     'Créé',
    adm_toast_saved:       'Enregistré',
    adm_toast_deactivated: 'Désactivé',
    adm_toast_removed:     'Retiré du groupe',
    adm_toast_added:       'Ajouté au groupe',
    adm_toast_error:       'Une erreur s\'est produite',
    adm_toast_load_error:  'Erreur de chargement',
    // --- Document Chat ---
    chatGreeting: 'Hej ! Je suis là pour vous aider. Que voulez-vous savoir ?',
    chatSubtitle: 'Interroger le document',
    chatButton: 'Questions',
    chatPlaceholder: 'Posez une question sur le document …',
    chatClear: 'Effacer le chat',
    chatSuggestion1: 'Résumer le document',
    chatSuggestion2: 'Quels sont les points clés ?',
    chatSuggestion3: 'Quelles sont les exigences mentionnées ?',
    chatErrorNotAuthenticated: 'Non authentifié. Veuillez vous reconnecter.',
    chatErrorNoAnswer: 'Aucune réponse reçue.',
    chatErrorGeneric: 'Erreur',
    // --- Global Chat Widget ---
    globalChatTitle: 'Assistant de Connaissances',
    globalChatSubtitle: 'Tous les documents & vidéos',
    globalChatFab: 'Demander n\'importe quoi',
    globalChatGreeting: 'Hej ! Je peux vous aider avec des questions sur l\'ensemble de vos documents et vidéos. Que voulez-vous savoir ?',
    globalChatPlaceholder: 'Posez une question sur tout votre contenu …',
    globalSuggestion1: 'Que disent mes documents sur les exigences de sécurité ?',
    globalSuggestion2: 'Résumer tout le contenu disponible',
    globalSuggestion3: 'Quelles vidéos couvrent ce sujet ?',
    sourcesUsed: 'Sources',
    sourceDocument: 'Document',
    sourceVideo: 'Vidéo',
    goToElement: 'Ouvrir l\'élément →',
    goToVideo: 'Regarder la vidéo →',
    createdOn: 'Créé le',
    photoVideo: 'Photo / Vidéo',
    document: 'Document',
    replaceFile: 'Remplacer',
    removeFile: 'Supprimer',
    documentTypeDefault: 'Document',
    invalidDocumentType: 'Veuillez télécharger un fichier valide : PDF, TXT, DOC/DOCX ou PPT/PPTX.',
    documentTooLarge: 'Le fichier est trop volumineux. Max {mb} Mo autorisé.',
    documentAiInfo: 'L\'IA extrait automatiquement le contenu, crée un résumé (1-2 phrases) en voix off et utilise la première page comme miniature.',
    documentModeActive: 'Mode document actif',
    documentModeDesc: 'L\'IA utilisera automatiquement le contenu de votre document comme texte vidéo. Vous pouvez ajouter du contexte ou laisser vide.',
    docAdditionalContextPlaceholder: 'Contexte supplémentaire facultatif (ex. public cible, domaine)...',
    optionLabel: 'Option',
    aiOptionLabel: 'Option IA',
    autoGeneratedFromDoc: 'Généré automatiquement à partir du document',
    documentAutoProcess: 'L\'IA extrait le contenu et crée un résumé comme texte vidéo.',
    aiDocProcessingInfo: 'Nous analysons le document, générons un résumé en voix off et créons une vidéo avec la première page comme miniature.',
    viewDocument: 'Voir',
    downloadDocument: 'Télécharger',
    responseVideoNotFound: 'Vidéo de réponse introuvable',
    responseVideoNotReady: 'La vidéo de réponse pour ce défi n\'existe pas encore.',
    unknownQRCodeTitle: 'Code QR inconnu',
    unknownQRCodeQuestion: 'Comment souhaitez-vous procéder ?',
    unknownQRCodeCreateCollection: 'Créer une nouvelle collection',
    recordingTooShort: "Enregistrement trop court",
    errorNoSpeechDetected: "Aucune parole détectée. Veuillez parler plus fort ou vous rapprocher du micro.",
    errorTranscriptionFailed: "Audio incompréhensible. Veuillez réessayer en parlant distinctement.",
    selectModeration: 'Choisissez le texte correspondant',
    selectModerationDesc: 'L\'IA a généré les suggestions de texte suivantes basées sur votre description :',
    generatingScripts: 'Génération des textes...',
    nothingFits: 'Rien ne correspond',
    backToDesc: 'Retour à la description',
    selectedModeration: 'Modération sélectionnée',
    maxRetriesReached: 'Veuillez préciser votre description. Plus aucune tentative possible.',
    errorLoadingScripts: 'Erreur lors du chargement des suggestions. Vérifiez votre connexion internet ou reconnectez-vous.',

    challenge: 'Défi',
    thinking: 'Je réfléchis...',
    aiSuggest: 'Suggestions IA Hejvi',
    aiNoSuggestions: 'L\'IA n\'a pas trouvé d\'éléments spécifiques. Tout est affiché.',
    showAll: 'Tout afficher',
    totalXp: 'Total XP',
    sec: "s",
    min: "min",
    invalidInput: "L'entrée contient des caractères invalides.",
    errorContentRejected: "Ce contenu a été rejeté car il enfreint nos règles de sécurité (ex. haine, violence, sexe). Veuillez réviser votre saisie.",
    errorImageTooLarge: "L'image est trop grande (Max 4Mo).",
    errorInvalidImageType: "Format invalide. Autorisé : JPG, PNG, WEBP, GIF.",
    warningImageTooLarge: "L'image de couverture est trop volumineuse pour le stockage temporaire. La structure de votre cours a été enregistrée, mais l'image a été ignorée. Veuillez la sélectionner à nouveau à votre retour.",
    draftSaveError: "Impossible d'enregistrer le brouillon.",
    authErrorTokenMissing: "Jeton d'authentification manquant.",
    uploadFailed: "Échec du téléchargement.",
    qrErrorEmpty: "Veuillez entrer la valeur du Code QR.",
    errorOptionMissing: "Veuillez saisir du texte pour l'Option",
    viewQuiz: 'Voir le quiz',
    details: 'Détails',
    pleaseUploadThumbnail: "Veuillez télécharger une image miniature pour le cours.",
    createVideoElement: 'Créer une vidéo',
    createQuizElement: 'Créer un quiz',
    orSelectExisting: 'Ou sélectionnez des éléments existants :',
    organize: 'Déplacez les vidéos pour changer l\'ordre',
    viewCourse: 'Voir le cours',
    filterMyContent: 'Mon contenu uniquement',
    makeVisible: 'Rendre visible',
    makeInvisible: 'Masquer',
    selectCorrectAnswer: 'Sélectionner la bonne réponse',
    selectCorrectAnswerDesc: 'Quelle option est la bonne solution ?',
    QuizExampleQrHash: 'ex. el-32hhuz3',
    pleaseEnterQuestion: 'Veuillez entrer une question ou un titre.',
    typeYesNo: 'Oui / Non',
    typeQR: 'Scan QR',
    typeMulti: 'Choix multiple',
    QuizQuestionPlaceholder: 'ex. Cet équipement de sécurité est-il correct ?',
    QuizDescriptionPlaceholder: 'Description facultative...',
    quizCreatedSuccess: 'Quiz créé avec succès !',
    tapToUpload: 'Télécharger une image miniature',
    uploadOrAutoThumb: 'Télécharger une image',
    autoThumbHint: 'Sinon généré automatiquement à partir des miniatures vidéo',
    imageSelected: 'Image sélectionnée',
    yes: 'Oui',
    no: 'Non',
    correct: 'Correct',
    incorrect: 'Incorrect',
    submit: 'Soumettre',
    next: 'Suivant',
    back: 'Retour',
    cancel: 'Annuler',
    create: 'Créer',
    error: 'Erreur',
    success: 'Succès',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    previous: 'Précédent',
    loading: 'Chargement...',

    // --- Quiz Builder ---
    createQuiz: 'Créer un Quiz',
    configureQuiz: 'Configurer le Quiz',
    selectType: 'Sélectionner le type',
    selectResponses: 'Sélectionner les réponses vidéo',
    selectResponsesDesc: 'Sélectionnez les vidéos qui seront lues après la réponse de l\'utilisateur.',
    question: 'Question',
    enableHint: 'Activer l\'indice ?',
    hintNotAvailableQR: 'Les indices sont désactivés pour les défis QR Code.',

    // QR
    qrTargetTitle: 'Cible du Code QR',
    qrTargetDesc: 'Quel texte/code est caché dans le QR code ?',
    qrValueLabel: 'Contenu QR (Exact)',

    // Review
    reviewQuiz: 'Résumé',
    reviewDesc: 'Veuillez vérifier vos paramètres avant de créer le quiz.',

    // Validation
    pleaseEnterName: 'Veuillez entrer un nom.',
    errorSelectCorrect: 'Veuillez sélectionner la bonne réponse.',
    selectBothResponses: 'Veuillez sélectionner les deux vidéos de réponse.',

    // Success
    backToDashboard: 'Retour au tableau de bord',
    createAnother: 'En créer un autre',
    scanToStart: 'Scannez pour commencer',
    useExactTextTitle: 'Utiliser le texte exact',
    useExactTextDesc: 'Sauter l\'optimisation IA et lire la description 1:1.',
    transcribeVideoTitle: 'Utiliser l\'audio vidéo comme voix off',
    transcribeVideoDesc: 'Le texte parlé est transcrit. À utiliser tel quel comme voix off (synchronisé) ou comme base pour un script optimisé par l\'IA.',
    transcribeVideo: 'Transcrire',
    transcribing: 'Transcription...',
    transcriptAdopted: 'Audio vidéo adopté comme voix off',
    resetTranscript: 'Ignorer la transcription',
    transcriptionFailed: 'Échec de la transcription.',
    transcribeExactInfo: 'Le texte parlé est transcrit tel quel et utilisé comme voix off. Les sous-titres restent synchronisés avec la vidéo originale.',
    transcribeLLMInfo: 'Le texte parlé est transcrit. L\'IA crée un script de voix off optimisé dans la langue détectée de la vidéo.',
    transcribeExactToggleDesc: 'Utiliser la transcription 1:1 comme voix off (synchronisé avec la vidéo). Désactivé : l\'IA génère un script optimisé depuis la transcription.',
    confirmDelete: 'Voulez-vous vraiment supprimer cet élément ? Cette action est irréversible.',
    deleteSuccess: 'Élément supprimé avec succès.',
    deleteError: 'Échec de la suppression.',
    loginWithQRCode: 'Se connecter avec un code QR',
    search: 'Rechercher',
    filter: 'Filtrer',
    all: 'Tous',
    needHint: 'Besoin d’un indice ?',
    
    // Navigation
    home: 'Accueil',
    challenges: 'Défis',
    favorites: 'Favoris',
    profile: 'Profil',
    myCourses: 'Mes Cours',
    
    // Dashboard
    welcome: 'Bon retour ! 👋',
    searchPlaceholder: 'Rechercher du contenu…',
    mustSee: 'À voir',
    safety: 'Sécurité',
    tools: 'Outils',
    law: 'Droit',
    mandatory: 'Obligatoire',
    mandatoryFilter: 'Cours obligatoires',
    mandatoryCourses: 'Cours obligatoires',
    favourites: 'Favoris',
    favouritesFilter: 'Favoris',
    loadMore: 'Charger plus',
    play: 'Jouer',
    favorite: 'Favori',
    unfavorite: 'Ne plus favoriser',
    
    // Login
    login: 'Se connecter',
    enterPin: 'Veuillez entrer le code PIN',
    invalidPin: 'Veuillez entrer un code PIN valide de 8 caractères',
    loginError: 'Code PIN invalide. Veuillez réessayer.',
    wrongPin: 'Code PIN incorrect. Veuillez réessayer.',
    loginSuccess: 'Connexion réussie ! Bon retour ! 🎉',
    
    // Profile
    myProfile: 'Mon Profil',
    myProgress: 'Mon Progrès',
    contactSupport: 'Contacter le Support',
    language: 'Langue',
    settings: 'Paramètres',
    privacy: 'Confidentialité',
    help: 'Aide',
    logout: 'Se déconnecter',
    active: 'Actif',
    beginner: 'Débutant',
    intermediate: 'Intermédiaire',
    advanced: 'Avancé',
    joined: 'Rejoint',
    courses: 'Cours',
    completed: 'Terminé',
    inProgress: 'En cours',
    achievements: 'Réalisations',
    topLearner: 'Meilleur Apprenant',
    safetyStar: 'Étoile de Sécurité',
    firstSteps: 'Premiers Pas',
    learner: 'Apprenant',
    group: 'Groupe',
    client: 'Client',
    
    // Contact Form
    yourName: 'Votre Nom',
    emailAddress: 'Adresse E-mail',
    describeIssue: 'Décrivez votre problème...',
    sendMessage: 'Envoyer le Message',
    messageSent: 'Message envoyé avec succès !',
    messageSendError: 'Échec de l\'envoi du message. Veuillez réessayer.',
    
    // Course/Video
    startCourse: 'Commencer le Cours',
    continueCourse: 'Continuer le Cours',
    courseProgress: 'Progrès du Cours',
    videoProgress: 'Progrès de la Vidéo',
    stepsInThisVideo: 'Étapes dans cette vidéo',
    relatedVideos: 'Vidéos connexes',
    duration: 'Durée',
    experiencePoints: 'Points d\'Expérience',
    levelComplexity: 'Niveau de Complexité',
    lessons: 'Leçons',
    nextLessonStartsIn: 'La prochaine leçon commence dans',
    nextVideoIn: 'Vidéo suivante dans',
    seconds: 's',
    replay: 'Rejouer',
    cancelAutoplay: 'Annuler la lecture automatique',
    loadingCourses: 'Chargement des cours...',
    noCourses: 'Aucun cours disponible',
    searchCourses: 'Rechercher des cours...',
    noResults: 'Aucun cours trouvé',
    workplaceSafety: 'Bases de la Sécurité au Travail',
    workplaceSafetyDesc: 'Protocoles de sécurité essentiels pour le lieu de travail',
    
    // Challenges
    allChallenges: 'Tous les Défis',
    currentChallenges: 'Défis Actuels',
    challengeProgress: 'Progrès du Défi',
    challengeEnds: 'Le Défi se termine',
    daysLeft: 'jours restants',
    hoursLeft: 'heures restantes',
    minutesLeft: 'minutes restantes',
    loadingChallenges: 'Chargement des défis...',
    activeChallenges: 'Défis Actifs',
    weeklyProgress: 'Progrès',
    noChallenges: 'Aucun défi disponible pour le moment.',
    startNow: 'Commencer Maintenant',
    discoverMore: 'Découvrir Plus de Défis',
    stayMotivated: 'Restez motivé et gagnez des récompenses !',
    doneChallenges: 'fait',
    challengesProgressLabel: 'Progrès Défis',
    mandatoryProgressLabel: 'Progrès cours obligatoires',
    doneMandatory: 'cours obligatoires terminés',
    completeChallengesEarnXP: 'Complétez les défis pour gagner des XP !',
    noDeadline: 'Aucune échéance',
    failedToLoadChallenges: 'Échec du chargement des défis',
    expired: 'Expiré',
    lessThan1hLeft: 'Moins d\'1h restante',
    expert: 'Expert',
    
    // QR Scanner
    scanQR: 'Scanner le QR Code',
    scanPlaceholder: 'Pointer la caméra vers le QR code',
    scanSuccess: 'QR code scanné avec succès !',
    scanError: 'Échec du scan du QR code',
    cameraError: 'Accès à la caméra refusé',
    cameraPermission: 'Veuillez autoriser l\'accès à la caméra',
    cameraPermissionDenied: 'Accès à la caméra refusé. Veuillez autoriser l\'accès à la caméra.',
    noCameraFound: 'Aucune caméra trouvée. Veuillez vérifier votre appareil.',
    cameraNotSupported: 'Caméra non prise en charge dans ce navigateur.',
    cameraInUse: 'La caméra est utilisée par une autre application.',
    cameraConstraintsNotMet: 'Contraintes de caméra non respectées. Veuillez essayer une autre caméra.',
    failedToStartCamera: 'Échec du démarrage de la caméra',
    failedToAccessCamera: 'Échec de l\'accès à la caméra. Veuillez vérifier les permissions de votre navigateur.',
    onlyOneCameraAvailable: 'Une seule caméra disponible sur cet appareil',
    noSuitableCameraFound: 'Aucune caméra appropriée trouvée pour le changement',
    failedToSwitchCamera: 'Échec du changement de caméra',
    cameraSwitchFailed: 'Échec du changement de caméra',
    unableToReadCodeFromImage: 'Impossible de lire le code à partir de l\'image',
    errorAccessingCamera: 'Erreur d\'accès à la caméra',
    tryAgain: 'Réessayer',
    switchingCamera: 'Changement de caméra...',
    gallery: 'Galerie',
    flash: 'Flash',
    switchCamera: 'Changer de caméra',
    capture: 'Capturer',
    
    // Voice Recording
    voiceSearch: 'Recherche Vocale',
    tapToStartRecording: 'Appuyez pour commencer l\'enregistrement',
    speakYourSearchQuery: 'Parlez clairement votre requête de recherche',
    startRecording: 'Commencer l\'Enregistrement',
    stopRecording: 'Arrêter l\'Enregistrement',
    recording: 'Enregistrement...',
    processingAudio: 'Traitement audio...',
    transcript: 'Transcription',
    closingOverlay: 'Fermeture de l\'overlay et affichage des résultats...',
    searchAgain: 'Rechercher à Nouveau',
    
    // Toast Messages
    urlOpened: 'URL ouverte dans un nouvel onglet',
    navigatingCourse: 'Navigation vers le cours...',
    productCode: 'Code produit : {code}',
    lookingUpEAN: 'Recherche de l\'EAN {ean}...',
    fetchingContent: 'Récupération du contenu...',
    elementFound: 'Élément trouvé : {name}',
    collectionFound: 'Collection trouvée : {name}',
    contentNotFound: 'Contenu non trouvé',
    
    // Errors
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion.',
    serverError: 'Erreur serveur. Veuillez réessayer plus tard.',
    unauthorized: 'Non autorisé. Veuillez vous reconnecter.',
    notFound: 'Contenu non trouvé.',
    generalError: 'Une erreur inattendue s\'est produite.',
    
    // Time
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    thisWeek: 'Cette Semaine',
    thisMonth: 'Ce Mois',
    ago: 'il y a',
    minutes: 'minutes',
    hours: 'heures',
    days: 'jours',
    weeks: 'semaines',
    months: 'mois',
    years: 'années',
    
    // Additional UI Elements
    seeAll: 'Voir Tout',
    seeMore: 'Voir Plus',
    seeLess: 'Voir Moins',
    expand: 'Développer',
    collapse: 'Réduire',
    refresh: 'Actualiser',
    retry: 'Réessayer',
    confirm: 'Confirmer',
    ok: 'OK',
    done: 'Terminé',
    skip: 'Passer',
    continue: 'Continuer',
    finish: 'Terminer',
    start: 'Commencer',
    stop: 'Arrêter',
    pause: 'Pause',
    resume: 'Reprendre',
    restart: 'Redémarrer',
    reset: 'Réinitialiser',
    clear: 'Effacer',
    remove: 'Supprimer',
    add: 'Ajouter',
    update: 'Mettre à jour',
    change: 'Changer',
    select: 'Sélectionner',
    choose: 'Choisir',
    browse: 'Parcourir',
    upload: 'Télécharger',
    download: 'Télécharger',
    share: 'Partager',
    copy: 'Copier',
    paste: 'Coller',
    cut: 'Couper',
    undo: 'Annuler',
    redo: 'Rétablir',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    fullscreen: 'Plein écran',
    exitFullscreen: 'Quitter le plein écran',
    volume: 'Volume',
    mute: 'Muet',
    unmute: 'Activer le son',
    preferences: 'Préférences',
    account: 'Compte',
    notifications: 'Notifications',
    messages: 'Messages',
    inbox: 'Boîte de réception',
    sent: 'Envoyé',
    drafts: 'Brouillons',
    trash: 'Corbeille',
    archive: 'Archives',
    starred: 'Marqué',
    important: 'Important',
    unread: 'Non lu',
    read: 'Lu',
    markAsRead: 'Marquer comme lu',
    markAsUnread: 'Marquer comme non lu',
    reply: 'Répondre',
    forward: 'Transférer',
    compose: 'Composer',
    send: 'Envoyer',
    receive: 'Recevoir',
    sync: 'Synchroniser',
    backup: 'Sauvegarde',
    restore: 'Restaurer',
    import: 'Importer',
    export: 'Exporter',
    print: 'Imprimer',
    saveAs: 'Enregistrer sous',
    open: 'Ouvrir',
    new: 'Nouveau',
    openInNewTab: 'Ouvrir dans un nouvel onglet',
    openInNewWindow: 'Ouvrir dans une nouvelle fenêtre',
    bookmark: 'Favori',
    unbookmark: 'Retirer des favoris',
    history: 'Historique',
    bookmarks: 'Favoris',
    downloads: 'Téléchargements',
    recent: 'Récent',
    popular: 'Populaire',
    trending: 'Tendance',
    featured: 'Mis en avant',
    recommended: 'Recommandé',
    suggested: 'Suggéré',
    related: 'Connexe',
    similar: 'Similaire',
    other: 'Autre',
    more: 'Plus',
    less: 'Moins',
    none: 'Aucun',
    some: 'Certains',
    few: 'Peu',
    many: 'Beaucoup',
    most: 'La plupart',
    least: 'Le moins',
    best: 'Meilleur',
    worst: 'Pire',
    highest: 'Plus haut',
    lowest: 'Plus bas',
    fastest: 'Plus rapide',
    slowest: 'Plus lent',
    newest: 'Plus récent',
    oldest: 'Plus ancien',
    latest: 'Dernier',
    earliest: 'Plus tôt',
    first: 'Premier',
    last: 'Dernier',
    current: 'Actuel',
    inactive: 'Inactif',
    enabled: 'Activé',
    disabled: 'Désactivé',
    on: 'Activé',
    off: 'Désactivé',
    true: 'Vrai',
    false: 'Faux',
    maybe: 'Peut-être',
    unknown: 'Inconnu',
    pending: 'En attente',
    processing: 'En cours de traitement',
    failed: 'Échoué',
    cancelled: 'Annulé',
    scheduled: 'Programmé',
    overdue: 'En retard',
    due: 'Dû',
    valid: 'Valide',
    invalid: 'Invalide',
    required: 'Requis',
    optional: 'Optionnel',
    available: 'Disponible',
    unavailable: 'Indisponible',
    online: 'En ligne',
    offline: 'Hors ligne',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    public: 'Public',
    private: 'Privé',
    hidden: 'Masqué',
    visible: 'Visible',
    locked: 'Verrouillé',
    unlocked: 'Déverrouillé',
    secure: 'Sécurisé',
    insecure: 'Non sécurisé',
    verified: 'Vérifié',
    unverified: 'Non vérifié',
    authenticated: 'Authentifié',
    unauthenticated: 'Non authentifié',
    authorized: 'Autorisé',
    permitted: 'Permis',
    forbidden: 'Interdit',
    allowed: 'Autorisé',
    denied: 'Refusé',
    granted: 'Accordé',
    revoked: 'Révoqué',
    accepted: 'Accepté',
    rejected: 'Rejeté',
    approved: 'Approuvé',
    disapproved: 'Désapprouvé',
    confirmed: 'Confirmé',
    unconfirmed: 'Non confirmé',
    signed: 'Signé',
    unsigned: 'Non signé',
    encrypted: 'Chiffré',
    decrypted: 'Déchiffré',
    compressed: 'Compressé',
    uncompressed: 'Non compressé',
    archived: 'Archivé',
    unarchived: 'Non archivé',
    backedUp: 'Sauvegardé',
    restored: 'Restauré',
    imported: 'Importé',
    exported: 'Exporté',
    printed: 'Imprimé',
    saved: 'Enregistré',
    opened: 'Ouvert',
    created: 'Créé',
    updated: 'Mis à jour',
    changed: 'Modifié',
    selected: 'Sélectionné',
    chosen: 'Choisi',
    browsed: 'Parcouru',
    uploaded: 'Téléchargé',
    downloaded: 'Téléchargé',
    shared: 'Partagé',
    copied: 'Copié',
    pasted: 'Collé',
    undone: 'Annulé',
    redone: 'Rétabli',
    zoomedIn: 'Zoom avant',
    zoomedOut: 'Zoom arrière',
    fullscreened: 'Plein écran',
    muted: 'Mis en sourdine',
    unmuted: 'Son activé',
    notified: 'Notifié',
    messaged: 'Message envoyé',
    replied: 'Répondu',
    forwarded: 'Transféré',
    composed: 'Composé',
    received: 'Reçu',
    synced: 'Synchronisé',
    bookmarked: 'Ajouté aux favoris',
    unbookmarked: 'Retiré des favoris',
    openedInNewTab: 'Ouvert dans un nouvel onglet',
    openedInNewWindow: 'Ouvert dans une nouvelle fenêtre',

    // Element Creator Specific
    elementCreator: 'Créateur d\'éléments',
    createElement: 'Créer un élément',
    createStep1Title: "Commençons ! Donnez-lui un nom.",
    elementNamePlaceholder: "ex. Comment réparer la fraiseuse",
    createStep2Title: "Téléchargez votre contenu",
    createStep2Sub: "Prenez une photo/vidéo ou téléchargez depuis la bibliothèque.",
    selectMedia: 'Sélectionner un média',
    tapToChange: 'Appuyez pour changer',
    createStep3Title: "Expliquez-le",
    createStep3Sub: "Que se passe-t-il dans cette vidéo ? Notre IA va transformer cela en une narration professionnelle.",
    descPlaceholder: "Décrivez le processus étape par étape...",
    createStep4Title: "Vérification",
    aiProcessingInfo: "Nous allons maintenant compresser la vidéo, générer une voix off professionnelle à partir de votre description et tout traduire en 10 langues.",
    creatingElement: "Création de l'élément...",
    videoGenerating: "La vidéo est en cours de génération, veuillez patienter…",
    videoProcessing: "La vidéo est en cours de finalisation… Le bouton sera activé automatiquement.",
    videoProcessingHint: "La vidéo est encore en cours de traitement. Attendez un moment pour la visionner directement, ou continuez simplement à travailler.",
    pleaseWait: "Cela peut prendre une minute. Téléchargement et traitement IA en cours.",
    elementCreatedSuccess: 'Élément créé avec succès !',
    elementReadyDesc: 'Votre élément a été créé et traité avec succès.',
    viewElement: 'Voir l\'élément maintenant',
    goToMyCourses: 'Aller à mes cours',
    elementPendingTitle: 'Votre vidéo est en cours de vérification',
    elementPendingDesc: "Votre vidéo a été téléchargée avec succès et est maintenant examinée par un administrateur. Elle sera bientôt disponible pour tous.",
    elementPendingHint: 'Vous serez notifié dès que votre vidéo sera approuvée.',
    elementApprovedTitle: 'Votre vidéo a été approuvée\u00a0!',
    elementApprovedBody: 'Bonne nouvelle\u00a0— votre vidéo «\u00a0{name}\u00a0» a été approuvée et est maintenant visible par tous les utilisateurs.',
    descTooShort: 'Veuillez fournir une description détaillée (min. 10 caractères).',
    invalidFileType: 'Veuillez télécharger une vidéo ou une image valide.',
    fileTooLarge: 'Le fichier est trop volumineux. La taille maximale est de 500 Mo.',
    media: 'Média',
    description: 'Description',
    name: 'Nom',
    
    // Course Builder
    courseDetails: 'Détails du cours',
    courseName: 'Nom du cours',
    courseNamePlaceholder: 'ex. maintenance machine',
    courseDescPlaceholder: 'Décrivez brièvement le sujet de ce cours...',
    thumbnail: 'Image miniature',
    uploadImage: '+ Télécharger une image',
    addElements: 'Ajouter des éléments',
    searchElements: 'Rechercher des éléments...',
    loadingElements: 'Chargement des éléments...',
    preview: 'Aperçu',
    added: 'Ajouté',
    noElementsFound: 'Aucun élément correspondant trouvé.',
    organizeCourse: 'Organiser le cours',
    dragDropReorder: 'Glisser-déposer pour réorganiser',
    addMoreElements: '+ Ajouter plus d\'éléments',
    courseCreated: 'Cours créé !',
    courseCreatedDesc: 'Votre collection a été enregistrée avec succès.',
    createAnotherCourse: 'Créer un autre cours',
    createCourse: 'Créer le cours',
    addToCourse: 'Ajouter au cours',
    saving: 'Enregistrement...',
    noElementsSelected: 'Veuillez sélectionner au moins un élément',
    errorCreatingCourse: 'Erreur lors de la création du cours',
    authError401: 'Non autorisé (401). Votre session a peut-être expiré. Veuillez vous reconnecter.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: '💡 Le nom et la description sont traduits automatiquement dans toutes les langues.',
    adm_en_readonly_hint: 'Traduit automatiquement – non modifiable',
    adm_filter_active: 'Actif',
    adm_filter_all: 'Tous',
    adm_filter_inactive: 'Inactif',
    adm_last_superadmin_hint: 'Dernier Super Admin – ne peut pas être supprimé',
    adm_no_group_access: 'Pas d\'accès au contenu',
    adm_no_group_assign_warn: 'Cet utilisateur n\'est assigné à aucun groupe et n\'a donc pas accès au contenu.',
    adm_no_group_warn_body: 'Les nouveaux utilisateurs sans groupe n\'ont pas accès au contenu. Veuillez assigner un groupe via 🏷️ Groupes après la création.',
    adm_no_group_warn_title: 'Remarque : Pas d\'accès au groupe',
    adm_toast_added_to_group: 'Ajouté au groupe',
    adm_toast_removed_from_group: 'Retiré du groupe',
    adm_toast_group_assigned: 'Groupe attribué',
    adm_toast_group_removed: 'Groupe retiré',
    adm_toast_content_assigned: 'Contenu attribué',
    adm_toast_content_removed: 'Contenu retiré',
    // ── Système de notifications ──────────────────────────────────────────
    adm_notifications:          'Messages',
    notif_type_new_content:     'Nouveau contenu',
    notif_type_message:         'Message',
    notif_goto_collection:      'Voir la collection',
    notif_dismiss_all:          'Tout fermer',
    notif_just_now:             'À l\'instant',

    // ── MyCourses: pilules de filtre, en-têtes de section & messages vides
    mc_filter_all:            'Tout',
    mc_filter_courses:        '📚 Mes Cours',
    mc_filter_videos:         '▶ Mes Vidéos',
    mc_filter_favorites:      '★ Favoris',
    mc_status_all:            'Tous les statuts',
    mc_only_mine:             'Seulement les miens',
    mc_section_courses_sub:   'Cours commencés et terminés',
    mc_section_videos:        'Mes Vidéos',
    mc_section_videos_sub:    'Contenu créé par vous',
    mc_section_favorites:     'Mes Favoris',
    mc_section_favorites_sub: 'Cours et vidéos aimés',
    mc_empty_courses:         "Vous n'avez pas encore commencé de cours.",
    mc_empty_videos:          "Vous n'avez pas encore créé de vidéos.",
    mc_empty_favorites:       "Vous n'avez pas encore ajouté de contenu à vos favoris.",
    videoRendering:     'Rendu de la vidéo en cours…',
    videoRenderingHint: 'La vidéo est encore en cours de traitement. Elle sera disponible sous peu.',
    // ── AdminPanel: nouvelles chaînes i18n ───────────────────────────────
    adm_qr_unavailable:         'QR non disponible — npm install qrcode',
    adm_qr_login_title:         'QR Code de connexion',
    adm_qr_scan_login_hint:     'Scanner → se connecter directement sans PIN',
    adm_qr_permanent_hint:      'Le QR code est accessible en permanence dans la fiche utilisateur.',
    adm_qr_print_hint:          'Imprimer le PIN maintenant ou le transmettre de façon sécurisée.',
    adm_msg_subject_placeholder:'ex. Nouvelle instruction de sécurité disponible',
    adm_msg_text_placeholder:   'Texte du message…',
    adm_col_license_type:       'Type de licence',
    adm_btn_show_qr:            'Afficher le QR Code',
    adm_btn_send_msg:           'Envoyer le message',
    adm_login_qr_label:         'QR Code de connexion',
    adm_btn_gen_pin:            'Générer un nouveau PIN',
    adm_qr_scan_hint:           "L'utilisateur peut scanner ce code pour se connecter sans PIN.",
    adm_pin_reset_hint:         'Pour réinitialiser le PIN : fermez et utilisez 🔄 Réinitialiser PIN dans la fiche.',
    adm_role_supervisor:        'Superviseur',
    adm_role_admin_opt:         'Admin',
    adm_role_superadmin:        'Super Admin',
    adm_seat_essentials_desc:   'Essentials – toutes les fonctionnalités sauf la création de contenu',
    adm_pin_force_change:       'Forcer le changement de PIN à la première connexion',
    adm_btn_msg_group:          'Message au groupe',
    adm_btn_show:               'Afficher',
    adm_btn_unlock:             "Débloquer l'élément",
    adm_btn_show_assigned:      'Afficher le contenu assigné',
    adm_no_videos_assigned:     'Aucune vidéo assignée. Cliquez sur « + Ajouter une vidéo ».',
    adm_drag_sort:              'Glisser pour trier',
    adm_search_video:           'Rechercher une vidéo…',
    adm_no_videos:              'Aucune vidéo trouvée.',
    adm_video_unassigned:       "Cette vidéo n'est assignée à aucun contenu.",
    adm_search_messages:        'Rechercher des messages…',
    adm_btn_reload:             'Recharger',
    adm_enriching:              'Enrichissement en cours…',
    adm_no_video_chunks:        'Aucune vidéo avec fragments de transcription trouvée',
    adm_ki_enrichment:          'Enrichissement IA',
    adm_col_updated:            'Mis à jour',
    adm_search_docs:            'Rechercher un document ou un élément…',
    adm_no_docs:                'Aucun document disponible',
    adm_col_size:               'Taille',
    adm_search_questions:       'Rechercher des questions…',
    adm_label_question:         "Question de l'employé",
    adm_label_answer:           'Réponse',
    adm_btn_upload_doc:         'Télécharger un document',
    adm_just_moment:            'Un instant',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Seuls les admins peuvent modifier le profil de domaine.',
    adm_primary_lang:           'Langue de travail principale',
    adm_drop_doc:               'Déposer le document ici ou cliquer',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  "Documents d'entreprise existants",
    adm_company_docs_empty:     "Aucun document d'entreprise téléchargé.",
    adm_no_licence:             'Aucune donnée de licence disponible.',
    adm_full_seats_label:       '⭐ Full Seats (incl. création de contenu)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            "Valable jusqu'au",
    adm_base_lang:              'Langue de base',
    adm_active_ui_langs:        "Langues UI actives",
    adm_tts_langs:              'Langues TTS',
    adm_full_seats_total_label: '⭐ Full Seats total',
    adm_essentials_total_label: 'Essentials Seats total',
    adm_ui_langs_field:         "Langues UI (langues actives de l'app)",
    adm_tts_langs_field:        'Langues TTS (synthèse vocale)',
    adm_config_title:           'Configuration',
    adm_config_desc:            'Paramètres de la plateforme pour ce tenant. Les modifications prennent effet immédiatement.',
    adm_supervisor_mode:        'Mode superviseur',
    adm_warning_no_admin:       '⚠️ Attention : Aucun utilisateur actif avec le rôle Superviseur ou Admin (Groupe 2 ou 3).',
    adm_std_delete_toggle:      'Utilisateurs standard : supprimer & désactiver des vidéos',
    adm_std_course_toggle:      'Utilisateurs standard : créer des cours & quiz',
    adm_supervisor_confirm_title: 'Activer le mode superviseur ?',
    adm_btn_activate:           'Activer',
    adm_admin_only_setting:     "Seuls les administrateurs tenant (Groupe 3) ou Super Admins peuvent modifier ce paramètre.",
    adm_only_admins_edit:       'Seuls les administrateurs peuvent modifier ce paramètre.',
  },

  ru: {
    // Common
    // --- Выбор Сценария / Озвучки ---
    // --- Missing Keys Update ---
    // Russisch (ru)
      assignToGeneral: 'Добавить в общую группу',
  assignToGeneralOn: 'Контент будет виден всем участникам группы по умолчанию после создания.',
  assignToGeneralOff: '⚠ Внимание: этот контент не будет виден широкой аудитории. Он будет доступен только администраторам и создателю.',
    videoRenderingBackground: 'Видео обрабатывается в фоновом режиме – вы сможете продолжить через мгновение.',
    manyPagesHint: 'Документ содержит {count} страниц – анализ займёт немного больше времени.',
    analyzingPages: 'Анализ страниц…',
    notif_goto_adminpanel:    'Открыть панель администратора',
    notif_type_new_question:  'Новый вопрос',
    notif_title:         'Уведомления',
    notif_back:          'Назад',
    notif_loading:       'Загрузка…',
    notif_empty:         'Нет сообщений',
    notif_just_now:          'Только что',
    notif_type_message:      'Сообщение от администратора',
    notif_type_new_content:  'Новый контент',
    notif_goto_collection:   'Перейти к коллекции',
    notif_goto_document:     'Открыть документ',
    notif_open_document:     'Открыть документ',
    notif_goto_fraghejvi:    'Открыть FragHejVi',
    notif_close:             'Закрыть',
    notif_dismiss_all:       'Закрыть все',
    adminArea: 'Панель администратора',
    adm_pin_format_hint:    'Ровно 8 символов: буквы и цифры',
    adm_pin_format_error:   'PIN должен содержать ровно 8 буквенно-цифровых символов.',
    adm_subtitle:          'Управление HejVi',
    adm_access_denied:     'Доступ запрещён',
    adm_access_denied_desc:'У вас нет прав для доступа к этому разделу.',
    adm_back:              'Назад',
    adm_users:             'Пользователи',
    adm_groups:            'Группы',
    adm_videos:            'Видео',
    adm_topics:            'Темы',
    adm_video_sg:          'Видео',
    adm_topic_sg:          'Тема',
    adm_docs:              'Документы & База знаний',
    adm_open_video:        'Открыть видео в новой вкладке',
    adm_open_doc:          'Открыть документ в новой вкладке',
    adm_open_element:      'Открыть элемент в новой вкладке',
    adm_stat_users:        'Всего пользователей',
    adm_stat_active:       'Активные пользователи',
    adm_members:           'Участники',
    adm_content:           'Контент',
    adm_name:              'Название',
    adm_status:            'Статус',
    adm_role:              'Роль',
    adm_role_standard:     'Стандарт',
    adm_created:           'Создан',
    adm_actions:           'Действия',
    adm_preview:           'Превью',
    adm_active:            'Активен',
    adm_inactive:          'Неактивен',
    adm_edit:              'Изменить',
    adm_delete:            'Удалить',
    adm_new_user:          'Новый пользователь',
    adm_new_group:         'Новая группа',
    adm_edit_user:         'Редактировать пользователя',
    adm_edit_group:        'Редактировать группу',
    adm_create:            'Создать',
    adm_save:              'Сохранить',
    adm_save_translate:    'Сохранить и перевести',
    adm_translating:       'Перевод…',
    adm_cancel:            'Отмена',
    adm_done:              'Готово',
    adm_confirm:           'Уверены?',
    adm_yes:               'Да',
    adm_no:                'Нет',
    adm_mandatory:         'Обязательный',
    adm_description:       'Описание',
    adm_rights_level:      'Уровень прав',
    adm_lang_id:           'Язык',
    adm_client_id:         'Клиент',
    adm_pin_change:        'Изменить PIN (пусто = без изменений)',
    adm_pin_hint:          'Минимум 4 символа',
    adm_pin_change_hint:   'Оставьте пустым для сохранения старого',
    adm_groups_for:        'Группы для',
    adm_groups_assign_hint:'Назначить или удалить группы',
    adm_content_for_group: 'Контент для группы',
    adm_content_visible_hint: 'Этот контент виден следующим группам:',
    adm_assigned:          'Назначено',
    adm_add:               'Добавить',
    adm_remove:            'Удалить',
    adm_assign:            'Назначить',
    adm_search_hint:       'поиск',
    adm_no_users:          'Пользователи не найдены',
    adm_no_groups:         'Нет доступных групп',
    adm_no_entries:        'Записи не найдены',
    adm_no_content:        'Контент не найден',
    adm_toast_deleted:     'Удалено',
    adm_toast_created:     'Создано',
    adm_toast_saved:       'Сохранено',
    adm_toast_deactivated: 'Деактивировано',
    adm_toast_removed:     'Удалено из группы',
    adm_toast_added:       'Добавлено в группу',
    adm_toast_error:       'Произошла ошибка',
    adm_toast_load_error:  'Ошибка загрузки',
    // --- Document Chat ---
    chatGreeting: 'Hej! Я с удовольствием помогу. Что вы хотите узнать?',
    chatSubtitle: 'Спросить о документе',
    chatButton: 'Спросить',
    chatPlaceholder: 'Задайте вопрос по документу …',
    chatClear: 'Очистить чат',
    chatSuggestion1: 'Резюмировать документ',
    chatSuggestion2: 'Каковы ключевые моменты?',
    chatSuggestion3: 'Какие требования упоминаются?',
    chatErrorNotAuthenticated: 'Не авторизован. Пожалуйста, войдите снова.',
    chatErrorNoAnswer: 'Ответ не получен.',
    chatErrorGeneric: 'Ошибка',
    // --- Global Chat Widget ---
    globalChatTitle: 'Ассистент знаний',
    globalChatSubtitle: 'Все документы и видео',
    globalChatFab: 'Спросить о чем угодно',
    globalChatGreeting: 'Hej! Я могу помочь вам с вопросами по всем вашим документам и видео. Что вы хотите узнать?',
    globalChatPlaceholder: 'Задайте вопрос по всему вашему контенту …',
    globalSuggestion1: 'Что в моих документах говорится о требованиях безопасности?',
    globalSuggestion2: 'Резюмировать весь доступный контент',
    globalSuggestion3: 'В каких видео рассматривается эта тема?',
    sourcesUsed: 'Источники',
    sourceDocument: 'Документ',
    sourceVideo: 'Видео',
    goToElement: 'Открыть элемент →',
    goToVideo: 'Смотреть видео →',
    createdOn: 'Создано',
    pleaseSelectDocument: 'Пожалуйста, выберите документ (PDF, TXT или DOC).',
    selectDocument: 'Выбрать документ',
    photoVideo: 'Фото / Видео',
    document: 'Документ',
    replaceFile: 'Заменить',
    removeFile: 'Удалить',
    documentTypeDefault: 'Документ',
    invalidDocumentType: 'Пожалуйста, загрузите действительный файл: PDF, TXT, DOC/DOCX или PPT/PPTX.',
    documentTooLarge: 'Файл слишком большой. Максимум {mb} МБ.',
    documentAiInfo: 'ИИ автоматически извлекает контент, создает краткое резюме (1-2 предложения) для озвучки и использует первую страницу как миниатюру.',
    documentModeActive: 'Режим документа активен',
    documentModeDesc: 'ИИ автоматически использует содержание документа как текст видео. Вы можете добавить контекст или оставить пустым.',
    docAdditionalContextPlaceholder: 'Дополнительный контекст (например, целевая аудитория)...',
    optionLabel: 'Вариант',
    aiOptionLabel: 'Вариант ИИ',
    autoGeneratedFromDoc: 'Автоматически создано из документа',
    documentAutoProcess: 'ИИ извлекает контент и создает резюме как текст видео.',
    aiDocProcessingInfo: 'Мы анализируем документ, генерируем резюме для озвучки и создаем видео с первой страницей в качестве обложки.',
    viewDocument: 'Просмотр',
    downloadDocument: 'Скачать',
    responseVideoNotFound: 'Видео ответа не найдено',
    responseVideoNotReady: 'Видео ответа для этой задачи еще не существует.',
    unknownQRCodeTitle: 'Неизвестный QR-код',
    unknownQRCodeQuestion: 'Как вы хотите продолжить?',
    unknownQRCodeCreateCollection: 'Создать новую коллекцию',
    addVideo: 'Добавить видео',
    pleaseSelectMedia: 'Пожалуйста, выберите видео или фото.',
    originalText: 'Оригинал',
    printQRLabel: '🖨️ Печать QR-этикетки',
    printerConnecting: '🔵 Подключение принтера...',
    printerPrinting: '⏳ Печать...',
    printerDone: '✅ Напечатано!',
    printerError: '❌ Ошибка – Попробуйте еще раз',
    bluetoothHint: 'Подключается по Bluetooth – выберите Niimbot B1 из списка',
    printerErrorHint: 'Принтер включен? Только Chrome/Edge поддерживают Web Bluetooth.',
    number_of_views: 'Просмотры',
    number_of_likes: 'Лайки',
    qrCode: 'QR-код',
    printQrCode: 'Распечатать QR-код',
    playFrom: 'Воспроизвести с',
    voiceSearchSummary: '{collections} коллекций, {elements} элементов',
    pleaseLoginFirst: 'Пожалуйста, сначала войдите в систему',
    openingUrl: 'Открытие URL...',
    eanNotFound: 'Элемент с таким EAN не найден',
    sessionExpired: 'Время сеанса истекло. Пожалуйста, войдите снова.',
    recordingTooShort: "Запись слишком короткая",
    errorNoSpeechDetected: "Речь не обнаружена. Пожалуйста, говорите громче или подойдите ближе к микрофону.",
    errorTranscriptionFailed: "Не удалось распознать аудио. Пожалуйста, попробуйте еще раз и говорите четко.",
    reactionVideo: 'Видео-реакция?',
    setThisToReaction: 'Помечает этот элемент как видео-ответ (Тип контента 4).',
    selectModeration: 'Выберите подходящий текст',
    selectModerationDesc: 'ИИ создал следующие варианты текста на основе вашего описания:',
    generatingScripts: 'Генерация текстов...',
    nothingFits: 'Ничего не подходит',
    backToDesc: 'Назад к описанию',
    selectedModeration: 'Выбранный текст',
    maxRetriesReached: 'Пожалуйста, уточните описание. Больше попыток нет.',
    errorLoadingScripts: 'Ошибка загрузки предложений. Проверьте интернет или войдите снова.',

    challenge: 'Задача',
    thinking: 'Думаю...',
    aiSuggest: 'Предложения ИИ Hejvi',
    aiNoSuggestions: 'ИИ не смог найти конкретные элементы. Показаны все.',
    showAll: 'Показать все',
    totalXp: 'Всего XP',
    sec: "сек",
    min: "мин",
    invalidInput: "Ввод содержит недопустимые символы.",
    errorContentRejected: "Этот контент был отклонен, так как он нарушает наши правила безопасности (например, разжигание ненависти, насилие, контент сексуального характера). Пожалуйста, проверьте введенные данные.",
    errorImageTooLarge: "Изображение слишком большое (Макс 4МБ).",
    errorInvalidImageType: "Неверный формат. Разрешено: JPG, PNG, WEBP, GIF.",
    warningImageTooLarge: "Изображение обложки слишком велико для временного хранения. Структура курса сохранена, но изображение было пропущено. Пожалуйста, выберите его снова по возвращении.",
    draftSaveError: "Не удалось сохранить черновик.",
    authErrorTokenMissing: "Отсутствует токен авторизации.",
    uploadFailed: "Ошибка загрузки.",
    qrErrorEmpty: "Пожалуйста, введите значение QR-кода.",
    errorOptionMissing: "Пожалуйста, заполните опцию",
    viewQuiz: 'Смотреть квиз',
    details: 'Детали',
    pleaseUploadThumbnail: "Пожалуйста, загрузите миниатюру для курса.",
    createVideoElement: 'Создать видео',
    createQuizElement: 'Создать викторину',
    orSelectExisting: 'Или выберите существующие элементы:',
    organize: 'Переместите видео, чтобы изменить порядок',
    viewCourse: 'Просмотреть курс',
    filterMyContent: 'Только мой контент',
    makeVisible: 'Сделать видимым',
    makeInvisible: 'Скрыть',
    selectCorrectAnswer: 'Выберите правильный ответ',
    selectCorrectAnswerDesc: 'Какой вариант является правильным решением?',
    QuizExampleQrHash: 'напр. el-32hhuz3',
    pleaseEnterQuestion: 'Пожалуйста, введите вопрос или заголовок.',
    typeYesNo: 'Да / Нет',
    typeQR: 'QR-скан',
    typeMulti: 'Мультивыбор',
    QuizQuestionPlaceholder: 'напр., Правильно ли это защитное снаряжение?',
    QuizDescriptionPlaceholder: 'Необязательное описание...',
    quizCreatedSuccess: 'Викторина успешно создана!',
    tapToUpload: 'Загрузить миниатюру',
    uploadOrAutoThumb: 'Загрузить изображение',
    autoThumbHint: 'Иначе создаётся автоматически из миниатюр видео',
    imageSelected: 'Изображение выбрано',
    yes: 'Да',
    no: 'Нет',
    correct: 'Правильно',
    incorrect: 'Неправильно',
    submit: 'Отправить',
    next: 'Далее',
    back: 'Назад',
    cancel: 'Отмена',
    create: 'Создать',
    error: 'Ошибка',
    success: 'Успех',
    save: 'Сохранить',
    delete: 'Удалить',
    edit: 'Редактировать',
    close: 'Закрыть',
    previous: 'Предыдущий',
    loading: 'Загрузка...',

    // --- Quiz Builder ---
    createQuiz: 'Создать викторину',
    configureQuiz: 'Настроить викторину',
    selectType: 'Выбрать тип',
    selectResponses: 'Выбрать видео-ответы',
    selectResponsesDesc: 'Выберите видео, которые будут воспроизводиться после ответа пользователя.',
    question: 'Вопрос',
    enableHint: 'Включить подсказку?',
    hintNotAvailableQR: 'Подсказки отключены для QR-задач.',

    // QR
    qrTargetTitle: 'Цель QR-кода',
    qrTargetDesc: 'Какой текст/код скрыт в QR-коде?',
    qrValueLabel: 'Содержимое QR (Точно)',

    // Review
    reviewQuiz: 'Обзор',
    reviewDesc: 'Пожалуйста, проверьте настройки перед созданием викторины.',

    // Валидация
    pleaseEnterName: 'Пожалуйста, введите имя.',
    errorSelectCorrect: 'Пожалуйста, выберите правильный ответ.',
    selectBothResponses: 'Пожалуйста, выберите оба видео-ответа.',

    // Success
    backToDashboard: 'Вернуться на панель',
    createAnother: 'Создать еще',
    scanToStart: 'Сканируйте, чтобы начать',
    useExactTextTitle: 'Использовать точный текст',
    useExactTextDesc: 'Пропустить оптимизацию ИИ и читать описание 1:1.',
    transcribeVideoTitle: 'Использовать аудио видео как озвучку',
    transcribeVideoDesc: 'Текст речи транскрибируется. Используйте дословно как озвучку (синхронно) или как основу для оптимизированного сценария ИИ.',
    transcribeVideo: 'Транскрибировать',
    transcribing: 'Транскрибирование...',
    transcriptAdopted: 'Аудио видео принято как озвучка',
    resetTranscript: 'Отменить транскрипцию',
    transcriptionFailed: 'Ошибка транскрипции.',
    transcribeExactInfo: 'Текст речи транскрибируется дословно и используется как озвучка. Субтитры остаются синхронизированными с оригинальным видео.',
    transcribeLLMInfo: 'Текст речи транскрибируется. ИИ создаёт оптимизированный сценарий озвучки на обнаруженном языке видео.',
    transcribeExactToggleDesc: 'Использовать транскрипцию 1:1 как озвучку (синхронно с видео). Выкл: ИИ создаёт оптимизированный сценарий из транскрипции.',
    loginWithQRCode: 'Вход с помощью QR-кода',
    search: 'Поиск',
    filter: 'Фильтр',
    all: 'Все',
    needHint: 'Нужна подсказка?',
    
    // Navigation
    home: 'Главная',
    challenges: 'Задачи',
    favorites: 'Избранное',
    profile: 'Профиль',
    myCourses: 'Мои Курсы',
    
    // Dashboard
    welcome: 'Добро пожаловать! 👋',
    searchPlaceholder: 'Поиск контента…',
    mustSee: 'Обязательно к просмотру',
    safety: 'Безопасность',
    tools: 'Инструменты',
    law: 'Закон',
    mandatory: 'Обязательно',
    mandatoryFilter: 'Обязательные курсы',
    mandatoryCourses: 'Обязательные курсы',
    favourites: 'Избранное',
    favouritesFilter: 'Избранное',
    loadMore: 'Загрузить ещё',
    play: 'Играть',
    favorite: 'В избранное',
    unfavorite: 'Убрать из избранного',
    
    // Login
    login: 'Войти',
    enterPin: 'Введите PIN-код',
    invalidPin: 'Введите действительный 8-значный PIN-код',
    loginError: 'Неверный PIN-код. Попробуйте еще раз.',
    wrongPin: 'Неверный PIN-код. Попробуйте еще раз.',
    loginSuccess: 'Вход выполнен успешно! Добро пожаловать! 🎉',
    
    // Profile
    myProfile: 'Мой профиль',
    myProgress: 'Мой прогресс',
    contactSupport: 'Связаться с поддержкой',
    language: 'Язык',
    settings: 'Настройки',
    privacy: 'Конфиденциальность',
    help: 'Помощь',
    logout: 'Выйти',
    active: 'Активный',
    beginner: 'Начинающий',
    intermediate: 'Средний',
    advanced: 'Продвинутый',
    joined: 'Присоединился',
    courses: 'Курсы',
    completed: 'Завершено',
    inProgress: 'В процессе',
    achievements: 'Достижения',
    topLearner: 'Лучший ученик',
    safetyStar: 'Звезда безопасности',
    firstSteps: 'Первые шаги',
    learner: 'Ученик',
    group: 'Группа',
    client: 'Клиент',
    
    // Contact Form
    yourName: 'Ваше имя',
    emailAddress: 'Адрес электронной почты',
    describeIssue: 'Опишите вашу проблему...',
    sendMessage: 'Отправить сообщение',
    messageSent: 'Сообщение отправлено успешно!',
    messageSendError: 'Не удалось отправить сообщение. Попробуйте еще раз.',
    
    // Course/Video
    startCourse: 'Начать курс',
    continueCourse: 'Продолжить курс',
    courseProgress: 'Прогресс курса',
    videoProgress: 'Прогресс видео',
    stepsInThisVideo: 'Шаги в этом видео',
    relatedVideos: 'Похожие видео',
    duration: 'Продолжительность',
    experiencePoints: 'Очки опыта',
    levelComplexity: 'Уровень сложности',
    lessons: 'Уроки',
    nextLessonStartsIn: 'Следующий урок начнется через',
    nextVideoIn: 'Следующее видео через',
    seconds: 'с',
    replay: 'Повтор',
    cancelAutoplay: 'Отменить автозапуск',
    loadingCourses: 'Загрузка курсов...',
    noCourses: 'Курсы недоступны',
    searchCourses: 'Поиск курсов...',
    noResults: 'Курсы не найдены',
    workplaceSafety: 'Основы безопасности на рабочем месте',
    workplaceSafetyDesc: 'Основные протоколы безопасности для рабочего места',
    
    // Challenges
    allChallenges: 'Все задачи',
    currentChallenges: 'Текущие задачи',
    challengeProgress: 'Прогресс задачи',
    challengeEnds: 'Задача заканчивается',
    daysLeft: 'дней осталось',
    hoursLeft: 'часов осталось',
    minutesLeft: 'минут осталось',
    loadingChallenges: 'Загрузка задач...',
    activeChallenges: 'Активные задачи',
    weeklyProgress: 'Прогресс',
    noChallenges: 'На данный момент задачи недоступны.',
    startNow: 'Начать сейчас',
    discoverMore: 'Открыть больше задач',
    stayMotivated: 'Оставайтесь мотивированными и зарабатывайте награды!',
    doneChallenges: 'выполнено',
    challengesProgressLabel: 'Прогресс заданий',
    mandatoryProgressLabel: 'Прогресс обязательных курсов',
    doneMandatory: 'обязательных курсов выполнено',
    completeChallengesEarnXP: 'Выполняйте задачи, чтобы заработать XP!',
    noDeadline: 'Нет срока',
    failedToLoadChallenges: 'Не удалось загрузить задачи',
    expired: 'Истекло',
    lessThan1hLeft: 'Меньше 1ч осталось',
    expert: 'Эксперт',
    
    // QR Scanner
    scanQR: 'Сканировать QR-код',
    scanPlaceholder: 'Наведите камеру на QR-код',
    scanSuccess: 'QR-код успешно отсканирован!',
    scanError: 'Не удалось отсканировать QR-код',
    cameraError: 'Доступ к камере запрещен',
    cameraPermission: 'Пожалуйста, разрешите доступ к камере',
    cameraPermissionDenied: 'Доступ к камере запрещен. Пожалуйста, разрешите доступ к камере.',
    noCameraFound: 'Камера не найдена. Пожалуйста, проверьте ваше устройство.',
    cameraNotSupported: 'Камера не поддерживается в этом браузере.',
    cameraInUse: 'Камера используется другим приложением.',
    cameraConstraintsNotMet: 'Ограничения камеры не выполнены. Попробуйте другую камеру.',
    failedToStartCamera: 'Не удалось запустить камеру',
    failedToAccessCamera: 'Не удалось получить доступ к камере. Проверьте разрешения браузера.',
    onlyOneCameraAvailable: 'Только одна камера доступна на этом устройстве',
    noSuitableCameraFound: 'Не найдена подходящая камера для переключения',
    failedToSwitchCamera: 'Не удалось переключить камеру',
    cameraSwitchFailed: 'Переключение камеры не удалось',
    unableToReadCodeFromImage: 'Не удалось прочитать код из изображения',
    errorAccessingCamera: 'Ошибка доступа к камере',
    tryAgain: 'Попробовать снова',
    switchingCamera: 'Переключение камеры...',
    gallery: 'Галерея',
    flash: 'Вспышка',
    switchCamera: 'Переключить камеру',
    capture: 'Захватить',
    
    // Voice Recording
    voiceSearch: 'Голосовой поиск',
    tapToStartRecording: 'Нажмите, чтобы начать запись',
    speakYourSearchQuery: 'Четко произнесите ваш поисковый запрос',
    startRecording: 'Начать запись',
    stopRecording: 'Остановить запись',
    recording: 'Запись...',
    processingAudio: 'Обработка аудио...',
    transcript: 'Транскрипт',
    closingOverlay: 'Закрытие оверлея и показ результатов поиска...',
    searchAgain: 'Поиск снова',
    
    // Toast Messages
    urlOpened: 'URL открыт в новой вкладке',
    navigatingCourse: 'Переход к курсу...',
    productCode: 'Код продукта: {code}',
    lookingUpEAN: 'Поиск EAN {ean}...',
    fetchingContent: 'Загрузка контента...',
    elementFound: 'Элемент найден: {name}',
    collectionFound: 'Коллекция найдена: {name}',
    contentNotFound: 'Контент не найден',
    
    // Errors
    networkError: 'Ошибка сети. Проверьте подключение.',
    serverError: 'Ошибка сервера. Попробуйте позже.',
    unauthorized: 'Не авторизован. Войдите снова.',
    notFound: 'Контент не найден.',
    generalError: 'Произошла неожиданная ошибка.',
    
    // Time
    today: 'Сегодня',
    yesterday: 'Вчера',
    thisWeek: 'На этой неделе',
    thisMonth: 'В этом месяце',
    ago: 'назад',
    minutes: 'минут',
    hours: 'часов',
    days: 'дней',
    weeks: 'недель',
    months: 'месяцев',
    years: 'лет',
    
    // Additional UI Elements
    seeAll: 'Посмотреть все',
    seeMore: 'Показать больше',
    seeLess: 'Показать меньше',
    expand: 'Развернуть',
    collapse: 'Свернуть',
    refresh: 'Обновить',
    retry: 'Повторить',
    confirm: 'Подтвердить',
    ok: 'ОК',
    done: 'Готово',
    skip: 'Пропустить',
    continue: 'Продолжить',
    finish: 'Завершить',
    start: 'Начать',
    stop: 'Остановить',
    pause: 'Пауза',
    resume: 'Возобновить',
    restart: 'Перезапустить',
    reset: 'Сбросить',
    clear: 'Очистить',
    remove: 'Удалить',
    add: 'Добавить',
    update: 'Обновить',
    change: 'Изменить',
    select: 'Выбрать',
    choose: 'Выбрать',
    browse: 'Просматривать',
    upload: 'Загрузить',
    download: 'Скачать',
    share: 'Поделиться',
    copy: 'Копировать',
    paste: 'Вставить',
    cut: 'Вырезать',
    undo: 'Отменить',
    redo: 'Повторить',
    zoomIn: 'Увеличить',
    zoomOut: 'Уменьшить',
    fullscreen: 'Полноэкранный режим',
    exitFullscreen: 'Выйти из полноэкранного режима',
    volume: 'Громкость',
    mute: 'Отключить звук',
    unmute: 'Включить звук',
    preferences: 'Настройки',
    account: 'Аккаунт',
    notifications: 'Уведомления',
    messages: 'Сообщения',
    inbox: 'Входящие',
    sent: 'Отправленные',
    drafts: 'Черновики',
    trash: 'Корзина',
    archive: 'Архив',
    starred: 'Отмеченные',
    important: 'Важные',
    unread: 'Непрочитанные',
    read: 'Прочитанные',
    markAsRead: 'Отметить как прочитанное',
    markAsUnread: 'Отметить как непрочитанное',
    reply: 'Ответить',
    forward: 'Переслать',
    compose: 'Создать',
    send: 'Отправить',
    receive: 'Получить',
    sync: 'Синхронизировать',
    backup: 'Резервная копия',
    restore: 'Восстановить',
    import: 'Импортировать',
    export: 'Экспортировать',
    print: 'Печать',
    saveAs: 'Сохранить как',
    open: 'Открыть',
    new: 'Новый',
    openInNewTab: 'Открыть в новой вкладке',
    openInNewWindow: 'Открыть в новом окне',
    bookmark: 'Закладка',
    unbookmark: 'Удалить закладку',
    history: 'История',
    bookmarks: 'Закладки',
    downloads: 'Загрузки',
    recent: 'Недавние',
    popular: 'Популярные',
    trending: 'Тренды',
    featured: 'Рекомендуемые',
    recommended: 'Рекомендуемые',
    suggested: 'Предлагаемые',
    related: 'Похожие',
    similar: 'Аналогичные',
    other: 'Другие',
    more: 'Больше',
    less: 'Меньше',
    none: 'Нет',
    some: 'Некоторые',
    few: 'Несколько',
    many: 'Много',
    most: 'Большинство',
    least: 'Наименьшее',
    best: 'Лучший',
    worst: 'Худший',
    highest: 'Высший',
    lowest: 'Низший',
    fastest: 'Быстрейший',
    slowest: 'Медленнейший',
    newest: 'Новейший',
    oldest: 'Старейший',
    latest: 'Последний',
    earliest: 'Ранний',
    first: 'Первый',
    last: 'Последний',
    current: 'Текущий',
    inactive: 'Неактивный',
    enabled: 'Включен',
    disabled: 'Отключен',
    on: 'Включено',
    off: 'Выключено',
    true: 'Истина',
    false: 'Ложь',
    maybe: 'Возможно',
    unknown: 'Неизвестно',
    pending: 'В ожидании',
    processing: 'Обработка',
    failed: 'Неудачно',
    cancelled: 'Отменено',
    scheduled: 'Запланировано',
    overdue: 'Просрочено',
    due: 'Срок',
    valid: 'Действительно',
    invalid: 'Недействительно',
    required: 'Обязательно',
    optional: 'Необязательно',
    available: 'Доступно',
    unavailable: 'Недоступно',
    online: 'В сети',
    offline: 'Не в сети',
    connected: 'Подключено',
    disconnected: 'Отключено',
    public: 'Публичный',
    private: 'Приватный',
    hidden: 'Скрытый',
    visible: 'Видимый',
    locked: 'Заблокировано',
    unlocked: 'Разблокировано',
    secure: 'Безопасный',
    insecure: 'Небезопасный',
    verified: 'Подтверждено',
    unverified: 'Не подтверждено',
    authenticated: 'Аутентифицировано',
    unauthenticated: 'Не аутентифицировано',
    authorized: 'Авторизовано',
    permitted: 'Разрешено',
    forbidden: 'Запрещено',
    allowed: 'Разрешено',
    denied: 'Отказано',
    granted: 'Предоставлено',
    revoked: 'Отозвано',
    accepted: 'Принято',
    rejected: 'Отклонено',
    approved: 'Одобрено',
    disapproved: 'Не одобрено',
    confirmed: 'Подтверждено',
    unconfirmed: 'Не подтверждено',
    signed: 'Подписано',
    unsigned: 'Не подписано',
    encrypted: 'Зашифровано',
    decrypted: 'Расшифровано',
    compressed: 'Сжато',
    uncompressed: 'Не сжато',
    archived: 'Архивировано',
    unarchived: 'Не архивировано',
    backedUp: 'Сохранено',
    restored: 'Восстановлено',
    imported: 'Импортировано',
    exported: 'Экспортировано',
    printed: 'Напечатано',
    saved: 'Сохранено',
    opened: 'Открыто',
    created: 'Создано',
    updated: 'Обновлено',
    changed: 'Изменено',
    selected: 'Выбрано',
    chosen: 'Выбрано',
    browsed: 'Просмотрено',
    uploaded: 'Загружено',
    downloaded: 'Скачано',
    shared: 'Поделено',
    copied: 'Скопировано',
    pasted: 'Вставлено',
    undone: 'Отменено',
    redone: 'Повторено',
    zoomedIn: 'Увеличено',
    zoomedOut: 'Уменьшено',
    fullscreened: 'Полноэкранный режим',
    muted: 'Без звука',
    unmuted: 'Со звуком',
    notified: 'Уведомлено',
    messaged: 'Сообщение отправлено',
    replied: 'Ответ отправлен',
    forwarded: 'Переслано',
    composed: 'Создано',
    received: 'Получено',
    synced: 'Синхронизировано',
    bookmarked: 'Добавлено в закладки',
    unbookmarked: 'Удалено из закладок',
    openedInNewTab: 'Открыто в новой вкладке',
    openedInNewWindow: 'Открыто в новом окне',

    // Element Creator
    elementCreator: 'Создание элемента',
    createElement: 'Создать элемент',
    createStep1Title: "Начнем! Дайте ему название.",
    elementNamePlaceholder: "напр., Как починить фрезерный станок",
    createStep2Title: "Загрузите контент",
    createStep2Sub: "Сделайте фото/видео или загрузите из галереи.",
    selectMedia: 'Выбрать медиа',
    tapToChange: 'Нажмите, чтобы изменить',
    createStep3Title: "Объясните это",
    createStep3Sub: "Что происходит на видео? Наш ИИ превратит это в профессиональное озвучивание.",
    descPlaceholder: "Опишите процесс шаг за шагом...",
    createStep4Title: "Проверка",
    aiProcessingInfo: "Сейчас мы сожмем видео, создадим профессиональную озвучку по вашему описанию и переведем все на 10 языков.",
    creatingElement: "Создание элемента...",
    videoGenerating: "Видео создаётся, подождите немного…",
    videoProcessing: "Видео завершается… Кнопка активируется автоматически.",
    videoProcessingHint: "Видео ещё обрабатывается. Подождите немного, чтобы посмотреть его сразу, или продолжайте работу.",
    pleaseWait: "Это может занять минуту. Загрузка и обработка ИИ.",
    elementCreatedSuccess: 'Элемент успешно создан!',
    elementReadyDesc: 'Ваш элемент был успешно создан и обработан.',
    viewElement: 'Посмотреть элемент сейчас',
    goToMyCourses: 'Перейти к моим курсам',
    elementPendingTitle: 'Ваше видео проверяется',
    elementPendingDesc: 'Ваше видео успешно загружено и сейчас проверяется администратором. Вскоре оно будет доступно всем.',
    elementPendingHint: 'Вы получите уведомление, как только ваше видео будет одобрено.',
    elementApprovedTitle: 'Ваше видео одобрено!',
    elementApprovedBody: 'Хорошие новости — ваше видео «{name}» одобрено и теперь доступно всем пользователям.',
    descTooShort: 'Пожалуйста, предоставьте подробное описание (мин. 10 символов).',
    invalidFileType: 'Пожалуйста, загрузите корректное видео или изображение.',
    fileTooLarge: 'Файл слишком большой. Максимальный размер 500 МБ.',
    media: 'Медиа',
    description: 'Описание',
    name: 'Название',
    
    // Course Builder
    courseDetails: 'Детали курса',
    courseName: 'Название курса',
    courseNamePlaceholder: 'напр. обслуживание машин',
    courseDescPlaceholder: 'Кратко опишите, о чем этот курс...',
    thumbnail: 'Миниатюра',
    uploadImage: '+ Загрузить изображение',
    addElements: 'Добавить элементы',
    searchElements: 'Поиск элементов...',
    loadingElements: 'Загрузка элементов...',
    preview: 'Предпросмотр',
    added: 'Добавлено',
    noElementsFound: 'Подходящие элементы не найдены.',
    organizeCourse: 'Организация курса',
    dragDropReorder: 'Перетащите, чтобы изменить порядок',
    addMoreElements: '+ Добавить еще элементы',
    courseCreated: 'Курс создан!',
    courseCreatedDesc: 'Ваша коллекция успешно сохранена.',
    createAnotherCourse: 'Создать еще один курс',
    createCourse: 'Создать курс',
    addToCourse: 'Добавить в курс',
    saving: 'Сохранение...',
    noElementsSelected: 'Пожалуйста, выберите хотя бы один элемент',
    errorCreatingCourse: 'Ошибка при создании курса',
    authError401: 'Не авторизован (401). Ваша сессия могла истечь. Войдите снова.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: '💡 Название и описание автоматически переводятся на все языки.',
    adm_en_readonly_hint: 'Переводится автоматически – нередактируемо',
    adm_filter_active: 'Активные',
    adm_filter_all: 'Все',
    adm_filter_inactive: 'Неактивные',
    adm_last_superadmin_hint: 'Последний Super Admin – нельзя удалить',
    adm_no_group_access: 'Нет доступа к контенту',
    adm_no_group_assign_warn: 'Этот пользователь не принадлежит ни одной группе и не имеет доступа к контенту.',
    adm_no_group_warn_body: 'Новые пользователи без группы не имеют доступа к контенту. Назначьте группу через 🏷️ Группы после создания.',
    adm_no_group_warn_title: 'Внимание: нет доступа к группе',
    adm_toast_added_to_group: 'Добавлен в группу',
    adm_toast_removed_from_group: 'Удалён из группы',
    adm_toast_group_assigned: 'Группа назначена',
    adm_toast_group_removed: 'Группа удалена',
    adm_toast_content_assigned: 'Контент назначен',
    adm_toast_content_removed: 'Контент удалён',
    // ── Система уведомлений ───────────────────────────────────────────────
    adm_notifications:          'Сообщения',
    notif_type_new_content:     'Новый контент',
    notif_type_message:         'Сообщение',
    notif_goto_collection:      'К коллекции',
    notif_dismiss_all:          'Закрыть все',
    notif_just_now:             'Только что',

    // ── MyCourses: фильтры, заголовки секций и пустые состояния ─────────
    mc_filter_all:            'Все',
    mc_filter_courses:        '📚 Мои Курсы',
    mc_filter_videos:         '▶ Мои Видео',
    mc_filter_favorites:      '★ Избранное',
    mc_status_all:            'Все статусы',
    mc_only_mine:             'Только мои',
    mc_section_courses_sub:   'Начатые и завершённые курсы',
    mc_section_videos:        'Мои Видео',
    mc_section_videos_sub:    'Контент, созданный вами',
    mc_section_favorites:     'Моё Избранное',
    mc_section_favorites_sub: 'Понравившиеся курсы и видео',
    mc_empty_courses:         'Вы ещё не начали ни одного курса.',
    mc_empty_videos:          'Вы ещё не создали ни одного видео.',
    mc_empty_favorites:       'Вы ещё не добавили контент в избранное.',
    videoRendering:     'Видео обрабатывается…',
    videoRenderingHint: 'Видео ещё обрабатывается. Оно будет доступно в ближайшее время.',
    // ── AdminPanel: новые строки i18n ─────────────────────────────────────
    adm_qr_unavailable:         'QR недоступен — npm install qrcode',
    adm_qr_login_title:         'QR-код для входа',
    adm_qr_scan_login_hint:     'Сканировать → войти без ввода PIN',
    adm_qr_permanent_hint:      'QR-код постоянно доступен в карточке пользователя.',
    adm_qr_print_hint:          'Распечатайте PIN сейчас или передайте безопасным способом.',
    adm_msg_subject_placeholder:'например, Новая инструкция по безопасности',
    adm_msg_text_placeholder:   'Текст сообщения…',
    adm_col_license_type:       'Тип лицензии',
    adm_btn_show_qr:            'Показать QR-код',
    adm_btn_send_msg:           'Отправить сообщение',
    adm_login_qr_label:         'QR-код для входа',
    adm_btn_gen_pin:            'Создать новый PIN',
    adm_qr_scan_hint:           'Пользователь может отсканировать код для входа без ввода PIN.',
    adm_pin_reset_hint:         'Для сброса PIN: закройте и используйте 🔄 Сбросить PIN в карточке.',
    adm_role_supervisor:        'Супервизор',
    adm_role_admin_opt:         'Администратор',
    adm_role_superadmin:        'Супер-администратор',
    adm_seat_essentials_desc:   'Essentials – все функции кроме создания контента',
    adm_pin_force_change:       'Требовать смену PIN при первом входе',
    adm_btn_msg_group:          'Сообщение группе',
    adm_btn_show:               'Показать',
    adm_btn_unlock:             'Разблокировать элемент',
    adm_btn_show_assigned:      'Показать привязанный контент',
    adm_no_videos_assigned:     'Нет прикреплённых видео. Нажмите «+ Добавить видео».',
    adm_drag_sort:              'Перетащить для сортировки',
    adm_search_video:           'Поиск видео…',
    adm_no_videos:              'Видео не найдены.',
    adm_video_unassigned:       'Это видео не привязано ни к одному материалу.',
    adm_search_messages:        'Поиск по сообщениям…',
    adm_btn_reload:             'Обновить',
    adm_enriching:              'Обогащение выполняется…',
    adm_no_video_chunks:        'Видео с фрагментами транскрипта не найдены',
    adm_ki_enrichment:          'ИИ-обогащение',
    adm_col_updated:            'Обновлено',
    adm_search_docs:            'Поиск документа или элемента…',
    adm_no_docs:                'Нет доступных документов',
    adm_col_size:               'Размер',
    adm_search_questions:       'Поиск вопросов…',
    adm_label_question:         'Вопрос сотрудника',
    adm_label_answer:           'Ответ',
    adm_btn_upload_doc:         'Загрузить документ',
    adm_just_moment:            'Одну секунду',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Только администраторы могут редактировать профиль домена.',
    adm_primary_lang:           'Основной рабочий язык',
    adm_drop_doc:               'Перетащите документ сюда или нажмите',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Существующие документы компании',
    adm_company_docs_empty:     'Документы компании ещё не загружены.',
    adm_no_licence:             'Данные о лицензии недоступны.',
    adm_full_seats_label:       '⭐ Full Seats (включая создание контента)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'Действует до',
    adm_base_lang:              'Базовый язык',
    adm_active_ui_langs:        'Активные языки интерфейса',
    adm_tts_langs:              'Языки TTS',
    adm_full_seats_total_label: '⭐ Full Seats всего',
    adm_essentials_total_label: 'Essentials Seats всего',
    adm_ui_langs_field:         'Языки UI (активные языки приложения)',
    adm_tts_langs_field:        'Языки TTS (синтез речи)',
    adm_config_title:           'Конфигурация',
    adm_config_desc:            'Настройки платформы для этого тенанта. Изменения вступают в силу немедленно.',
    adm_supervisor_mode:        'Режим супервизора',
    adm_warning_no_admin:       '⚠️ Внимание: нет активного пользователя с ролью Супервизора или Администратора (Группа 2 или 3).',
    adm_std_delete_toggle:      'Стандартные пользователи: удалять и деактивировать видео',
    adm_std_course_toggle:      'Стандартные пользователи: создавать курсы и квизы',
    adm_supervisor_confirm_title: 'Активировать режим супервизора?',
    adm_btn_activate:           'Активировать',
    adm_admin_only_setting:     'Только администраторы тенанта (Группа 3) или Супер-администраторы могут изменить этот параметр.',
    adm_only_admins_edit:       'Только администраторы могут изменить этот параметр.',
  },
  pl: {
    // Common
    // --- Wybór Scenariusza / Moderacji ---
    // --- Missing Keys Update ---
    // Polnisch (pl)
      assignToGeneral: 'Dodaj do grupy ogólnej',
  assignToGeneralOn: 'Treść będzie widoczna dla wszystkich członków grupy domyślnej po utworzeniu.',
  assignToGeneralOff: '⚠ Uwaga: Ta treść nie będzie widoczna dla ogółu użytkowników. Będzie dostępna tylko dla administratorów i twórcy.',
    videoRenderingBackground: 'Wideo jest renderowane w tle – za chwilę będzie można kontynuować.',
    manyPagesHint: 'Dokument zawiera {count} stron – analiza potrwa nieco dłużej.',
    analyzingPages: 'Analizowanie stron…',
    notif_goto_adminpanel:    'Otwórz panel admina',
    notif_type_new_question:  'Nowe pytanie',
    notif_title:         'Powiadomienia',
    notif_back:          'Wstecz',
    notif_loading:       'Ładowanie…',
    notif_empty:         'Brak wiadomości',
    notif_just_now:          'Przed chwilą',
    notif_type_message:      'Wiadomość od admina',
    notif_type_new_content:  'Nowa zawartość',
    notif_goto_collection:   'Przejdź do kolekcji',
    notif_goto_document:     'Otwórz dokument',
    notif_open_document:     'Otwórz dokument',
    notif_goto_fraghejvi:    'Otwórz FragHejVi',
    notif_close:             'Zamknij',
    notif_dismiss_all:       'Zamknij wszystkie',
    adminArea: 'Panel administratora',
    adm_pin_format_hint:    'Dokładnie 8 znaków: litery i cyfry',
    adm_pin_format_error:   'PIN musi mieć dokładnie 8 znaków alfanumerycznych.',
    adm_subtitle:          'Zarządzanie HejVi',
    adm_access_denied:     'Brak dostępu',
    adm_access_denied_desc:'Nie masz uprawnień do tego obszaru.',
    adm_back:              'Wróć',
    adm_users:             'Użytkownicy',
    adm_groups:            'Grupy',
    adm_videos:            'Filmy',
    adm_topics:            'Tematy',
    adm_video_sg:          'Film',
    adm_topic_sg:          'Temat',
    adm_docs:              'Dokumenty & Baza wiedzy',
    adm_open_video:        'Otwórz wideo w nowej karcie',
    adm_open_doc:          'Otwórz dokument w nowej karcie',
    adm_open_element:      'Otwórz element w nowej karcie',
    adm_stat_users:        'Wszyscy użytkownicy',
    adm_stat_active:       'Aktywni użytkownicy',
    adm_members:           'Członkowie',
    adm_content:           'Treści',
    adm_name:              'Nazwa',
    adm_status:            'Status',
    adm_role:              'Rola',
    adm_role_standard:     'Standardowy',
    adm_created:           'Utworzono',
    adm_actions:           'Akcje',
    adm_preview:           'Podgląd',
    adm_active:            'Aktywny',
    adm_inactive:          'Nieaktywny',
    adm_edit:              'Edytuj',
    adm_delete:            'Usuń',
    adm_new_user:          'Nowy użytkownik',
    adm_new_group:         'Nowa grupa',
    adm_edit_user:         'Edytuj użytkownika',
    adm_edit_group:        'Edytuj grupę',
    adm_create:            'Utwórz',
    adm_save:              'Zapisz',
    adm_save_translate:    'Zapisz i przetłumacz',
    adm_translating:       'Tłumaczenie…',
    adm_cancel:            'Anuluj',
    adm_done:              'Gotowe',
    adm_confirm:           'Na pewno?',
    adm_yes:               'Tak',
    adm_no:                'Nie',
    adm_mandatory:         'Obowiązkowy',
    adm_description:       'Opis',
    adm_rights_level:      'Poziom uprawnień',
    adm_lang_id:           'Język',
    adm_client_id:         'Klient',
    adm_pin_change:        'Zmień PIN (puste = bez zmian)',
    adm_pin_hint:          'Minimum 4 znaki',
    adm_pin_change_hint:   'Pozostaw puste bez zmian',
    adm_groups_for:        'Grupy dla',
    adm_groups_assign_hint:'Przypisz lub usuń grupy',
    adm_content_for_group: 'Treści dla grupy',
    adm_content_visible_hint: 'Ta treść jest widoczna dla następujących grup:',
    adm_assigned:          'Przypisano',
    adm_add:               'Dodaj',
    adm_remove:            'Usuń',
    adm_assign:            'Przypisz',
    adm_search_hint:       'szukaj',
    adm_no_users:          'Nie znaleziono użytkowników',
    adm_no_groups:         'Brak dostępnych grup',
    adm_no_entries:        'Nie znaleziono wpisów',
    adm_no_content:        'Nie znaleziono treści',
    adm_toast_deleted:     'Usunięto',
    adm_toast_created:     'Utworzono',
    adm_toast_saved:       'Zapisano',
    adm_toast_deactivated: 'Dezaktywowano',
    adm_toast_removed:     'Usunięto z grupy',
    adm_toast_added:       'Dodano do grupy',
    adm_toast_error:       'Wystąpił błąd',
    adm_toast_load_error:  'Błąd ładowania',
    // --- Document Chat ---
    chatGreeting: 'Hej! Chętnie pomogę. Co chcesz wiedzieć?',
    chatSubtitle: 'Zapytaj o dokument',
    chatButton: 'Pytania',
    chatPlaceholder: 'Zadaj pytanie dotyczące dokumentu …',
    chatClear: 'Wyczyść czat',
    chatSuggestion1: 'Podsumuj ten dokument',
    chatSuggestion2: 'Jakie są kluczowe punkty?',
    chatSuggestion3: 'Jakie wymagania są wymienione?',
    chatErrorNotAuthenticated: 'Brak autoryzacji. Zaloguj się ponownie.',
    chatErrorNoAnswer: 'Nie otrzymano odpowiedzi.',
    chatErrorGeneric: 'Błąd',
    // --- Global Chat Widget ---
    globalChatTitle: 'Asystent Wiedzy',
    globalChatSubtitle: 'Wszystkie dokumenty i wideo',
    globalChatFab: 'Zapytaj o cokolwiek',
    globalChatGreeting: 'Hej! Mogę pomóc Ci w pytaniach dotyczących wszystkich Twoich dokumentów i filmów. Co chcesz wiedzieć?',
    globalChatPlaceholder: 'Zadaj pytanie dotyczące wszystkich Twoich treści …',
    globalSuggestion1: 'Co moje dokumenty mówią o wymogach bezpieczeństwa?',
    globalSuggestion2: 'Podsumuj wszystkie dostępne treści',
    globalSuggestion3: 'Które filmy poruszają ten temat?',
    sourcesUsed: 'Źródła',
    sourceDocument: 'Dokument',
    sourceVideo: 'Wideo',
    goToElement: 'Otwórz element →',
    goToVideo: 'Obejrzyj wideo →',
    createdOn: 'Utworzono',
    pleaseSelectDocument: 'Proszę wybrać dokument (PDF, TXT lub DOC).',
    selectDocument: 'Wybierz dokument',
    photoVideo: 'Zdjęcie / Wideo',
    document: 'Dokument',
    replaceFile: 'Zastąp',
    removeFile: 'Usuń',
    documentTypeDefault: 'Dokument',
    invalidDocumentType: 'Prześlij prawidłowy plik: PDF, TXT, DOC/DOCX lub PPT/PPTX.',
    documentTooLarge: 'Plik jest za duży. Maksymalnie {mb} MB.',
    documentAiInfo: 'AI automatycznie wyodrębnia treść, tworzy podsumowanie (1-2 zdania) jako lektora i używa pierwszej strony jako miniatury.',
    documentModeActive: 'Tryb dokumentu aktywny',
    documentModeDesc: 'AI automatycznie użyje treści dokumentu jako tekstu wideo. Możesz dodać kontekst lub zostawić puste.',
    docAdditionalContextPlaceholder: 'Opcjonalny dodatkowy kontekst (np. grupa docelowa)...',
    optionLabel: 'Opcja',
    aiOptionLabel: 'Opcja AI',
    autoGeneratedFromDoc: 'Wygenerowano automatycznie z dokumentu',
    documentAutoProcess: 'AI wyodrębnia treść i tworzy podsumowanie jako tekst wideo.',
    aiDocProcessingInfo: 'Analizujemy dokument, generujemy podsumowanie jako lektora i tworzymy wideo z pierwszą stroną jako miniaturą.',
    viewDocument: 'Podgląd',
    downloadDocument: 'Pobierz',
    responseVideoNotFound: 'Nie znaleziono wideo odpowiedzi',
    responseVideoNotReady: 'Wideo odpowiedzi dla tego wyzwania jeszcze nie istnieje.',
    unknownQRCodeTitle: 'Nieznany kod QR',
    unknownQRCodeQuestion: 'Jak chcesz postąpić?',
    unknownQRCodeCreateCollection: 'Utwórz nową kolekcję',
    addVideo: 'Dodaj wideo',
    pleaseSelectMedia: 'Proszę wybrać wideo lub zdjęcie.',
    originalText: 'Oryginał',
    printQRLabel: '🖨️ Drukuj etykietę QR',
    printerConnecting: '🔵 Łączenie z drukarką...',
    printerPrinting: '⏳ Drukowanie...',
    printerDone: '✅ Wydrukowano!',
    printerError: '❌ Błąd – Spróbuj ponownie',
    bluetoothHint: 'Łączy przez Bluetooth – wybierz Niimbot B1 z listy',
    printerErrorHint: 'Drukarka włączona? Tylko Chrome/Edge obsługują Web Bluetooth.',
    number_of_views: 'Wyświetlenia',
    number_of_likes: 'Polubienia',
    qrCode: 'Kod QR',
    printQrCode: 'Drukuj kod QR',
    playFrom: 'Odtwarzaj od',
    voiceSearchSummary: '{collections} kolekcji, {elements} elementów',
    pleaseLoginFirst: 'Zaloguj się, aby skanować kody QR',
    openingUrl: 'Otwieranie URL...',
    eanNotFound: 'Nie znaleziono przedmiotu z tym EAN',
    sessionExpired: 'Twoja sesja wygasła. Zaloguj się ponownie.',
    recordingTooShort: "Nagranie za krótkie",
    errorNoSpeechDetected: "Nie wykryto mowy. Proszę mówić głośniej lub zbliżyć się do mikrofonu.",
    errorTranscriptionFailed: "Nie zrozumiano nagrania. Spróbuj ponownie i mów wyraźnie.",
    reactionVideo: 'Wideo reakcji?',
    setThisToReaction: 'Oznacza ten element jako wideo odpowiedzi (Typ zawartości 4).',
    selectModeration: 'Wybierz pasujący tekst',
    selectModerationDesc: 'AI wygenerowało następujące propozycje tekstu na podstawie twojego opisu:',
    generatingScripts: 'Generowanie tekstów...',
    nothingFits: 'Nic nie pasuje',
    backToDesc: 'Wróć do opisu',
    selectedModeration: 'Wybrana moderacja',
    maxRetriesReached: 'Proszę doprecyzować opis. Brak kolejnych prób.',
    errorLoadingScripts: 'Błąd ładowania sugestii. Sprawdź połączenie internetowe lub zaloguj się ponownie.',

    challenge: 'Wyzwanie',
    thinking: 'Myślę...',
    aiSuggest: 'Sugestie AI Hejvi',
    aiNoSuggestions: 'AI nie znalazło konkretnych elementów. Pokazano wszystkie.',
    showAll: 'Pokaż wszystko',
    totalXp: 'Całkowite XP',
    sec: "sek",
    min: "min",
    invalidInput: "Dane wejściowe zawierają nieprawidłowe znaki.",
    errorContentRejected: "Ta treść została odrzucona, ponieważ narusza nasze zasady bezpieczeństwa (np. mowa nienawiści, przemoc, treści seksualne). Proszę poprawić wprowadzone dane.",
    errorImageTooLarge: "Obraz jest za duży (Maks 4MB).",
    errorInvalidImageType: "Nieprawidłowy format. Dozwolone: JPG, PNG, WEBP, GIF.",
    warningImageTooLarge: "Obraz okładki jest zbyt duży do tymczasowego przechowywania. Struktura kursu została zapisana, ale obraz został pominięty. Proszę wybrać go ponownie po powrocie.",
    draftSaveError: "Nie można zapisać szkicu.",
    authErrorTokenMissing: "Brak tokenu autoryzacji.",
    uploadFailed: "Przesyłanie nie powiodło się.",
    qrErrorEmpty: "Proszę wprowadzić wartość kodu QR.",
    errorOptionMissing: "Proszę wypełnić Opcję",
    viewQuiz: 'Zobacz quiz',
    details: 'Szczegóły',
    pleaseUploadThumbnail: "Proszę przesłać miniaturkę kursu.",
    createVideoElement: 'Utwórz wideo',
    createQuizElement: 'Utwórz quiz',
    orSelectExisting: 'Lub wybierz istniejące elementy:',
    organize: 'Przesuń filmy, aby zmienić kolejność',
    viewCourse: 'Zobacz kurs',
    filterMyContent: 'Tylko moje treści',
    makeVisible: 'Uczyń widocznym',
    makeInvisible: 'Ukryj',
    selectCorrectAnswer: 'Wybierz poprawną odpowiedź',
    selectCorrectAnswerDesc: 'Która opcja jest poprawnym rozwiązaniem?',
    QuizExampleQrHash: 'np. el-32hhuz3',
    pleaseEnterQuestion: 'Proszę wprowadzić pytanie lub tytuł.',
    typeYesNo: 'Tak / Nie',
    typeQR: 'Skan QR',
    typeMulti: 'Wielokrotny wybór',
    QuizQuestionPlaceholder: 'np. Czy ten sprzęt ochronny jest poprawny?',
    QuizDescriptionPlaceholder: 'Opcjonalny opis...',
    quizCreatedSuccess: 'Quiz został pomyślnie utworzony!',
    tapToUpload: 'Prześlij miniaturkę',
    uploadOrAutoThumb: 'Prześlij obraz',
    autoThumbHint: 'W przeciwnym razie generowane automatycznie z miniatur wideo',
    imageSelected: 'Wybrano obraz',
    yes: 'Tak',
    no: 'Nie',
    correct: 'Poprawnie',
    incorrect: 'Niepoprawnie',
    submit: 'Wyślij',
    next: 'Dalej',
    back: 'Wstecz',
    cancel: 'Anuluj',
    create: 'Utwórz',
    error: 'Błąd',
    success: 'Sukces',
    save: 'Zapisz',
    delete: 'Usuń',
    edit: 'Edytuj',
    close: 'Zamknij',
    previous: 'Poprzedni',
    loading: 'Ładowanie...',

    // --- Quiz Builder ---
    createQuiz: 'Utwórz Quiz',
    configureQuiz: 'Konfiguruj Quiz',
    selectType: 'Wybierz typ',
    selectResponses: 'Wybierz wideo odpowiedzi',
    selectResponsesDesc: 'Wybierz filmy, które zostaną odtworzone po odpowiedzi użytkownika.',
    question: 'Pytanie',
    enableHint: 'Włączyć podpowiedź?',
    hintNotAvailableQR: 'Podpowiedzi są wyłączone dla wyzwań QR.',

    // QR
    qrTargetTitle: 'Cel kodu QR',
    qrTargetDesc: 'Jaki tekst/kod jest ukryty w kodzie QR?',
    qrValueLabel: 'Treść QR (Dokładnie)',

    // Review
    reviewQuiz: 'Podsumowanie',
    reviewDesc: 'Sprawdź swoje ustawienia przed utworzeniem quizu.',

    // Walidacja
    pleaseEnterName: 'Proszę wprowadzić nazwę.',
    errorSelectCorrect: 'Proszę wybrać poprawną odpowiedź.',
    selectBothResponses: 'Proszę wybrać oba filmy odpowiedzi.',

    // Success
    backToDashboard: 'Powrót do pulpitu',
    createAnother: 'Utwórz kolejny',
    scanToStart: 'Zeskanuj, aby rozpocząć',
    useExactTextTitle: 'Użyj dokładnego tekstu',
    useExactTextDesc: 'Pomiń optymalizację AI i czytaj opis 1:1.',
    transcribeVideoTitle: 'Użyj dźwięku wideo jako lektora',
    transcribeVideoDesc: 'Mówiony tekst jest transkrybowany. Użyj dosłownie jako lektora (zsynchronizowanego) lub jako podstawy do zoptymalizowanego skryptu AI.',
    transcribeVideo: 'Transkrybuj',
    transcribing: 'Transkrybuję...',
    transcriptAdopted: 'Dźwięk wideo przyjęty jako lektor',
    resetTranscript: 'Odrzuć transkrypcję',
    transcriptionFailed: 'Transkrypcja nie powiodła się.',
    transcribeExactInfo: 'Mówiony tekst jest transkrybowany dosłownie i używany jako lektor. Napisy pozostają zsynchronizowane z oryginalnym wideo.',
    transcribeLLMInfo: 'Mówiony tekst jest transkrybowany. AI tworzy zoptymalizowany skrypt lektora w wykrytym języku wideo.',
    transcribeExactToggleDesc: 'Użyj transkrypcji 1:1 jako lektora (zsynchronizowanej z wideo). Wył: AI generuje zoptymalizowany skrypt z transkrypcji.',
    loginWithQRCode: 'Zaloguj się kodem QR',
    search: 'Szukaj',
    filter: 'Filtruj',
    all: 'Wszystkie',
    needHint: 'Potrzebujesz podpowiedzi?',
    
    // Navigation
    home: 'Strona główna',
    challenges: 'Wyzwania',
    favorites: 'Ulubione',
    profile: 'Profil',
    myCourses: 'Moje kursy',
    
    // Dashboard
    welcome: 'Witaj ponownie! 👋',
    searchPlaceholder: 'Szukaj treści…',
    mustSee: 'Koniecznie zobacz',
    safety: 'Bezpieczeństwo',
    tools: 'Narzędzia',
    law: 'Prawo',
    mandatory: 'Obowiązkowe',
    mandatoryFilter: 'Kursy obowiązkowe',
    mandatoryCourses: 'Kursy obowiązkowe',
    favourites: 'Ulubione',
    favouritesFilter: 'Ulubione',
    loadMore: 'Załaduj więcej',
    play: 'Odtwórz',
    favorite: 'Dodaj do ulubionych',
    unfavorite: 'Usuń z ulubionych',
    
    // Login
    login: 'Zaloguj się',
    enterPin: 'Wprowadź PIN',
    invalidPin: 'Proszę wprowadzić poprawny 8-cyfrowy PIN',
    loginError: 'Nieprawidłowy PIN. Spróbuj ponownie.',
    wrongPin: 'Błędny PIN. Spróbuj ponownie.',
    loginSuccess: 'Logowanie pomyślne! Witaj ponownie! 🎉',
    
    // Profile
    myProfile: 'Mój profil',
    myProgress: 'Mój postęp',
    contactSupport: 'Kontakt z pomocą',
    language: 'Język',
    settings: 'Ustawienia',
    privacy: 'Prywatność',
    help: 'Pomoc',
    logout: 'Wyloguj się',
    active: 'Aktywny',
    beginner: 'Początkujący',
    intermediate: 'Średnio zaawansowany',
    advanced: 'Zaawansowany',
    joined: 'Dołączono',
    courses: 'Kursy',
    completed: 'Ukończone',
    inProgress: 'W toku',
    achievements: 'Osiągnięcia',
    topLearner: 'Najlepszy uczeń',
    safetyStar: 'Gwiazda bezpieczeństwa',
    firstSteps: 'Pierwsze kroki',
    learner: 'Uczeń',
    group: 'Grupa',
    client: 'Klient',
    
    // Contact Form
    yourName: 'Twoje imię i nazwisko',
    emailAddress: 'Adres e-mail',
    describeIssue: 'Opisz swój problem...',
    sendMessage: 'Wyślij wiadomość',
    messageSent: 'Wiadomość wysłana pomyślnie!',
    messageSendError: 'Nie udało się wysłać wiadomości. Spróbuj ponownie.',
    
    // Course/Video
    startCourse: 'Rozpocznij kurs',
    continueCourse: 'Kontynuuj kurs',
    courseProgress: 'Postęp kursu',
    videoProgress: 'Postęp wideo',
    stepsInThisVideo: 'Kroki w tym wideo',
    relatedVideos: 'Powiązane wideo',
    duration: 'Czas trwania',
    experiencePoints: 'Punkty doświadczenia',
    levelComplexity: 'Poziom trudności',
    lessons: 'Lekcje',
    nextLessonStartsIn: 'Następna lekcja rozpocznie się za',
    nextVideoIn: 'Następne wideo za',
    seconds: 's',
    replay: 'Odtwórz ponownie',
    cancelAutoplay: 'Anuluj autoodtwarzanie',
    loadingCourses: 'Ładowanie kursów...',
    noCourses: 'Brak dostępnych kursów',
    searchCourses: 'Szukaj kursów...',
    noResults: 'Nie znaleziono kursów',
    workplaceSafety: 'Bezpieczeństwo w pracy',
    workplaceSafetyDesc: 'Kluczowe protokoły bezpieczeństwa w miejscu pracy',
    
    // Challenges
    allChallenges: 'Wszystkie wyzwania',
    currentChallenges: 'Bieżące wyzwania',
    challengeProgress: 'Postęp wyzwania',
    challengeEnds: 'Wyzwanie kończy się',
    daysLeft: 'dni pozostało',
    hoursLeft: 'godz. pozostało',
    minutesLeft: 'min pozostało',
    loadingChallenges: 'Ładowanie wyzwań...',
    activeChallenges: 'Aktywne wyzwania',
    weeklyProgress: 'Postęp',
    noChallenges: 'Brak dostępnych wyzwań w tej chwili.',
    startNow: 'Rozpocznij teraz',
    discoverMore: 'Odkryj więcej wyzwań',
    stayMotivated: 'Utrzymaj motywację i zdobywaj nagrody!',
    doneChallenges: 'zrobione',
    challengesProgressLabel: 'Postęp wyzwań',
    mandatoryProgressLabel: 'Postęp kursów obowiązkowych',
    doneMandatory: 'kursów obowiązkowych ukończono',
    completeChallengesEarnXP: 'Ukończ wyzwania, aby zdobyć XP!',
    noDeadline: 'Bez terminu',
    failedToLoadChallenges: 'Nie udało się załadować wyzwań',
    expired: 'Wygasłe',
    lessThan1hLeft: 'Pozostało mniej niż 1h',
    expert: 'Ekspert',
    
    // QR Scanner
    scanQR: 'Zeskanuj kod QR',
    scanPlaceholder: 'Skieruj kamerę na kod QR',
    scanSuccess: 'Kod QR zeskanowany pomyślnie!',
    scanError: 'Nie udało się zeskanować kodu QR',
    cameraError: 'Odmowa dostępu do kamery',
    cameraPermission: 'Proszę zezwolić na dostęp do kamery',
    cameraPermissionDenied: 'Odmowa dostępu do kamery. Proszę zezwolić na dostęp.',
    noCameraFound: 'Nie znaleziono kamery. Sprawdź swoje urządzenie.',
    cameraNotSupported: 'Kamera nieobsługiwana w tej przeglądarce.',
    cameraInUse: 'Kamera jest używana przez inną aplikację.',
    cameraConstraintsNotMet: 'Wymagania kamery niespełnione. Spróbuj innej kamery.',
    failedToStartCamera: 'Nie udało się uruchomić kamery',
    failedToAccessCamera: 'Nie udało się uzyskać dostępu do kamery. Sprawdź uprawnienia przeglądarki.',
    onlyOneCameraAvailable: 'Dostępna tylko jedna kamera na tym urządzeniu',
    noSuitableCameraFound: 'Nie znaleziono odpowiedniej kamery do przełączenia',
    failedToSwitchCamera: 'Nie udało się przełączyć kamery',
    cameraSwitchFailed: 'Przełączanie kamery nie powiodło się',
    unableToReadCodeFromImage: 'Nie można odczytać kodu z obrazu',
    errorAccessingCamera: 'Błąd dostępu do kamery',
    tryAgain: 'Spróbuj ponownie',
    switchingCamera: 'Przełączanie kamery...',
    gallery: 'Galeria',
    flash: 'Lampa błyskowa',
    switchCamera: 'Przełącz kamerę',
    capture: 'Zrób zdjęcie',
    
    // Voice Recording
    voiceSearch: 'Wyszukiwanie głosowe',
    tapToStartRecording: 'Dotknij, aby rozpocząć nagrywanie',
    speakYourSearchQuery: 'Wypowiedz wyraźnie zapytanie',
    startRecording: 'Rozpocznij nagrywanie',
    stopRecording: 'Zatrzymaj nagrywanie',
    recording: 'Nagrywanie...',
    processingAudio: 'Przetwarzanie dźwięku...',
    transcript: 'Transkrypcja',
    closingOverlay: 'Zamykanie nakładki i wyświetlanie wyników...',
    searchAgain: 'Szukaj ponownie',
    
    // Toast Messages
    urlOpened: 'URL otwarty w nowej karcie',
    navigatingCourse: 'Przechodzenie do kursu...',
    productCode: 'Kod produktu: {code}',
    lookingUpEAN: 'Wyszukiwanie EAN {ean}...',
    fetchingContent: 'Pobieranie treści...',
    elementFound: 'Znaleziono element: {name}',
    collectionFound: 'Znaleziono kolekcję: {name}',
    contentNotFound: 'Treść nie znaleziona',
    
    // Errors
    networkError: 'Błąd sieci. Sprawdź swoje połączenie.',
    serverError: 'Błąd serwera. Spróbuj ponownie później.',
    unauthorized: 'Nieautoryzowany dostęp. Zaloguj się ponownie.',
    notFound: 'Treść nie znaleziona.',
    generalError: 'Wystąpił nieoczekiwany błąd.',
    
    // Time
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
    thisWeek: 'W tym tygodniu',
    thisMonth: 'W tym miesiącu',
    ago: 'temu',
    minutes: 'minuty',
    hours: 'godziny',
    days: 'dni',
    weeks: 'tygodnie',
    months: 'miesiące',
    years: 'lata',
    
    // Additional UI Elements
    seeAll: 'Zobacz wszystkie',
    seeMore: 'Zobacz więcej',
    seeLess: 'Pokaż mniej',
    expand: 'Rozwiń',
    collapse: 'Zwiń',
    refresh: 'Odśwież',
    retry: 'Ponów',
    confirm: 'Potwierdź',
    ok: 'OK',
    done: 'Gotowe',
    skip: 'Pomiń',
    continue: 'Kontynuuj',
    finish: 'Zakończ',
    start: 'Start',
    stop: 'Stop',
    pause: 'Pauza',
    resume: 'Wznów',
    restart: 'Uruchom ponownie',
    reset: 'Resetuj',
    clear: 'Wyczyść',
    remove: 'Usuń',
    add: 'Dodaj',
    update: 'Aktualizuj',
    change: 'Zmień',
    select: 'Wybierz',
    choose: 'Wybierz',
    browse: 'Przeglądaj',
    upload: 'Prześlij',
    download: 'Pobierz',
    share: 'Udostępnij',
    copy: 'Kopiuj',
    paste: 'Wklej',
    cut: 'Wycięto',
    undo: 'Cofnij',
    redo: 'Ponów',
    zoomIn: 'Powiększ',
    zoomOut: 'Pomniejsz',
    fullscreen: 'Pełny ekran',
    exitFullscreen: 'Zamknij pełny ekran',
    volume: 'Głośność',
    mute: 'Wycisz',
    unmute: 'Wyłącz wyciszenie',
    preferences: 'Preferencje',
    account: 'Konto',
    notifications: 'Powiadomienia',
    messages: 'Wiadomości',
    inbox: 'Odebrane',
    sent: 'Wysłane',
    drafts: 'Wersje robocze',
    trash: 'Kosz',
    archive: 'Archiwum',
    starred: 'Oznaczone gwiazdką',
    important: 'Ważne',
    unread: 'Nieprzeczytane',
    read: 'Przeczytane',
    markAsRead: 'Oznacz jako przeczytane',
    markAsUnread: 'Oznacz jako nieprzeczytane',
    reply: 'Odpowiedz',
    forward: 'Przekaż',
    compose: 'Utwórz',
    receive: 'Odbierz',
    sync: 'Synchronizuj',
    backup: 'Kopia zapasowa',
    restore: 'Przywróć',
    import: 'Importuj',
    export: 'Eksportuj',
    print: 'Drukuj',
    saveAs: 'Zapisz jako',
    open: 'Otwórz',
    new: 'Nowy',
    openInNewTab: 'Otwórz w nowej karcie',
    openInNewWindow: 'Otwórz w nowym oknie',
    bookmark: 'Zakładka',
    unbookmark: 'Usuń zakładkę',
    history: 'Historia',
    bookmarks: 'Zakładki',
    downloads: 'Pobrane',
    recent: 'Ostatnie',
    popular: 'Popularne',
    trending: 'Na czasie',
    featured: 'Polecane',
    recommended: 'Rekomendowane',
    suggested: 'Sugerowane',
    related: 'Powiązane',
    similar: 'Podobne',
    other: 'Inne',
    more: 'Więcej',
    less: 'Mniej',
    none: 'Brak',
    some: 'Trochę',
    few: 'Kilka',
    many: 'Wiele',
    most: 'Większość',
    least: 'Najmniej',
    best: 'Najlepsze',
    worst: 'Najgorsze',
    highest: 'Najwyższe',
    lowest: 'Najniższe',
    fastest: 'Najszybsze',
    slowest: 'Najwolniejsze',
    newest: 'Najnowsze',
    oldest: 'Najstarsze',
    latest: 'Ostatnie',
    earliest: 'Najwcześniejsze',
    first: 'Pierwsze',
    last: 'Ostatnie',
    current: 'Bieżące',
    inactive: 'Nieaktywny',
    enabled: 'Włączone',
    disabled: 'Wyłączone',
    on: 'Wł.',
    off: 'Wył.',
    true: 'Prawda',
    false: 'Fałsz',
    maybe: 'Może',
    unknown: 'Nieznany',
    pending: 'Oczekujący',
    processing: 'Przetwarzanie',
    failed: 'Niepowodzenie',
    cancelled: 'Anulowano',
    scheduled: 'Zaplanowano',
    overdue: 'Zaległe',
    due: 'Termin',
    valid: 'Ważne',
    invalid: 'Nieważne',
    required: 'Wymagane',
    optional: 'Opcjonalne',
    available: 'Dostępne',
    unavailable: 'Niedostępne',
    online: 'Online',
    offline: 'Offline',
    connected: 'Połączono',
    disconnected: 'Rozłączono',
    public: 'Publiczne',
    private: 'Prywatne',
    hidden: 'Ukryte',
    visible: 'Widoczne',
    locked: 'Zablokowane',
    unlocked: 'Odblokowane',
    secure: 'Bezpieczne',
    insecure: 'Niebezpieczne',
    verified: 'Zweryfikowany',
    unverified: 'Niezweryfikowany',
    authenticated: 'Uwierzytelniony',
    unauthenticated: 'Nieuwierzytelniony',
    authorized: 'Autoryzowany',
    permitted: 'Dozwolone',
    forbidden: 'Zabronione',
    allowed: 'Dozwolone',
    denied: 'Odmówiono',
    granted: 'Przyznano',
    revoked: 'Odwołano',
    accepted: 'Zaakceptowano',
    rejected: 'Odrzucono',
    approved: 'Zatwierdzono',
    disapproved: 'Odrzucono',
    confirmed: 'Potwierdzono',
    unconfirmed: 'Niepotwierdzono',
    signed: 'Podpisano',
    unsigned: 'Niepodpisano',
    encrypted: 'Zaszyfrowane',
    decrypted: 'Odszyfrowane',
    compressed: 'Skompresowane',
    uncompressed: 'Nieskompresowane',
    archived: 'Zarchiwizowano',
    unarchived: 'Przywrócono z archiwum',
    backedUp: 'Utworzono kopię zapasową',
    restored: 'Przywrócono',
    imported: 'Zaimportowano',
    exported: 'Wyeksportowano',
    printed: 'Wydrukowano',
    saved: 'Zapisano',
    opened: 'Otwarto',
    created: 'Utworzono',
    updated: 'Zaktualizowano',
    changed: 'Zmieniono',
    selected: 'Wybrano',
    chosen: 'Wybrano',
    browsed: 'Przeglądano',
    uploaded: 'Przesłano',
    downloaded: 'Pobrano',
    shared: 'Udostępniono',
    copied: 'Skopiowano',
    pasted: 'Wklejono',
    undone: 'Cofnięto',
    redone: 'Ponowiono',
    zoomedIn: 'Powiększono',
    zoomedOut: 'Pomniejszono',
    fullscreened: 'Przełączono na pełny ekran',
    muted: 'Wyciszono',
    unmuted: 'Wyłączono wyciszenie',
    notified: 'Powiadomiono',
    messaged: 'Wysłano wiadomość',
    replied: 'Odpowiedziano',
    forwarded: 'Przekazano',
    composed: 'Utworzono',
    received: 'Odebrano',
    synced: 'Zsynchronizowano',
    bookmarked: 'Dodano do zakładek',
    unbookmarked: 'Usunięto z zakładek',
    openedInNewTab: 'Otwarto w nowej karcie',
    openedInNewWindow: 'Otwarto w nowym oknie',

    // Element Creator Specific
    elementCreator: 'Kreator Elementów',
    createElement: 'Utwórz element',
    createStep1Title: "Zaczynajmy! Nadaj mu nazwę.",
    elementNamePlaceholder: "np. Jak naprawić frezarkę",
    createStep2Title: "Prześlij treść",
    createStep2Sub: "Zrób zdjęcie/wideo lub wybierz z galerii.",
    selectMedia: 'Wybierz media',
    tapToChange: 'Dotknij, aby zmienić',
    createStep3Title: "Wyjaśnij to",
    createStep3Sub: "Co dzieje się na tym filmie? Nasze AI zamieni to w profesjonalną narrację.",
    descPlaceholder: "Opisz proces krok po kroku...",
    createStep4Title: "Przegląd",
    aiProcessingInfo: "Teraz skompresujemy wideo, wygenerujemy profesjonalnego lektora na podstawie twojego opisu i przetłumaczymy wszystko na 10 języków.",
    creatingElement: "Tworzenie elementu...",
    videoGenerating: "Wideo jest generowane, proszę chwilę poczekać…",
    videoProcessing: "Wideo jest finalizowane… Przycisk zostanie automatycznie odblokowany.",
    videoProcessingHint: "Wideo jest jeszcze przetwarzane. Poczekaj chwilę, aby je od razu obejrzeć, lub po prostu kontynuuj pracę.",
    pleaseWait: "To może potrwać minutę. Przesyłanie i przetwarzanie AI.",
    elementCreatedSuccess: 'Element został pomyślnie utworzony!',
    elementReadyDesc: 'Twój element został pomyślnie utworzony i przetworzony.',
    viewElement: 'Zobacz element teraz',
    goToMyCourses: 'Przejdź do moich kursów',
    elementPendingTitle: 'Twój film jest sprawdzany',
    elementPendingDesc: 'Twój film został przesłany pomyślnie i jest teraz sprawdzany przez administratora. Wkrótce będzie dostępny dla wszystkich.',
    elementPendingHint: 'Otrzymasz powiadomienie, gdy Twój film zostanie zatwierdzony.',
    elementApprovedTitle: 'Twój film został zatwierdzony!',
    elementApprovedBody: 'Dobra wiadomość — Twój film „{name}" został zatwierdzony i jest teraz widoczny dla wszystkich użytkowników.',
    descTooShort: 'Proszę podać szczegółowy opis (min. 10 znaków).',
    invalidFileType: 'Proszę przesłać poprawny plik wideo lub obraz.',
    fileTooLarge: 'Plik jest za duży. Maksymalny rozmiar to 500MB.',
    media: 'Media',
    description: 'Opis',
    name: 'Nazwa',
    
    // Course Builder
    courseDetails: 'Szczegóły kursu',
    courseName: 'Nazwa kursu',
    courseNamePlaceholder: 'np. konserwacja maszyn',
    courseDescPlaceholder: 'Krótko opisz, o czym jest ten kurs...',
    thumbnail: 'Miniaturka',
    uploadImage: '+ Prześlij obraz',
    addElements: 'Dodaj elementy',
    searchElements: 'Szukaj elementów...',
    loadingElements: 'Ładowanie elementów...',
    preview: 'Podgląd',
    added: 'Dodano',
    noElementsFound: 'Nie znaleziono pasujących elementów.',
    organizeCourse: 'Organizuj kurs',
    dragDropReorder: 'Przeciągnij i upuść, aby zmienić kolejność',
    addMoreElements: '+ Dodaj więcej elementów',
    courseCreated: 'Kurs utworzony!',
    courseCreatedDesc: 'Twoja kolekcja została pomyślnie zapisana.',
    createAnotherCourse: 'Utwórz kolejny kurs',
    createCourse: 'Utwórz kurs',
    addToCourse: 'Dodaj do kursu',
    saving: 'Zapisywanie...',
    noElementsSelected: 'Proszę wybrać co najmniej jeden element',
    errorCreatingCourse: 'Błąd podczas tworzenia kursu',
    authError401: 'Brak autoryzacji (401). Twoja sesja mogła wygasnąć. Zaloguj się ponownie.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: '💡 Nazwa i opis są automatycznie tłumaczone na wszystkie języki.',
    adm_en_readonly_hint: 'Tłumaczone automatycznie – nie do edycji',
    adm_filter_active: 'Aktywne',
    adm_filter_all: 'Wszystkie',
    adm_filter_inactive: 'Nieaktywne',
    adm_last_superadmin_hint: 'Ostatni Super Admin – nie można usunąć',
    adm_no_group_access: 'Brak dostępu do treści',
    adm_no_group_assign_warn: 'Ten użytkownik nie jest przypisany do żadnej grupy i dlatego nie ma dostępu do treści.',
    adm_no_group_warn_body: 'Nowi użytkownicy bez grupy nie mają dostępu do treści. Przypisz grupę przez 🏷️ Grupy po utworzeniu.',
    adm_no_group_warn_title: 'Uwaga: brak dostępu do grupy',
    adm_toast_added_to_group: 'Dodano do grupy',
    adm_toast_removed_from_group: 'Usunięto z grupy',
    adm_toast_group_assigned: 'Grupa przypisana',
    adm_toast_group_removed: 'Grupa usunięta',
    adm_toast_content_assigned: 'Treść przypisana',
    adm_toast_content_removed: 'Treść usunięta',
    // ── System powiadomień ────────────────────────────────────────────────
    adm_notifications:          'Wiadomości',
    notif_type_new_content:     'Nowa treść',
    notif_type_message:         'Wiadomość',
    notif_goto_collection:      'Do kolekcji',
    notif_dismiss_all:          'Zamknij wszystko',
    notif_just_now:             'Przed chwilą',

    // ── MyCourses: filtry, nagłówki sekcji i komunikaty o braku danych ──
    mc_filter_all:            'Wszystkie',
    mc_filter_courses:        '📚 Moje Kursy',
    mc_filter_videos:         '▶ Moje Filmy',
    mc_filter_favorites:      '★ Ulubione',
    mc_status_all:            'Wszystkie statusy',
    mc_only_mine:             'Tylko moje',
    mc_section_courses_sub:   'Rozpoczęte i ukończone kursy',
    mc_section_videos:        'Moje Filmy',
    mc_section_videos_sub:    'Treści stworzone przez ciebie',
    mc_section_favorites:     'Moje Ulubione',
    mc_section_favorites_sub: 'Polubione kursy i filmy',
    mc_empty_courses:         'Nie rozpocząłeś jeszcze żadnego kursu.',
    mc_empty_videos:          'Nie stworzyłeś jeszcze żadnych filmów.',
    mc_empty_favorites:       'Nie dodałeś jeszcze żadnych treści do ulubionych.',
    videoRendering:     'Renderowanie wideo…',
    videoRenderingHint: 'Wideo jest jeszcze przetwarzane. Będzie dostępne wkrótce.',
    // ── AdminPanel: nowe ciągi i18n ───────────────────────────────────────
    adm_qr_unavailable:         'QR niedostępny — npm install qrcode',
    adm_qr_login_title:         'Kod QR do logowania',
    adm_qr_scan_login_hint:     'Skanuj → zaloguj się bez wprowadzania PIN',
    adm_qr_permanent_hint:      'Kod QR jest trwale dostępny w danych użytkownika.',
    adm_qr_print_hint:          'Wydrukuj PIN teraz lub przekaż go bezpiecznie.',
    adm_msg_subject_placeholder:'np. Dostępna nowa instrukcja bezpieczeństwa',
    adm_msg_text_placeholder:   'Treść wiadomości…',
    adm_col_license_type:       'Typ licencji',
    adm_btn_show_qr:            'Pokaż kod QR',
    adm_btn_send_msg:           'Wyślij wiadomość',
    adm_login_qr_label:         'Kod QR logowania',
    adm_btn_gen_pin:            'Generuj nowy PIN',
    adm_qr_scan_hint:           'Użytkownik może zeskanować ten kod, aby zalogować się bez PIN.',
    adm_pin_reset_hint:         'Aby zresetować PIN: zamknij i użyj 🔄 Resetuj PIN w karcie użytkownika.',
    adm_role_supervisor:        'Supervisor',
    adm_role_admin_opt:         'Admin',
    adm_role_superadmin:        'Super Admin',
    adm_seat_essentials_desc:   'Essentials – wszystkie funkcje z wyjątkiem tworzenia treści',
    adm_pin_force_change:       'Wymuś zmianę PIN przy pierwszym logowaniu',
    adm_btn_msg_group:          'Wiadomość do grupy',
    adm_btn_show:               'Pokaż',
    adm_btn_unlock:             'Odblokuj element',
    adm_btn_show_assigned:      'Pokaż przypisane treści',
    adm_no_videos_assigned:     'Brak przypisanych filmów. Kliknij „+ Dodaj film".',
    adm_drag_sort:              'Przeciągnij, aby posortować',
    adm_search_video:           'Szukaj filmu…',
    adm_no_videos:              'Nie znaleziono filmów.',
    adm_video_unassigned:       'Ten film nie jest przypisany do żadnej treści.',
    adm_search_messages:        'Szukaj wiadomości…',
    adm_btn_reload:             'Odśwież',
    adm_enriching:              'Wzbogacanie w toku…',
    adm_no_video_chunks:        'Nie znaleziono filmów z fragmentami transkrypcji',
    adm_ki_enrichment:          'Wzbogacanie AI',
    adm_col_updated:            'Zaktualizowano',
    adm_search_docs:            'Szukaj dokumentu lub elementu…',
    adm_no_docs:                'Brak dostępnych dokumentów',
    adm_col_size:               'Rozmiar',
    adm_search_questions:       'Szukaj pytań…',
    adm_label_question:         'Pytanie pracownika',
    adm_label_answer:           'Odpowiedź',
    adm_btn_upload_doc:         'Prześlij dokument',
    adm_just_moment:            'Chwilę',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Tylko administratorzy mogą edytować profil domeny.',
    adm_primary_lang:           'Podstawowy język roboczy',
    adm_drop_doc:               'Upuść dokument tutaj lub kliknij',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Istniejące dokumenty firmowe',
    adm_company_docs_empty:     'Nie przesłano jeszcze żadnych dokumentów firmowych.',
    adm_no_licence:             'Brak danych licencji.',
    adm_full_seats_label:       '⭐ Full Seats (z tworzeniem treści)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'Ważny do',
    adm_base_lang:              'Język bazowy',
    adm_active_ui_langs:        'Aktywne języki UI',
    adm_tts_langs:              'Języki TTS',
    adm_full_seats_total_label: '⭐ Full Seats łącznie',
    adm_essentials_total_label: 'Essentials Seats łącznie',
    adm_ui_langs_field:         'Języki UI (aktywne języki aplikacji)',
    adm_tts_langs_field:        'Języki TTS (zamiana tekstu na mowę)',
    adm_config_title:           'Konfiguracja',
    adm_config_desc:            'Ustawienia platformy dla tego tenanta. Zmiany są natychmiast aktywne.',
    adm_supervisor_mode:        'Tryb supervisora',
    adm_warning_no_admin:       '⚠️ Uwaga: Brak aktywnego użytkownika z rolą Supervisora lub Admina (Grupa 2 lub 3).',
    adm_std_delete_toggle:      'Standardowi użytkownicy: usuwanie i dezaktywacja filmów',
    adm_std_course_toggle:      'Standardowi użytkownicy: tworzenie kursów i quizów',
    adm_supervisor_confirm_title: 'Aktywować tryb supervisora?',
    adm_btn_activate:           'Aktywuj',
    adm_admin_only_setting:     'Tylko administratorzy tenanta (Grupa 3) lub Super Admini mogą zmienić to ustawienie.',
    adm_only_admins_edit:       'Tylko administratorzy mogą zmienić to ustawienie.',
  },

  ar: {
    // Common
    // --- اختيار النص / السيناريو ---
    // --- Missing Keys Update ---
    // Arabisch (ar)
      assignToGeneral: 'إضافة إلى المجموعة العامة',
  assignToGeneralOn: 'سيكون المحتوى مرئياً لجميع أعضاء المجموعة الافتراضية بعد الإنشاء.',
  assignToGeneralOff: '⚠ تحذير: لن يكون هذا المحتوى مرئياً للجمهور العام. سيكون متاحاً فقط للمسؤولين والمنشئ.',
    videoRenderingBackground: 'يتم معالجة الفيديو في الخلفية – ستتمكن من المتابعة لاحقاً.',
    manyPagesHint: 'يحتوي المستند على {count} صفحات – سيستغرق التحليل وقتاً أطول قليلاً.',
    analyzingPages: 'جارٍ تحليل الصفحات…',
    notif_goto_adminpanel:    'فتح لوحة الإدارة',
    notif_type_new_question:  'سؤال جديد',
    notif_title:         'الإشعارات',
    notif_back:          'رجوع',
    notif_loading:       'جارٍ التحميل…',
    notif_empty:         'لا توجد رسائل',
    notif_just_now:          'الآن',
    notif_type_message:      'رسالة من المشرف',
    notif_type_new_content:  'محتوى جديد',
    notif_goto_collection:   'الانتقال إلى المجموعة',
    notif_goto_document:     'فتح المستند',
    notif_open_document:     'فتح المستند',
    notif_goto_fraghejvi:    'فتح FragHejVi',
    notif_close:             'إغلاق',
    notif_dismiss_all:       'إغلاق الكل',
    adminArea: 'لوحة الإدارة',
    adm_pin_format_hint:    '8 أحرف بالضبط: حروف وأرقام',
    adm_pin_format_error:   'يجب أن يتكون الرمز من 8 أحرف أبجدية رقمية بالضبط.',
    adm_subtitle:          'إدارة HejVi',
    adm_access_denied:     'تم رفض الوصول',
    adm_access_denied_desc:'ليس لديك صلاحية للوصول إلى هذا القسم.',
    adm_back:              'رجوع',
    adm_users:             'المستخدمون',
    adm_groups:            'المجموعات',
    adm_videos:            'فيديوهات',
    adm_topics:            'مواضيع',
    adm_video_sg:          'فيديو',
    adm_topic_sg:          'موضوع',
    adm_docs:              'المستندات & قاعدة المعرفة',
    adm_open_video:        'فتح الفيديو في علامة تبويب جديدة',
    adm_open_doc:          'فتح المستند في علامة تبويب جديدة',
    adm_open_element:      'فتح العنصر في علامة تبويب جديدة',
    adm_stat_users:        'إجمالي المستخدمين',
    adm_stat_active:       'المستخدمون النشطون',
    adm_members:           'الأعضاء',
    adm_content:           'المحتوى',
    adm_name:              'الاسم',
    adm_status:            'الحالة',
    adm_role:              'الدور',
    adm_role_standard:     'قياسي',
    adm_created:           'تاريخ الإنشاء',
    adm_actions:           'الإجراءات',
    adm_preview:           'معاينة',
    adm_active:            'نشط',
    adm_inactive:          'غير نشط',
    adm_edit:              'تعديل',
    adm_delete:            'حذف',
    adm_new_user:          'مستخدم جديد',
    adm_new_group:         'مجموعة جديدة',
    adm_edit_user:         'تعديل المستخدم',
    adm_edit_group:        'تعديل المجموعة',
    adm_create:            'إنشاء',
    adm_save:              'حفظ',
    adm_save_translate:    'حفظ وترجمة',
    adm_translating:       'جارٍ الترجمة…',
    adm_cancel:            'إلغاء',
    adm_done:              'تم',
    adm_confirm:           'هل أنت متأكد؟',
    adm_yes:               'نعم',
    adm_no:                'لا',
    adm_mandatory:         'إلزامي',
    adm_description:       'الوصف',
    adm_rights_level:      'مستوى الصلاحيات',
    adm_lang_id:           'اللغة',
    adm_client_id:         'العميل',
    adm_pin_change:        'تغيير الرمز (اتركه فارغاً = بدون تغيير)',
    adm_pin_hint:          '4 أحرف على الأقل',
    adm_pin_change_hint:   'اتركه فارغاً لعدم التغيير',
    adm_groups_for:        'المجموعات لـ',
    adm_groups_assign_hint:'تعيين المجموعات أو إزالتها',
    adm_content_for_group: 'المحتوى للمجموعة',
    adm_content_visible_hint: 'هذا المحتوى مرئي للمجموعات التالية:',
    adm_assigned:          'مُعيَّن',
    adm_add:               'إضافة',
    adm_remove:            'إزالة',
    adm_assign:            'تعيين',
    adm_search_hint:       'بحث',
    adm_no_users:          'لم يتم العثور على مستخدمين',
    adm_no_groups:         'لا توجد مجموعات',
    adm_no_entries:        'لم يتم العثور على إدخالات',
    adm_no_content:        'لم يتم العثور على محتوى',
    adm_toast_deleted:     'تم الحذف',
    adm_toast_created:     'تم الإنشاء',
    adm_toast_saved:       'تم الحفظ',
    adm_toast_deactivated: 'تم إلغاء التنشيط',
    adm_toast_removed:     'تمت الإزالة من المجموعة',
    adm_toast_added:       'تمت الإضافة إلى المجموعة',
    adm_toast_error:       'حدث خطأ',
    adm_toast_load_error:  'خطأ في التحميل',
    // --- Document Chat ---
    chatGreeting: 'مرحباً! يسعدني مساعدتك. ماذا تود أن تعرف؟',
    chatSubtitle: 'اسأل عن المستند',
    chatButton: 'اسأل',
    chatPlaceholder: 'اطرح سؤالاً حول المستند ...',
    chatClear: 'مسح الدردشة',
    chatSuggestion1: 'لخّص المستند',
    chatSuggestion2: 'ما هي النقاط الرئيسية؟',
    chatSuggestion3: 'ما هي المتطلبات المذكورة؟',
    chatErrorNotAuthenticated: 'غير مصادق. يرجى تسجيل الدخول مرة أخرى.',
    chatErrorNoAnswer: 'لم يتم تلقي أي إجابة.',
    chatErrorGeneric: 'خطأ',
    // --- Global Chat Widget ---
    globalChatTitle: 'مساعد المعرفة',
    globalChatSubtitle: 'جميع المستندات ومقاطع الفيديو',
    globalChatFab: 'اسأل عن أي شيء',
    globalChatGreeting: 'مرحباً! يمكنني مساعدتك في الأسئلة المتعلقة بجميع مستنداتك ومقاطع الفيديو الخاصة بك. ماذا تود أن تعرف؟',
    globalChatPlaceholder: 'اطرح سؤالاً حول كل المحتوى الخاص بك ...',
    globalSuggestion1: 'ماذا تقول مستنداتي عن متطلبات السلامة؟',
    globalSuggestion2: 'لخّص جميع المحتويات المتاحة',
    globalSuggestion3: 'ما هي مقاطع الفيديو التي تغطي هذا الموضوع؟',
    sourcesUsed: 'المصادر',
    sourceDocument: 'مستند',
    sourceVideo: 'فيديو',
    goToElement: 'فتح العنصر ←',
    goToVideo: 'مشاهدة الفيديو ←',
    createdOn: 'تم الإنشاء في',
    pleaseSelectDocument: 'يرجى تحديد مستند (PDF أو TXT أو DOC).',
    selectDocument: 'تحديد مستند',
    photoVideo: 'صورة / فيديو',
    document: 'وثيقة',
    replaceFile: 'استبدال',
    removeFile: 'إزالة',
    documentTypeDefault: 'وثيقة',
    invalidDocumentType: 'يرجى تحميل ملف صالح: PDF أو TXT أو DOC/DOCX أو PPT/PPTX.',
    documentTooLarge: 'الملف كبير جداً. الحد الأقصى {mb} ميجابايت.',
    documentAiInfo: 'يستخرج الذكاء الاصطناعي المحتوى تلقائيًا، وينشئ ملخصًا (1-2 جمل) كتعليق صوتي، ويستخدم الصفحة الأولى كصورة مصغرة.',
    documentModeActive: 'وضع الوثيقة نشط',
    documentModeDesc: 'سيستخدم الذكاء الاصطناعي محتوى وثيقتك تلقائيًا كنص للفيديو. يمكنك إضافة سياق أو تركه فارغًا.',
    docAdditionalContextPlaceholder: 'سياق إضافي اختياري (مثل الجمهور المستهدف)...',
    optionLabel: 'خيار',
    aiOptionLabel: 'خيار الذكاء الاصطناعي',
    autoGeneratedFromDoc: 'تم إنشاؤه تلقائيًا من الوثيقة',
    documentAutoProcess: 'يستخرج الذكاء الاصطناعي المحتوى وينشئ ملخصًا كنص للفيديو.',
    aiDocProcessingInfo: 'نقوم بتحليل الوثيقة، وإنشاء ملخص كتعليق صوتي، وإنشاء فيديو باستخدام الصفحة الأولى كصورة مصغرة.',
    viewDocument: 'عرض',
    downloadDocument: 'تحميل',
    responseVideoNotFound: 'فيديو الرد غير موجود',
    responseVideoNotReady: 'فيديو الرد لهذا التحدي غير موجود بعد.',
    unknownQRCodeTitle: 'رمز استجابة سريعة غير معروف',
    unknownQRCodeQuestion: 'كيف تود المتابعة؟',
    unknownQRCodeCreateCollection: 'إنشاء مجموعة جديدة',
    addVideo: 'إضافة فيديو',
    pleaseSelectMedia: 'يرجى تحديد فيديو أو صورة.',
    originalText: 'النص الأصلي',
    printQRLabel: '🖨️ طباعة ملصق الاستجابة السريعة',
    printerConnecting: '🔵 جاري الاتصال بالطابعة...',
    printerPrinting: '⏳ جاري الطباعة...',
    printerDone: '✅ تمت الطباعة!',
    printerError: '❌ خطأ – حاول مرة أخرى',
    bluetoothHint: 'يتصل عبر البلوتوث - اختر Niimbot B1 من القائمة',
    printerErrorHint: 'هل الطابعة قيد التشغيل؟ متصفحات Chrome/Edge فقط تدعم Web Bluetooth.',
    number_of_views: 'عدد المشاهدات',
    number_of_likes: 'عدد الإعجابات',
    qrCode: 'رمز الاستجابة السريعة',
    printQrCode: 'طباعة رمز الاستجابة السريعة',
    playFrom: 'تشغيل من',
    voiceSearchSummary: '{collections} مجموعات، {elements} عناصر',
    pleaseLoginFirst: 'يرجى تسجيل الدخول أولاً لمسح رموز QR',
    openingUrl: 'جاري فتح الرابط...',
    eanNotFound: 'لم يتم العثور على عنصر يطابق EAN هذا',
    sessionExpired: 'انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.',
    recordingTooShort: "التسجيل قصير جدًا",
    errorNoSpeechDetected: "لم يتم اكتشاف أي كلام. يرجى التحدث بصوت أعلى أو الاقتراب من الميكروفون.",
    errorTranscriptionFailed: "تعذر فهم الصوت. يرجى المحاولة مرة أخرى والتحدث بوضوح.",
    reactionVideo: 'فيديو رد فعل؟',
    setThisToReaction: 'يحدد هذا العنصر كفيديو رد (نوع المحتوى 4).',
    selectModeration: 'اختر النص المناسب',
    selectModerationDesc: 'قام الذكاء الاصطناعي بإنشاء اقتراحات النصوص التالية بناءً على وصفك:',
    generatingScripts: 'جاري إنشاء النصوص...',
    nothingFits: 'لا شيء مناسب',
    backToDesc: 'العودة إلى الوصف',
    selectedModeration: 'النص المختار',
    maxRetriesReached: 'يرجى تحسين وصفك. لا توجد محاولات أخرى ممكنة.',
    errorLoadingScripts: 'خطأ في تحميل الاقتراحات. يرجى التحقق من اتصال الإنترنت أو تسجيل الدخول مرة أخرى.',
    challenge: 'تحدي',
    thinking: 'أفكر...',
    aiSuggest: 'اقتراحات Hejvi للذكاء الاصطناعي',
    aiNoSuggestions: 'لم يتمكن الذكاء الاصطناعي من العثور على عناصر محددة. يتم عرض الكل.',
    showAll: 'عرض الكل',
    totalXp: 'إجمالي XP',
    sec: "ث",
    min: "د",
    invalidInput: "يحتوي الإدخال على أحرف غير صالحة.",
    errorContentRejected: "تم رفض هذا المحتوى لأنه ينتهك إرشادات الأمان الخاصة بنا (مثل خطاب الكراهية، العنف، المحتوى الجنسي). يرجى مراجعة ما أدخلته.",
    errorImageTooLarge: "الصورة كبيرة جدًا (الحد الأقصى 4 ميجابايت).",
    errorInvalidImageType: "تنسيق غير صالح. المسموح: JPG, PNG, WEBP, GIF.",
    warningImageTooLarge: "صورة الغلاف كبيرة جداً للتخزين المؤقت. تم حفظ هيكل الدورة التدريبية، ولكن تم تجاهل الصورة. يرجى إعادة تحديدها عند العودة.",
    draftSaveError: "لا يمكن حفظ المسودة.",
    authErrorTokenMissing: "رمز المصادقة مفقود.",
    uploadFailed: "فشل التحميل.",
    qrErrorEmpty: "يرجى إدخال قيمة رمز QR.",
    errorOptionMissing: "الرجاء إدخال نص للخيار",
    viewQuiz: 'عرض الاختبار',
    details: 'التفاصيل',
    pleaseUploadThumbnail: "يرجى تحميل صورة مصغرة للدورة.",
    createVideoElement: 'إنشاء فيديو',
    createQuizElement: 'إنشاء اختبار',
    orSelectExisting: 'أو اختر عناصر موجودة:',
    organize: 'حرك الفيديوهات لتغيير الترتيب',
    filterMyContent: 'المحتوى الخاص بي فقط',
    makeVisible: 'اجعله مرئياً',
    makeInvisible: 'إخفاء',
    selectCorrectAnswer: 'اختر الإجابة الصحيحة',
    selectCorrectAnswerDesc: 'أي خيار هو الحل الصحيح؟',
    typeYesNo: 'نعم / لا',
    typeQR: 'مسح QR',
    typeMulti: 'متعدد الخيارات',
    QuizQuestionPlaceholder: 'مثلاً: هل معدات السلامة هذه صحيحة؟',
    QuizDescriptionPlaceholder: 'وصف اختياري...',
    quizCreatedSuccess: 'تم إنشاء الاختبار بنجاح!',
    tapToUpload: 'تحميل الصورة المصغرة',
    uploadOrAutoThumb: 'رفع صورة',
    autoThumbHint: 'وإلا سيتم إنشاؤها تلقائيًا من مصغرات الفيديو',
    imageSelected: 'تم تحديد الصورة',
    yes: 'نعم',
    no: 'لا',
    correct: 'صحيح',
    incorrect: 'خطأ',
    submit: 'إرسال',
    next: 'التالي',
    back: 'رجوع',
    cancel: 'إلغاء',
    create: 'إنشاء',
    error: 'خطأ',
    success: 'نجح',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    close: 'إغلاق',
    previous: 'السابق',
    loading: 'جاري التحميل...',

    // --- Quiz Builder ---
    createQuiz: 'إنشاء اختبار',
    configureQuiz: 'إعداد الاختبار',
    selectType: 'اختيار النوع',
    selectResponses: 'اختيار فيديوهات الرد',
    selectResponsesDesc: 'اختر الفيديوهات التي سيتم تشغيلها بعد إجابة المستخدم.',
    question: 'سؤال',
    enableHint: 'تفعيل التلميح؟',
    hintNotAvailableQR: 'التلميحات غير مفعلة لتحديات رمز الاستجابة السريعة.',

    // QR
    qrTargetTitle: 'هدف رمز QR',
    qrTargetDesc: 'ما هو النص/الرمز المخفي في رمز الاستجابة السريعة؟',
    qrValueLabel: 'محتوى QR (بالضبط)',

    // Review
    reviewQuiz: 'ملخص',
    reviewDesc: 'يرجى مراجعة إعداداتك قبل إنشاء الاختبار.',

    // Validation
    pleaseEnterName: 'يرجى إدخال اسم.',
    errorSelectCorrect: 'يرجى اختيار الإجابة الصحيحة.',
    selectBothResponses: 'يرجى اختيار كلا فيديو الرد.',

    // Success
    backToDashboard: 'العودة للوحة التحكم',
    createAnother: 'إنشاء آخر',
    scanToStart: 'امسح للبدء',
    useExactTextTitle: 'استخدام النص الدقيق',
    useExactTextDesc: 'تخطي تحسين الذكاء الاصطناعي وقراءة الوصف كما هو.',
    transcribeVideoTitle: 'استخدام صوت الفيديو كصوت توضيحي',
    transcribeVideoDesc: 'يتم نسخ الكلام تلقائيًا. استخدمه حرفيًا كصوت توضيحي (متزامن) أو كأساس لنص محسّن بالذكاء الاصطناعي.',
    transcribeVideo: 'نسخ',
    transcribing: 'جارٍ النسخ...',
    transcriptAdopted: 'تم اعتماد صوت الفيديو كصوت توضيحي',
    resetTranscript: 'تجاهل النص المنسوخ',
    transcriptionFailed: 'فشل النسخ.',
    transcribeExactInfo: 'يتم نسخ الكلام حرفيًا واستخدامه كصوت توضيحي. تبقى الترجمات متزامنة مع الفيديو الأصلي.',
    transcribeLLMInfo: 'يتم نسخ الكلام. يقوم الذكاء الاصطناعي بإنشاء نص صوت توضيحي محسّن باللغة المكتشفة للفيديو.',
    transcribeExactToggleDesc: 'استخدام النص المنسوخ حرفيًا كصوت توضيحي (متزامن مع الفيديو). إيقاف: يُنشئ الذكاء الاصطناعي نصًا محسّنًا من النص المنسوخ.',
    loginWithQRCode: 'تسجيل الدخول باستخدام رمز الاستجابة السريعة (QR Code)',
    search: 'بحث',
    filter: 'تصفية',
    all: 'الكل',
    needHint: 'هل تحتاج إلى تلميح؟',
    
    // Navigation
    home: 'الرئيسية',
    challenges: 'التحديات',
    favorites: 'المفضلة',
    profile: 'الملف الشخصي',
    myCourses: 'دوراتي',
    
    // Dashboard
    welcome: 'مرحباً بعودتك! 👋',
    searchPlaceholder: 'البحث في المحتوى…',
    mustSee: 'يجب المشاهدة',
    safety: 'السلامة',
    tools: 'الأدوات',
    law: 'القانون',
    mandatory: 'إلزامي',
    mandatoryFilter: 'الدورات الإلزامية',
    mandatoryCourses: 'الدورات الإلزامية',
    favourites: 'المفضلة',
    favouritesFilter: 'المفضلة',
    loadMore: 'تحميل المزيد',
    play: 'تشغيل',
    favorite: 'مفضل',
    unfavorite: 'إلغاء التفضيل',
    
    // Login
    login: 'تسجيل الدخول',
    enterPin: 'يرجى إدخال الرمز السري',
    invalidPin: 'يرجى إدخال رمز سري صحيح مكون من 8 أرقام',
    loginError: 'رمز سري غير صحيح. يرجى المحاولة مرة أخرى.',
    wrongPin: 'رمز سري خاطئ. يرجى المحاولة مرة أخرى.',
    loginSuccess: 'تم تسجيل الدخول بنجاح! مرحباً بعودتك! 🎉',
    
    // Profile
    myProfile: 'ملفي الشخصي',
    myProgress: 'تقدمي',
    contactSupport: 'الاتصال بالدعم',
    language: 'اللغة',
    settings: 'الإعدادات',
    privacy: 'الخصوصية',
    help: 'المساعدة',
    logout: 'تسجيل الخروج',
    active: 'نشط',
    beginner: 'مبتدئ',
    intermediate: 'متوسط',
    advanced: 'متقدم',
    joined: 'انضم',
    courses: 'الدورات',
    completed: 'مكتمل',
    inProgress: 'قيد التنفيذ',
    achievements: 'الإنجازات',
    topLearner: 'أفضل متعلم',
    safetyStar: 'نجمة السلامة',
    firstSteps: 'الخطوات الأولى',
    learner: 'متعلم',
    group: 'مجموعة',
    client: 'عميل',
    
    // Contact Form
    yourName: 'اسمك',
    emailAddress: 'عنوان البريد الإلكتروني',
    describeIssue: 'صف مشكلتك...',
    sendMessage: 'إرسال الرسالة',
    messageSent: 'تم إرسال الرسالة بنجاح!',
    messageSendError: 'فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى.',
    
    // Course/Video
    startCourse: 'بدء الدورة',
    continueCourse: 'متابعة الدورة',
    courseProgress: 'تقدم الدورة',
    videoProgress: 'تقدم الفيديو',
    stepsInThisVideo: 'الخطوات في هذا الفيديو',
    relatedVideos: 'فيديوهات ذات صلة',
    duration: 'المدة',
    experiencePoints: 'نقاط الخبرة',
    levelComplexity: 'مستوى التعقيد',
    lessons: 'الدروس',
    nextLessonStartsIn: 'سيبدأ الدرس التالي خلال',
    nextVideoIn: 'الفيديو التالي خلال',
    seconds: 'ث',
    replay: 'إعادة التشغيل',
    cancelAutoplay: 'إلغاء التشغيل التلقائي',
    loadingCourses: 'تحميل الدورات...',
    noCourses: 'لا توجد دورات متاحة',
    searchCourses: 'البحث في الدورات...',
    noResults: 'لم يتم العثور على دورات',
    workplaceSafety: 'أساسيات السلامة المهنية',
    workplaceSafetyDesc: 'بروتوكولات السلامة الأساسية لمكان العمل',
    
    // Challenges
    allChallenges: 'جميع التحديات',
    currentChallenges: 'التحديات الحالية',
    challengeProgress: 'تقدم التحدي',
    challengeEnds: 'ينتهي التحدي',
    daysLeft: 'أيام متبقية',
    hoursLeft: 'ساعات متبقية',
    minutesLeft: 'دقائق متبقية',
    loadingChallenges: 'تحميل التحديات...',
    activeChallenges: 'التحديات النشطة',
    weeklyProgress: 'التقدم',
    noChallenges: 'لا توجد تحديات متاحة في الوقت الحالي.',
    startNow: 'ابدأ الآن',
    discoverMore: 'اكتشف المزيد من التحديات',
    stayMotivated: 'ابق متحمساً واكسب المكافآت!',
    doneChallenges: 'مكتمل',
    challengesProgressLabel: 'تقدم التحديات',
    mandatoryProgressLabel: 'تقدم الدورات الإلزامية',
    doneMandatory: 'دورات إلزامية مكتملة',
    completeChallengesEarnXP: 'أكمل التحديات لربح نقاط الخبرة!',
    noDeadline: 'لا يوجد موعد نهائي',
    failedToLoadChallenges: 'فشل في تحميل التحديات',
    expired: 'منتهي الصلاحية',
    lessThan1hLeft: 'أقل من ساعة متبقية',
    expert: 'خبير',
    
    // QR Scanner
    scanQR: 'مسح رمز QR',
    scanPlaceholder: 'وجه الكاميرا نحو رمز QR',
    scanSuccess: 'تم مسح رمز QR بنجاح!',
    scanError: 'فشل في مسح رمز QR',
    cameraError: 'تم رفض الوصول للكاميرا',
    cameraPermission: 'يرجى السماح بالوصول للكاميرا',
    cameraPermissionDenied: 'تم رفض الوصول للكاميرا. يرجى السماح بالوصول للكاميرا.',
    noCameraFound: 'لم يتم العثور على كاميرا. يرجى التحقق من جهازك.',
    cameraNotSupported: 'الكاميرا غير مدعومة في هذا المتصفح.',
    cameraInUse: 'الكاميرا مستخدمة من قبل تطبيق آخر.',
    cameraConstraintsNotMet: 'قيود الكاميرا غير مستوفاة. يرجى تجربة كاميرا أخرى.',
    failedToStartCamera: 'فشل في تشغيل الكاميرا',
    failedToAccessCamera: 'فشل في الوصول للكاميرا. يرجى التحقق من أذونات المتصفح.',
    onlyOneCameraAvailable: 'كاميرا واحدة فقط متاحة على هذا الجهاز',
    noSuitableCameraFound: 'لم يتم العثور على كاميرا مناسبة للتبديل',
    failedToSwitchCamera: 'فشل في تبديل الكاميرا',
    cameraSwitchFailed: 'فشل في تبديل الكاميرا',
    unableToReadCodeFromImage: 'غير قادر على قراءة الرمز من الصورة',
    errorAccessingCamera: 'خطأ في الوصول للكاميرا',
    tryAgain: 'حاول مرة أخرى',
    switchingCamera: 'جاري تبديل الكاميرا...',
    gallery: 'المعرض',
    flash: 'الفلاش',
    switchCamera: 'تبديل الكاميرا',
    capture: 'التقاط',
    
    // Voice Recording
    voiceSearch: 'البحث الصوتي',
    tapToStartRecording: 'انقر لبدء التسجيل',
    speakYourSearchQuery: 'تحدث بوضوح استعلام البحث الخاص بك',
    startRecording: 'بدء التسجيل',
    stopRecording: 'إيقاف التسجيل',
    recording: 'تسجيل...',
    processingAudio: 'معالجة الصوت...',
    transcript: 'النص المكتوب',
    closingOverlay: 'إغلاق الطبقة وعرض نتائج البحث...',
    searchAgain: 'البحث مرة أخرى',
    
    // Toast Messages
    urlOpened: 'تم فتح الرابط في تبويب جديد',
    navigatingCourse: 'التوجه للدورة...',
    productCode: 'رمز المنتج: {code}',
    lookingUpEAN: 'البحث عن EAN {ean}...',
    fetchingContent: 'جلب المحتوى...',
    elementFound: 'تم العثور على العنصر: {name}',
    collectionFound: 'تم العثور على المجموعة: {name}',
    contentNotFound: 'المحتوى غير موجود',
    
    // Errors
    networkError: 'خطأ في الشبكة. يرجى التحقق من الاتصال.',
    serverError: 'خطأ في الخادم. يرجى المحاولة لاحقاً.',
    unauthorized: 'غير مصرح. يرجى تسجيل الدخول مرة أخرى.',
    notFound: 'المحتوى غير موجود.',
    generalError: 'حدث خطأ غير متوقع.',
    
    // Time
    today: 'اليوم',
    yesterday: 'أمس',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',
    ago: 'منذ',
    minutes: 'دقائق',
    hours: 'ساعات',
    days: 'أيام',
    weeks: 'أسابيع',
    months: 'أشهر',
    years: 'سنوات',
    
    // Additional UI Elements
    seeAll: 'عرض الكل',
    seeMore: 'عرض المزيد',
    seeLess: 'عرض أقل',
    expand: 'توسيع',
    collapse: 'طي',
    refresh: 'تحديث',
    retry: 'إعادة المحاولة',
    confirm: 'تأكيد',
    ok: 'موافق',
    done: 'تم',
    skip: 'تخطي',
    continue: 'متابعة',
    finish: 'إنهاء',
    start: 'بدء',
    stop: 'إيقاف',
    pause: 'إيقاف مؤقت',
    resume: 'استئناف',
    restart: 'إعادة تشغيل',
    reset: 'إعادة تعيين',
    clear: 'مسح',
    remove: 'إزالة',
    add: 'إضافة',
    update: 'تحديث',
    change: 'تغيير',
    select: 'اختيار',
    choose: 'اختيار',
    browse: 'تصفح',
    upload: 'رفع',
    download: 'تحميل',
    share: 'مشاركة',
    copy: 'نسخ',
    paste: 'لصق',
    cut: 'قص',
    undo: 'تراجع',
    redo: 'إعادة',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    fullscreen: 'ملء الشاشة',
    exitFullscreen: 'خروج من ملء الشاشة',
    volume: 'مستوى الصوت',
    mute: 'كتم الصوت',
    unmute: 'إلغاء كتم الصوت',
    preferences: 'التفضيلات',
    account: 'الحساب',
    notifications: 'الإشعارات',
    messages: 'الرسائل',
    inbox: 'صندوق الوارد',
    sent: 'مرسل',
    drafts: 'المسودات',
    trash: 'سلة المحذوفات',
    archive: 'الأرشيف',
    starred: 'مميز',
    important: 'مهم',
    unread: 'غير مقروء',
    read: 'مقروء',
    markAsRead: 'تحديد كمقروء',
    markAsUnread: 'تحديد كغير مقروء',
    reply: 'رد',
    forward: 'إعادة توجيه',
    compose: 'إنشاء',
    send: 'إرسال',
    receive: 'استقبال',
    sync: 'مزامنة',
    backup: 'نسخة احتياطية',
    restore: 'استعادة',
    import: 'استيراد',
    export: 'تصدير',
    print: 'طباعة',
    saveAs: 'حفظ باسم',
    open: 'فتح',
    new: 'جديد',
    openInNewTab: 'فتح في تبويب جديد',
    openInNewWindow: 'فتح في نافذة جديدة',
    bookmark: 'إشارة مرجعية',
    unbookmark: 'إزالة الإشارة المرجعية',
    history: 'السجل',
    bookmarks: 'الإشارات المرجعية',
    downloads: 'التحميلات',
    recent: 'حديث',
    popular: 'شائع',
    trending: 'رائج',
    featured: 'مميز',
    recommended: 'موصى به',
    suggested: 'مقترح',
    related: 'ذو صلة',
    similar: 'مشابه',
    other: 'آخر',
    more: 'المزيد',
    less: 'أقل',
    none: 'لا شيء',
    some: 'بعض',
    few: 'قليل',
    many: 'كثير',
    most: 'الأكثر',
    least: 'الأقل',
    best: 'الأفضل',
    worst: 'الأسوأ',
    highest: 'الأعلى',
    lowest: 'الأدنى',
    fastest: 'الأسرع',
    slowest: 'الأبطأ',
    newest: 'الأحدث',
    oldest: 'الأقدم',
    latest: 'الأحدث',
    earliest: 'الأقدم',
    first: 'الأول',
    last: 'الأخير',
    current: 'الحالي',
    inactive: 'غير نشط',
    enabled: 'مفعل',
    disabled: 'معطل',
    on: 'تشغيل',
    off: 'إيقاف',
    true: 'صحيح',
    false: 'خطأ',
    maybe: 'ربما',
    unknown: 'غير معروف',
    pending: 'في الانتظار',
    processing: 'قيد المعالجة',
    failed: 'فشل',
    cancelled: 'ملغي',
    scheduled: 'مجدول',
    overdue: 'متأخر',
    due: 'مستحق',
    valid: 'صالح',
    invalid: 'غير صالح',
    required: 'مطلوب',
    optional: 'اختياري',
    available: 'متاح',
    unavailable: 'غير متاح',
    online: 'متصل',
    offline: 'غير متصل',
    connected: 'متصل',
    disconnected: 'غير متصل',
    public: 'عام',
    private: 'خاص',
    hidden: 'مخفي',
    visible: 'مرئي',
    locked: 'مقفل',
    unlocked: 'مفتوح',
    secure: 'آمن',
    insecure: 'غير آمن',
    verified: 'متحقق',
    unverified: 'غير متحقق',
    authenticated: 'مصادق',
    unauthenticated: 'غير مصادق',
    authorized: 'مصرح',
    permitted: 'مسموح',
    forbidden: 'محظور',
    allowed: 'مسموح',
    denied: 'مرفوض',
    granted: 'ممنوح',
    revoked: 'ملغي',
    accepted: 'مقبول',
    rejected: 'مرفوض',
    approved: 'موافق عليه',
    disapproved: 'غير موافق عليه',
    confirmed: 'مؤكد',
    unconfirmed: 'غير مؤكد',
    signed: 'موقوع',
    unsigned: 'غير موقوع',
    encrypted: 'مشفر',
    decrypted: 'مفكك التشفير',
    compressed: 'مضغوط',
    uncompressed: 'غير مضغوط',
    archived: 'مؤرشف',
    unarchived: 'غير مؤرشف',
    backedUp: 'محمي',
    restored: 'مستعاد',
    imported: 'مستورد',
    exported: 'مصدر',
    printed: 'مطبوع',
    saved: 'محفوظ',
    opened: 'مفتوح',
    created: 'منشأ',
    updated: 'محدث',
    changed: 'متغير',
    selected: 'مختار',
    chosen: 'مختار',
    browsed: 'متصفح',
    uploaded: 'مرفوع',
    downloaded: 'محمل',
    shared: 'مشارك',
    copied: 'منسوخ',
    pasted: 'ملصق',
    undone: 'ملغي',
    redone: 'معاد',
    zoomedIn: 'مكبر',
    zoomedOut: 'مصغر',
    fullscreened: 'ملء الشاشة',
    muted: 'مكتوم الصوت',
    unmuted: 'غير مكتوم الصوت',
    notified: 'مخطر',
    messaged: 'رسالة مرسلة',
    replied: 'مردود',
    forwarded: 'معاد توجيهه',
    composed: 'منشأ',
    received: 'مستلم',
    synced: 'مزامن',
    bookmarked: 'إشارة مرجعية مضبوطة',
    unbookmarked: 'إشارة مرجعية ملغية',
    openedInNewTab: 'مفتوح في تبويب جديد',
    openedInNewWindow: 'مفتوح في نافذة جديدة',

    // Element Creator Specific
    elementCreator: 'منشئ العناصر',
    createElement: 'إنشاء عنصر',
    createStep1Title: "لنبدأ! قم بتسميته.",
    elementNamePlaceholder: "مثلاً: كيفية إصلاح آلة الطحن",
    createStep2Title: "تحميل المحتوى الخاص بك",
    createStep2Sub: "التقط صورة/فيديو أو قم بالتحميل من المكتبة.",
    selectMedia: 'اختيار الوسائط',
    tapToChange: 'اضغط للتغيير',
    createStep3Title: "اشرح ذلك",
    createStep3Sub: "ماذا يحدث في هذا الفيديو؟ سيقوم الذكاء الاصطناعي لدينا بتحويل هذا إلى سرد احترافي.",
    descPlaceholder: "اشرح العملية خطوة بخطوة...",
    createStep4Title: "مراجعة",
    aiProcessingInfo: "سنقوم الآن بضغط الفيديو، وإنشاء تعليق صوتي احترافي من وصفك، وترجمة كل شيء إلى 10 لغات.",
    creatingElement: "جاري إنشاء العنصر...",
    videoGenerating: "يتم إنشاء الفيديو، يرجى الانتظار لحظة…",
    videoProcessing: "يتم الانتهاء من الفيديو… سيتم تفعيل الزر تلقائياً.",
    videoProcessingHint: "الفيديو لا يزال قيد المعالجة. انتظر لحظة لمشاهدته مباشرة أو تابع عملك ببساطة.",
    pleaseWait: "قد يستغرق هذا دقيقة. جاري التحميل ومعالجة مهام الذكاء الاصطناعي.",
    elementCreatedSuccess: 'تم إنشاء العنصر بنجاح!',
    elementReadyDesc: 'تم إنشاء العنصر الخاص بك ومعالجته بنجاح.',
    viewElement: 'عرض العنصر الآن',
    goToMyCourses: 'الذهاب إلى دوراتي',
    elementPendingTitle: 'يتم مراجعة الفيديو الخاص بك',
    elementPendingDesc: 'تم رفع الفيديو الخاص بك بنجاح ويتم مراجعته الآن من قِبل المسؤول. سيتم نشره للجميع قريبًا.',
    elementPendingHint: 'ستتلقى إشعارًا بمجرد الموافقة على الفيديو الخاص بك.',
    elementApprovedTitle: 'تمت الموافقة على الفيديو الخاص بك!',
    elementApprovedBody: 'خبر رائع — تمت الموافقة على الفيديو "{name}" وهو الآن مرئي لجميع المستخدمين.',
    descTooShort: 'يرجى تقديم وصف مفصل (على الأقل 10 أحرف).',
    invalidFileType: 'يرجى تحميل فيديو أو صورة صالحة.',
    fileTooLarge: 'الملف كبير جداً. الحد الأقصى للحجم هو 500 ميغابايت.',
    media: 'الوسائط',
    description: 'الوصف',
    name: 'الاسم',
    
    // Course Builder
    courseDetails: 'تفاصيل الدورة',
    courseName: 'اسم الدورة',
    courseNamePlaceholder: 'مثل صيانة الآلات',
    courseDescPlaceholder: 'صف بإيجاز ما تدور حوله هذه الدورة...',
    thumbnail: 'صورة مصغرة',
    uploadImage: '+ رفع صورة',
    addElements: 'إضافة عناصر',
    searchElements: 'البحث في العناصر...',
    loadingElements: 'تحميل العناصر...',
    preview: 'معاينة',
    added: 'تمت الإضافة',
    noElementsFound: 'لم يتم العثور على عناصر مطابقة.',
    organizeCourse: 'تنظيم الدورة',
    dragDropReorder: 'اسحب وأفلت لإعادة الترتيب',
    addMoreElements: '+ إضافة المزيد من العناصر',
    courseCreated: 'تم إنشاء الدورة!',
    courseCreatedDesc: 'تم حفظ مجموعتك بنجاح.',
    createAnotherCourse: 'إنشاء دورة أخرى',
    createCourse: 'إنشاء الدورة',
    addToCourse: 'إضافة إلى الدورة',
    saving: 'جاري الحفظ...',
    noElementsSelected: 'يرجى اختيار عنصر واحد على الأقل',
    errorCreatingCourse: 'خطأ في إنشاء الدورة',
    authError401: 'غير مصرح (401). ربما انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: '💡 يتم ترجمة الاسم والوصف تلقائياً إلى جميع اللغات.',
    adm_en_readonly_hint: 'مُترجَم تلقائياً – غير قابل للتعديل',
    adm_filter_active: 'نشط',
    adm_filter_all: 'الكل',
    adm_filter_inactive: 'غير نشط',
    adm_last_superadmin_hint: 'آخر مشرف عام – لا يمكن حذفه',
    adm_no_group_access: 'لا يوجد وصول للمحتوى',
    adm_no_group_assign_warn: 'هذا المستخدم غير مُعيَّن لأي مجموعة وبالتالي ليس لديه وصول للمحتوى.',
    adm_no_group_warn_body: 'المستخدمون الجدد بدون مجموعة ليس لديهم وصول للمحتوى. يرجى تعيين مجموعة عبر 🏷️ المجموعات بعد الإنشاء.',
    adm_no_group_warn_title: 'ملاحظة: لا يوجد وصول للمجموعة',
    adm_toast_added_to_group: 'تمت الإضافة إلى المجموعة',
    adm_toast_removed_from_group: 'تمت الإزالة من المجموعة',
    adm_toast_group_assigned: 'تم تعيين المجموعة',
    adm_toast_group_removed: 'تمت إزالة المجموعة',
    adm_toast_content_assigned: 'تم تعيين المحتوى',
    adm_toast_content_removed: 'تمت إزالة المحتوى',
    // ── نظام الإشعارات ────────────────────────────────────────────────────
    adm_notifications:          'الرسائل',
    notif_type_new_content:     'محتوى جديد',
    notif_type_message:         'رسالة',
    notif_goto_collection:      'إلى المجموعة',
    notif_dismiss_all:          'إغلاق الكل',
    notif_just_now:             'الآن',

    // ── MyCourses: فلاتر، عناوين الأقسام، والرسائل الفارغة ──────────────
    mc_filter_all:            'الكل',
    mc_filter_courses:        '📚 دوراتي',
    mc_filter_videos:         '▶ مقاطعي',
    mc_filter_favorites:      '★ المفضلة',
    mc_status_all:            'جميع الحالات',
    mc_only_mine:             'فقط ما أنشأته',
    mc_section_courses_sub:   'الدورات المبدوءة والمكتملة',
    mc_section_videos:        'مقاطعي',
    mc_section_videos_sub:    'المحتوى الذي أنشأته',
    mc_section_favorites:     'مفضلتي',
    mc_section_favorites_sub: 'الدورات والمقاطع التي أعجبتني',
    mc_empty_courses:         'لم تبدأ أي دورة بعد.',
    mc_empty_videos:          'لم تنشئ أي مقطع بعد.',
    mc_empty_favorites:       'لم تضف أي محتوى إلى مفضلتك بعد.',
    videoRendering:     'جارٍ معالجة الفيديو…',
    videoRenderingHint: 'لا يزال الفيديو قيد المعالجة. سيكون متاحاً قريباً.',
    // ── AdminPanel: سلاسل i18n الجديدة ────────────────────────────────────
    adm_qr_unavailable:         'QR غير متوفر — npm install qrcode',
    adm_qr_login_title:         'رمز QR لتسجيل الدخول',
    adm_qr_scan_login_hint:     'مسح ← تسجيل الدخول مباشرة بدون PIN',
    adm_qr_permanent_hint:      'رمز QR متاح دائمًا في سجل المستخدم.',
    adm_qr_print_hint:          'اطبع الـ PIN الآن أو أرسله بشكل آمن.',
    adm_msg_subject_placeholder:'مثال: تعليمات سلامة جديدة متاحة',
    adm_msg_text_placeholder:   'نص الرسالة…',
    adm_col_license_type:       'نوع الترخيص',
    adm_btn_show_qr:            'عرض رمز QR',
    adm_btn_send_msg:           'إرسال رسالة',
    adm_login_qr_label:         'رمز QR لتسجيل الدخول',
    adm_btn_gen_pin:            'إنشاء PIN جديد',
    adm_qr_scan_hint:           'يمكن للمستخدم مسح هذا الرمز لتسجيل الدخول بدون PIN.',
    adm_pin_reset_hint:         'لإعادة تعيين الـ PIN: أغلق وانقر على 🔄 إعادة تعيين PIN.',
    adm_role_supervisor:        'مشرف',
    adm_role_admin_opt:         'مدير',
    adm_role_superadmin:        'مدير عام',
    adm_seat_essentials_desc:   'Essentials – جميع الميزات باستثناء إنشاء المحتوى',
    adm_pin_force_change:       'إجبار تغيير PIN عند أول تسجيل دخول',
    adm_btn_msg_group:          'رسالة إلى المجموعة',
    adm_btn_show:               'عرض',
    adm_btn_unlock:             'إلغاء قفل العنصر',
    adm_btn_show_assigned:      'عرض المحتوى المخصص',
    adm_no_videos_assigned:     'لا توجد مقاطع فيديو مخصصة. انقر على «+ إضافة فيديو».',
    adm_drag_sort:              'اسحب للفرز',
    adm_search_video:           'البحث عن فيديو…',
    adm_no_videos:              'لم يتم العثور على مقاطع فيديو.',
    adm_video_unassigned:       'هذا الفيديو غير مرتبط بأي محتوى.',
    adm_search_messages:        'البحث في الرسائل…',
    adm_btn_reload:             'إعادة تحميل',
    adm_enriching:              'الإثراء جارٍ…',
    adm_no_video_chunks:        'لم يتم العثور على مقاطع فيديو مع مقتطفات النص',
    adm_ki_enrichment:          'الإثراء بالذكاء الاصطناعي',
    adm_col_updated:            'محدَّث',
    adm_search_docs:            'البحث عن مستند أو عنصر…',
    adm_no_docs:                'لا توجد مستندات متاحة',
    adm_col_size:               'الحجم',
    adm_search_questions:       'البحث في الأسئلة…',
    adm_label_question:         'سؤال الموظف',
    adm_label_answer:           'الجواب',
    adm_btn_upload_doc:         'رفع مستند',
    adm_just_moment:            'لحظة من فضلك',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'يمكن للمديرين فقط تعديل ملف النطاق.',
    adm_primary_lang:           'لغة العمل الأساسية',
    adm_drop_doc:               'أسقط المستند هنا أو انقر',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'مستندات الشركة الموجودة',
    adm_company_docs_empty:     'لم يتم رفع أي مستندات شركة بعد.',
    adm_no_licence:             'لا تتوفر بيانات ترخيص.',
    adm_full_seats_label:       '⭐ Full Seats (شامل إنشاء المحتوى)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'صالح حتى',
    adm_base_lang:              'اللغة الأساسية',
    adm_active_ui_langs:        'لغات الواجهة النشطة',
    adm_tts_langs:              'لغات TTS',
    adm_full_seats_total_label: '⭐ Full Seats الإجمالي',
    adm_essentials_total_label: 'Essentials Seats الإجمالي',
    adm_ui_langs_field:         'لغات الواجهة (لغات التطبيق النشطة)',
    adm_tts_langs_field:        'لغات TTS (تحويل النص إلى كلام)',
    adm_config_title:           'الإعدادات',
    adm_config_desc:            'إعدادات المنصة لهذا المستأجر. التغييرات سارية فورًا.',
    adm_supervisor_mode:        'وضع المشرف',
    adm_warning_no_admin:       '⚠️ تحذير: لا يوجد مستخدم نشط بدور مشرف أو مدير (المجموعة 2 أو 3).',
    adm_std_delete_toggle:      'المستخدمون العاديون: حذف وتعطيل الفيديوهات',
    adm_std_course_toggle:      'المستخدمون العاديون: إنشاء الدورات والاختبارات',
    adm_supervisor_confirm_title: 'تفعيل وضع المشرف؟',
    adm_btn_activate:           'تفعيل',
    adm_admin_only_setting:     'يمكن فقط لمديري المستأجر (المجموعة 3) أو المديرين العامين تغيير هذا الإعداد.',
    adm_only_admins_edit:       'يمكن فقط للمديرين تغيير هذا الإعداد.',
  },
  es: {
    // --- General ---
    // --- Selección de Guión / Moderación ---
    // --- Missing Keys Update ---
    // Spanisch (es)
      assignToGeneral: 'Añadir al grupo general',
  assignToGeneralOn: 'El contenido será visible para todos los miembros del grupo predeterminado tras su creación.',
  assignToGeneralOff: '⚠ Atención: Este contenido no será visible para el público general. Solo será accesible para administradores y el creador.',
    videoRenderingBackground: 'El vídeo se está procesando en segundo plano – podrá continuar en un momento.',
    manyPagesHint: 'El documento tiene {count} páginas – el análisis tardará un poco más.',
    analyzingPages: 'Analizando páginas…',
    notif_goto_adminpanel:    'Abrir panel de administración',
    notif_type_new_question:  'Nueva pregunta',
    notif_title:         'Notificaciones',
    notif_back:          'Volver',
    notif_loading:       'Cargando…',
    notif_empty:         'No hay mensajes disponibles',
    notif_just_now:          'Ahora mismo',
    notif_type_message:      'Mensaje de admin',
    notif_type_new_content:  'Contenido nuevo',
    notif_goto_collection:   'Ir a la colección',
    notif_goto_document:     'Ver documento',
    notif_open_document:     'Abrir documento',
    notif_goto_fraghejvi:    'Abrir FragHejVi',
    notif_close:             'Cerrar',
    notif_dismiss_all:       'Cerrar todo',
    adminArea: 'Área de administración',
    adm_pin_format_hint:    'Exactamente 8 caracteres: letras y dígitos',
    adm_pin_format_error:   'El PIN debe tener exactamente 8 caracteres alfanuméricos.',
    adm_subtitle:          'Administración HejVi',
    adm_access_denied:     'Acceso denegado',
    adm_access_denied_desc:'No tienes permiso para acceder a esta sección.',
    adm_back:              'Volver',
    adm_users:             'Usuarios',
    adm_groups:            'Grupos',
    adm_videos:            'Vídeos',
    adm_topics:            'Temas',
    adm_video_sg:          'Vídeo',
    adm_topic_sg:          'Tema',
    adm_docs:              'Documentos & Base de conocimientos',
    adm_open_video:        'Abrir video en nueva pestaña',
    adm_open_doc:          'Abrir documento en nueva pestaña',
    adm_open_element:      'Abrir elemento en nueva pestaña',
    adm_stat_users:        'Usuarios totales',
    adm_stat_active:       'Usuarios activos',
    adm_members:           'Miembros',
    adm_content:           'Contenido',
    adm_name:              'Nombre',
    adm_status:            'Estado',
    adm_role:              'Rol',
    adm_role_standard:     'Estándar',
    adm_created:           'Creado',
    adm_actions:           'Acciones',
    adm_preview:           'Vista previa',
    adm_active:            'Activo',
    adm_inactive:          'Inactivo',
    adm_edit:              'Editar',
    adm_delete:            'Eliminar',
    adm_new_user:          'Nuevo usuario',
    adm_new_group:         'Nuevo grupo',
    adm_edit_user:         'Editar usuario',
    adm_edit_group:        'Editar grupo',
    adm_create:            'Crear',
    adm_save:              'Guardar',
    adm_save_translate:    'Guardar y traducir',
    adm_translating:       'Traduciendo…',
    adm_cancel:            'Cancelar',
    adm_done:              'Listo',
    adm_confirm:           '¿Seguro?',
    adm_yes:               'Sí',
    adm_no:                'No',
    adm_mandatory:         'Obligatorio',
    adm_description:       'Descripción',
    adm_rights_level:      'Nivel de permisos',
    adm_lang_id:           'Idioma',
    adm_client_id:         'Cliente',
    adm_pin_change:        'Cambiar PIN (vacío = sin cambios)',
    adm_pin_hint:          'Mínimo 4 caracteres',
    adm_pin_change_hint:   'Dejar vacío para no cambiar',
    adm_groups_for:        'Grupos para',
    adm_groups_assign_hint:'Asignar o quitar grupos',
    adm_content_for_group: 'Contenido para el grupo',
    adm_content_visible_hint: 'Este contenido es visible para los siguientes grupos:',
    adm_assigned:          'Asignado',
    adm_add:               'Añadir',
    adm_remove:            'Quitar',
    adm_assign:            'Asignar',
    adm_search_hint:       'buscar',
    adm_no_users:          'No se encontraron usuarios',
    adm_no_groups:         'No hay grupos disponibles',
    adm_no_entries:        'No se encontraron entradas',
    adm_no_content:        'No se encontró contenido',
    adm_toast_deleted:     'Eliminado',
    adm_toast_created:     'Creado',
    adm_toast_saved:       'Guardado',
    adm_toast_deactivated: 'Desactivado',
    adm_toast_removed:     'Eliminado del grupo',
    adm_toast_added:       'Añadido al grupo',
    adm_toast_error:       'Ocurrió un error',
    adm_toast_load_error:  'Error al cargar',
    // --- Document Chat ---
    chatGreeting: '¡Hej! Estoy aquí para ayudarte. ¿Qué quieres saber?',
    chatSubtitle: 'Consultar documento',
    chatButton: 'Preguntas',
    chatPlaceholder: 'Haz una pregunta sobre el documento …',
    chatClear: 'Limpiar chat',
    chatSuggestion1: 'Resume el documento',
    chatSuggestion2: '¿Cuáles son los puntos clave?',
    chatSuggestion3: '¿Qué requisitos se mencionan?',
    chatErrorNotAuthenticated: 'No autenticado. Por favor, vuelve a iniciar sesión.',
    chatErrorNoAnswer: 'No se recibió respuesta.',
    chatErrorGeneric: 'Error',
    // --- Global Chat Widget ---
    globalChatTitle: 'Asistente de Conocimiento',
    globalChatSubtitle: 'Todos los documentos y videos',
    globalChatFab: 'Preguntar cualquier cosa',
    globalChatGreeting: '¡Hej! Puedo ayudarte con preguntas sobre todos tus documentos y videos. ¿Qué te gustaría saber?',
    globalChatPlaceholder: 'Haz una pregunta sobre todo tu contenido …',
    globalSuggestion1: '¿Qué dicen mis documentos sobre los requisitos de seguridad?',
    globalSuggestion2: 'Resumir todo el contenido disponible',
    globalSuggestion3: '¿Qué videos cubren este tema?',
    sourcesUsed: 'Fuentes',
    sourceDocument: 'Documento',
    sourceVideo: 'Video',
    goToElement: 'Abrir elemento →',
    goToVideo: 'Ver video →',
    createdOn: 'Creado el',
    pleaseSelectDocument: 'Por favor, selecciona un documento (PDF, TXT o DOC).',
    selectDocument: 'Seleccionar documento',
    photoVideo: 'Foto / Video',
    document: 'Documento',
    replaceFile: 'Reemplazar',
    removeFile: 'Eliminar',
    documentTypeDefault: 'Documento',
    invalidDocumentType: 'Por favor sube un archivo válido: PDF, TXT, DOC/DOCX o PPT/PPTX.',
    documentTooLarge: 'El archivo es demasiado grande. Máx {mb} MB permitidos.',
    documentAiInfo: 'La IA extrae automáticamente el contenido, crea un resumen (1-2 oraciones) como voz en off y usa la primera página como miniatura.',
    documentModeActive: 'Modo documento activo',
    documentModeDesc: 'La IA usará automáticamente el contenido de tu documento como texto de video. Puedes añadir contexto o dejarlo vacío.',
    docAdditionalContextPlaceholder: 'Contexto adicional opcional (ej. público objetivo)...',
    optionLabel: 'Opción',
    aiOptionLabel: 'Opción IA',
    autoGeneratedFromDoc: 'Generado automáticamente del documento',
    documentAutoProcess: 'La IA extrae contenido y crea resumen como texto de video.',
    aiDocProcessingInfo: 'Estamos analizando el documento, generando un resumen como voz en off y creando un video con la primera página como miniatura.',
    viewDocument: 'Ver',
    downloadDocument: 'Descargar',
    responseVideoNotFound: 'Video de respuesta no encontrado',
    responseVideoNotReady: 'El video de respuesta para este desafío aún no existe.',
    unknownQRCodeTitle: 'Código QR desconocido',
    unknownQRCodeQuestion: '¿Cómo te gustaría proceder?',
    unknownQRCodeCreateCollection: 'Crear nueva colección',
    addVideo: 'Añadir video',
    pleaseSelectMedia: 'Por favor selecciona un video o foto.',
    originalText: 'Original',
    printQRLabel: '🖨️ Imprimir etiqueta QR',
    printerConnecting: '🔵 Conectando impresora...',
    printerPrinting: '⏳ Imprimiendo...',
    printerDone: '✅ ¡Impreso!',
    printerError: '❌ Error – Intentar de nuevo',
    bluetoothHint: 'Se conecta por Bluetooth – selecciona Niimbot B1 de la lista',
    printerErrorHint: '¿Impresora encendida? Solo Chrome/Edge soportan Web Bluetooth.',
    number_of_views: 'Vistas',
    number_of_likes: 'Me gusta',
    qrCode: 'Código QR',
    printQrCode: 'Imprimir código QR',
    playFrom: 'Reproducir desde',
    voiceSearchSummary: '{collections} colecciones, {elements} elementos',
    pleaseLoginFirst: 'Por favor, inicia sesión para escanear códigos QR',
    openingUrl: 'Abriendo URL...',
    eanNotFound: 'No se encontró ningún elemento con este EAN',
    sessionExpired: 'Tu sesión ha expirado. Por favor inicia sesión de nuevo.',
    recordingTooShort: "Grabación demasiado corta",
    errorNoSpeechDetected: "No se detectó voz. Por favor hable más fuerte o acérquese al micrófono.",
    errorTranscriptionFailed: "No se pudo entender el audio. Por favor intente de nuevo hablando claro.",
    reactionVideo: '¿Video de reacción?',
    setThisToReaction: 'Marca este elemento como video de respuesta (Tipo de contenido 4).',
    selectModeration: 'Elige el texto adecuado',
    selectModerationDesc: 'La IA generó las siguientes sugerencias de texto basadas en tu descripción:',
    generatingScripts: 'Generando textos...',
    nothingFits: 'Ninguno encaja',
    backToDesc: 'Volver a la descripción',
    selectedModeration: 'Moderación seleccionada',
    maxRetriesReached: 'Por favor, refina tu descripción. No hay más intentos posibles.',
    errorLoadingScripts: 'Error al cargar sugerencias. Revisa tu conexión a internet o inicia sesión de nuevo.',
    challenge: 'Desafío',
    thinking: 'Pensando...',
    aiSuggest: 'Sugerencias de IA Hejvi',
    aiNoSuggestions: 'La IA no encontró elementos específicos. Se muestran todos.',
    showAll: 'Mostrar todo',
    totalXp: 'XP Total',
    sec: "seg",
    min: "min",
    invalidInput: "La entrada contiene caracteres inválidos o código HTML.",
    errorContentRejected: "Este contenido fue rechazado porque viola nuestras pautas de seguridad (por ejemplo, discurso de odio, violencia).",
    errorImageTooLarge: "La imagen es demasiado grande (Máx 4MB).",
    errorInvalidImageType: "Formato inválido. Permitido: JPG, PNG, WEBP, GIF.",
    warningImageTooLarge: "La imagen de portada es demasiado grande para el almacenamiento temporal. La estructura del curso se ha guardado, pero la imagen se ha omitido. Por favor, vuelva a seleccionarla al regresar.",
    draftSaveError: "No se pudo guardar el borrador (Almacenamiento lleno).",
    authErrorTokenMissing: "Falta token de autenticación.",
    uploadFailed: "Carga fallida.",
    qrErrorEmpty: "Por favor, introduce el valor del código QR.",
    errorOptionMissing: "Por favor completa la Opción",
    viewQuiz: 'Ver Quiz',
    details: 'Detalles',
    pleaseUploadThumbnail: "Por favor, sube una imagen de portada para el curso.",
    createVideoElement: 'Crear video',
    createQuizElement: 'Crear quiz',
    orSelectExisting: 'O seleccionar elementos existentes:',
    organize: 'Mueve los videos para cambiar el orden',
    viewCourse: 'Ver curso',
    filterMyContent: 'Solo mi contenido',
    makeVisible: 'Hacer visible',
    makeInvisible: 'Ocultar',
    selectCorrectAnswer: 'Seleccionar respuesta correcta',
    selectCorrectAnswerDesc: '¿Qué opción es la solución correcta?',
    QuizExampleQrHash: 'ej. el-32hhuz3',
    pleaseEnterQuestion: 'Por favor, introduce una pregunta o un título.',
    typeYesNo: 'Sí / No',
    typeQR: 'Escaneo QR',
    typeMulti: 'Opción múltiple',
    QuizQuestionPlaceholder: 'p.ej. ¿Es correcto este equipo de seguridad?',
    QuizDescriptionPlaceholder: 'Descripción opcional...',
    quizCreatedSuccess: '¡Cuestionario creado con éxito!',
    tapToUpload: 'Subir imagen de portada',
    uploadOrAutoThumb: 'Subir imagen',
    autoThumbHint: 'Si no, se genera automáticamente desde las miniaturas del vídeo',
    imageSelected: 'Imagen seleccionada',
    yes: 'Sí',
    no: 'No',
    correct: 'Correcto',
    incorrect: 'Incorrecto',
    submit: 'Enviar',
    next: 'Siguiente',
    back: 'Atrás',
    cancel: 'Cancelar',
    create: 'Crear',
    error: 'Error',
    success: 'Éxito',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    previous: 'Anterior',
    loading: 'Cargando...',

    // --- Quiz Builder ---
    createQuiz: 'Crear Quiz',
    configureQuiz: 'Configurar Quiz',
    selectType: 'Seleccionar tipo',
    selectResponses: 'Seleccionar videos de respuesta',
    selectResponsesDesc: 'Selecciona los videos que se reproducirán después de la respuesta.',
    question: 'Pregunta',
    enableHint: '¿Activar pista?',
    hintNotAvailableQR: 'Las pistas están desactivadas para desafíos de código QR.',

    // QR
    qrTargetTitle: 'Objetivo del código QR',
    qrTargetDesc: '¿Qué texto/código está oculto en el código QR?',
    qrValueLabel: 'Contenido QR (Exacto)',

    // Review
    reviewQuiz: 'Resumen',
    reviewDesc: 'Por favor, revisa tu configuración antes de crear el quiz.',

    // Validación
    pleaseEnterName: 'Por favor, introduce un nombre.',
    errorSelectCorrect: 'Por favor, selecciona la respuesta correcta.',
    selectBothResponses: 'Por favor, selecciona ambos videos de respuesta.',

    // Success
    backToDashboard: 'Volver al panel',
    createAnother: 'Crear otro',
    scanToStart: 'Escanear para comenzar',
    useExactTextTitle: 'Usar texto exacto',
    useExactTextDesc: 'Omitir optimización de IA y leer descripción 1:1.',
    transcribeVideoTitle: 'Usar audio del video como narración',
    transcribeVideoDesc: 'El texto hablado se transcribe automáticamente. Úsalo 1:1 como narración (sincronizado) o como base para un guión optimizado por IA.',
    transcribeVideo: 'Transcribir',
    transcribing: 'Transcribiendo...',
    transcriptAdopted: 'Audio del video adoptado como narración',
    resetTranscript: 'Descartar transcripción',
    transcriptionFailed: 'Error en la transcripción.',
    transcribeExactInfo: 'El texto hablado se transcribe 1:1 y se usa como narración. Los subtítulos permanecen sincronizados con el video original.',
    transcribeLLMInfo: 'El texto hablado se transcribe. La IA crea un guión de narración optimizado en el idioma detectado del video.',
    transcribeExactToggleDesc: 'Usar transcripción 1:1 como narración (sincronizado con el video). Desactivado: la IA genera un guión optimizado desde la transcripción.',
    loginWithQRCode: 'Iniciar sesión con código QR',
    search: 'Buscar',
    filter: 'Filtrar',
    all: 'Todo',
    needHint: '¿Necesitas una pista?',
    
    // Navigation
    home: 'Inicio',
    challenges: 'Desafíos',
    favorites: 'Favoritos',
    profile: 'Perfil',
    myCourses: 'Mis Cursos',
    
    // Dashboard
    welcome: '¡Bienvenido de nuevo! 👋',
    searchPlaceholder: 'Buscar contenido…',
    mustSee: 'Imperdible',
    safety: 'Seguridad',
    tools: 'Herramientas',
    law: 'Legal',
    mandatory: 'Obligatorio',
    mandatoryFilter: 'Cursos obligatorios',
    mandatoryCourses: 'Cursos obligatorios',
    favourites: 'Favoritos',
    favouritesFilter: 'Favoritos',
    loadMore: 'Cargar más',
    play: 'Reproducir',
    favorite: 'Favorito',
    unfavorite: 'Quitar de favoritos',
    
    // Login
    login: 'Iniciar Sesión',
    enterPin: 'Por favor, introduce el PIN',
    invalidPin: 'Por favor, introduce un PIN válido de 8 caracteres',
    loginError: 'PIN inválido. Por favor, inténtalo de nuevo.',
    wrongPin: 'PIN incorrecto. Por favor, inténtalo de nuevo.',
    loginSuccess: '¡Inicio de sesión exitoso! ¡Bienvenido de nuevo! 🎉',
    
    // Profile
    myProfile: 'Mi Perfil',
    myProgress: 'Mi Progreso',
    contactSupport: 'Contactar Soporte',
    language: 'Idioma',
    settings: 'Configuración',
    privacy: 'Privacidad',
    help: 'Ayuda',
    logout: 'Cerrar Sesión',
    active: 'Activo',
    beginner: 'Principiante',
    intermediate: 'Intermedio',
    advanced: 'Avanzado',
    joined: 'Unido',
    courses: 'Cursos',
    completed: 'Completado',
    inProgress: 'En Progreso',
    achievements: 'Logros',
    topLearner: 'Mejor Aprendiz',
    safetyStar: 'Estrella de Seguridad',
    firstSteps: 'Primeros Pasos',
    learner: 'Aprendiz',
    group: 'Grupo',
    client: 'Cliente',
    
    // Contact Form
    yourName: 'Tu Nombre',
    emailAddress: 'Correo Electrónico',
    describeIssue: 'Describe tu problema...',
    sendMessage: 'Enviar Mensaje',
    messageSent: '¡Mensaje enviado con éxito!',
    messageSendError: 'Error al enviar el mensaje. Por favor, inténtalo de nuevo.',
    
    // Course/Video
    startCourse: 'Iniciar Curso',
    continueCourse: 'Continuar Curso',
    courseProgress: 'Progreso del Curso',
    videoProgress: 'Progreso del Video',
    stepsInThisVideo: 'Pasos en este video',
    relatedVideos: 'Videos Relacionados',
    duration: 'Duración',
    experiencePoints: 'Puntos de Experiencia',
    levelComplexity: 'Nivel de Complejidad',
    lessons: 'Lecciones',
    nextLessonStartsIn: 'La próxima lección comienza en',
    nextVideoIn: 'Próximo video en',
    seconds: 's',
    replay: 'Repetir',
    cancelAutoplay: 'Cancelar reproducción automática',
    loadingCourses: 'Cargando cursos...',
    noCourses: 'No hay cursos disponibles',
    searchCourses: 'Buscar cursos...',
    noResults: 'No se encontraron cursos',
    workplaceSafety: 'Conceptos Básicos de Seguridad Laboral',
    workplaceSafetyDesc: 'Protocolos de seguridad esenciales para el lugar de trabajo',
    
    // Challenges
    allChallenges: 'Todos los Desafíos',
    currentChallenges: 'Desafíos Actuales',
    challengeProgress: 'Progreso del Desafío',
    challengeEnds: 'El desafío termina',
    daysLeft: 'días restantes',
    hoursLeft: 'horas restantes',
    minutesLeft: 'minutos restantes',
    loadingChallenges: 'Cargando desafíos...',
    activeChallenges: 'Desafíos Activos',
    weeklyProgress: 'Progreso',
    noChallenges: 'No hay desafíos disponibles por el momento.',
    startNow: 'Empezar Ahora',
    discoverMore: 'Descubrir más desafíos',
    stayMotivated: '¡Mantente motivado y gana recompensas!',
    doneChallenges: 'hecho',
    challengesProgressLabel: 'Progreso Desafíos',
    mandatoryProgressLabel: 'Progreso Cursos Obligatorios',
    doneMandatory: 'cursos obligatorios completados',
    completeChallengesEarnXP: '¡Completa desafíos para ganar XP!',
    noDeadline: 'Sin fecha límite',
    failedToLoadChallenges: 'Error al cargar desafíos',
    expired: 'Expirado',
    lessThan1hLeft: 'Menos de 1h restante',
    expert: 'Experto',
    
    // QR Scanner
    scanQR: 'Escanear Código QR',
    scanPlaceholder: 'Apunta la cámara al código QR',
    scanSuccess: '¡Código QR escaneado con éxito!',
    scanError: 'Error al escanear el código QR',
    cameraError: 'Acceso a la cámara denegado',
    cameraPermission: 'Por favor, permite el acceso a la cámara',
    cameraPermissionDenied: 'Permiso de cámara denegado. Por favor, permite el acceso.',
    noCameraFound: 'No se encontró cámara. Por favor, revisa tu dispositivo.',
    cameraNotSupported: 'Cámara no soportada en este navegador.',
    cameraInUse: 'La cámara está siendo usada por otra aplicación.',
    cameraConstraintsNotMet: 'Restricciones de cámara no cumplidas. Intenta con otra cámara.',
    failedToStartCamera: 'Error al iniciar la cámara',
    failedToAccessCamera: 'Error al acceder a la cámara. Revisa los permisos del navegador.',
    onlyOneCameraAvailable: 'Solo hay una cámara disponible en este dispositivo',
    noSuitableCameraFound: 'No se encontró una cámara adecuada para cambiar',
    failedToSwitchCamera: 'Error al cambiar de cámara',
    cameraSwitchFailed: 'Cambio de cámara fallido',
    unableToReadCodeFromImage: 'No se pudo leer el código de la imagen',
    errorAccessingCamera: 'Error accediendo a la cámara',
    tryAgain: 'Intentar de nuevo',
    switchingCamera: 'Cambiando cámara...',
    gallery: 'Galería',
    flash: 'Flash',
    switchCamera: 'Cambiar Cámara',
    capture: 'Capturar',
    
    // Voice Recording
    voiceSearch: 'Búsqueda por Voz',
    tapToStartRecording: 'Toca para empezar a grabar',
    speakYourSearchQuery: 'Di tu consulta claramente',
    startRecording: 'Iniciar Grabación',
    stopRecording: 'Detener Grabación',
    recording: 'Grabando...',
    processingAudio: 'Procesando audio...',
    transcript: 'Transcripción',
    closingOverlay: 'Cerrando superposición y mostrando resultados...',
    searchAgain: 'Buscar de nuevo',
    
    // Toast Messages
    urlOpened: 'URL abierta en nueva pestaña',
    navigatingCourse: 'Navegando al curso...',
    productCode: 'Código de producto: {code}',
    lookingUpEAN: 'Buscando EAN {ean}...',
    fetchingContent: 'Obteniendo contenido...',
    elementFound: 'Elemento encontrado: {name}',
    collectionFound: 'Colección encontrada: {name}',
    contentNotFound: 'Contenido no encontrado',
    
    // Errors
    networkError: 'Error de red. Por favor, revisa tu conexión.',
    serverError: 'Error del servidor. Por favor, inténtalo más tarde.',
    unauthorized: 'No autorizado. Por favor, inicia sesión de nuevo.',
    notFound: 'Contenido no encontrado.',
    generalError: 'Ocurrió un error inesperado.',
    
    // Time
    today: 'Hoy',
    yesterday: 'Ayer',
    thisWeek: 'Esta Semana',
    thisMonth: 'Este Mes',
    ago: 'hace',
    minutes: 'minutos',
    hours: 'horas',
    days: 'días',
    weeks: 'semanas',
    months: 'meses',
    years: 'años',
    
    // Additional UI Elements
    seeAll: 'Ver todo',
    seeMore: 'Ver más',
    seeLess: 'Ver menos',
    expand: 'Expandir',
    collapse: 'Contraer',
    refresh: 'Actualizar',
    retry: 'Reintentar',
    confirm: 'Confirmar',
    ok: 'OK',
    done: 'Hecho',
    skip: 'Omitir',
    continue: 'Continuar',
    finish: 'Finalizar',
    start: 'Inicio',
    stop: 'Detener',
    pause: 'Pausa',
    resume: 'Reanudar',
    restart: 'Reiniciar',
    reset: 'Restablecer',
    clear: 'Limpiar',
    remove: 'Quitar',
    add: 'Añadir',
    update: 'Actualizar',
    change: 'Cambiar',
    select: 'Seleccionar',
    choose: 'Elegir',
    browse: 'Explorar',
    upload: 'Subir',
    download: 'Descargar',
    share: 'Compartir',
    copy: 'Copiar',
    paste: 'Pegar',
    cut: 'Cortar',
    undo: 'Deshacer',
    redo: 'Rehacer',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    fullscreen: 'Pantalla completa',
    exitFullscreen: 'Salir de pantalla completa',
    volume: 'Volumen',
    mute: 'Silenciar',
    unmute: 'Activar sonido',
    preferences: 'Preferencias',
    account: 'Cuenta',
    notifications: 'Notificaciones',
    messages: 'Mensajes',
    inbox: 'Bandeja de entrada',
    sent: 'Enviados',
    drafts: 'Borradores',
    trash: 'Papelera',
    archive: 'Archivo',
    starred: 'Destacados',
    important: 'Importante',
    unread: 'No leídos',
    read: 'Leídos',
    markAsRead: 'Marcar como leído',
    markAsUnread: 'Marcar como no leído',
    reply: 'Responder',
    forward: 'Reenviar',
    compose: 'Redactar',
    send: 'Enviar',
    receive: 'Recibir',
    sync: 'Sincronizar',
    backup: 'Copia de seguridad',
    restore: 'Restaurar',
    import: 'Importar',
    export: 'Exportar',
    print: 'Imprimir',
    saveAs: 'Guardar como',
    open: 'Abrir',
    new: 'Nuevo',
    openInNewTab: 'Abrir en nueva pestaña',
    openInNewWindow: 'Abrir en nueva ventana',
    bookmark: 'Marcador',
    unbookmark: 'Quitar marcador',
    history: 'Historial',
    bookmarks: 'Marcadores',
    downloads: 'Descargas',
    recent: 'Reciente',
    popular: 'Popular',
    trending: 'Tendencia',
    featured: 'Destacado',
    recommended: 'Recomendado',
    suggested: 'Sugerido',
    related: 'Relacionado',
    similar: 'Similar',
    other: 'Otro',
    more: 'Más',
    less: 'Menos',
    none: 'Ninguno',
    some: 'Algunos',
    few: 'Pocos',
    many: 'Muchos',
    most: 'La mayoría',
    least: 'Menos',
    best: 'Mejor',
    worst: 'Peor',
    highest: 'Más alto',
    lowest: 'Más bajo',
    fastest: 'Más rápido',
    slowest: 'Más lento',
    newest: 'Más nuevo',
    oldest: 'Más antiguo',
    latest: 'Último',
    earliest: 'Más temprano',
    first: 'Primero',
    last: 'Último',
    current: 'Actual',
    inactive: 'Inactivo',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    on: 'Encendido',
    off: 'Apagado',
    true: 'Verdadero',
    false: 'Falso',
    maybe: 'Quizás',
    unknown: 'Desconocido',
    pending: 'Pendiente',
    processing: 'Procesando',
    failed: 'Fallido',
    cancelled: 'Cancelado',
    scheduled: 'Programado',
    overdue: 'Vencido',
    due: 'Vencimiento',
    valid: 'Válido',
    invalid: 'Inválido',
    required: 'Requerido',
    optional: 'Opcional',
    available: 'Disponible',
    unavailable: 'No disponible',
    online: 'En línea',
    offline: 'Desconectado',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    public: 'Público',
    private: 'Privado',
    hidden: 'Oculto',
    visible: 'Visible',
    locked: 'Bloqueado',
    unlocked: 'Desbloqueado',
    secure: 'Seguro',
    insecure: 'Inseguro',
    verified: 'Verificado',
    unverified: 'No verificado',
    authenticated: 'Autenticado',
    unauthenticated: 'No autenticado',
    authorized: 'Autorizado',
    permitted: 'Permitido',
    forbidden: 'Prohibido',
    allowed: 'Permitido',
    denied: 'Denegado',
    granted: 'Concedido',
    revoked: 'Revocado',
    accepted: 'Aceptado',
    rejected: 'Rechazado',
    approved: 'Aprobado',
    disapproved: 'Desaprobado',
    confirmed: 'Confirmado',
    unconfirmed: 'No confirmado',
    signed: 'Firmado',
    unsigned: 'Sin firmar',
    encrypted: 'Cifrado',
    decrypted: 'Descifrado',
    compressed: 'Comprimido',
    uncompressed: 'Descomprimido',
    archived: 'Archivado',
    unarchived: 'Desarchivado',
    backedUp: 'Respaldado',
    restored: 'Restaurado',
    imported: 'Importado',
    exported: 'Exportado',
    printed: 'Impreso',
    saved: 'Guardado',
    opened: 'Abierto',
    created: 'Creado',
    updated: 'Actualizado',
    changed: 'Cambiado',
    selected: 'Seleccionado',
    chosen: 'Elegido',
    browsed: 'Navegado',
    uploaded: 'Subido',
    downloaded: 'Descargado',
    shared: 'Compartido',
    copied: 'Copiado',
    pasted: 'Pegado',
    undone: 'Deshecho',
    redone: 'Rehecho',
    zoomedIn: 'Acercado',
    zoomedOut: 'Alejado',
    fullscreened: 'Pantalla completa',
    muted: 'Silenciado',
    unmuted: 'Sonido activado',
    notified: 'Notificado',
    messaged: 'Mensaje enviado',
    replied: 'Respondido',
    forwarded: 'Reenviado',
    composed: 'Redactado',
    received: 'Recibido',
    synced: 'Sincronizado',
    bookmarked: 'Marcado',
    unbookmarked: 'Desmarcado',
    openedInNewTab: 'Abierto en nueva pestaña',
    openedInNewWindow: 'Abierto en nueva ventana',

    // Element Creator Specific
    elementCreator: 'Creador de elementos',
    createElement: 'Crear elemento',
    createStep1Title: "¡Empecemos! Dale un nombre.",
    elementNamePlaceholder: "ej. Cómo arreglar la fresadora",
    createStep2Title: "Sube tu contenido",
    createStep2Sub: "Toma una foto/video o súbelo desde la galería.",
    selectMedia: 'Seleccionar medios',
    tapToChange: 'Toca para cambiar',
    createStep3Title: "Explícalo",
    createStep3Sub: "¿Qué sucede en este video? Nuestra IA lo convertirá en una narración profesional.",
    descPlaceholder: "Describe el proceso paso a paso...",
    createStep4Title: "Revisión",
    aiProcessingInfo: "Ahora comprimiremos el video, generaremos una narración profesional a partir de tu descripción y traduciremos todo a 10 idiomas.",
    creatingElement: "Creando elemento...",
    videoGenerating: "El vídeo se está generando, por favor espera un momento…",
    videoProcessing: "El vídeo se está finalizando… El botón se activará automáticamente.",
    videoProcessingHint: "El vídeo todavía se está procesando. Espera un momento para verlo directamente o simplemente sigue trabajando.",
    pleaseWait: "Esto puede tardar un minuto. Subiendo y procesando tareas de IA.",
    elementCreatedSuccess: '¡Elemento creado con éxito!',
    elementReadyDesc: 'Tu elemento ha sido creado y procesado con éxito.',
    viewElement: 'Ver elemento ahora',
    goToMyCourses: 'Ir a mis cursos',
    elementPendingTitle: 'Tu vídeo está siendo revisado',
    elementPendingDesc: 'Tu vídeo se ha subido correctamente y ahora está siendo revisado por un administrador. Pronto estará disponible para todos.',
    elementPendingHint: 'Recibirás una notificación cuando tu vídeo sea aprobado.',
    elementApprovedTitle: '¡Tu vídeo ha sido aprobado!',
    elementApprovedBody: 'Buenas noticias — tu vídeo «{name}» ha sido aprobado y ahora es visible para todos los usuarios.',
    descTooShort: 'Por favor, proporciona una descripción detallada (mín. 10 caracteres).',
    invalidFileType: 'Por favor, sube un video o imagen válida.',
    fileTooLarge: 'El archivo es demasiado grande. El tamaño máximo es de 500 MB.',
    media: 'Medios',
    description: 'Descripción',
    name: 'Nombre',
    
    // Course Builder
    courseDetails: 'Detalles del curso',
    courseName: 'Nombre del curso',
    courseNamePlaceholder: 'ej. mantenimiento de máquinas',
    courseDescPlaceholder: 'Describe brevemente de qué trata este curso...',
    thumbnail: 'Imagen en miniatura',
    uploadImage: '+ Subir imagen',
    addElements: 'Añadir elementos',
    searchElements: 'Buscar elementos...',
    loadingElements: 'Cargando elementos...',
    preview: 'Vista previa',
    added: 'Añadido',
    noElementsFound: 'No se encontraron elementos coincidentes.',
    organizeCourse: 'Organizar curso',
    dragDropReorder: 'Arrastrar y soltar para reordenar',
    addMoreElements: '+ Añadir más elementos',
    courseCreated: '¡Curso creado!',
    courseCreatedDesc: 'Tu colección se ha guardado con éxito.',
    createAnotherCourse: 'Crear otro curso',
    createCourse: 'Crear curso',
    addToCourse: 'Añadir al curso',
    saving: 'Guardando...',
    noElementsSelected: 'Por favor, selecciona al menos un elemento',
    errorCreatingCourse: 'Error al crear el curso',
    authError401: 'No autorizado (401). Tu sesión puede haber expirado. Por favor inicia sesión de nuevo.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: '💡 El nombre y la descripción se traducen automáticamente a todos los idiomas.',
    adm_en_readonly_hint: 'Traducido automáticamente – no editable',
    adm_filter_active: 'Activo',
    adm_filter_all: 'Todos',
    adm_filter_inactive: 'Inactivo',
    adm_last_superadmin_hint: 'Último Super Admin – no se puede eliminar',
    adm_no_group_access: 'Sin acceso al contenido',
    adm_no_group_assign_warn: 'Este usuario no está asignado a ningún grupo y, por tanto, no tiene acceso al contenido.',
    adm_no_group_warn_body: 'Los nuevos usuarios sin grupo no tienen acceso al contenido. Por favor, asigne un grupo a través de 🏷️ Grupos después de la creación.',
    adm_no_group_warn_title: 'Nota: Sin acceso a grupo',
    adm_toast_added_to_group: 'Añadido al grupo',
    adm_toast_removed_from_group: 'Eliminado del grupo',
    adm_toast_group_assigned: 'Grupo asignado',
    adm_toast_group_removed: 'Grupo quitado',
    adm_toast_content_assigned: 'Contenido asignado',
    adm_toast_content_removed: 'Contenido quitado',
    // ── Sistema de notificaciones ─────────────────────────────────────────
    adm_notifications:          'Mensajes',
    notif_type_new_content:     'Nuevo contenido',
    notif_type_message:         'Mensaje',
    notif_goto_collection:      'Ir a la colección',
    notif_dismiss_all:          'Cerrar todo',
    notif_just_now:             'Ahora mismo',

    // ── MyCourses: filtros, encabezados de sección y estados vacíos ─────
    mc_filter_all:            'Todo',
    mc_filter_courses:        '📚 Mis Cursos',
    mc_filter_videos:         '▶ Mis Vídeos',
    mc_filter_favorites:      '★ Favoritos',
    mc_status_all:            'Todos los estados',
    mc_only_mine:             'Solo los míos',
    mc_section_courses_sub:   'Cursos iniciados y completados',
    mc_section_videos:        'Mis Vídeos',
    mc_section_videos_sub:    'Contenido creado por ti',
    mc_section_favorites:     'Mis Favoritos',
    mc_section_favorites_sub: 'Cursos y vídeos que te gustan',
    mc_empty_courses:         'Aún no has iniciado ningún curso.',
    mc_empty_videos:          'Aún no has creado ningún vídeo.',
    mc_empty_favorites:       'Aún no has añadido contenido a tus favoritos.',
    videoRendering:     'Renderizando vídeo…',
    videoRenderingHint: 'El vídeo aún se está procesando. Estará disponible en breve.',
    // ── AdminPanel: nuevas cadenas i18n ──────────────────────────────────
    adm_qr_unavailable:         'QR no disponible — npm install qrcode',
    adm_qr_login_title:         'Código QR para iniciar sesión',
    adm_qr_scan_login_hint:     'Escanear → iniciar sesión directamente sin PIN',
    adm_qr_permanent_hint:      'El código QR está disponible permanentemente en el registro del usuario.',
    adm_qr_print_hint:          'Imprimir el PIN ahora o transmitirlo de forma segura.',
    adm_msg_subject_placeholder:'ej. Nueva instrucción de seguridad disponible',
    adm_msg_text_placeholder:   'Texto del mensaje…',
    adm_col_license_type:       'Tipo de licencia',
    adm_btn_show_qr:            'Mostrar código QR',
    adm_btn_send_msg:           'Enviar mensaje',
    adm_login_qr_label:         'Código QR de inicio de sesión',
    adm_btn_gen_pin:            'Generar nuevo PIN',
    adm_qr_scan_hint:           'El usuario puede escanear este código para iniciar sesión sin PIN.',
    adm_pin_reset_hint:         'Para restablecer el PIN: cierra y usa 🔄 Restablecer PIN en la tarjeta.',
    adm_role_supervisor:        'Supervisor',
    adm_role_admin_opt:         'Admin',
    adm_role_superadmin:        'Super Admin',
    adm_seat_essentials_desc:   'Essentials – todas las funciones excepto la creación de contenido',
    adm_pin_force_change:       'Forzar cambio de PIN en el primer inicio de sesión',
    adm_btn_msg_group:          'Mensaje al grupo',
    adm_btn_show:               'Mostrar',
    adm_btn_unlock:             'Desbloquear elemento',
    adm_btn_show_assigned:      'Mostrar contenido asignado',
    adm_no_videos_assigned:     'No hay vídeos asignados. Haz clic en «+ Añadir vídeo».',
    adm_drag_sort:              'Arrastrar para ordenar',
    adm_search_video:           'Buscar vídeo…',
    adm_no_videos:              'No se encontraron vídeos.',
    adm_video_unassigned:       'Este vídeo no está asignado a ningún contenido.',
    adm_search_messages:        'Buscar mensajes…',
    adm_btn_reload:             'Recargar',
    adm_enriching:              'Enriquecimiento en curso…',
    adm_no_video_chunks:        'No se encontraron vídeos con fragmentos de transcripción',
    adm_ki_enrichment:          'Enriquecimiento IA',
    adm_col_updated:            'Actualizado',
    adm_search_docs:            'Buscar documento o elemento…',
    adm_no_docs:                'No hay documentos disponibles',
    adm_col_size:               'Tamaño',
    adm_search_questions:       'Buscar preguntas…',
    adm_label_question:         'Pregunta del empleado',
    adm_label_answer:           'Respuesta',
    adm_btn_upload_doc:         'Subir documento',
    adm_just_moment:            'Un momento',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Solo los administradores pueden editar el perfil de dominio.',
    adm_primary_lang:           'Idioma de trabajo principal',
    adm_drop_doc:               'Soltar documento aquí o hacer clic',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Documentos de empresa existentes',
    adm_company_docs_empty:     'Aún no se han subido documentos de empresa.',
    adm_no_licence:             'No hay datos de licencia disponibles.',
    adm_full_seats_label:       '⭐ Full Seats (incl. creación de contenido)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'Válido hasta',
    adm_base_lang:              'Idioma base',
    adm_active_ui_langs:        'Idiomas UI activos',
    adm_tts_langs:              'Idiomas TTS',
    adm_full_seats_total_label: '⭐ Full Seats total',
    adm_essentials_total_label: 'Essentials Seats total',
    adm_ui_langs_field:         'Idiomas UI (idiomas activos de la app)',
    adm_tts_langs_field:        'Idiomas TTS (texto a voz)',
    adm_config_title:           'Configuración',
    adm_config_desc:            'Configuración de la plataforma para este tenant. Los cambios tienen efecto inmediato.',
    adm_supervisor_mode:        'Modo supervisor',
    adm_warning_no_admin:       '⚠️ Atención: No hay ningún usuario activo con rol de Supervisor o Admin (Grupo 2 o 3).',
    adm_std_delete_toggle:      'Usuarios estándar: eliminar y desactivar vídeos',
    adm_std_course_toggle:      'Usuarios estándar: crear cursos y quizzes',
    adm_supervisor_confirm_title: '¿Activar el modo supervisor?',
    adm_btn_activate:           'Activar',
    adm_admin_only_setting:     'Solo los administradores del tenant (Grupo 3) o Super Admins pueden cambiar esta configuración.',
    adm_only_admins_edit:       'Solo los administradores pueden cambiar esta configuración.',
  },

  ro: {
    // Rumänisch (ro)
      assignToGeneral: 'Adaugă la grupul general',
  assignToGeneralOn: 'Conținutul va fi vizibil pentru toți membrii grupului implicit după creare.',
  assignToGeneralOff: '⚠ Atenție: Acest conținut nu va fi vizibil pentru publicul general. Va fi accesibil doar administratorilor și creatorului.',
    videoRenderingBackground: 'Videoclipul este procesat în fundal – veți putea continua imediat.',
    manyPagesHint: 'Documentul conține {count} pagini – analiza va dura puțin mai mult.',
    analyzingPages: 'Se analizează paginile…',
    notif_goto_adminpanel:    'Deschide panoul de administrare',
    notif_type_new_question:  'Întrebare nouă',
    notif_title:         'Notificări',
    notif_back:          'Înapoi',
    notif_loading:       'Se încarcă…',
    notif_empty:         'Nu există mesaje',
    notif_just_now:          'Chiar acum',
    notif_type_message:      'Mesaj admin',
    notif_type_new_content:  'Conținut nou',
    notif_goto_collection:   'Mergi la colecție',
    notif_goto_document:     'Deschide documentul',
    notif_open_document:     'Deschide documentul',
    notif_goto_fraghejvi:    'Deschide FragHejVi',
    notif_close:             'Închide',
    notif_dismiss_all:       'Închide tot',
    adminArea: 'Panou de administrare',
    adm_pin_format_hint:    'Exact 8 caractere: litere și cifre',
    adm_pin_format_error:   'PIN-ul trebuie să aibă exact 8 caractere alfanumerice.',
    adm_subtitle:          'Management HejVi',
    adm_access_denied:     'Acces refuzat',
    adm_access_denied_desc:'Nu aveți permisiunea de a accesa această zonă.',
    adm_back:              'Înapoi',
    adm_users:             'Utilizatori',
    adm_groups:            'Grupuri',
    adm_videos:            'Videoclipuri',
    adm_topics:            'Teme',
    adm_video_sg:          'Video',
    adm_topic_sg:          'Temă',
    adm_docs:              'Documente & Bază de cunoștințe',
    adm_open_video:        'Deschide videoclipul într-o filă nouă',
    adm_open_doc:          'Deschide documentul într-o filă nouă',
    adm_open_element:      'Deschide elementul într-o filă nouă',
    adm_stat_users:        'Total utilizatori',
    adm_stat_active:       'Utilizatori activi',
    adm_members:           'Membri',
    adm_content:           'Conținut',
    adm_name:              'Nume',
    adm_status:            'Stare',
    adm_role:              'Rol',
    adm_role_standard:     'Standard',
    adm_created:           'Creat',
    adm_actions:           'Acțiuni',
    adm_preview:           'Previzualizare',
    adm_active:            'Activ',
    adm_inactive:          'Inactiv',
    adm_edit:              'Editare',
    adm_delete:            'Ștergere',
    adm_new_user:          'Utilizator nou',
    adm_new_group:         'Grup nou',
    adm_edit_user:         'Editează utilizator',
    adm_edit_group:        'Editează grup',
    adm_create:            'Creare',
    adm_save:              'Salvare',
    adm_save_translate:    'Salvează și traduce',
    adm_translating:       'Se traduce…',
    adm_cancel:            'Anulare',
    adm_done:              'Gata',
    adm_confirm:           'Sigur?',
    adm_yes:               'Da',
    adm_no:                'Nu',
    adm_mandatory:         'Obligatoriu',
    adm_description:       'Descriere',
    adm_rights_level:      'Nivel drepturi',
    adm_lang_id:           'Limbă',
    adm_client_id:         'Client',
    adm_pin_change:        'Schimbă PIN (gol = neschimbat)',
    adm_pin_hint:          'Minim 4 caractere',
    adm_pin_change_hint:   'Lasă gol pentru a nu schimba',
    adm_groups_for:        'Grupuri pentru',
    adm_groups_assign_hint:'Atribuiți sau eliminați grupuri',
    adm_content_for_group: 'Conținut pentru grup',
    adm_content_visible_hint: 'Acest conținut este vizibil pentru grupurile:',
    adm_assigned:          'Atribuit',
    adm_add:               'Adaugă',
    adm_remove:            'Elimină',
    adm_assign:            'Atribuie',
    adm_search_hint:       'caută',
    adm_no_users:          'Niciun utilizator găsit',
    adm_no_groups:         'Niciun grup disponibil',
    adm_no_entries:        'Nicio intrare găsită',
    adm_no_content:        'Niciun conținut găsit',
    adm_toast_deleted:     'Șters',
    adm_toast_created:     'Creat',
    adm_toast_saved:       'Salvat',
    adm_toast_deactivated: 'Dezactivat',
    adm_toast_removed:     'Eliminat din grup',
    adm_toast_added:       'Adăugat în grup',
    adm_toast_error:       'A apărut o eroare',
    adm_toast_load_error:  'Eroare la încărcare',
    chatGreeting: 'Hej! Sunt bucuros să te ajut. Ce vrei să știi?',
    chatSubtitle: 'Întreabă despre document',
    chatButton: 'Întreabă',
    chatPlaceholder: 'Pune o întrebare despre document …',
    chatClear: 'Șterge chat',
    chatSuggestion1: 'Rezumă documentul',
    chatSuggestion2: 'Care sunt punctele cheie?',
    chatSuggestion3: 'Ce cerințe sunt menționate?',
    chatErrorNotAuthenticated: 'Neautentificat. Te rugăm să te autentifici din nou.',
    chatErrorNoAnswer: 'Nu s-a primit niciun răspuns.',
    chatErrorGeneric: 'Eroare',
    globalChatTitle: 'Asistent de cunoaștere',
    globalChatSubtitle: 'Toate documentele și videoclipurile',
    globalChatFab: 'Întreabă HejVi',
    globalChatGreeting: 'Hej! Pot să te ajut cu întrebări despre toate documentele și videoclipurile tale. Ce vrei să știi?',
    globalChatPlaceholder: 'Pune o întrebare despre tot conținutul tău …',
    globalSuggestion1: 'Ce spun documentele mele despre cerințele de siguranță?',
    globalSuggestion2: 'Rezumă tot conținutul disponibil',
    globalSuggestion3: 'Ce videoclipuri acoperă acest subiect?',
    sourcesUsed: 'Surse',
    sourceDocument: 'Document',
    sourceVideo: 'Video',
    goToElement: 'Deschide elementul →',
    goToVideo: 'Vizionează videoclipul →',
    createdOn: 'Creat la',
    pleaseSelectDocument: 'Te rugăm să selectezi un document (PDF, TXT sau DOC).',
    selectDocument: 'Selectează document',
    photoVideo: 'Foto / Video',
    document: 'Document',
    replaceFile: 'Înlocuiește',
    removeFile: 'Elimină',
    documentTypeDefault: 'Document',
    invalidDocumentType: 'Te rugăm să încarci un fișier valid: PDF, TXT, DOC/DOCX sau PPT/PPTX.',
    documentTooLarge: 'Fișierul este prea mare. Maxim {mb} MB permis.',
    documentAiInfo: 'AI extrage automat conținutul, creează un rezumat (1-2 propoziții) ca narațiune și folosește prima pagină ca imagine de previzualizare.',
    documentModeActive: 'Mod document activ',
    documentModeDesc: 'AI va folosi automat conținutul documentului tău ca text video.',
    docAdditionalContextPlaceholder: 'Context suplimentar opțional (ex. public țintă)...',
    optionLabel: 'Opțiune',
    aiOptionLabel: 'Opțiune AI',
    autoGeneratedFromDoc: 'Generat automat din document',
    documentAutoProcess: 'AI extrage conținut și creează rezumat ca text video.',
    aiDocProcessingInfo: 'Analizăm documentul, generăm un rezumat ca narațiune și creăm un videoclip cu prima pagină ca imagine de previzualizare.',
    viewDocument: 'Vizualizează',
    downloadDocument: 'Descarcă',
    responseVideoNotFound: 'Videoclipul de răspuns nu a fost găsit',
    responseVideoNotReady: 'Videoclipul de răspuns pentru această provocare nu există încă.',
    unknownQRCodeTitle: 'Cod QR necunoscut',
    unknownQRCodeQuestion: 'Cum dorești să continui?',
    unknownQRCodeCreateCollection: 'Creează colecție nouă',
    addVideo: 'Adaugă video',
    pleaseSelectMedia: 'Te rugăm să selectezi un video sau o fotografie.',
    originalText: 'Original',
    printQRLabel: '🖨️ Tipărește eticheta QR',
    printerConnecting: '🔵 Se conectează imprimanta...',
    printerPrinting: '⏳ Se tipărește...',
    printerDone: '✅ Tipărit!',
    printerError: '❌ Eroare – Încearcă din nou',
    bluetoothHint: 'Se conectează prin Bluetooth – selectează Niimbot B1 din listă',
    printerErrorHint: 'Imprimanta pornită? Doar Chrome/Edge suportă Web Bluetooth.',
    number_of_views: 'Vizualizări',
    number_of_likes: 'Aprecieri',
    qrCode: 'Cod QR',
    printQrCode: 'Tipărește cod QR',
    playFrom: 'Redă din',
    voiceSearchSummary: '{collections} colecții, {elements} elemente',
    pleaseLoginFirst: 'Te rugăm să te autentifici mai întâi pentru a scana coduri QR',
    openingUrl: 'Se deschide URL-ul...',
    eanNotFound: 'Nu s-a găsit niciun element cu acest EAN',
    sessionExpired: 'Sesiunea ta a expirat. Te rugăm să te autentifici din nou.',
    recordingTooShort: 'Înregistrarea este prea scurtă',
    errorNoSpeechDetected: 'Nu s-a detectat nicio voce. Te rugăm să vorbești mai tare sau să te apropii de microfon.',
    errorTranscriptionFailed: 'Nu s-a putut înțelege audio. Te rugăm să încerci din nou vorbind clar.',
    reactionVideo: 'Videoclip de reacție?',
    setThisToReaction: 'Marchează acest element ca videoclip de răspuns (Tip conținut 4).',
    selectModeration: 'Alege textul potrivit',
    selectModerationDesc: 'AI a generat următoarele sugestii de text pe baza descrierii tale:',
    generatingScripts: 'Se generează textele...',
    nothingFits: 'Nimic nu se potrivește',
    backToDesc: 'Înapoi la descriere',
    selectedModeration: 'Moderare selectată',
    maxRetriesReached: 'Te rugăm să îmbunătățești descrierea. Nu mai sunt posibile alte încercări.',
    errorLoadingScripts: 'Eroare la încărcarea sugestiilor. Verifică conexiunea la internet sau autentifică-te din nou.',
    challenge: 'Provocare',
    thinking: 'Mă gândesc...',
    aiSuggest: 'Sugestii AI Hejvi',
    aiNoSuggestions: 'AI nu a găsit elemente specifice. Se afișează toate.',
    showAll: 'Arată tot',
    totalXp: 'Total XP',
    levelUp: 'Nivel superior!',
    achievementUnlocked: 'Realizare deblocată!',
    congrats: 'Felicitări!',
    awesome: 'Excelent!',
    newXp: 'XP obținut',
    sec: 's',
    min: 'min',
    invalidInput: 'Intrarea conține caractere nevalide.',
    errorContentRejected: 'Acest conținut a fost respins deoarece încalcă regulile noastre de siguranță.',
    errorImageTooLarge: 'Imaginea este prea mare (Max 4MB).',
    errorInvalidImageType: 'Format invalid. Permis: JPG, PNG, WEBP, GIF.',
    warningImageTooLarge: 'Imaginea de copertă este prea mare pentru stocarea temporară.',
    draftSaveError: 'Schița nu a putut fi salvată.',
    authErrorTokenMissing: 'Token de autentificare lipsă.',
    uploadFailed: 'Încărcare eșuată.',
    qrErrorEmpty: 'Te rugăm să introduci valoarea codului QR.',
    errorOptionMissing: 'Te rugăm să completezi opțiunea',
    viewQuiz: 'Vizualizează quiz',
    details: 'Detalii',
    pleaseUploadThumbnail: 'Te rugăm să încarci o imagine de previzualizare pentru curs.',
    createVideoElement: 'Creează video',
    createQuizElement: 'Creează quiz',
    orSelectExisting: 'Sau selectează elemente existente:',
    organize: 'Mută videoclipurile pentru a schimba ordinea',
    viewCourse: 'Vizualizează cursul',
    filterMyContent: 'Doar conținutul meu',
    makeVisible: 'Fă vizibil',
    makeInvisible: 'Ascunde',
    selectCorrectAnswer: 'Selectează răspunsul corect',
    selectCorrectAnswerDesc: 'Care opțiune este soluția corectă?',
    QuizExampleQrHash: 'ex. el-32hhuz3',
    pleaseEnterQuestion: 'Te rugăm să introduci o întrebare sau un titlu.',
    typeYesNo: 'Da / Nu',
    typeQR: 'Scanare QR',
    typeMulti: 'Răspuns multiplu',
    QuizQuestionPlaceholder: 'ex. Echipamentul de protecție este corect?',
    QuizDescriptionPlaceholder: 'Descriere opțională...',
    quizCreatedSuccess: 'Quiz creat cu succes!',
    tapToUpload: 'Încarcă imagine de previzualizare',
    uploadOrAutoThumb: 'Încarcă imagine',
    autoThumbHint: 'Altfel se generează automat din miniaturile video',
    imageSelected: 'Imagine selectată',
    yes: 'Da',
    no: 'Nu',
    correct: 'Corect',
    incorrect: 'Incorect',
    submit: 'Trimite',
    next: 'Următor',
    back: 'Înapoi',
    cancel: 'Anulează',
    create: 'Creează',
    error: 'Eroare',
    success: 'Succes',
    save: 'Salvează',
    delete: 'Șterge',
    edit: 'Editează',
    close: 'Închide',
    previous: 'Anterior',
    loading: 'Se încarcă...',
    createQuiz: 'Creează Quiz',
    configureQuiz: 'Configurează Quiz',
    selectType: 'Selectează tipul',
    selectResponses: 'Selectează videoclipuri de răspuns',
    selectResponsesDesc: 'Selectează videoclipurile care vor fi redate după răspunsul utilizatorului.',
    question: 'Întrebare',
    enableHint: 'Activează indiciu?',
    hintNotAvailableQR: 'Indiciile sunt dezactivate pentru provocările cu cod QR.',
    qrTargetTitle: 'Ținta codului QR',
    qrTargetDesc: 'Ce text/cod este ascuns în codul QR?',
    qrValueLabel: 'Conținut QR (Exact)',
    reviewQuiz: 'Rezumat',
    reviewDesc: 'Te rugăm să verifici setările înainte de a crea quiz-ul.',
    pleaseEnterName: 'Te rugăm să introduci un nume.',
    errorSelectCorrect: 'Te rugăm să selectezi răspunsul corect.',
    selectBothResponses: 'Te rugăm să selectezi ambele videoclipuri de răspuns.',
    backToDashboard: 'Înapoi la panou',
    createAnother: 'Creează altul',
    scanToStart: 'Scanează pentru a începe',
    useExactTextTitle: 'Folosește textul exact',
    useExactTextDesc: 'Omite optimizarea AI și citește descrierea 1:1.',
    transcribeVideoTitle: 'Folosește audio videoclipului ca narațiune',
    transcribeVideoDesc: 'Textul vorbit este transcris. Folosește-l literal ca narațiune sau ca bază pentru un script AI optimizat.',
    transcribeVideo: 'Transcrie',
    transcribing: 'Se transcrie...',
    transcriptAdopted: 'Audio videoclipului adoptat ca narațiune',
    resetTranscript: 'Renunță la transcriere',
    transcriptionFailed: 'Transcriere eșuată.',
    transcribeExactInfo: 'Textul vorbit este transcris 1:1 și folosit ca narațiune. Subtitrările rămân sincronizate cu videoclipul original.',
    transcribeLLMInfo: 'Textul vorbit este transcris. AI creează un script de narațiune optimizat în limba detectată a videoclipului.',
    transcribeExactToggleDesc: 'Folosește transcrierea 1:1 ca narațiune (sincronizat cu videoclipul). Dezactivat: AI generează un script optimizat din transcriere.',
    confirmDelete: 'Ești sigur că vrei să ștergi acest element? Acțiunea nu poate fi anulată.',
    deleteSuccess: 'Element șters cu succes.',
    deleteError: 'Ștergerea a eșuat.',
    loginWithQRCode: 'Autentifică-te cu cod QR',
    search: 'Caută',
    filter: 'Filtrează',
    all: 'Toate',
    needHint: 'Ai nevoie de un indiciu?',
    home: 'Acasă',
    challenges: 'Provocări',
    favorites: 'Favorite',
    profile: 'Profil',
    myCourses: 'Cursurile mele',
    welcome: 'Bun venit înapoi! 👋',
    searchPlaceholder: 'Caută conținut…',
    mustSee: 'De văzut',
    safety: 'Siguranță',
    tools: 'Instrumente',
    law: 'Legislație',
    mandatory: 'Obligatoriu',
    mandatoryFilter: 'Cursuri obligatorii',
    mandatoryCourses: 'Cursuri obligatorii',
    favourites: 'Favorite',
    favouritesFilter: 'Favorite',
    loadMore: 'Încarcă mai mult',
    play: 'Redă',
    favorite: 'Favorit',
    unfavorite: 'Elimină din favorite',
    login: 'Autentifică-te',
    enterPin: 'Te rugăm să introduci PIN-ul',
    invalidPin: 'Te rugăm să introduci un PIN valid de 8 caractere',
    loginError: 'PIN invalid. Te rugăm să încerci din nou.',
    wrongPin: 'PIN greșit. Te rugăm să încerci din nou.',
    loginSuccess: 'Autentificare reușită! Bun venit înapoi! 🎉',
    myProfile: 'Profilul meu',
    myProgress: 'Progresul meu',
    contactSupport: 'Contactează suport',
    language: 'Limbă',
    settings: 'Setări',
    privacy: 'Confidențialitate',
    help: 'Ajutor',
    logout: 'Deconectează-te',
    active: 'Activ',
    beginner: 'Începător',
    intermediate: 'Intermediar',
    advanced: 'Avansat',
    joined: 'Înscris',
    courses: 'Cursuri',
    completed: 'Finalizat',
    inProgress: 'În curs',
    achievements: 'Realizări',
    topLearner: 'Top cursant',
    safetyStar: 'Stea siguranță',
    firstSteps: 'Primii pași',
    learner: 'Cursant',
    group: 'Grup',
    client: 'Client',
    yourName: 'Numele tău',
    emailAddress: 'Adresă de email',
    describeIssue: 'Descrie problema ta...',
    sendMessage: 'Trimite mesaj',
    messageSent: 'Mesaj trimis cu succes!',
    messageSendError: 'Trimiterea mesajului a eșuat. Te rugăm să încerci din nou.',
    startCourse: 'Începe cursul',
    continueCourse: 'Continuă cursul',
    courseProgress: 'Progres curs',
    videoProgress: 'Progres video',
    stepsInThisVideo: 'Pași în acest videoclip',
    relatedVideos: 'Videoclipuri similare',
    duration: 'Durată',
    experiencePoints: 'Puncte de experiență',
    levelComplexity: 'Nivel complexitate',
    lessons: 'Lecții',
    nextLessonStartsIn: 'Următoarea lecție începe în',
    nextVideoIn: 'Următorul videoclip în',
    seconds: 's',
    replay: 'Redă din nou',
    cancelAutoplay: 'Anulează redarea automată',
    loadingCourses: 'Se încarcă cursurile...',
    noCourses: 'Nu sunt cursuri disponibile',
    searchCourses: 'Caută cursuri...',
    noResults: 'Nu s-au găsit cursuri',
    allChallenges: 'Toate provocările',
    currentChallenges: 'Provocări curente',
    challengeProgress: 'Progres provocare',
    challengeEnds: 'Provocarea se termină',
    daysLeft: 'zile rămase',
    hoursLeft: 'ore rămase',
    minutesLeft: 'minute rămase',
    loadingChallenges: 'Se încarcă provocările...',
    activeChallenges: 'Provocări active',
    weeklyProgress: 'Progres',
    noChallenges: 'Nu sunt provocări disponibile momentan.',
    startNow: 'Începe acum',
    discoverMore: 'Descoperă mai multe provocări',
    stayMotivated: 'Rămâi motivat și câștigă recompense!',
    doneChallenges: 'terminat',
    challengesProgressLabel: 'Progres Provocări',
    mandatoryProgressLabel: 'Progres cursuri obligatorii',
    doneMandatory: 'cursuri obligatorii terminate',
    completeChallengesEarnXP: 'Finalizează provocări pentru a câștiga XP!',
    noDeadline: 'Fără termen limită',
    failedToLoadChallenges: 'Nu s-au putut încărca provocările',
    expired: 'Expirat',
    lessThan1hLeft: 'Mai puțin de 1h rămasă',
    expert: 'Expert',
    scanQR: 'Scanează cod QR',
    scanPlaceholder: 'Îndreptă camera spre codul QR',
    scanSuccess: 'Cod QR scanat cu succes!',
    scanError: 'Scanarea codului QR a eșuat',
    cameraError: 'Acces la cameră refuzat',
    cameraPermission: 'Te rugăm să permiți accesul la cameră',
    cameraPermissionDenied: 'Acces la cameră refuzat. Te rugăm să permiți accesul.',
    noCameraFound: 'Nu s-a găsit nicio cameră. Verifică dispozitivul.',
    failedToStartCamera: 'Nu s-a putut porni camera',
    failedToAccessCamera: 'Accesul la cameră a eșuat. Verifică permisiunile browserului.',
    tryAgain: 'Încearcă din nou',
    gallery: 'Galerie',
    flash: 'Bliț',
    switchCamera: 'Schimbă camera',
    capture: 'Captură',
    voiceSearch: 'Căutare vocală',
    tapToStartRecording: 'Apasă pentru a începe înregistrarea',
    speakYourSearchQuery: 'Rostește clar interogarea de căutare',
    startRecording: 'Începe înregistrarea',
    stopRecording: 'Oprește înregistrarea',
    recording: 'Se înregistrează...',
    processingAudio: 'Se procesează audio...',
    transcript: 'Transcriere',
    searchAgain: 'Caută din nou',
    networkError: 'Eroare de rețea. Verifică conexiunea.',
    serverError: 'Eroare de server. Te rugăm să încerci mai târziu.',
    unauthorized: 'Neautorizat. Te rugăm să te autentifici din nou.',
    notFound: 'Conținut negăsit.',
    generalError: 'A apărut o eroare neașteptată.',
    today: 'Azi',
    yesterday: 'Ieri',
    thisWeek: 'Săptămâna aceasta',
    thisMonth: 'Luna aceasta',
    ago: 'acum',
    minutes: 'minute',
    hours: 'ore',
    days: 'zile',
    weeks: 'săptămâni',
    months: 'luni',
    years: 'ani',
    seeAll: 'Vezi tot',
    seeMore: 'Vezi mai mult',
    seeLess: 'Vezi mai puțin',
    confirm: 'Confirmă',
    ok: 'OK',
    done: 'Gata',
    skip: 'Omite',
    continue: 'Continuă',
    finish: 'Finalizează',
    start: 'Start',
    stop: 'Stop',
    pause: 'Pauză',
    resume: 'Reia',
    restart: 'Repornește',
    reset: 'Resetează',
    clear: 'Șterge',
    remove: 'Elimină',
    add: 'Adaugă',
    update: 'Actualizează',
    change: 'Schimbă',
    select: 'Selectează',
    upload: 'Încarcă',
    download: 'Descarcă',
    share: 'Distribuie',
    copy: 'Copiază',
    none: 'Niciunul',
    elementCreator: 'Creator Video',
    createElement: 'Creează Video',
    createStep1Title: 'Să începem! Dă-i un nume.',
    elementNamePlaceholder: 'ex. Cum să repari mașina de frezat',
    createStep2Title: 'Încarcă conținutul tău',
    createStep2Sub: 'Fă o fotografie/videoclip sau încarcă din galerie.',
    selectMedia: 'Selectează media',
    tapToChange: 'Apasă pentru a schimba',
    createStep3Title: 'Explică-l',
    createStep3Sub: 'Ce se întâmplă în acest videoclip? AI-ul nostru va transforma aceasta într-o narațiune profesională.',
    descPlaceholder: 'Descrie procesul pas cu pas...',
    createStep4Title: 'Revizuiește',
    aiProcessingInfo: 'Vom comprima acum videoclipul, vom genera o narațiune profesională din descrierea ta și vom traduce totul în mai multe limbi.',
    creatingElement: 'Se creează elementul...',
    videoGenerating: 'Videoclipul este în curs de generare, vă rugăm așteptați…',
    videoProcessing: 'Videoclipul este în curs de finalizare… Butonul va fi activat automat.',
    videoProcessingHint: 'Videoclipul este încă în procesare. Așteaptă puțin pentru a-l viziona direct sau continuă să lucrezi.',
    pleaseWait: 'Aceasta poate dura un minut. Se încarcă și se procesează sarcini AI.',
    elementCreatedSuccess: 'Element creat cu succes!',
    elementReadyDesc: 'Elementul tău a fost creat și procesat cu succes.',
    viewElement: 'Vizualizează elementul acum',
    goToMyCourses: 'Mergi la cursurile mele',
    elementPendingTitle: 'Videoclipul tău este în curs de verificare',
    elementPendingDesc: 'Videoclipul tău a fost încărcat cu succes și este acum examinat de un administrator. Va fi publicat pentru toți în curând.',
    elementPendingHint: 'Vei fi notificat când videoclipul tău va fi aprobat.',
    elementApprovedTitle: 'Videoclipul tău a fost aprobat!',
    elementApprovedBody: 'Vești bune — videoclipul „{name}" a fost aprobat și este acum vizibil pentru toți utilizatorii.',
    descTooShort: 'Te rugăm să furnizezi o descriere detaliată (min. 10 caractere).',
    invalidFileType: 'Te rugăm să încarci un videoclip sau o imagine validă.',
    fileTooLarge: 'Fișierul este prea mare. Dimensiunea maximă este 500MB.',
    media: 'Media',
    description: 'Descriere',
    name: 'Nume',
    courseDetails: 'Detalii curs',
    courseName: 'Nume curs',
    courseNamePlaceholder: 'ex. întreținere mașini',
    courseDescPlaceholder: 'Descrie pe scurt despre ce este acest curs...',
    thumbnail: 'Imagine previzualizare',
    uploadImage: '+ Încarcă imagine',
    addElements: 'Adaugă elemente',
    searchElements: 'Caută elemente...',
    loadingElements: 'Se încarcă elementele...',
    preview: 'Previzualizare',
    added: 'Adăugat',
    noElementsFound: 'Nu s-au găsit elemente potrivite.',
    organizeCourse: 'Organizează cursul',
    dragDropReorder: 'Trage și plasează pentru a reordona',
    addMoreElements: '+ Adaugă mai multe elemente',
    courseCreated: 'Curs creat!',
    courseCreatedDesc: 'Colecția ta a fost salvată cu succes.',
    createAnotherCourse: 'Creează alt curs',
    createCourse: 'Creează curs',
    addToCourse: 'Adaugă la curs',
    saving: 'Se salvează...',
    noElementsSelected: 'Te rugăm să selectezi cel puțin un element',
    errorCreatingCourse: 'Eroare la crearea cursului',
    authError401: 'Neautorizat (401). Sesiunea ta a expirat. Te rugăm să te autentifici din nou.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: '💡 Numele și descrierea sunt traduse automat în toate limbile.',
    adm_en_readonly_hint: 'Tradus automat – needitabil',
    adm_filter_active: 'Activ',
    adm_filter_all: 'Toate',
    adm_filter_inactive: 'Inactiv',
    adm_last_superadmin_hint: 'Ultimul Super Admin – nu poate fi șters',
    adm_no_group_access: 'Fără acces la conținut',
    adm_no_group_assign_warn: 'Acest utilizator nu este atribuit niciunui grup și, prin urmare, nu are acces la conținut.',
    adm_no_group_warn_body: 'Utilizatorii noi fără grup nu au acces la conținut. Atribuiți un grup prin 🏷️ Grupuri după creare.',
    adm_no_group_warn_title: 'Notă: Fără acces la grup',
    adm_toast_added_to_group: 'Adăugat în grup',
    adm_toast_removed_from_group: 'Eliminat din grup',
    adm_toast_group_assigned: 'Grup atribuit',
    adm_toast_group_removed: 'Grup eliminat',
    adm_toast_content_assigned: 'Conținut atribuit',
    adm_toast_content_removed: 'Conținut eliminat',
    // ── Sistem de notificări ──────────────────────────────────────────────
    adm_notifications:          'Mesaje',
    notif_type_new_content:     'Conținut nou',
    notif_type_message:         'Mesaj',
    notif_goto_collection:      'La colecție',
    notif_dismiss_all:          'Închide tot',
    notif_just_now:             'Chiar acum',

    // ── MyCourses: filtre, titluri secțiuni și stări goale ───────────────
    mc_filter_all:            'Toate',
    mc_filter_courses:        '📚 Cursurile Mele',
    mc_filter_videos:         '▶ Videoclipurile Mele',
    mc_filter_favorites:      '★ Favorite',
    mc_status_all:            'Toate statusurile',
    mc_only_mine:             'Doar ale mele',
    mc_section_courses_sub:   'Cursuri începute și finalizate',
    mc_section_videos:        'Videoclipurile Mele',
    mc_section_videos_sub:    'Conținut creat de tine',
    mc_section_favorites:     'Favoritele Mele',
    mc_section_favorites_sub: 'Cursuri și videoclipuri apreciate',
    mc_empty_courses:         'Nu ai început niciun curs încă.',
    mc_empty_videos:          'Nu ai creat niciun videoclip încă.',
    mc_empty_favorites:       'Nu ai adăugat niciun conținut la favorite încă.',
    videoRendering:     'Se randează videoclipul…',
    videoRenderingHint: 'Videoclipul este încă în procesare. Va fi disponibil în curând.',
    // ── AdminPanel: noi șiruri i18n ───────────────────────────────────────
    adm_qr_unavailable:         'QR indisponibil — npm install qrcode',
    adm_qr_login_title:         'Cod QR pentru autentificare',
    adm_qr_scan_login_hint:     'Scanează → autentificare directă fără PIN',
    adm_qr_permanent_hint:      'Codul QR este disponibil permanent în fișa utilizatorului.',
    adm_qr_print_hint:          'Tipărește PIN-ul acum sau transmite-l în siguranță.',
    adm_msg_subject_placeholder:'ex. Instrucțiune nouă de siguranță disponibilă',
    adm_msg_text_placeholder:   'Textul mesajului…',
    adm_col_license_type:       'Tip licență',
    adm_btn_show_qr:            'Afișați codul QR',
    adm_btn_send_msg:           'Trimiteți mesajul',
    adm_login_qr_label:         'Cod QR de autentificare',
    adm_btn_gen_pin:            'Generați PIN nou',
    adm_qr_scan_hint:           'Utilizatorul poate scana acest cod pentru a se autentifica fără PIN.',
    adm_pin_reset_hint:         'Pentru resetarea PIN-ului: închideți și utilizați 🔄 Resetare PIN.',
    adm_role_supervisor:        'Supervizor',
    adm_role_admin_opt:         'Admin',
    adm_role_superadmin:        'Super Admin',
    adm_seat_essentials_desc:   'Essentials – toate funcțiile cu excepția creării de conținut',
    adm_pin_force_change:       'Forțați schimbarea PIN-ului la prima autentificare',
    adm_btn_msg_group:          'Mesaj către grup',
    adm_btn_show:               'Afișați',
    adm_btn_unlock:             'Deblocați elementul',
    adm_btn_show_assigned:      'Afișați conținutul atribuit',
    adm_no_videos_assigned:     'Niciun videoclip atribuit. Faceți clic pe „+ Adăugați videoclip".',
    adm_drag_sort:              'Trageți pentru a sorta',
    adm_search_video:           'Căutați videoclip…',
    adm_no_videos:              'Niciun videoclip găsit.',
    adm_video_unassigned:       'Acest videoclip nu este atribuit niciunui conținut.',
    adm_search_messages:        'Căutați mesaje…',
    adm_btn_reload:             'Reîncărcați',
    adm_enriching:              'Îmbogățire în curs…',
    adm_no_video_chunks:        'Niciun videoclip cu fragmente de transcriere găsit',
    adm_ki_enrichment:          'Îmbogățire AI',
    adm_col_updated:            'Actualizat',
    adm_search_docs:            'Căutați document sau element…',
    adm_no_docs:                'Niciun document disponibil',
    adm_col_size:               'Dimensiune',
    adm_search_questions:       'Căutați întrebări…',
    adm_label_question:         'Întrebarea angajatului',
    adm_label_answer:           'Răspuns',
    adm_btn_upload_doc:         'Încărcați document',
    adm_just_moment:            'Un moment',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Numai administratorii pot edita profilul de domeniu.',
    adm_primary_lang:           'Limba de lucru principală',
    adm_drop_doc:               'Plasați documentul aici sau faceți clic',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Documente existente ale companiei',
    adm_company_docs_empty:     'Nu au fost încărcate încă documente ale companiei.',
    adm_no_licence:             'Nu sunt disponibile date privind licența.',
    adm_full_seats_label:       '⭐ Full Seats (incl. creare conținut)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'Valabil până la',
    adm_base_lang:              'Limbă de bază',
    adm_active_ui_langs:        'Limbi UI active',
    adm_tts_langs:              'Limbi TTS',
    adm_full_seats_total_label: '⭐ Full Seats total',
    adm_essentials_total_label: 'Essentials Seats total',
    adm_ui_langs_field:         'Limbi UI (limbi active ale aplicației)',
    adm_tts_langs_field:        'Limbi TTS (text în vorbire)',
    adm_config_title:           'Configurare',
    adm_config_desc:            'Setările platformei pentru acest tenant. Modificările sunt imediat active.',
    adm_supervisor_mode:        'Modul supervizor',
    adm_warning_no_admin:       '⚠️ Atenție: Nu există niciun utilizator activ cu rol de Supervizor sau Admin (Grup 2 sau 3).',
    adm_std_delete_toggle:      'Utilizatori standard: ștergere și dezactivare videoclipuri',
    adm_std_course_toggle:      'Utilizatori standard: creare cursuri și quiz-uri',
    adm_supervisor_confirm_title: 'Activați modul supervizor?',
    adm_btn_activate:           'Activați',
    adm_admin_only_setting:     'Numai administratorii tenant (Grup 3) sau Super Admins pot modifica această setare.',
    adm_only_admins_edit:       'Numai administratorii pot modifica această setare.',
  },

  // =========================================================================
  // TÜRKÇE (Turkish)
  // =========================================================================
  tr: {
    // Türkisch (tr)
      assignToGeneral: 'Genel gruba ekle',
  assignToGeneralOn: 'İçerik oluşturulduktan sonra varsayılan grubun tüm üyelerine görünür olacak.',
  assignToGeneralOff: '⚠ Uyarı: Bu içerik genel kullanıcılara görünmeyecek. Yalnızca yöneticiler ve oluşturucu tarafından erişilebilir olacak.',
    videoRenderingBackground: 'Video arka planda işleniyor – birazdan devam edebileceksiniz.',
    manyPagesHint: 'Belge {count} sayfa içeriyor – analiz biraz daha uzun sürecek.',
    analyzingPages: 'Sayfalar analiz ediliyor…',
    notif_goto_adminpanel:    'Yönetici panelini aç',
    notif_type_new_question:  'Yeni soru',
    notif_title:         'Bildirimler',
    notif_back:          'Geri',
    notif_loading:       'Yükleniyor…',
    notif_empty:         'Mesaj bulunmuyor',
    notif_just_now:          'Az önce',
    notif_type_message:      'Yönetici mesajı',
    notif_type_new_content:  'Yeni içerik',
    notif_goto_collection:   'Koleksiyona git',
    notif_goto_document:     'Belgeyi aç',
    notif_open_document:     'Belgeyi aç',
    notif_goto_fraghejvi:    'FragHejVi\'yi aç',
    notif_close:             'Kapat',
    notif_dismiss_all:       'Tümünü kapat',
    adminArea: 'Yönetim paneli',
    adm_pin_format_hint:    'Tam 8 karakter: harf ve rakam',
    adm_pin_format_error:   'PIN tam olarak 8 alfanümerik karakter olmalıdır.',
    adm_subtitle:          'HejVi Yönetimi',
    adm_access_denied:     'Erişim reddedildi',
    adm_access_denied_desc:'Bu alana erişim izniniz yok.',
    adm_back:              'Geri',
    adm_users:             'Kullanıcılar',
    adm_groups:            'Gruplar',
    adm_videos:            'Videolar',
    adm_topics:            'Konular',
    adm_video_sg:          'Video',
    adm_topic_sg:          'Konu',
    adm_docs:              'Belgeler & Bilgi Tabanı',
    adm_open_video:        'Videoyu yeni sekmede aç',
    adm_open_doc:          'Belgeyi yeni sekmede aç',
    adm_open_element:      'Öğeyi yeni sekmede aç',
    adm_stat_users:        'Toplam kullanıcı',
    adm_stat_active:       'Aktif kullanıcılar',
    adm_members:           'Üyeler',
    adm_content:           'İçerik',
    adm_name:              'Ad',
    adm_status:            'Durum',
    adm_role:              'Rol',
    adm_role_standard:     'Standart',
    adm_created:           'Oluşturuldu',
    adm_actions:           'İşlemler',
    adm_preview:           'Önizleme',
    adm_active:            'Aktif',
    adm_inactive:          'Pasif',
    adm_edit:              'Düzenle',
    adm_delete:            'Sil',
    adm_new_user:          'Yeni kullanıcı',
    adm_new_group:         'Yeni grup',
    adm_edit_user:         'Kullanıcıyı düzenle',
    adm_edit_group:        'Grubu düzenle',
    adm_create:            'Oluştur',
    adm_save:              'Kaydet',
    adm_save_translate:    'Kaydet ve çevir',
    adm_translating:       'Çevriliyor…',
    adm_cancel:            'İptal',
    adm_done:              'Tamam',
    adm_confirm:           'Emin misiniz?',
    adm_yes:               'Evet',
    adm_no:                'Hayır',
    adm_mandatory:         'Zorunlu',
    adm_description:       'Açıklama',
    adm_rights_level:      'Yetki seviyesi',
    adm_lang_id:           'Dil',
    adm_client_id:         'İstemci',
    adm_pin_change:        'PIN değiştir (boş = değişmez)',
    adm_pin_hint:          'En az 4 karakter',
    adm_pin_change_hint:   'Değiştirmemek için boş bırakın',
    adm_groups_for:        'Gruplar:',
    adm_groups_assign_hint:'Grupları ata veya kaldır',
    adm_content_for_group: 'Grup için içerik',
    adm_content_visible_hint: 'Bu içerik şu gruplar tarafından görülebilir:',
    adm_assigned:          'Atandı',
    adm_add:               'Ekle',
    adm_remove:            'Kaldır',
    adm_assign:            'Ata',
    adm_search_hint:       'ara',
    adm_no_users:          'Kullanıcı bulunamadı',
    adm_no_groups:         'Grup yok',
    adm_no_entries:        'Kayıt bulunamadı',
    adm_no_content:        'İçerik bulunamadı',
    adm_toast_deleted:     'Silindi',
    adm_toast_created:     'Oluşturuldu',
    adm_toast_saved:       'Kaydedildi',
    adm_toast_deactivated: 'Devre dışı',
    adm_toast_removed:     'Gruptan kaldırıldı',
    adm_toast_added:       'Gruba eklendi',
    adm_toast_error:       'Bir hata oluştu',
    adm_toast_load_error:  'Yükleme hatası',
    chatGreeting: 'Hej! Yardımcı olmaktan mutluluk duyarım. Ne öğrenmek istersiniz?',
    chatSubtitle: 'Belge hakkında sor',
    chatButton: 'Sor',
    chatPlaceholder: 'Belge hakkında bir soru sorun …',
    chatClear: 'Sohbeti temizle',
    chatSuggestion1: 'Belgeyi özetle',
    chatSuggestion2: 'Temel noktalar nelerdir?',
    chatSuggestion3: 'Hangi gereksinimler belirtiliyor?',
    chatErrorNotAuthenticated: 'Kimlik doğrulanmadı. Lütfen tekrar giriş yapın.',
    chatErrorNoAnswer: 'Yanıt alınamadı.',
    chatErrorGeneric: 'Hata',
    globalChatTitle: 'Bilgi Asistanı',
    globalChatSubtitle: 'Tüm belgeler ve videolar',
    globalChatFab: 'HejVi\'ye sor',
    globalChatGreeting: 'Hej! Tüm belgeleriniz ve videolarınızdaki sorularda size yardımcı olabilirim. Ne öğrenmek istersiniz?',
    globalChatPlaceholder: 'Tüm içerikleriniz hakkında bir soru sorun …',
    globalSuggestion1: 'Belgelerim güvenlik gereksinimleri hakkında ne söylüyor?',
    globalSuggestion2: 'Mevcut tüm içerikleri özetle',
    globalSuggestion3: 'Bu konuyu hangi videolar ele alıyor?',
    sourcesUsed: 'Kaynaklar',
    sourceDocument: 'Belge',
    sourceVideo: 'Video',
    goToElement: 'Öğeyi aç →',
    goToVideo: 'Videoyu izle →',
    createdOn: 'Oluşturulma tarihi',
    pleaseSelectDocument: 'Lütfen bir belge seçin (PDF, TXT veya DOC).',
    selectDocument: 'Belge seç',
    photoVideo: 'Fotoğraf / Video',
    document: 'Belge',
    replaceFile: 'Değiştir',
    removeFile: 'Kaldır',
    documentTypeDefault: 'Belge',
    invalidDocumentType: 'Lütfen geçerli bir dosya yükleyin: PDF, TXT, DOC/DOCX veya PPT/PPTX.',
    documentTooLarge: 'Dosya çok büyük. Maksimum {mb} MB izin verilir.',
    documentAiInfo: 'Yapay zeka içeriği otomatik olarak çıkarır, bir özet (1-2 cümle) seslendirme olarak oluşturur ve ilk sayfayı küçük resim olarak kullanır.',
    documentModeActive: 'Belge modu etkin',
    documentModeDesc: 'Yapay zeka belge içeriğinizi otomatik olarak video metni olarak kullanacak.',
    docAdditionalContextPlaceholder: 'İsteğe bağlı ek bağlam (örn. hedef kitle)...',
    optionLabel: 'Seçenek',
    aiOptionLabel: 'Yapay Zeka Seçeneği',
    autoGeneratedFromDoc: 'Belgeden otomatik oluşturuldu',
    documentAutoProcess: 'Yapay zeka içeriği çıkarır ve özeti video metni olarak oluşturur.',
    aiDocProcessingInfo: 'Belgeyi analiz ediyoruz, özet seslendirmesi oluşturuyoruz ve ilk sayfayı küçük resim olarak kullanan bir video oluşturuyoruz.',
    viewDocument: 'Görüntüle',
    downloadDocument: 'İndir',
    responseVideoNotFound: 'Yanıt videosu bulunamadı',
    responseVideoNotReady: 'Bu meydan okuma için yanıt videosu henüz mevcut değil.',
    unknownQRCodeTitle: 'Bilinmeyen QR Kodu',
    unknownQRCodeQuestion: 'Nasıl devam etmek istersiniz?',
    unknownQRCodeCreateCollection: 'Yeni koleksiyon oluştur',
    addVideo: 'Video ekle',
    pleaseSelectMedia: 'Lütfen bir video veya fotoğraf seçin.',
    originalText: 'Orijinal',
    printQRLabel: '🖨️ QR etiketini yazdır',
    printerConnecting: '🔵 Yazıcıya bağlanıyor...',
    printerPrinting: '⏳ Yazdırılıyor...',
    printerDone: '✅ Yazdırıldı!',
    printerError: '❌ Hata – Tekrar dene',
    bluetoothHint: 'Bluetooth üzerinden bağlanır – listeden Niimbot B1\'i seçin',
    printerErrorHint: 'Yazıcı açık mı? Yalnızca Chrome/Edge Web Bluetooth\'u destekler.',
    number_of_views: 'Görüntülemeler',
    number_of_likes: 'Beğeniler',
    qrCode: 'QR Kodu',
    printQrCode: 'QR kodunu yazdır',
    playFrom: 'Şuradan oynat',
    voiceSearchSummary: '{collections} koleksiyon, {elements} öğe',
    pleaseLoginFirst: 'QR kodlarını taramak için lütfen önce giriş yapın',
    openingUrl: 'URL açılıyor...',
    eanNotFound: 'Bu EAN ile eşleşen öğe bulunamadı',
    sessionExpired: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
    recordingTooShort: 'Kayıt çok kısa',
    errorNoSpeechDetected: 'Konuşma algılanamadı. Lütfen daha yüksek sesle veya mikrofona daha yakın konuşun.',
    errorTranscriptionFailed: 'Ses anlaşılamadı. Lütfen net konuşarak tekrar deneyin.',
    reactionVideo: 'Tepki videosu?',
    setThisToReaction: 'Bu öğeyi yanıt videosu olarak işaretler (İçerik Türü 4).',
    selectModeration: 'Uygun metni seçin',
    selectModerationDesc: 'Yapay zeka açıklamanıza göre aşağıdaki metin önerilerini oluşturdu:',
    generatingScripts: 'Metinler oluşturuluyor...',
    nothingFits: 'Hiçbiri uygun değil',
    backToDesc: 'Açıklamaya geri dön',
    selectedModeration: 'Seçilen moderasyon',
    maxRetriesReached: 'Lütfen açıklamanızı düzeltin. Başka deneme mümkün değil.',
    errorLoadingScripts: 'Öneriler yüklenirken hata oluştu. İnternet bağlantınızı kontrol edin veya tekrar giriş yapın.',
    challenge: 'Meydan Okuma',
    thinking: 'Düşünüyorum...',
    aiSuggest: 'Hejvi Yapay Zeka Önerileri',
    aiNoSuggestions: 'Yapay zeka belirli öğeler bulamadı. Tümü gösteriliyor.',
    showAll: 'Tümünü göster',
    totalXp: 'Toplam XP',
    levelUp: 'Seviye Atladı!',
    achievementUnlocked: 'Başarı Açıldı!',
    congrats: 'Tebrikler!',
    awesome: 'Harika!',
    newXp: 'XP kazanıldı',
    sec: 's',
    min: 'dk',
    invalidInput: 'Giriş geçersiz karakterler içeriyor.',
    errorContentRejected: 'Bu içerik güvenlik kurallarımızı ihlal ettiği için reddedildi.',
    errorImageTooLarge: 'Resim çok büyük (Maks 4MB).',
    errorInvalidImageType: 'Geçersiz format. İzin verilen: JPG, PNG, WEBP, GIF.',
    warningImageTooLarge: 'Kapak resmi geçici depolama için çok büyük.',
    draftSaveError: 'Taslak kaydedilemedi.',
    authErrorTokenMissing: 'Kimlik doğrulama jetonu eksik.',
    uploadFailed: 'Yükleme başarısız.',
    qrErrorEmpty: 'Lütfen QR Kodu değerini girin.',
    errorOptionMissing: 'Lütfen Seçenek için metin girin',
    viewQuiz: 'Testi görüntüle',
    details: 'Ayrıntılar',
    pleaseUploadThumbnail: 'Lütfen kurs için bir küçük resim yükleyin.',
    createVideoElement: 'Video oluştur',
    createQuizElement: 'Test oluştur',
    orSelectExisting: 'Veya mevcut öğeleri seçin:',
    organize: 'Sırayı değiştirmek için videoları taşıyın',
    viewCourse: 'Kursu görüntüle',
    filterMyContent: 'Yalnızca içeriğim',
    makeVisible: 'Görünür yap',
    makeInvisible: 'Gizle',
    selectCorrectAnswer: 'Doğru cevabı seçin',
    selectCorrectAnswerDesc: 'Hangi seçenek doğru çözümdür?',
    QuizExampleQrHash: 'örn. el-32hhuz3',
    pleaseEnterQuestion: 'Lütfen bir soru veya başlık girin.',
    typeYesNo: 'Evet / Hayır',
    typeQR: 'QR Tarama',
    typeMulti: 'Çoktan Seçmeli',
    QuizQuestionPlaceholder: 'örn. Bu güvenlik ekipmanı doğru mu?',
    QuizDescriptionPlaceholder: 'İsteğe bağlı açıklama...',
    quizCreatedSuccess: 'Test başarıyla oluşturuldu!',
    tapToUpload: 'Küçük resim yükle',
    uploadOrAutoThumb: 'Resim yükle',
    autoThumbHint: 'Aksi takdirde video küçük resimlerinden otomatik oluşturulur',
    imageSelected: 'Resim seçildi',
    yes: 'Evet',
    no: 'Hayır',
    correct: 'Doğru',
    incorrect: 'Yanlış',
    submit: 'Gönder',
    next: 'İleri',
    back: 'Geri',
    cancel: 'İptal',
    create: 'Oluştur',
    error: 'Hata',
    success: 'Başarı',
    save: 'Kaydet',
    delete: 'Sil',
    edit: 'Düzenle',
    close: 'Kapat',
    previous: 'Önceki',
    loading: 'Yükleniyor...',
    createQuiz: 'Test Oluştur',
    configureQuiz: 'Testi Yapılandır',
    selectType: 'Tür Seç',
    selectResponses: 'Yanıt videolarını seçin',
    selectResponsesDesc: 'Kullanıcının yanıtından sonra oynatılacak videoları seçin.',
    question: 'Soru',
    enableHint: 'İpucu etkinleştirilsin mi?',
    hintNotAvailableQR: 'QR Kodu meydan okumalarında ipuçları devre dışıdır.',
    qrTargetTitle: 'QR Kodu Hedefi',
    qrTargetDesc: 'QR kodunda gizli metin/kod nedir?',
    qrValueLabel: 'QR İçeriği (Tam)',
    reviewQuiz: 'Özet',
    reviewDesc: 'Testi oluşturmadan önce lütfen ayarlarınızı gözden geçirin.',
    pleaseEnterName: 'Lütfen bir ad girin.',
    errorSelectCorrect: 'Lütfen doğru cevabı seçin.',
    selectBothResponses: 'Lütfen her iki yanıt videosunu da seçin.',
    backToDashboard: 'Panoya dön',
    createAnother: 'Başka bir tane oluştur',
    scanToStart: 'Başlamak için tara',
    useExactTextTitle: 'Tam metni kullan',
    useExactTextDesc: 'Yapay zeka optimizasyonunu atla ve açıklamayı 1:1 oku.',
    transcribeVideoTitle: 'Video sesini seslendirme olarak kullan',
    transcribeVideoDesc: 'Konuşulan metin transkribe edilir. 1:1 seslendirme olarak veya optimize edilmiş yapay zeka komut dosyasının temeli olarak kullanın.',
    transcribeVideo: 'Transkripsyon yap',
    transcribing: 'Transkripsyon yapılıyor...',
    transcriptAdopted: 'Video sesi seslendirme olarak benimsendi',
    resetTranscript: 'Transkripsyonu iptal et',
    transcriptionFailed: 'Transkripsyon başarısız.',
    transcribeExactInfo: 'Konuşulan metin 1:1 transkribe edilir ve seslendirme olarak kullanılır. Altyazılar orijinal videoyla senkronize kalır.',
    transcribeLLMInfo: 'Konuşulan metin transkribe edilir. Yapay zeka, tespit edilen video dilinde optimize edilmiş bir seslendirme komut dosyası oluşturur.',
    transcribeExactToggleDesc: 'Transkripsyonu 1:1 seslendirme olarak kullan (videoyla senkronize). Kapalı: Yapay zeka transkripsyondan optimize edilmiş komut dosyası oluşturur.',
    confirmDelete: 'Bu öğeyi silmek istediğinizden emin misiniz? Bu geri alınamaz.',
    deleteSuccess: 'Öğe başarıyla silindi.',
    deleteError: 'Silme başarısız.',
    loginWithQRCode: 'QR Kodu ile giriş yap',
    search: 'Ara',
    filter: 'Filtrele',
    all: 'Tümü',
    needHint: 'İpucuna ihtiyacınız var mı?',
    home: 'Ana Sayfa',
    challenges: 'Meydan Okumalar',
    favorites: 'Favoriler',
    profile: 'Profil',
    myCourses: 'Kurslarım',
    welcome: 'Tekrar hoş geldiniz! 👋',
    searchPlaceholder: 'İçerik ara…',
    mustSee: 'Mutlaka Görülmeli',
    safety: 'Güvenlik',
    tools: 'Araçlar',
    law: 'Hukuk',
    mandatory: 'Zorunlu',
    mandatoryFilter: 'Zorunlu kurslar',
    mandatoryCourses: 'Zorunlu kurslar',
    favourites: 'Favoriler',
    favouritesFilter: 'Favoriler',
    loadMore: 'Daha fazla yükle',
    play: 'Oynat',
    favorite: 'Favori',
    unfavorite: 'Favorilerden çıkar',
    login: 'Giriş Yap',
    enterPin: 'Lütfen PIN girin',
    invalidPin: 'Lütfen geçerli 8 haneli bir PIN girin',
    loginError: 'Geçersiz PIN. Lütfen tekrar deneyin.',
    wrongPin: 'Yanlış PIN. Lütfen tekrar deneyin.',
    loginSuccess: 'Giriş başarılı! Tekrar hoş geldiniz! 🎉',
    myProfile: 'Profilim',
    myProgress: 'İlerlememem',
    contactSupport: 'Destek ile İletişim',
    language: 'Dil',
    settings: 'Ayarlar',
    privacy: 'Gizlilik',
    help: 'Yardım',
    logout: 'Çıkış Yap',
    active: 'Aktif',
    beginner: 'Başlangıç',
    intermediate: 'Orta',
    advanced: 'İleri',
    joined: 'Katıldı',
    courses: 'Kurslar',
    completed: 'Tamamlandı',
    inProgress: 'Devam Ediyor',
    achievements: 'Başarılar',
    topLearner: 'En İyi Öğrenci',
    safetyStar: 'Güvenlik Yıldızı',
    firstSteps: 'İlk Adımlar',
    learner: 'Öğrenci',
    group: 'Grup',
    client: 'Müşteri',
    yourName: 'Adınız',
    emailAddress: 'E-posta Adresi',
    describeIssue: 'Sorununuzu açıklayın...',
    sendMessage: 'Mesaj Gönder',
    messageSent: 'Mesaj başarıyla gönderildi!',
    messageSendError: 'Mesaj gönderilemedi. Lütfen tekrar deneyin.',
    startCourse: 'Kursa Başla',
    continueCourse: 'Kursa Devam Et',
    courseProgress: 'Kurs İlerlemesi',
    videoProgress: 'Video İlerlemesi',
    stepsInThisVideo: 'Bu videodaki adımlar',
    relatedVideos: 'İlgili Videolar',
    duration: 'Süre',
    experiencePoints: 'Deneyim Puanları',
    levelComplexity: 'Zorluk Seviyesi',
    lessons: 'Dersler',
    nextLessonStartsIn: 'Sonraki ders başlıyor',
    nextVideoIn: 'Sonraki video',
    seconds: 's',
    replay: 'Tekrarla',
    cancelAutoplay: 'Otomatik oynatmayı iptal et',
    loadingCourses: 'Kurslar yükleniyor...',
    noCourses: 'Kurs mevcut değil',
    searchCourses: 'Kurs ara...',
    noResults: 'Kurs bulunamadı',
    allChallenges: 'Tüm Meydan Okumalar',
    currentChallenges: 'Mevcut Meydan Okumalar',
    challengeProgress: 'Meydan Okuma İlerlemesi',
    challengeEnds: 'Meydan okuma bitiyor',
    daysLeft: 'gün kaldı',
    hoursLeft: 'saat kaldı',
    minutesLeft: 'dakika kaldı',
    loadingChallenges: 'Meydan okumalar yükleniyor...',
    activeChallenges: 'Aktif Meydan Okumalar',
    weeklyProgress: 'İlerleme',
    noChallenges: 'Şu an için meydan okuma mevcut değil.',
    startNow: 'Şimdi Başla',
    discoverMore: 'Daha Fazla Meydan Okuma Keşfet',
    stayMotivated: 'Motive kalmaya devam edin ve ödüller kazanın!',
    doneChallenges: 'tamamlandı',
    challengesProgressLabel: 'Meydan Okuma İlerlemesi',
    mandatoryProgressLabel: 'Zorunlu Kurs İlerlemesi',
    doneMandatory: 'zorunlu kurs tamamlandı',
    completeChallengesEarnXP: 'XP kazanmak için meydan okumaları tamamlayın!',
    noDeadline: 'Son tarih yok',
    failedToLoadChallenges: 'Meydan okumalar yüklenemedi',
    expired: 'Süresi Doldu',
    lessThan1hLeft: '1 saatten az kaldı',
    expert: 'Uzman',
    scanQR: 'QR Kod Tara',
    scanPlaceholder: 'Kamerayı QR koda doğrulayın',
    scanSuccess: 'QR kod başarıyla tarandı!',
    scanError: 'QR kod taranamadı',
    cameraError: 'Kamera erişimi reddedildi',
    cameraPermission: 'Lütfen kamera erişimine izin verin',
    cameraPermissionDenied: 'Kamera erişimi reddedildi. Lütfen izin verin.',
    noCameraFound: 'Kamera bulunamadı. Lütfen cihazınızı kontrol edin.',
    failedToStartCamera: 'Kamera başlatılamadı',
    failedToAccessCamera: 'Kameraya erişilemedi. Lütfen tarayıcı izinlerini kontrol edin.',
    tryAgain: 'Tekrar Dene',
    gallery: 'Galeri',
    flash: 'Flaş',
    switchCamera: 'Kamerayı Değiştir',
    capture: 'Yakala',
    voiceSearch: 'Sesli Arama',
    tapToStartRecording: 'Kayda başlamak için dokunun',
    speakYourSearchQuery: 'Arama sorgunuzu net bir şekilde söyleyin',
    startRecording: 'Kaydı Başlat',
    stopRecording: 'Kaydı Durdur',
    recording: 'Kaydediliyor...',
    processingAudio: 'Ses işleniyor...',
    transcript: 'Transkript',
    searchAgain: 'Yeniden Ara',
    networkError: 'Ağ hatası. Lütfen bağlantınızı kontrol edin.',
    serverError: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
    unauthorized: 'Yetkisiz. Lütfen tekrar giriş yapın.',
    notFound: 'İçerik bulunamadı.',
    generalError: 'Beklenmeyen bir hata oluştu.',
    today: 'Bugün',
    yesterday: 'Dün',
    thisWeek: 'Bu Hafta',
    thisMonth: 'Bu Ay',
    ago: 'önce',
    minutes: 'dakika',
    hours: 'saat',
    days: 'gün',
    weeks: 'hafta',
    months: 'ay',
    years: 'yıl',
    seeAll: 'Tümünü Gör',
    seeMore: 'Daha Fazla Gör',
    seeLess: 'Daha Az Gör',
    confirm: 'Onayla',
    ok: 'Tamam',
    done: 'Bitti',
    skip: 'Geç',
    continue: 'Devam Et',
    finish: 'Bitir',
    start: 'Başla',
    stop: 'Durdur',
    pause: 'Duraklat',
    resume: 'Devam Et',
    restart: 'Yeniden Başlat',
    reset: 'Sıfırla',
    clear: 'Temizle',
    remove: 'Kaldır',
    add: 'Ekle',
    update: 'Güncelle',
    change: 'Değiştir',
    select: 'Seç',
    upload: 'Yükle',
    download: 'İndir',
    share: 'Paylaş',
    copy: 'Kopyala',
    none: 'Hiçbiri',
    elementCreator: 'Video Oluşturucu',
    createElement: 'Video Oluştur',
    createStep1Title: 'Başlayalım! Bir ad verin.',
    elementNamePlaceholder: 'örn. Freze makinesini nasıl tamir ederim',
    createStep2Title: 'İçeriğinizi yükleyin',
    createStep2Sub: 'Fotoğraf/video çekin veya galeriden yükleyin.',
    selectMedia: 'Medya seç',
    tapToChange: 'Değiştirmek için dokunun',
    createStep3Title: 'Açıklayın',
    createStep3Sub: 'Bu videoda ne oluyor? Yapay zekamız bunu profesyonel bir anlatıma dönüştürecek.',
    descPlaceholder: 'Süreci adım adım açıklayın...',
    createStep4Title: 'İncele',
    aiProcessingInfo: 'Şimdi videoyu sıkıştıracağız, açıklamanızdan profesyonel seslendirme oluşturacağız ve her şeyi birden fazla dile çevireceğiz.',
    creatingElement: 'Öğe oluşturuluyor...',
    videoGenerating: 'Video oluşturuluyor, lütfen bir an bekleyin…',
    videoProcessing: 'Video tamamlanıyor… Düğme otomatik olarak etkinleştirilecek.',
    videoProcessingHint: 'Video hâlâ işleniyor. Doğrudan izlemek için biraz bekleyin ya da çalışmaya devam edin.',
    pleaseWait: 'Bu bir dakika sürebilir. Yükleme ve yapay zeka işlemleri devam ediyor.',
    elementCreatedSuccess: 'Öğe başarıyla oluşturuldu!',
    elementReadyDesc: 'Öğeniz başarıyla oluşturuldu ve işlendi.',
    viewElement: 'Öğeyi şimdi görüntüle',
    goToMyCourses: 'Kurslarıma git',
    elementPendingTitle: 'Videonuz inceleniyor',
    elementPendingDesc: 'Videonuz başarıyla yüklendi ve şu anda bir yönetici tarafından inceleniyor. Kısa süre içinde herkese açılacak.',
    elementPendingHint: 'Videonuz onaylandığında bildirim alacaksınız.',
    elementApprovedTitle: 'Videonuz onaylandı!',
    elementApprovedBody: 'Harika haber — "{name}" videonuz onaylandı ve artık tüm kullanıcılar için görünür.',
    descTooShort: 'Lütfen ayrıntılı bir açıklama girin (min. 10 karakter).',
    invalidFileType: 'Lütfen geçerli bir video veya resim yükleyin.',
    fileTooLarge: 'Dosya çok büyük. Maksimum boyut 500MB.',
    media: 'Medya',
    description: 'Açıklama',
    name: 'Ad',
    courseDetails: 'Kurs Ayrıntıları',
    courseName: 'Kurs Adı',
    courseNamePlaceholder: 'örn. makine bakımı',
    courseDescPlaceholder: 'Bu kursun hakkında kısaca açıklayın...',
    thumbnail: 'Küçük Resim',
    uploadImage: '+ Resim Yükle',
    addElements: 'Öğe Ekle',
    searchElements: 'Öğe ara...',
    loadingElements: 'Öğeler yükleniyor...',
    preview: 'Önizleme',
    added: 'Eklendi',
    noElementsFound: 'Eşleşen öğe bulunamadı.',
    organizeCourse: 'Kursu Düzenle',
    dragDropReorder: 'Yeniden sıralamak için sürükle ve bırak',
    addMoreElements: '+ Daha fazla öğe ekle',
    courseCreated: 'Kurs Oluşturuldu!',
    courseCreatedDesc: 'Koleksiyonunuz başarıyla kaydedildi.',
    createAnotherCourse: 'Başka Kurs Oluştur',
    createCourse: 'Kurs Oluştur',
    addToCourse: 'Kursa Ekle',
    saving: 'Kaydediliyor...',
    noElementsSelected: 'Lütfen en az bir öğe seçin',
    errorCreatingCourse: 'Kurs oluşturulurken hata',
    authError401: 'Yetkisiz (401). Oturumunuz sona ermiş olabilir. Lütfen tekrar giriş yapın.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: '💡 İsim ve açıklama tüm dillere otomatik olarak çevrilir.',
    adm_en_readonly_hint: 'Otomatik çevrildi – düzenlenemez',
    adm_filter_active: 'Aktif',
    adm_filter_all: 'Tümü',
    adm_filter_inactive: 'Pasif',
    adm_last_superadmin_hint: 'Son Süper Admin – silinemez',
    adm_no_group_access: 'İçeriğe erişim yok',
    adm_no_group_assign_warn: 'Bu kullanıcı hiçbir gruba atanmamış ve bu nedenle içeriğe erişimi bulunmuyor.',
    adm_no_group_warn_body: 'Grubu olmayan yeni kullanıcıların içeriğe erişimi yoktur. Oluşturulduktan sonra 🏷️ Gruplar aracılığıyla bir grup atayın.',
    adm_no_group_warn_title: 'Not: Grup erişimi yok',
    adm_toast_added_to_group: 'Gruba eklendi',
    adm_toast_removed_from_group: 'Gruptan çıkarıldı',
    adm_toast_group_assigned: 'Grup atandı',
    adm_toast_group_removed: 'Grup kaldırıldı',
    adm_toast_content_assigned: 'İçerik atandı',
    adm_toast_content_removed: 'İçerik kaldırıldı',
    // ── Bildirim sistemi ──────────────────────────────────────────────────
    adm_notifications:          'Mesajlar',
    notif_type_new_content:     'Yeni içerik',
    notif_type_message:         'Mesaj',
    notif_goto_collection:      'Koleksiyona git',
    notif_dismiss_all:          'Tümünü kapat',
    notif_just_now:             'Az önce',

    // ── MyCourses: filtreler, bölüm başlıkları ve boş durumlar ──────────
    mc_filter_all:            'Tümü',
    mc_filter_courses:        '📚 Kurslarım',
    mc_filter_videos:         '▶ Videolarım',
    mc_filter_favorites:      '★ Favoriler',
    mc_status_all:            'Tüm durumlar',
    mc_only_mine:             'Sadece benimkiler',
    mc_section_courses_sub:   'Başlanan ve tamamlanan kurslar',
    mc_section_videos:        'Videolarım',
    mc_section_videos_sub:    'Senin tarafından oluşturulan içerik',
    mc_section_favorites:     'Favorilerim',
    mc_section_favorites_sub: 'Beğenilen kurslar ve videolar',
    mc_empty_courses:         'Henüz hiçbir kursa başlamadınız.',
    mc_empty_videos:          'Henüz hiç video oluşturmadınız.',
    mc_empty_favorites:       'Henüz favorilerinize içerik eklemediniz.',
    videoRendering:     'Video işleniyor…',
    videoRenderingHint: 'Video hâlâ işlenmektedir. Kısa süre içinde hazır olacak.',
    // ── AdminPanel: yeni i18n dizeleri ────────────────────────────────────
    adm_qr_unavailable:         'QR mevcut değil — npm install qrcode',
    adm_qr_login_title:         'Giriş için QR Kodu',
    adm_qr_scan_login_hint:     'Tara → PIN girmeden doğrudan giriş yap',
    adm_qr_permanent_hint:      'QR kodu kullanıcı kaydında kalıcı olarak mevcuttur.',
    adm_qr_print_hint:          "PIN'i şimdi yazdırın veya güvenli şekilde iletin.",
    adm_msg_subject_placeholder:'ör. Yeni güvenlik talimatı mevcut',
    adm_msg_text_placeholder:   'Mesaj metni…',
    adm_col_license_type:       'Lisans Türü',
    adm_btn_show_qr:            'QR Kodunu Göster',
    adm_btn_send_msg:           'Mesaj Gönder',
    adm_login_qr_label:         'Giriş QR Kodu',
    adm_btn_gen_pin:            'Yeni PIN Oluştur',
    adm_qr_scan_hint:           'Kullanıcı bu kodu tarayarak PIN girmeden giriş yapabilir.',
    adm_pin_reset_hint:         "PIN sıfırlamak için: kapatın ve kullanıcı kartındaki 🔄 PIN Sıfırla'yı kullanın.",
    adm_role_supervisor:        'Süpervizör',
    adm_role_admin_opt:         'Yönetici',
    adm_role_superadmin:        'Süper Yönetici',
    adm_seat_essentials_desc:   'Essentials – içerik oluşturma dışında tüm özellikler',
    adm_pin_force_change:       'İlk girişte PIN değişikliğini zorla',
    adm_btn_msg_group:          'Gruba Mesaj',
    adm_btn_show:               'Göster',
    adm_btn_unlock:             'Öğeyi Aç',
    adm_btn_show_assigned:      'Atanan İçeriği Göster',
    adm_no_videos_assigned:     'Video atanmamış. "+ Video Ekle" üzerine tıklayın.',
    adm_drag_sort:              'Sıralamak için sürükleyin',
    adm_search_video:           'Video ara…',
    adm_no_videos:              'Video bulunamadı.',
    adm_video_unassigned:       'Bu video hiçbir içeriğe atanmamış.',
    adm_search_messages:        'Mesajlarda ara…',
    adm_btn_reload:             'Yenile',
    adm_enriching:              'Zenginleştirme devam ediyor…',
    adm_no_video_chunks:        'Transkript parçalı video bulunamadı',
    adm_ki_enrichment:          'Yapay Zeka Zenginleştirme',
    adm_col_updated:            'Güncellendi',
    adm_search_docs:            'Belge veya öğe ara…',
    adm_no_docs:                'Mevcut belge yok',
    adm_col_size:               'Boyut',
    adm_search_questions:       'Sorularda ara…',
    adm_label_question:         'Çalışanın Sorusu',
    adm_label_answer:           'Cevap',
    adm_btn_upload_doc:         'Belge Yükle',
    adm_just_moment:            'Bir dakika',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Yalnızca yöneticiler alan profilini düzenleyebilir.',
    adm_primary_lang:           'Birincil Çalışma Dili',
    adm_drop_doc:               'Belgeyi buraya bırakın veya tıklayın',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Mevcut Şirket Belgeleri',
    adm_company_docs_empty:     'Henüz şirket belgesi yüklenmedi.',
    adm_no_licence:             'Lisans verisi mevcut değil.',
    adm_full_seats_label:       '⭐ Full Seats (içerik oluşturma dahil)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'Geçerlilik tarihi',
    adm_base_lang:              'Temel Dil',
    adm_active_ui_langs:        'Aktif UI Dilleri',
    adm_tts_langs:              'TTS Dilleri',
    adm_full_seats_total_label: '⭐ Full Seats toplam',
    adm_essentials_total_label: 'Essentials Seats toplam',
    adm_ui_langs_field:         'UI Dilleri (etkin uygulama dilleri)',
    adm_tts_langs_field:        'TTS Dilleri (metinden sese)',
    adm_config_title:           'Yapılandırma',
    adm_config_desc:            'Bu tenant için platform ayarları. Değişiklikler hemen geçerli olur.',
    adm_supervisor_mode:        'Süpervizör Modu',
    adm_warning_no_admin:       '⚠️ Uyarı: Süpervizör veya Yönetici rolüne sahip aktif kullanıcı yok (Grup 2 veya 3).',
    adm_std_delete_toggle:      'Standart Kullanıcılar: videoları sil ve devre dışı bırak',
    adm_std_course_toggle:      'Standart Kullanıcılar: kurs ve test oluştur',
    adm_supervisor_confirm_title: 'Süpervizör modu etkinleştirilsin mi?',
    adm_btn_activate:           'Etkinleştir',
    adm_admin_only_setting:     'Yalnızca tenant yöneticileri (Grup 3) veya Süper Yöneticiler bu ayarı değiştirebilir.',
    adm_only_admins_edit:       'Yalnızca yöneticiler bu ayarı değiştirebilir.',
  },

  // =========================================================================
  // HRVATSKI (Croatian)
  // =========================================================================
  hr: {
    // Kroatisch (hr)
      assignToGeneral: 'Dodaj u opću grupu',
  assignToGeneralOn: 'Sadržaj će biti vidljiv svim članovima zadane grupe nakon stvaranja.',
  assignToGeneralOff: '⚠ Upozorenje: Ovaj sadržaj neće biti vidljiv široj publici. Bit će dostupan samo administratorima i stvaratelju.',
    videoRenderingBackground: 'Video se obrađuje u pozadini – uskoro možete nastaviti.',
    manyPagesHint: 'Dokument sadrži {count} stranica – analiza će potrajati malo duže.',
    analyzingPages: 'Analiziranje stranica…',
    notif_goto_adminpanel:    'Otvori admin panel',
    notif_type_new_question:  'Novo pitanje',
    notif_title:         'Obavijesti',
    notif_back:          'Natrag',
    notif_loading:       'Učitavanje…',
    notif_empty:         'Nema poruka',
    notif_just_now:          'Upravo sad',
    notif_type_message:      'Admin poruka',
    notif_type_new_content:  'Novi sadržaj',
    notif_goto_collection:   'Na kolekciju',
    notif_goto_document:     'Otvori dokument',
    notif_open_document:     'Otvori dokument',
    notif_goto_fraghejvi:    'Otvori FragHejVi',
    notif_close:             'Zatvori',
    notif_dismiss_all:       'Zatvori sve',
    adminArea: 'Administratorski panel',
    adm_pin_format_hint:    'Točno 8 znakova: slova i znamenke',
    adm_pin_format_error:   'PIN mora imati točno 8 alfanumeričkih znakova.',
    adm_subtitle:          'HejVi Upravljanje',
    adm_access_denied:     'Pristup odbijen',
    adm_access_denied_desc:'Nemate dozvolu za pristup ovom području.',
    adm_back:              'Natrag',
    adm_users:             'Korisnici',
    adm_groups:            'Grupe',
    adm_videos:            'Videozapisi',
    adm_topics:            'Teme',
    adm_video_sg:          'Video',
    adm_topic_sg:          'Tema',
    adm_stat_users:        'Ukupno korisnika',
    adm_docs:              'Dokumenti & Baza znanja',
    adm_open_video:        'Otvori video u novoj kartici',
    adm_open_doc:          'Otvori dokument u novoj kartici',
    adm_open_element:      'Otvori element u novoj kartici',
    adm_stat_active:       'Aktivni korisnici',
    adm_members:           'Članovi',
    adm_content:           'Sadržaj',
    adm_name:              'Naziv',
    adm_status:            'Status',
    adm_role:              'Uloga',
    adm_role_standard:     'Standardni',
    adm_created:           'Stvoreno',
    adm_actions:           'Radnje',
    adm_preview:           'Pregled',
    adm_active:            'Aktivan',
    adm_inactive:          'Neaktivan',
    adm_edit:              'Uredi',
    adm_delete:            'Izbriši',
    adm_new_user:          'Novi korisnik',
    adm_new_group:         'Nova grupa',
    adm_edit_user:         'Uredi korisnika',
    adm_edit_group:        'Uredi grupu',
    adm_create:            'Stvori',
    adm_save:              'Spremi',
    adm_save_translate:    'Spremi i prevedi',
    adm_translating:       'Prevođenje…',
    adm_cancel:            'Odustani',
    adm_done:              'Gotovo',
    adm_confirm:           'Sigurno?',
    adm_yes:               'Da',
    adm_no:                'Ne',
    adm_mandatory:         'Obvezno',
    adm_description:       'Opis',
    adm_rights_level:      'Razina prava',
    adm_lang_id:           'Jezik',
    adm_client_id:         'Klijent',
    adm_pin_change:        'Promijeni PIN (prazno = nepromijenjeno)',
    adm_pin_hint:          'Najmanje 4 znaka',
    adm_pin_change_hint:   'Ostavite prazno za bez promjene',
    adm_groups_for:        'Grupe za',
    adm_groups_assign_hint:'Dodijelite ili uklonite grupe',
    adm_content_for_group: 'Sadržaj za grupu',
    adm_content_visible_hint: 'Ovaj sadržaj je vidljiv sljedećim grupama:',
    adm_assigned:          'Dodijeljeno',
    adm_add:               'Dodaj',
    adm_remove:            'Ukloni',
    adm_assign:            'Dodijeli',
    adm_search_hint:       'traži',
    adm_no_users:          'Nema pronađenih korisnika',
    adm_no_groups:         'Nema dostupnih grupa',
    adm_no_entries:        'Nema pronađenih unosa',
    adm_no_content:        'Nema pronađenog sadržaja',
    adm_toast_deleted:     'Obrisano',
    adm_toast_created:     'Stvoreno',
    adm_toast_saved:       'Spremljeno',
    adm_toast_deactivated: 'Deaktivirano',
    adm_toast_removed:     'Uklonjeno iz grupe',
    adm_toast_added:       'Dodano u grupu',
    adm_toast_error:       'Došlo je do greške',
    adm_toast_load_error:  'Greška pri učitavanju',
    chatGreeting: 'Hej! Rado ću vam pomoći. Što biste željeli znati?',
    chatSubtitle: 'Pitajte o dokumentu',
    chatButton: 'Pitaj',
    chatPlaceholder: 'Postavite pitanje o dokumentu …',
    chatClear: 'Očisti razgovor',
    chatSuggestion1: 'Sažmi dokument',
    chatSuggestion2: 'Koje su ključne točke?',
    chatSuggestion3: 'Koji zahtjevi se spominju?',
    chatErrorNotAuthenticated: 'Nije autentificirano. Molimo prijavite se ponovo.',
    chatErrorNoAnswer: 'Nije primljen odgovor.',
    chatErrorGeneric: 'Greška',
    globalChatTitle: 'Asistent znanja',
    globalChatSubtitle: 'Svi dokumenti i videozapisi',
    globalChatFab: 'Pitajte HejVi',
    globalChatGreeting: 'Hej! Mogu vam pomoći s pitanjima o svim vašim dokumentima i videozapisima. Što biste željeli znati?',
    globalChatPlaceholder: 'Postavite pitanje o svom sadržaju …',
    globalSuggestion1: 'Što moji dokumenti govore o sigurnosnim zahtjevima?',
    globalSuggestion2: 'Sažmi sav dostupan sadržaj',
    globalSuggestion3: 'Koji videozapisi pokrivaju ovu temu?',
    sourcesUsed: 'Izvori',
    sourceDocument: 'Dokument',
    sourceVideo: 'Video',
    goToElement: 'Otvori element →',
    goToVideo: 'Pogledaj videozapis →',
    createdOn: 'Stvoreno',
    pleaseSelectDocument: 'Molimo odaberite dokument (PDF, TXT ili DOC).',
    selectDocument: 'Odaberi dokument',
    photoVideo: 'Foto / Video',
    document: 'Dokument',
    replaceFile: 'Zamijeni',
    removeFile: 'Ukloni',
    documentTypeDefault: 'Dokument',
    invalidDocumentType: 'Molimo učitajte valjanu datoteku: PDF, TXT, DOC/DOCX ili PPT/PPTX.',
    documentTooLarge: 'Datoteka je prevelika. Maksimalno {mb} MB dopušteno.',
    documentAiInfo: 'AI automatski izvlači sadržaj, stvara sažetak (1-2 rečenice) kao voiceover i koristi prvu stranicu kao minijaturu.',
    documentModeActive: 'Način dokumenta aktivan',
    documentModeDesc: 'AI će automatski koristiti sadržaj vašeg dokumenta kao tekst videozapisa.',
    docAdditionalContextPlaceholder: 'Neobavezni dodatni kontekst (npr. ciljna skupina)...',
    optionLabel: 'Opcija',
    aiOptionLabel: 'AI Opcija',
    autoGeneratedFromDoc: 'Automatski generirano iz dokumenta',
    documentAutoProcess: 'AI izvlači sadržaj i stvara sažetak kao tekst videozapisa.',
    aiDocProcessingInfo: 'Analiziramo dokument, generiramo sažetak kao voiceover i stvaramo videozapis s prvom stranicom kao miniaturom.',
    viewDocument: 'Prikaži',
    downloadDocument: 'Preuzmi',
    responseVideoNotFound: 'Videozapis odgovora nije pronađen',
    responseVideoNotReady: 'Videozapis odgovora za ovaj izazov još ne postoji.',
    unknownQRCodeTitle: 'Nepoznati QR kod',
    unknownQRCodeQuestion: 'Kako želite nastaviti?',
    unknownQRCodeCreateCollection: 'Stvori novu zbirku',
    addVideo: 'Dodaj video',
    pleaseSelectMedia: 'Molimo odaberite videozapis ili fotografiju.',
    originalText: 'Original',
    printQRLabel: '🖨️ Ispiši QR naljepnicu',
    printerConnecting: '🔵 Spajanje pisača...',
    printerPrinting: '⏳ Ispisivanje...',
    printerDone: '✅ Ispisano!',
    printerError: '❌ Greška – Pokušajte ponovo',
    bluetoothHint: 'Spaja se putem Bluetootha – odaberite Niimbot B1 s popisa',
    printerErrorHint: 'Je li pisač uključen? Samo Chrome/Edge podržavaju Web Bluetooth.',
    number_of_views: 'Pregledi',
    number_of_likes: 'Sviđanja',
    qrCode: 'QR kod',
    printQrCode: 'Ispiši QR kod',
    playFrom: 'Reproduciraj od',
    voiceSearchSummary: '{collections} zbirki, {elements} elemenata',
    pleaseLoginFirst: 'Molimo prijavite se kako biste skenirali QR kodove',
    openingUrl: 'Otvaranje URL-a...',
    eanNotFound: 'Nije pronađen element koji odgovara ovom EAN-u',
    sessionExpired: 'Vaša sesija je istekla. Molimo prijavite se ponovo.',
    recordingTooShort: 'Snimka je prekratka',
    errorNoSpeechDetected: 'Nije otkoren govor. Molimo govorite glasnije ili se približite mikrofonu.',
    errorTranscriptionFailed: 'Audio nije razumljiv. Molimo pokušajte ponovo govoreći jasno.',
    reactionVideo: 'Videozapis reakcije?',
    setThisToReaction: 'Označava ovaj element kao videozapis odgovora (Vrsta sadržaja 4).',
    selectModeration: 'Odaberite odgovarajući tekst',
    selectModerationDesc: 'AI je generirao sljedeće prijedloge teksta na temelju vašeg opisa:',
    generatingScripts: 'Generiraju se tekstovi...',
    nothingFits: 'Ništa ne odgovara',
    backToDesc: 'Natrag na opis',
    selectedModeration: 'Odabrana moderacija',
    maxRetriesReached: 'Molimo poboljšajte opis. Nema više pokušaja.',
    errorLoadingScripts: 'Greška pri učitavanju prijedloga. Provjerite internetsku vezu ili se prijavite ponovo.',
    challenge: 'Izazov',
    thinking: 'Razmišljam...',
    aiSuggest: 'Hejvi AI Prijedlozi',
    aiNoSuggestions: 'AI nije pronašao specifične elemente. Prikazuje se sve.',
    showAll: 'Prikaži sve',
    totalXp: 'Ukupno XP',
    levelUp: 'Napredovanje u razini!',
    achievementUnlocked: 'Postignuće otključano!',
    congrats: 'Čestitamo!',
    awesome: 'Sjajno!',
    newXp: 'XP zarađen',
    sec: 's',
    min: 'min',
    invalidInput: 'Unos sadrži nevaljane znakove.',
    errorContentRejected: 'Ovaj sadržaj je odbijen jer krši naše sigurnosne smjernice.',
    errorImageTooLarge: 'Slika je prevelika (Maks 4MB).',
    errorInvalidImageType: 'Nevaljani format. Dozvoljeno: JPG, PNG, WEBP, GIF.',
    warningImageTooLarge: 'Slika naslovnice je prevelika za privremenu pohranu.',
    draftSaveError: 'Nacrt nije mogao biti pohranjen.',
    authErrorTokenMissing: 'Nedostaje token za autentifikaciju.',
    uploadFailed: 'Prijenos nije uspio.',
    qrErrorEmpty: 'Molimo unesite vrijednost QR koda.',
    errorOptionMissing: 'Molimo unesite tekst za Opciju',
    viewQuiz: 'Prikaži kviz',
    details: 'Detalji',
    pleaseUploadThumbnail: 'Molimo učitajte minijaturnu sliku za tečaj.',
    createVideoElement: 'Stvori videozapis',
    createQuizElement: 'Stvori kviz',
    orSelectExisting: 'Ili odaberite postojeće elemente:',
    organize: 'Premjestite videozapise za promjenu redoslijeda',
    viewCourse: 'Prikaži tečaj',
    filterMyContent: 'Samo moj sadržaj',
    makeVisible: 'Učini vidljivim',
    makeInvisible: 'Sakrij',
    selectCorrectAnswer: 'Odaberi točan odgovor',
    selectCorrectAnswerDesc: 'Koja opcija je točno rješenje?',
    QuizExampleQrHash: 'npr. el-32hhuz3',
    pleaseEnterQuestion: 'Molimo unesite pitanje ili naslov.',
    typeYesNo: 'Da / Ne',
    typeQR: 'QR Skeniranje',
    typeMulti: 'Višestruki izbor',
    QuizQuestionPlaceholder: 'npr. Je li ova zaštitna oprema ispravna?',
    QuizDescriptionPlaceholder: 'Neobavezan opis...',
    quizCreatedSuccess: 'Kviz uspješno stvoren!',
    tapToUpload: 'Učitaj minijaturnu sliku',
    uploadOrAutoThumb: 'Učitaj sliku',
    autoThumbHint: 'Inače se automatski generira iz video minijatura',
    imageSelected: 'Slika odabrana',
    yes: 'Da',
    no: 'Ne',
    correct: 'Točno',
    incorrect: 'Netočno',
    submit: 'Pošalji',
    next: 'Sljedeće',
    back: 'Natrag',
    cancel: 'Odustani',
    create: 'Stvori',
    error: 'Greška',
    success: 'Uspjeh',
    save: 'Spremi',
    delete: 'Izbriši',
    edit: 'Uredi',
    close: 'Zatvori',
    previous: 'Prethodno',
    loading: 'Učitavanje...',
    createQuiz: 'Stvori Kviz',
    configureQuiz: 'Konfiguriraj Kviz',
    selectType: 'Odaberi vrstu',
    selectResponses: 'Odaberi videozapise odgovora',
    selectResponsesDesc: 'Odaberite videozapise koji će se reproducirati nakon korisnikovog odgovora.',
    question: 'Pitanje',
    enableHint: 'Aktiviraj naputak?',
    hintNotAvailableQR: 'Naputci su onemogućeni za izazove s QR kodom.',
    qrTargetTitle: 'Cilj QR koda',
    qrTargetDesc: 'Koji tekst/kod je skriven u QR kodu?',
    qrValueLabel: 'Sadržaj QR (Točno)',
    reviewQuiz: 'Sažetak',
    reviewDesc: 'Molimo pregledajte postavke prije stvaranja kviza.',
    pleaseEnterName: 'Molimo unesite ime.',
    errorSelectCorrect: 'Molimo odaberite točan odgovor.',
    selectBothResponses: 'Molimo odaberite oba videozapisa odgovora.',
    backToDashboard: 'Natrag na upravljačku ploču',
    createAnother: 'Stvori još jedan',
    scanToStart: 'Skeniraj za početak',
    useExactTextTitle: 'Koristi točan tekst',
    useExactTextDesc: 'Preskoči AI optimizaciju i čitaj opis 1:1.',
    transcribeVideoTitle: 'Koristi audio videozapisa kao voiceover',
    transcribeVideoDesc: 'Izgovoreni tekst se transkribira. Koristi doslovno kao voiceover (sinkronizirano) ili kao osnovu za AI optimiziranu skriptu.',
    transcribeVideo: 'Transkribiraj',
    transcribing: 'Transkribira se...',
    transcriptAdopted: 'Audio videozapisa prihvaćen kao voiceover',
    resetTranscript: 'Odbaci transkripciju',
    transcriptionFailed: 'Transkripcija nije uspjela.',
    transcribeExactInfo: 'Izgovoreni tekst se transkribira 1:1 i koristi kao voiceover. Titlovi ostaju sinkronizirani s originalnim videozapisom.',
    transcribeLLMInfo: 'Izgovoreni tekst se transkribira. AI stvara optimiziranu voiceover skriptu na otkrivenom jeziku videozapisa.',
    transcribeExactToggleDesc: 'Koristi transkripciju 1:1 kao voiceover (sinkronizirano s videozapisom). Isključeno: AI generira optimiziranu skriptu iz transkripcije.',
    confirmDelete: 'Jeste li sigurni da želite izbrisati ovaj element? Ovo se ne može poništiti.',
    deleteSuccess: 'Element uspješno izbrisan.',
    deleteError: 'Brisanje nije uspjelo.',
    loginWithQRCode: 'Prijavite se s QR kodom',
    search: 'Pretraži',
    filter: 'Filtriraj',
    all: 'Sve',
    needHint: 'Trebate naputak?',
    home: 'Početna',
    challenges: 'Izazovi',
    favorites: 'Favoriti',
    profile: 'Profil',
    myCourses: 'Moji Tečajevi',
    welcome: 'Dobrodošli natrag! 👋',
    searchPlaceholder: 'Pretraži sadržaj…',
    mustSee: 'Obavezno pogledati',
    safety: 'Sigurnost',
    tools: 'Alati',
    law: 'Pravo',
    mandatory: 'Obvezno',
    mandatoryFilter: 'Obvezni tečajevi',
    mandatoryCourses: 'Obvezni tečajevi',
    favourites: 'Favoriti',
    favouritesFilter: 'Favoriti',
    loadMore: 'Učitaj više',
    play: 'Reproduciraj',
    favorite: 'Favorit',
    unfavorite: 'Ukloni iz favorita',
    login: 'Prijava',
    enterPin: 'Molimo unesite PIN',
    invalidPin: 'Molimo unesite valjani 8-znamenkasti PIN',
    loginError: 'Nevaljani PIN. Molimo pokušajte ponovo.',
    wrongPin: 'Pogrešan PIN. Molimo pokušajte ponovo.',
    loginSuccess: 'Prijava uspješna! Dobrodošli natrag! 🎉',
    myProfile: 'Moj Profil',
    myProgress: 'Moj Napredak',
    contactSupport: 'Kontaktirajte Podršku',
    language: 'Jezik',
    settings: 'Postavke',
    privacy: 'Privatnost',
    help: 'Pomoć',
    logout: 'Odjava',
    active: 'Aktivan',
    beginner: 'Početnik',
    intermediate: 'Srednji',
    advanced: 'Napredniji',
    joined: 'Pridružio se',
    courses: 'Tečajevi',
    completed: 'Završeno',
    inProgress: 'U tijeku',
    achievements: 'Postignuća',
    topLearner: 'Najbolji učenik',
    safetyStar: 'Sigurnosna zvijezda',
    firstSteps: 'Prvi koraci',
    learner: 'Učenik',
    group: 'Grupa',
    client: 'Klijent',
    yourName: 'Vaše ime',
    emailAddress: 'E-mail adresa',
    describeIssue: 'Opišite svoj problem...',
    sendMessage: 'Pošalji poruku',
    messageSent: 'Poruka uspješno poslana!',
    messageSendError: 'Slanje poruke nije uspjelo. Molimo pokušajte ponovo.',
    startCourse: 'Pokreni tečaj',
    continueCourse: 'Nastavi tečaj',
    courseProgress: 'Napredak tečaja',
    videoProgress: 'Napredak videozapisa',
    stepsInThisVideo: 'Koraci u ovom videozapisu',
    relatedVideos: 'Srodni videozapisi',
    duration: 'Trajanje',
    experiencePoints: 'Iskustveni bodovi',
    levelComplexity: 'Razina složenosti',
    lessons: 'Lekcije',
    nextLessonStartsIn: 'Sljedeća lekcija počinje za',
    nextVideoIn: 'Sljedeći videozapis za',
    seconds: 's',
    replay: 'Ponovi',
    cancelAutoplay: 'Otkaži automatsko reproduciranje',
    loadingCourses: 'Učitavanje tečajeva...',
    noCourses: 'Nema dostupnih tečajeva',
    searchCourses: 'Pretraži tečajeve...',
    noResults: 'Nisu pronađeni tečajevi',
    allChallenges: 'Svi Izazovi',
    currentChallenges: 'Trenutni Izazovi',
    challengeProgress: 'Napredak izazova',
    challengeEnds: 'Izazov završava',
    daysLeft: 'dana preostalo',
    hoursLeft: 'sati preostalo',
    minutesLeft: 'minuta preostalo',
    loadingChallenges: 'Učitavanje izazova...',
    activeChallenges: 'Aktivni Izazovi',
    weeklyProgress: 'Napredak',
    noChallenges: 'Trenutno nema dostupnih izazova.',
    startNow: 'Počni sada',
    discoverMore: 'Otkrij više izazova',
    stayMotivated: 'Ostanite motivirani i zaradite nagrade!',
    doneChallenges: 'gotovo',
    challengesProgressLabel: 'Napredak Izazova',
    mandatoryProgressLabel: 'Napredak obveznih tečajeva',
    doneMandatory: 'obveznih tečajeva završeno',
    completeChallengesEarnXP: 'Završite izazove da zaradite XP!',
    noDeadline: 'Bez roka',
    failedToLoadChallenges: 'Nije uspjelo učitavanje izazova',
    expired: 'Isteklo',
    lessThan1hLeft: 'Manje od 1h preostalo',
    expert: 'Stručnjak',
    scanQR: 'Skeniraj QR kod',
    scanPlaceholder: 'Usmjeri kameru prema QR kodu',
    scanSuccess: 'QR kod uspješno skeniran!',
    scanError: 'Skeniranje QR koda nije uspjelo',
    cameraError: 'Pristup kameri odbijen',
    cameraPermission: 'Molimo dopustite pristup kameri',
    cameraPermissionDenied: 'Pristup kameri odbijen. Molimo dopustite pristup.',
    noCameraFound: 'Kamera nije pronađena. Provjerite uređaj.',
    failedToStartCamera: 'Pokretanje kamere nije uspjelo',
    failedToAccessCamera: 'Pristup kameri nije uspio. Provjerite dozvole preglednika.',
    tryAgain: 'Pokušaj ponovo',
    gallery: 'Galerija',
    flash: 'Bljeskalica',
    switchCamera: 'Promijeni kameru',
    capture: 'Snimanje',
    voiceSearch: 'Glasovno pretraživanje',
    tapToStartRecording: 'Dodirnite za početak snimanja',
    speakYourSearchQuery: 'Jasno izgovorite upit za pretraživanje',
    startRecording: 'Počni snimanje',
    stopRecording: 'Zaustavi snimanje',
    recording: 'Snimanje...',
    processingAudio: 'Obrađivanje zvuka...',
    transcript: 'Transkript',
    searchAgain: 'Pretraži ponovo',
    networkError: 'Mrežna greška. Provjerite vezu.',
    serverError: 'Greška poslužitelja. Molimo pokušajte kasnije.',
    unauthorized: 'Neovlašteno. Molimo prijavite se ponovo.',
    notFound: 'Sadržaj nije pronađen.',
    generalError: 'Došlo je do neočekivane greške.',
    today: 'Danas',
    yesterday: 'Jučer',
    thisWeek: 'Ovaj tjedan',
    thisMonth: 'Ovaj mjesec',
    ago: 'prije',
    minutes: 'minuta',
    hours: 'sati',
    days: 'dana',
    weeks: 'tjedana',
    months: 'mjeseci',
    years: 'godina',
    seeAll: 'Vidi sve',
    seeMore: 'Vidi više',
    seeLess: 'Vidi manje',
    confirm: 'Potvrdi',
    ok: 'U redu',
    done: 'Gotovo',
    skip: 'Preskoči',
    continue: 'Nastavi',
    finish: 'Završi',
    start: 'Start',
    stop: 'Zaustavi',
    pause: 'Pauziraj',
    resume: 'Nastavi',
    restart: 'Ponovi',
    reset: 'Resetiraj',
    clear: 'Obriši',
    remove: 'Ukloni',
    add: 'Dodaj',
    update: 'Ažuriraj',
    change: 'Promijeni',
    select: 'Odaberi',
    upload: 'Učitaj',
    download: 'Preuzmi',
    share: 'Podijeli',
    copy: 'Kopiraj',
    none: 'Ništa',
    elementCreator: 'Kreator Videozapisa',
    createElement: 'Stvori Video',
    createStep1Title: 'Počnimo! Dajte mu naziv.',
    elementNamePlaceholder: 'npr. Kako popraviti glodalicu',
    createStep2Title: 'Učitajte sadržaj',
    createStep2Sub: 'Snimite fotografiju/videozapis ili učitajte iz galerije.',
    selectMedia: 'Odaberi medij',
    tapToChange: 'Dodirnite za promjenu',
    createStep3Title: 'Objasnite ga',
    createStep3Sub: 'Što se događa u ovom videozapisu? Naš AI će ovo pretvoriti u profesionalni narativ.',
    descPlaceholder: 'Opišite proces korak po korak...',
    createStep4Title: 'Pregled',
    aiProcessingInfo: 'Sada ćemo komprimirati videozapis, generirati profesionalni voiceover iz vašeg opisa i prevesti sve na više jezika.',
    creatingElement: 'Stvaranje elementa...',
    videoGenerating: 'Video se generira, molimo pričekajte trenutak…',
    videoProcessing: 'Video se dovršava… Gumb će biti automatski aktiviran.',
    videoProcessingHint: 'Video se još obrađuje. Pričekajte trenutak da ga odmah pogledate ili jednostavno nastavite raditi.',
    pleaseWait: 'Ovo može potrajati minutu. Učitavanje i obrada AI zadataka.',
    elementCreatedSuccess: 'Element uspješno stvoren!',
    elementReadyDesc: 'Vaš element je uspješno stvoren i obrađen.',
    viewElement: 'Prikaži element sada',
    goToMyCourses: 'Idi na moje tečajeve',
    elementPendingTitle: 'Vaš video se pregledava',
    elementPendingDesc: 'Vaš video je uspješno učitan i sada ga pregledava administrator. Uskoro će biti dostupan svima.',
    elementPendingHint: 'Bit ćete obaviješteni kada vaš video bude odobren.',
    elementApprovedTitle: 'Vaš video je odobren!',
    elementApprovedBody: 'Sjajne vijesti — vaš video „{name}" je odobren i sada je vidljiv svim korisnicima.',
    descTooShort: 'Molimo navedite detaljan opis (min. 10 znakova).',
    invalidFileType: 'Molimo učitajte valjani videozapis ili sliku.',
    fileTooLarge: 'Datoteka je prevelika. Maksimalna veličina je 500MB.',
    media: 'Medij',
    description: 'Opis',
    name: 'Naziv',
    courseDetails: 'Detalji tečaja',
    courseName: 'Naziv tečaja',
    courseNamePlaceholder: 'npr. održavanje strojeva',
    courseDescPlaceholder: 'Kratko opišite o čemu je ovaj tečaj...',
    thumbnail: 'Minijatura',
    uploadImage: '+ Učitaj sliku',
    addElements: 'Dodaj elemente',
    searchElements: 'Pretraži elemente...',
    loadingElements: 'Učitavanje elemenata...',
    preview: 'Pregled',
    added: 'Dodano',
    noElementsFound: 'Nisu pronađeni odgovarajući elementi.',
    organizeCourse: 'Organiziraj tečaj',
    dragDropReorder: 'Povucite i ispustite za promjenu redoslijeda',
    addMoreElements: '+ Dodaj više elemenata',
    courseCreated: 'Tečaj stvoren!',
    courseCreatedDesc: 'Vaša zbirka je uspješno pohranjena.',
    createAnotherCourse: 'Stvori još jedan tečaj',
    createCourse: 'Stvori tečaj',
    addToCourse: 'Dodaj u tečaj',
    saving: 'Pohranjivanje...',
    noElementsSelected: 'Molimo odaberite barem jedan element',
    errorCreatingCourse: 'Greška pri stvaranju tečaja',
    authError401: 'Neovlašteno (401). Vaša sesija je možda istekla. Molimo prijavite se ponovo.',
    adm_activate: 'Activate',
    adm_deactivate: 'Deactivate',
    adm_auto_translate_hint: '💡 Naziv i opis automatski se prevode na sve jezike.',
    adm_en_readonly_hint: 'Automatski prevedeno – nije za uređivanje',
    adm_filter_active: 'Aktivno',
    adm_filter_all: 'Sve',
    adm_filter_inactive: 'Neaktivno',
    adm_last_superadmin_hint: 'Zadnji Super Admin – ne može se obrisati',
    adm_no_group_access: 'Nema pristupa sadržaju',
    adm_no_group_assign_warn: 'Ovaj korisnik nije dodijeljen nijednoj grupi i stoga nema pristup sadržaju.',
    adm_no_group_warn_body: 'Novi korisnici bez grupe nemaju pristup sadržaju. Dodijelite grupu putem 🏷️ Grupa nakon stvaranja.',
    adm_no_group_warn_title: 'Napomena: Nema pristupa grupi',
    adm_toast_added_to_group: 'Dodan u grupu',
    adm_toast_removed_from_group: 'Uklonjen iz grupe',
    adm_toast_group_assigned: 'Grupa dodijeljena',
    adm_toast_group_removed: 'Grupa uklonjena',
    adm_toast_content_assigned: 'Sadržaj dodijeljen',
    adm_toast_content_removed: 'Sadržaj uklonjen',
    // ── Sustav obavijesti ─────────────────────────────────────────────────
    adm_notifications:          'Poruke',
    notif_type_new_content:     'Novi sadržaj',
    notif_type_message:         'Poruka',
    notif_goto_collection:      'Na kolekciju',
    notif_dismiss_all:          'Zatvori sve',
    notif_just_now:             'Upravo sad',

    // ── MyCourses: filtri, naslovi sekcija i prazna stanja ───────────────
    mc_filter_all:            'Sve',
    mc_filter_courses:        '📚 Moji Tečajevi',
    mc_filter_videos:         '▶ Moji Videozapisi',
    mc_filter_favorites:      '★ Favoriti',
    mc_status_all:            'Svi statusi',
    mc_only_mine:             'Samo moji',
    mc_section_courses_sub:   'Započeti i završeni tečajevi',
    mc_section_videos:        'Moji Videozapisi',
    mc_section_videos_sub:    'Sadržaj koji si kreirao',
    mc_section_favorites:     'Moji Favoriti',
    mc_section_favorites_sub: 'Tečajevi i videozapisi koji su ti se svidjeli',
    mc_empty_courses:         'Još nisi započeo nijedan tečaj.',
    mc_empty_videos:          'Još nisi stvorio nijedan videozapis.',
    mc_empty_favorites:       'Još nisi dodao nikakav sadržaj u favorite.',
    videoRendering:     'Video se renderira…',
    videoRenderingHint: 'Video se još obrađuje. Uskoro će biti dostupan.',
    // ── AdminPanel: novi i18n nizovi ──────────────────────────────────────
    adm_qr_unavailable:         'QR nije dostupan — npm install qrcode',
    adm_qr_login_title:         'QR kôd za prijavu',
    adm_qr_scan_login_hint:     'Skeniraj → prijavi se izravno bez PIN-a',
    adm_qr_permanent_hint:      'QR kôd trajno je dostupan u korisničkom zapisu.',
    adm_qr_print_hint:          'Ispišite PIN sada ili ga sigurno pošaljite.',
    adm_msg_subject_placeholder:'npr. Dostupna nova sigurnosna uputa',
    adm_msg_text_placeholder:   'Tekst poruke…',
    adm_col_license_type:       'Vrsta licence',
    adm_btn_show_qr:            'Prikaži QR kôd',
    adm_btn_send_msg:           'Pošalji poruku',
    adm_login_qr_label:         'QR kôd za prijavu',
    adm_btn_gen_pin:            'Generiraj novi PIN',
    adm_qr_scan_hint:           'Korisnik može skenirati ovaj kôd za prijavu bez PIN-a.',
    adm_pin_reset_hint:         'Za resetiranje PIN-a: zatvorite i koristite 🔄 Resetiraj PIN u korisničkoj kartici.',
    adm_role_supervisor:        'Supervisor',
    adm_role_admin_opt:         'Admin',
    adm_role_superadmin:        'Super Admin',
    adm_seat_essentials_desc:   'Essentials – sve funkcije osim izrade sadržaja',
    adm_pin_force_change:       'Prisili promjenu PIN-a pri prvoj prijavi',
    adm_btn_msg_group:          'Poruka grupi',
    adm_btn_show:               'Prikaži',
    adm_btn_unlock:             'Otključaj element',
    adm_btn_show_assigned:      'Prikaži dodijeljeni sadržaj',
    adm_no_videos_assigned:     'Nema dodijeljenih videa. Kliknite na „+ Dodaj video".',
    adm_drag_sort:              'Povuci za sortiranje',
    adm_search_video:           'Pretraži video…',
    adm_no_videos:              'Nije pronađen nijedan video.',
    adm_video_unassigned:       'Ovaj video nije dodijeljen nijednom sadržaju.',
    adm_search_messages:        'Pretraži poruke…',
    adm_btn_reload:             'Učitaj ponovo',
    adm_enriching:              'Obogaćivanje u tijeku…',
    adm_no_video_chunks:        'Nije pronađen nijedan video s ulomcima transkripta',
    adm_ki_enrichment:          'AI obogaćivanje',
    adm_col_updated:            'Ažurirano',
    adm_search_docs:            'Pretraži dokument ili element…',
    adm_no_docs:                'Nema dostupnih dokumenata',
    adm_col_size:               'Veličina',
    adm_search_questions:       'Pretraži pitanja…',
    adm_label_question:         'Pitanje zaposlenika',
    adm_label_answer:           'Odgovor',
    adm_btn_upload_doc:         'Učitaj dokument',
    adm_just_moment:            'Trenutak',
    adm_allowed_types_pptx:     'PDF, DOCX, TXT, PPTX',
    adm_domain_readonly:        'Samo administratori mogu uređivati profil domene.',
    adm_primary_lang:           'Primarni radni jezik',
    adm_drop_doc:               'Ispusti dokument ovdje ili klikni',
    adm_allowed_types_doc:      'PDF, TXT, DOC, DOCX',
    adm_company_docs_existing:  'Postojeći dokumenti tvrtke',
    adm_company_docs_empty:     'Još nisu učitani dokumenti tvrtke.',
    adm_no_licence:             'Nema dostupnih podataka o licenci.',
    adm_full_seats_label:       '⭐ Full Seats (uklj. izradu sadržaja)',
    adm_essentials_seats_label: 'Essentials Seats',
    adm_valid_until:            'Vrijedi do',
    adm_base_lang:              'Osnovni jezik',
    adm_active_ui_langs:        'Aktivni UI jezici',
    adm_tts_langs:              'TTS jezici',
    adm_full_seats_total_label: '⭐ Full Seats ukupno',
    adm_essentials_total_label: 'Essentials Seats ukupno',
    adm_ui_langs_field:         'UI jezici (aktivni jezici aplikacije)',
    adm_tts_langs_field:        'TTS jezici (pretvaranje teksta u govor)',
    adm_config_title:           'Konfiguracija',
    adm_config_desc:            'Postavke platforme za ovog stanara. Promjene su odmah aktivne.',
    adm_supervisor_mode:        'Način rada supervisora',
    adm_warning_no_admin:       '⚠️ Upozorenje: Nema aktivnog korisnika s ulogom Supervisora ili Admina (Grupa 2 ili 3).',
    adm_std_delete_toggle:      'Standardni korisnici: brisanje i deaktiviranje videa',
    adm_std_course_toggle:      'Standardni korisnici: izrada tečajeva i kvizova',
    adm_supervisor_confirm_title: 'Aktivirati način rada supervisora?',
    adm_btn_activate:           'Aktiviraj',
    adm_admin_only_setting:     'Samo tenant administratori (Grupa 3) ili Super Admini mogu promijeniti ovu postavku.',
    adm_only_admins_edit:       'Samo administratori mogu promijeniti ovu postavku.',
  },
};

/*
const languageMap = {
  'Spanish': 'es',
  'English': 'en',
  'German': 'de',
  'French': 'fr',
  'Russian': 'ru',
  'Arabic': 'ar',
  'Polish': 'pl',
  'Romanian': 'ro',
  'Turkish': 'tr',
  'Croatian': 'hr'
};
*/
// Reverse mapping from API language IDs to language codes
const apiLanguageMap = {
  1: 'de', // German
  2: 'en', // English
  3: 'ru', // Russian
  4: 'ar', // Arabic
  5: 'fr',  // French
  6: 'es', // Spanish
  7: 'pl', // Polish
  8: 'ro', // Romanian  
  9: 'tr', // Turkish  
  10: 'hr' // Croatian 
};


const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('de');
  const [languageName, setLanguageName] = useState('Deutsch');
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const cached = localStorage.getItem('hejvi_available_languages');
    if (cached) {
      try {
        setAvailableLanguages(JSON.parse(cached));
      } catch (e) {
        console.error("Error parsing cached languages", e);
      }
    }
  }, []);

  const setContextLanguages = (langs) => {
    setAvailableLanguages(langs);
    localStorage.setItem('hejvi_available_languages', JSON.stringify(langs));
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem('hejvi_language');
    const savedLanguageName = localStorage.getItem('hejvi_language_name');

    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
      
      if (savedLanguageName) {
        setLanguageName(savedLanguageName);
      }

      document.documentElement.lang = savedLanguage;
      document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
    }
  }, []);

  const changeLanguage = async (input) => {
    try {
      setIsLoading(true);
      
      let targetCode = null;
      let targetName = input;

      const staticNames = {
        'de': 'Deutsch',
        'en': 'English',
        'fr': 'Français',
        'es': 'Español',
        'ru': 'Русский',
        'ar': 'العربية',
        'pl': 'Polski',
        'nl': 'Nederlands',
        'ro': 'Română',
        'tr': 'Türkçe',
        'hr': 'Hrvatski'
      };

      if (translations[input]) {
          targetCode = input;
          const foundLang = availableLanguages.find(l => l.language_code === input);
          if (foundLang) {
              targetName = foundLang.original_name || foundLang.english_name;
          } else {
              targetName = staticNames[input] || input;
          }
      } else {
          const languageObj = availableLanguages.find(lang => 
            lang.english_name === input || 
            lang.original_name === input ||
            lang.german_name === input ||
            lang.name === input
          );
          
          if (languageObj) {
            targetCode = languageObj.language_code;
            targetName = languageObj.original_name || languageObj.english_name;
          } else {
             const codeFound = Object.keys(staticNames).find(key => staticNames[key] === input);
             if (codeFound) {
                 targetCode = codeFound;
                 targetName = input;
             }
          }
      }
      
      if (!targetCode || !translations[targetCode]) {
        setIsLoading(false);
        return;
      }
      
      setCurrentLanguage(targetCode);
      setLanguageName(targetName);
      
      localStorage.setItem('hejvi_language', targetCode);
      localStorage.setItem('hejvi_language_name', targetName);
      
      document.documentElement.lang = targetCode;
      document.documentElement.dir = targetCode === 'ar' ? 'rtl' : 'ltr';

    } catch (error) {
      console.error('Failed to change language:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const t = (key, params = {}) => {
    const translation = translations[currentLanguage]?.[key] || translations.en[key] || key;
    return translation.replace(/\{(\w+)\}/g, (match, param) => {
      return params[param] || match;
    });
  };

  const getAvailableLanguages = () => {
    if (availableLanguages.length > 0) {
      return availableLanguages.map(lang => ({
        id: lang.id,
        code: lang.language_code || 'en',
        name: lang.original_name || lang.english_name || lang.language_code || 'en',
        flag: lang.flag_url || '🌐',
        originalName: lang.original_name,
        germanName: lang.german_name,
        englishName: lang.english_name,
        writingDirection: lang.writing_direction
      }));
    }
    
    return [
      { id: 1, name: 'Deutsch', code: 'de', flag: '🇩🇪' },
      { id: 2, name: 'English', code: 'en', flag: '🇺🇸' },
      { id: 3, name: 'Русский', code: 'ru', flag: '🇷🇺' },
      { id: 4, name: 'العربية', code: 'ar', flag: '🇸🇦' },
      { id: 5, name: 'Français', code: 'fr', flag: '🇫🇷' },
      { id: 6, name: 'Español', code: 'es', flag: '🇪🇸' },
      { id: 7, name: 'Polski', code: 'pl', flag: '🇵🇱' },
      { id: 8, name: 'Română', code: 'ro', flag: '🇷🇴' },
      { id: 9, name: 'Türkçe', code: 'tr', flag: '🇹🇷' },
      { id: 10, name: 'Hrvatski', code: 'hr', flag: '🇭🇷' },
    ];
  };

  const setLanguageFromId = (id) => {
    if (!id) return;
    const code = apiLanguageMap[id];
    if (code) {
      changeLanguage(code);
    }
  };

  const getAvailableLanguagesFromLocalStorage = () => {
    return getAvailableLanguages();
  };

  const getLanguageFlag = (code) => {
    const flags = {
      'en': '🇺🇸',
      'de': '🇩🇪',
      'es': '🇪🇸',
      'fr': '🇫🇷',
      'ru': '🇷🇺',
      'pl': '🇵🇱',
      'ar': '🇸🇦',
      'ro': '🇷🇴',
      'tr': '🇹🇷',
      'hr': '🇭🇷'
    };
    return flags[code] || '🌐';
  };

  const value = {
    currentLanguage,
    languageName,
    t,
    getAvailableLanguages,
    getAvailableLanguagesFromLocalStorage,
    getLanguageFlag,
    setContextLanguages,
    setLanguageFromId,
    changeLanguage,
    isLoading,
    availableLanguages
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};